// Auto-generated nutrition data
import type { GeneratedData } from '../app/types.js'

export const nutritionData: GeneratedData = {
  "foods": [
    {
      "id": "1064099",
      "name": "chlorella",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 6000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 60,
        "1004": 0,
        "1005": 40,
        "1008": 300,
        "1079": 0,
        "1087": 333,
        "1089": 240,
        "1092": 0,
        "1093": 0,
        "1104": 58331,
        "1110": 0,
        "1162": 20,
        "1178": 300,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "2000": 0
      }
    },
    {
      "id": "172241",
      "name": "ecet - balzsam",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 25,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.49,
        "1004": 0,
        "1005": 17.03,
        "1008": 88,
        "1010": 0,
        "1011": 7.57,
        "1012": 7.38,
        "1013": 0,
        "1014": 0,
        "1051": 76.45,
        "1075": 0,
        "1087": 27,
        "1089": 0.72,
        "1090": 12,
        "1091": 19,
        "1092": 112,
        "1093": 23,
        "1095": 0.08,
        "1098": 0.026,
        "1101": 0.131,
        "1106": 0,
        "1162": 0,
        "1257": 0,
        "1258": 0,
        "2000": 14.95
      }
    },
    {
      "id": "173469",
      "name": "ecet - cider",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 25,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 0,
        "1005": 0.93,
        "1008": 21,
        "1010": 0,
        "1011": 0.1,
        "1012": 0.3,
        "1013": 0,
        "1014": 0,
        "1051": 93.81,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 7,
        "1089": 0.2,
        "1090": 5,
        "1091": 8,
        "1092": 73,
        "1093": 5,
        "1095": 0.04,
        "1098": 0.008,
        "1101": 0.249,
        "1103": 0.1,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 0,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1268": 0,
        "1269": 0,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 0,
        "1292": 0,
        "1293": 0,
        "2000": 0.4
      }
    },
    {
      "id": "168833",
      "name": "édesítő - barna nádcukor",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 250,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.12,
        "1004": 0,
        "1005": 98.09,
        "1008": 380,
        "1010": 94.56,
        "1011": 1.35,
        "1012": 1.11,
        "1013": 0,
        "1014": 0,
        "1051": 1.34,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 83,
        "1089": 0.71,
        "1090": 9,
        "1091": 4,
        "1092": 133,
        "1093": 28,
        "1095": 0.03,
        "1098": 0.047,
        "1101": 0.064,
        "1103": 1.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0.11,
        "1170": 0.132,
        "1175": 0.041,
        "1177": 1,
        "1178": 0,
        "1180": 2.3,
        "1185": 0,
        "1187": 1,
        "1190": 1,
        "1198": 0.1,
        "1253": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1268": 0,
        "1269": 0,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0,
        "2000": 97.02
      }
    },
    {
      "id": "169661",
      "name": "édesítő - juharszirup",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.04,
        "1004": 0.06,
        "1005": 67.04,
        "1008": 260,
        "1010": 58.32,
        "1011": 1.6,
        "1012": 0.52,
        "1013": 0,
        "1014": 0,
        "1051": 32.39,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 102,
        "1089": 0.11,
        "1090": 21,
        "1091": 2,
        "1092": 212,
        "1093": 12,
        "1095": 1.47,
        "1098": 0.018,
        "1101": 2.908,
        "1103": 0.6,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.066,
        "1166": 1.27,
        "1167": 0.081,
        "1170": 0.036,
        "1175": 0.002,
        "1177": 0,
        "1178": 0,
        "1180": 1.6,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1253": 0,
        "1258": 0.007,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.006,
        "1266": 0.001,
        "1268": 0.011,
        "1269": 0.017,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.011,
        "1293": 0.017,
        "2000": 60.46
      }
    },
    {
      "id": "168820",
      "name": "édesítő - melasz",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0,
        "1004": 0.1,
        "1005": 74.73,
        "1008": 290,
        "1010": 29.4,
        "1011": 11.92,
        "1012": 12.79,
        "1051": 21.87,
        "1058": 0,
        "1079": 0,
        "1087": 205,
        "1089": 4.72,
        "1090": 242,
        "1091": 31,
        "1092": 1464,
        "1093": 37,
        "1095": 0.29,
        "1098": 0.487,
        "1101": 1.53,
        "1103": 17.8,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.041,
        "1166": 0.002,
        "1167": 0.93,
        "1170": 0.804,
        "1175": 0.67,
        "1177": 0,
        "1178": 0,
        "1180": 13.3,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1253": 0,
        "1258": 0.018,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.018,
        "1266": 0.002,
        "1268": 0.032,
        "1269": 0.05,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.032,
        "1293": 0.05,
        "2000": 74.72
      }
    },
    {
      "id": "169640",
      "name": "édesítő - méz",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.3,
        "1004": 0,
        "1005": 82.4,
        "1008": 304,
        "1010": 0.89,
        "1011": 35.75,
        "1012": 40.94,
        "1014": 1.44,
        "1051": 17.1,
        "1058": 0,
        "1075": 3.1,
        "1079": 0.2,
        "1087": 6,
        "1089": 0.42,
        "1090": 2,
        "1091": 4,
        "1092": 52,
        "1093": 4,
        "1095": 0.22,
        "1098": 0.036,
        "1099": 7,
        "1101": 0.08,
        "1103": 0.8,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.5,
        "1165": 0,
        "1166": 0.038,
        "1167": 0.121,
        "1170": 0.068,
        "1175": 0.024,
        "1177": 2,
        "1178": 0,
        "1180": 2.2,
        "1185": 0,
        "1187": 2,
        "1190": 2,
        "1198": 1.7,
        "1210": 0.004,
        "1211": 0.004,
        "1212": 0.008,
        "1213": 0.01,
        "1214": 0.008,
        "1215": 0.001,
        "1216": 0.003,
        "1217": 0.011,
        "1218": 0.008,
        "1219": 0.009,
        "1220": 0.005,
        "1221": 0.001,
        "1222": 0.006,
        "1223": 0.027,
        "1224": 0.018,
        "1225": 0.007,
        "1226": 0.09,
        "1227": 0.006,
        "1253": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1268": 0,
        "1269": 0,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0,
        "2000": 82.12
      }
    },
    {
      "id": "2587229",
      "name": "kollagén - peptidek",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 85.71,
        "1004": 0,
        "1005": 0,
        "1008": 357,
        "1079": 0,
        "1087": 207,
        "1089": 0,
        "1092": 7,
        "1093": 321,
        "1114": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "2000": 0
      }
    },
    {
      "id": "516095",
      "name": "lecitin - napraforgó",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 20,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 50,
        "1005": 10,
        "1008": 800,
        "1079": 0,
        "1087": 200,
        "1089": 3.6,
        "1091": 2500,
        "1092": 800,
        "1093": 0,
        "1104": 0,
        "1162": 0,
        "1253": 0,
        "1257": 0,
        "1258": 10,
        "1292": 15,
        "1293": 25,
        "2000": 0
      }
    },
    {
      "id": "173573",
      "name": "olaj - avokádó",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 100,
        "1005": 0,
        "1008": 884,
        "1051": 0,
        "1079": 0,
        "1087": 0,
        "1089": 0,
        "1090": 0,
        "1091": 0,
        "1092": 0,
        "1093": 0,
        "1095": 0,
        "1098": 0,
        "1101": 0,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1187": 0,
        "1190": 0,
        "1258": 11.56,
        "1265": 10.9,
        "1266": 0.66,
        "1268": 67.889,
        "1269": 12.53,
        "1270": 0.957,
        "1275": 2.665,
        "1292": 70.554,
        "1293": 13.486
      }
    },
    {
      "id": "171030",
      "name": "olaj - dió",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 100,
        "1005": 0,
        "1008": 884,
        "1051": 0,
        "1058": 0,
        "1079": 0,
        "1087": 0,
        "1089": 0,
        "1090": 0,
        "1091": 0,
        "1092": 0,
        "1093": 0,
        "1095": 0,
        "1098": 0,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.4,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 0.4,
        "1185": 15,
        "1187": 0,
        "1190": 0,
        "1198": 0,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 0,
        "1258": 9.1,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 7,
        "1266": 2,
        "1268": 22.2,
        "1269": 52.9,
        "1270": 10.4,
        "1271": 0,
        "1272": 0,
        "1275": 0.1,
        "1276": 0,
        "1277": 0.4,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 176,
        "1292": 22.8,
        "1293": 63.3,
        "2000": 0
      }
    },
    {
      "id": "167702",
      "name": "olaj - lenmag, hidegen préselt",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.11,
        "1004": 99.98,
        "1005": 0,
        "1008": 884,
        "1051": 0.12,
        "1058": 0,
        "1079": 0,
        "1087": 1,
        "1089": 0,
        "1090": 0,
        "1091": 1,
        "1092": 0,
        "1093": 0,
        "1095": 0.07,
        "1098": 0,
        "1101": 0,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.47,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.55,
        "1126": 28.76,
        "1127": 1.65,
        "1128": 0.87,
        "1129": 0,
        "1130": 0.89,
        "1131": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 0.2,
        "1183": 0,
        "1184": 0,
        "1185": 9.3,
        "1187": 0,
        "1190": 0,
        "1253": 0,
        "1257": 0.094,
        "1258": 8.976,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.008,
        "1263": 0.018,
        "1264": 0.077,
        "1265": 5.109,
        "1266": 3.367,
        "1267": 0.131,
        "1268": 18.316,
        "1269": 14.327,
        "1270": 53.368,
        "1271": 0,
        "1272": 0,
        "1273": 0.113,
        "1274": 0.008,
        "1275": 0.06,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0.031,
        "1280": 0,
        "1285": 30,
        "1286": 98,
        "1288": 206,
        "1292": 18.438,
        "1293": 67.849,
        "1299": 0.027,
        "1300": 0.051,
        "1301": 0.075,
        "1303": 0,
        "1304": 0.03,
        "1305": 0.014,
        "1306": 0.05,
        "1311": 0.031,
        "1312": 0.023,
        "1313": 0.031,
        "1314": 0.06,
        "1315": 18.286,
        "1316": 14.246,
        "1317": 0.017,
        "1321": 0,
        "1323": 0,
        "1325": 0.096,
        "1329": 0.044,
        "1331": 0.05,
        "1333": 0,
        "1404": 53.368,
        "1405": 0.081,
        "1406": 0.015,
        "1411": 0.013,
        "2000": 0
      }
    },
    {
      "id": "171031",
      "name": "olaj - mandula",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 100,
        "1005": 0,
        "1008": 884,
        "1051": 0,
        "1058": 0,
        "1079": 0,
        "1087": 0,
        "1089": 0,
        "1090": 0,
        "1091": 0,
        "1092": 0,
        "1093": 0,
        "1095": 0,
        "1098": 0,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 39.2,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 0.4,
        "1185": 7,
        "1187": 0,
        "1190": 0,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 0,
        "1258": 8.2,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 6.5,
        "1266": 1.7,
        "1268": 69.4,
        "1269": 17.4,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0.6,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 266,
        "1292": 69.9,
        "1293": 17.4,
        "2000": 0
      }
    },
    {
      "id": "171413",
      "name": "olaj - oliva",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 100,
        "1005": 0,
        "1008": 884,
        "1051": 0,
        "1058": 0,
        "1079": 0,
        "1087": 1,
        "1089": 0.56,
        "1090": 0,
        "1091": 0,
        "1092": 1,
        "1093": 2,
        "1095": 0,
        "1098": 0,
        "1101": 0,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 14.35,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.11,
        "1126": 0.83,
        "1127": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 0.3,
        "1184": 0,
        "1185": 60.2,
        "1187": 0,
        "1190": 0,
        "1198": 0.1,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 0,
        "1258": 13.808,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 11.29,
        "1266": 1.953,
        "1267": 0.414,
        "1268": 71.269,
        "1269": 9.762,
        "1270": 0.761,
        "1271": 0,
        "1272": 0,
        "1273": 0.129,
        "1274": 0,
        "1275": 1.255,
        "1276": 0,
        "1277": 0.311,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 221,
        "1292": 72.961,
        "1293": 10.523,
        "1300": 0.022,
        "1301": 0,
        "1323": 0.125,
        "2000": 0
      }
    },
    {
      "id": "171028",
      "name": "olaj - szőlőmag",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 100,
        "1005": 0,
        "1008": 884,
        "1051": 0,
        "1058": 0,
        "1079": 0,
        "1087": 0,
        "1089": 0,
        "1090": 0,
        "1091": 0,
        "1092": 0,
        "1093": 0,
        "1095": 0,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 28.8,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1187": 0,
        "1190": 0,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 0,
        "1258": 9.6,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.1,
        "1265": 6.7,
        "1266": 2.7,
        "1268": 15.8,
        "1269": 69.6,
        "1270": 0.1,
        "1271": 0,
        "1272": 0,
        "1275": 0.3,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 180,
        "1292": 16.1,
        "1293": 69.9,
        "2000": 0
      }
    },
    {
      "id": "174158",
      "name": "víz",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 15,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 2000,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 0,
        "1005": 0,
        "1008": 0,
        "1051": 99.98,
        "1058": 0,
        "1079": 0,
        "1087": 10,
        "1089": 0,
        "1090": 2,
        "1091": 0,
        "1092": 0,
        "1093": 2,
        "1095": 0,
        "1098": 0.007,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 0,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1268": 0,
        "1269": 0,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0,
        "2000": 0
      }
    },
    {
      "id": "173572",
      "name": "zsír - liba",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": false,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 99.8,
        "1005": 0,
        "1008": 900,
        "1051": 0.2,
        "1079": 0,
        "1087": 0,
        "1089": 0,
        "1090": 0,
        "1091": 0,
        "1092": 0,
        "1093": 0,
        "1095": 0,
        "1103": 0.2,
        "1105": 0,
        "1106": 0,
        "1109": 2.7,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1187": 0,
        "1190": 0,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 100,
        "1258": 27.7,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.5,
        "1265": 20.7,
        "1266": 6.1,
        "1268": 53.5,
        "1269": 9.8,
        "1270": 0.5,
        "1271": 0,
        "1272": 0,
        "1275": 2.8,
        "1276": 0,
        "1277": 0.1,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 0,
        "1292": 56.7,
        "1293": 11
      }
    },
    {
      "id": "171401",
      "name": "zsír - sertés",
      "category": "alapanyag",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": false,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 100,
        "1005": 0,
        "1008": 902,
        "1051": 0,
        "1058": 0,
        "1079": 0,
        "1087": 0,
        "1089": 0,
        "1090": 0,
        "1091": 0,
        "1092": 0,
        "1093": 0,
        "1095": 0.11,
        "1098": 0,
        "1101": 0,
        "1103": 0.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.6,
        "1112": 2.5,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 49.7,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 95,
        "1258": 39.2,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.1,
        "1263": 0.2,
        "1264": 1.3,
        "1265": 23.8,
        "1266": 13.5,
        "1268": 41.2,
        "1269": 10.2,
        "1270": 1,
        "1271": 0,
        "1272": 0,
        "1275": 2.7,
        "1276": 0,
        "1277": 1,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 0,
        "1292": 45.1,
        "1293": 11.2,
        "2000": 0
      }
    },
    {
      "id": "170917",
      "name": "babérlevél",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 7.61,
        "1004": 8.36,
        "1005": 74.97,
        "1008": 313,
        "1051": 5.44,
        "1079": 26.3,
        "1087": 834,
        "1089": 43,
        "1090": 120,
        "1091": 113,
        "1092": 529,
        "1093": 23,
        "1095": 3.7,
        "1098": 0.416,
        "1101": 8.167,
        "1103": 2.8,
        "1105": 0,
        "1106": 309,
        "1110": 0,
        "1114": 0,
        "1162": 46.5,
        "1165": 0.009,
        "1166": 0.421,
        "1167": 2.005,
        "1175": 1.74,
        "1177": 180,
        "1178": 0,
        "1187": 180,
        "1190": 180,
        "1253": 0,
        "1257": 0,
        "1258": 2.28,
        "1259": 0,
        "1260": 0,
        "1261": 0.01,
        "1262": 0.01,
        "1263": 0.53,
        "1264": 0.21,
        "1265": 1.27,
        "1266": 0.16,
        "1268": 1.5,
        "1269": 1.24,
        "1270": 1.05,
        "1271": 0,
        "1272": 0,
        "1275": 0.14,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.64,
        "1293": 2.29
      },
      "scientificName": "Laurus nobilis"
    },
    {
      "id": "171317",
      "name": "bazsalikom - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 22.98,
        "1004": 4.07,
        "1005": 47.75,
        "1008": 233,
        "1010": 0.02,
        "1011": 0.75,
        "1012": 0.75,
        "1013": 0,
        "1014": 0,
        "1051": 10.35,
        "1058": 0,
        "1075": 0.19,
        "1079": 37.7,
        "1087": 2240,
        "1089": 89.8,
        "1090": 711,
        "1091": 274,
        "1092": 2630,
        "1093": 76,
        "1095": 7.1,
        "1098": 2.1,
        "1101": 9.8,
        "1103": 3,
        "1105": 0,
        "1106": 37,
        "1107": 378,
        "1108": 113,
        "1109": 10.7,
        "1110": 0,
        "1114": 0,
        "1120": 24,
        "1122": 393,
        "1123": 1150,
        "1125": 0,
        "1126": 0.77,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.8,
        "1165": 0.08,
        "1166": 1.2,
        "1167": 4.9,
        "1170": 0.838,
        "1175": 1.34,
        "1177": 310,
        "1178": 0,
        "1180": 54.9,
        "1184": 0,
        "1185": 1714.5,
        "1187": 310,
        "1190": 310,
        "1198": 16.1,
        "1210": 0.26,
        "1211": 0.76,
        "1212": 1.06,
        "1213": 1.85,
        "1214": 1.15,
        "1215": 0.32,
        "1216": 0.19,
        "1217": 1.25,
        "1218": 0.75,
        "1219": 1.45,
        "1220": 1.23,
        "1221": 0.45,
        "1222": 1.18,
        "1223": 3.02,
        "1224": 2.57,
        "1225": 1.25,
        "1226": 2.7,
        "1227": 0.53,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 2.157,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.046,
        "1265": 1.036,
        "1266": 1.075,
        "1267": 0,
        "1268": 1.067,
        "1269": 0.199,
        "1270": 0.3,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.171,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 106,
        "1292": 1.238,
        "1293": 0.498,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 1.067,
        "1321": 0.004,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 0.296,
        "2000": 1.71
      },
      "scientificName": "Ocimum basilicum"
    },
    {
      "id": "170931",
      "name": "bors - fekete - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 10.39,
        "1004": 3.26,
        "1005": 63.95,
        "1008": 251,
        "1010": 0.02,
        "1011": 0.24,
        "1012": 0.23,
        "1013": 0,
        "1014": 0,
        "1051": 12.46,
        "1058": 0,
        "1075": 0.15,
        "1079": 25.3,
        "1087": 443,
        "1089": 9.71,
        "1090": 171,
        "1091": 158,
        "1092": 1329,
        "1093": 20,
        "1095": 1.19,
        "1098": 1.33,
        "1099": 34.2,
        "1101": 12.753,
        "1103": 4.9,
        "1105": 0,
        "1106": 27,
        "1107": 310,
        "1108": 12,
        "1109": 1.04,
        "1110": 0,
        "1114": 0,
        "1120": 25,
        "1122": 20,
        "1123": 454,
        "1125": 0,
        "1126": 6.56,
        "1127": 0,
        "1128": 0.85,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.108,
        "1166": 0.18,
        "1167": 1.143,
        "1170": 1.399,
        "1175": 0.291,
        "1177": 17,
        "1178": 0,
        "1180": 11.3,
        "1184": 0,
        "1185": 163.7,
        "1187": 17,
        "1190": 17,
        "1198": 8.9,
        "1210": 0.058,
        "1211": 0.244,
        "1212": 0.366,
        "1213": 1.014,
        "1214": 0.244,
        "1215": 0.096,
        "1216": 0.138,
        "1217": 0.446,
        "1218": 0.483,
        "1219": 0.547,
        "1220": 0.308,
        "1221": 0.159,
        "1222": 0.616,
        "1223": 1.413,
        "1224": 1.413,
        "1225": 0.441,
        "1226": 1.413,
        "1227": 0.409,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 1.392,
        "1259": 0,
        "1260": 0.012,
        "1261": 0.102,
        "1262": 0.036,
        "1263": 0.093,
        "1264": 0.03,
        "1265": 0.533,
        "1266": 0.327,
        "1267": 0,
        "1268": 0.647,
        "1269": 0.694,
        "1270": 0.152,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0.016,
        "1275": 0.077,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 92,
        "1292": 0.739,
        "1293": 0.998,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 0.647,
        "1321": 0,
        "1323": 0,
        "1325": 0.152,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 0.152,
        "2000": 0.64
      },
      "scientificName": "Piper nigrum"
    },
    {
      "id": "171319",
      "name": "csili - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 13.46,
        "1004": 14.28,
        "1005": 49.7,
        "1008": 282,
        "1010": 0.76,
        "1011": 2.14,
        "1012": 4.29,
        "1013": 0,
        "1014": 0,
        "1051": 10.75,
        "1058": 0,
        "1075": 0,
        "1079": 34.8,
        "1087": 330,
        "1089": 17.3,
        "1090": 149,
        "1091": 300,
        "1092": 1950,
        "1093": 2867,
        "1095": 4.3,
        "1098": 1,
        "1101": 1.7,
        "1103": 20.4,
        "1105": 0,
        "1106": 1483,
        "1107": 15000,
        "1108": 2090,
        "1109": 38.14,
        "1110": 0,
        "1114": 0,
        "1120": 3490,
        "1122": 21,
        "1123": 310,
        "1125": 0.24,
        "1126": 3.41,
        "1127": 0,
        "1128": 3.1,
        "1129": 0,
        "1130": 2.85,
        "1131": 0,
        "1162": 0.7,
        "1165": 0.25,
        "1166": 0.94,
        "1167": 11.6,
        "1170": 0.888,
        "1175": 2.094,
        "1177": 28,
        "1178": 0,
        "1180": 66.5,
        "1184": 0,
        "1185": 105.7,
        "1187": 28,
        "1190": 28,
        "1198": 2.7,
        "1210": 0.07,
        "1211": 0.27,
        "1212": 0.39,
        "1213": 0.63,
        "1214": 0.36,
        "1215": 0.13,
        "1216": 0.18,
        "1217": 0.37,
        "1218": 0.19,
        "1219": 0.54,
        "1220": 0.49,
        "1221": 0.18,
        "1222": 0.45,
        "1223": 1.69,
        "1224": 1.59,
        "1225": 0.6,
        "1226": 1.25,
        "1227": 0.23,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 2.462,
        "1259": 0,
        "1260": 0.013,
        "1261": 0,
        "1262": 0.013,
        "1263": 0.081,
        "1264": 0.189,
        "1265": 1.619,
        "1266": 0.396,
        "1267": 0.055,
        "1268": 3.116,
        "1269": 7.473,
        "1270": 0.533,
        "1271": 0,
        "1272": 0,
        "1273": 0.055,
        "1274": 0,
        "1275": 0.082,
        "1276": 0,
        "1277": 0.014,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 83,
        "1292": 3.211,
        "1293": 8.006,
        "1299": 0,
        "1300": 0.014,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 3.116,
        "1321": 0.014,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0.027,
        "1333": 0,
        "1404": 0.519,
        "2000": 7.19
      }
    },
    {
      "id": "170924",
      "name": "curry",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 14.29,
        "1004": 14.01,
        "1005": 55.83,
        "1008": 325,
        "1010": 0.62,
        "1011": 1.14,
        "1012": 0.79,
        "1013": 0,
        "1014": 0,
        "1051": 8.8,
        "1058": 0,
        "1075": 0.21,
        "1079": 53.2,
        "1087": 525,
        "1089": 19.1,
        "1090": 255,
        "1091": 367,
        "1092": 1170,
        "1093": 52,
        "1095": 4.7,
        "1098": 1.2,
        "1101": 8.3,
        "1103": 40.3,
        "1105": 0,
        "1106": 1,
        "1107": 11,
        "1108": 0,
        "1109": 25.24,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 1.15,
        "1127": 0,
        "1162": 0.7,
        "1165": 0.176,
        "1166": 0.2,
        "1167": 3.26,
        "1170": 1.07,
        "1175": 0.105,
        "1177": 56,
        "1178": 0,
        "1180": 64.2,
        "1184": 0,
        "1185": 99.8,
        "1187": 56,
        "1190": 56,
        "1198": 28.8,
        "1210": 0.11,
        "1211": 0.35,
        "1212": 0.63,
        "1213": 0.89,
        "1214": 0.7,
        "1215": 0.19,
        "1216": 0.2,
        "1217": 0.58,
        "1218": 0.4,
        "1219": 0.75,
        "1220": 0.89,
        "1221": 0.29,
        "1222": 0.55,
        "1223": 1.79,
        "1224": 2.27,
        "1225": 0.79,
        "1226": 1.24,
        "1227": 0.39,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 1.648,
        "1259": 0.012,
        "1260": 0.038,
        "1261": 0.013,
        "1262": 0.013,
        "1263": 0,
        "1264": 0.637,
        "1265": 0.681,
        "1266": 0.174,
        "1267": 0,
        "1268": 8.742,
        "1269": 2.788,
        "1270": 0.268,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.013,
        "1276": 0,
        "1277": 0.013,
        "1278": 0,
        "1279": 0.014,
        "1280": 0,
        "1292": 8.782,
        "1293": 3.056,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 8.742,
        "1321": 0.013,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0.079,
        "1333": 0,
        "1404": 0.255,
        "2000": 2.76
      }
    },
    {
      "id": "171320",
      "name": "fahéj - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 0.5,
      "portionGrams": 0.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 3.99,
        "1004": 1.24,
        "1005": 80.59,
        "1008": 247,
        "1010": 0.02,
        "1011": 1.04,
        "1012": 1.11,
        "1013": 0,
        "1014": 0,
        "1051": 10.58,
        "1058": 0,
        "1075": 0,
        "1079": 53.1,
        "1087": 1002,
        "1089": 8.32,
        "1090": 60,
        "1091": 64,
        "1092": 431,
        "1093": 10,
        "1095": 1.83,
        "1098": 0.339,
        "1101": 17.466,
        "1103": 3.1,
        "1105": 0,
        "1106": 15,
        "1107": 112,
        "1108": 1,
        "1109": 2.32,
        "1110": 0,
        "1114": 0,
        "1120": 129,
        "1122": 15,
        "1123": 222,
        "1125": 0,
        "1126": 10.44,
        "1127": 0.26,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 3.8,
        "1165": 0.022,
        "1166": 0.041,
        "1167": 1.332,
        "1170": 0.358,
        "1175": 0.158,
        "1177": 6,
        "1178": 0,
        "1180": 11,
        "1184": 0,
        "1185": 31.2,
        "1187": 6,
        "1190": 6,
        "1198": 3.9,
        "1210": 0.049,
        "1211": 0.136,
        "1212": 0.146,
        "1213": 0.253,
        "1214": 0.243,
        "1215": 0.078,
        "1216": 0.058,
        "1217": 0.146,
        "1218": 0.136,
        "1219": 0.224,
        "1220": 0.166,
        "1221": 0.117,
        "1222": 0.166,
        "1223": 0.438,
        "1224": 0.37,
        "1225": 0.195,
        "1226": 0.419,
        "1227": 0.195,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0.345,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.003,
        "1263": 0.006,
        "1264": 0.009,
        "1265": 0.104,
        "1266": 0.082,
        "1267": 0,
        "1268": 0.246,
        "1269": 0.044,
        "1270": 0.011,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 26,
        "1292": 0.246,
        "1293": 0.068,
        "1299": 0,
        "1300": 0.136,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 0.246,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 0.011,
        "2000": 2.17
      },
      "scientificName": "Cinnamomum aromaticum"
    },
    {
      "id": "169231",
      "name": "gyömbér - friss",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 25,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.82,
        "1004": 0.75,
        "1005": 17.77,
        "1008": 80,
        "1051": 78.89,
        "1058": 0,
        "1079": 2,
        "1087": 16,
        "1089": 0.6,
        "1090": 43,
        "1091": 34,
        "1092": 415,
        "1093": 13,
        "1095": 0.34,
        "1098": 0.226,
        "1101": 0.229,
        "1103": 0.7,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.26,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 5,
        "1165": 0.025,
        "1166": 0.034,
        "1167": 0.75,
        "1170": 0.203,
        "1175": 0.16,
        "1177": 11,
        "1178": 0,
        "1180": 28.8,
        "1185": 0.1,
        "1187": 11,
        "1190": 11,
        "1210": 0.012,
        "1211": 0.036,
        "1212": 0.051,
        "1213": 0.074,
        "1214": 0.057,
        "1215": 0.013,
        "1216": 0.008,
        "1217": 0.045,
        "1218": 0.02,
        "1219": 0.073,
        "1220": 0.043,
        "1221": 0.03,
        "1222": 0.031,
        "1223": 0.208,
        "1224": 0.162,
        "1225": 0.043,
        "1226": 0.041,
        "1227": 0.045,
        "1253": 0,
        "1257": 0,
        "1258": 0.203,
        "1259": 0,
        "1260": 0,
        "1261": 0.007,
        "1262": 0,
        "1263": 0.039,
        "1264": 0.018,
        "1265": 0.12,
        "1266": 0.017,
        "1268": 0.119,
        "1269": 0.12,
        "1270": 0.034,
        "1271": 0,
        "1272": 0,
        "1275": 0.021,
        "1276": 0,
        "1277": 0.007,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 15,
        "1292": 0.154,
        "1293": 0.154,
        "2000": 1.7
      },
      "scientificName": "Zingiber officinale"
    },
    {
      "id": "170926",
      "name": "gyömbér - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 8.98,
        "1004": 4.24,
        "1005": 71.62,
        "1008": 335,
        "1010": 0.2,
        "1011": 1.22,
        "1012": 1.78,
        "1013": 0,
        "1014": 0,
        "1051": 9.94,
        "1058": 0,
        "1075": 0.19,
        "1079": 14.1,
        "1087": 114,
        "1089": 19.8,
        "1090": 214,
        "1091": 168,
        "1092": 1320,
        "1093": 27,
        "1095": 3.64,
        "1098": 0.48,
        "1101": 33.3,
        "1103": 55.8,
        "1105": 0,
        "1106": 2,
        "1107": 18,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 3.01,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.7,
        "1165": 0.046,
        "1166": 0.17,
        "1167": 9.62,
        "1170": 0.477,
        "1175": 0.626,
        "1177": 13,
        "1178": 0,
        "1180": 41.2,
        "1184": 2.4,
        "1185": 0.8,
        "1187": 13,
        "1190": 13,
        "1198": 3.4,
        "1210": 0.152,
        "1211": 0.289,
        "1212": 0.341,
        "1213": 0.513,
        "1214": 0.241,
        "1215": 0.089,
        "1216": 0.099,
        "1217": 0.311,
        "1218": 0.243,
        "1219": 0.411,
        "1220": 0.708,
        "1221": 0.199,
        "1222": 0.272,
        "1223": 1.387,
        "1224": 0.79,
        "1225": 0.497,
        "1226": 0.334,
        "1227": 0.25,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 2.599,
        "1259": 0,
        "1260": 0.027,
        "1261": 0,
        "1262": 1.56,
        "1263": 0.068,
        "1264": 0.044,
        "1265": 0.574,
        "1266": 0.227,
        "1267": 0,
        "1268": 0.357,
        "1269": 0.706,
        "1270": 0.223,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0.032,
        "1275": 0.036,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0.037,
        "1280": 0,
        "1283": 83,
        "1292": 0.479,
        "1293": 0.929,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 0.357,
        "1321": 0,
        "1323": 0.016,
        "1325": 0,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 0.223,
        "2000": 3.39
      },
      "scientificName": "Zingiber officinale"
    },
    {
      "id": "170938",
      "name": "kakukkfű - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 9.11,
        "1004": 7.43,
        "1005": 63.94,
        "1008": 276,
        "1051": 7.79,
        "1058": 0,
        "1079": 37,
        "1087": 1890,
        "1089": 123.6,
        "1090": 220,
        "1091": 201,
        "1092": 814,
        "1093": 55,
        "1095": 6.18,
        "1098": 0.86,
        "1101": 7.867,
        "1103": 4.6,
        "1105": 0,
        "1106": 190,
        "1107": 2264,
        "1108": 0,
        "1109": 7.48,
        "1110": 0,
        "1114": 0,
        "1120": 33,
        "1122": 0,
        "1123": 1895,
        "1162": 50,
        "1165": 0.513,
        "1166": 0.399,
        "1167": 4.94,
        "1175": 0.55,
        "1177": 274,
        "1178": 0,
        "1180": 43.6,
        "1185": 1714.5,
        "1187": 274,
        "1190": 274,
        "1210": 0.186,
        "1211": 0.252,
        "1212": 0.468,
        "1213": 0.43,
        "1214": 0.207,
        "1219": 0.502,
        "1253": 0,
        "1257": 0,
        "1258": 2.73,
        "1259": 0,
        "1260": 0,
        "1261": 0.24,
        "1262": 0.12,
        "1263": 0.23,
        "1264": 0.15,
        "1265": 1.72,
        "1266": 0.28,
        "1268": 0.47,
        "1269": 0.5,
        "1270": 0.69,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 163,
        "1292": 0.47,
        "1293": 1.19,
        "2000": 1.71
      },
      "scientificName": "Thymus vulgaris"
    },
    {
      "id": "172233",
      "name": "kapor - friss",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 3.46,
        "1004": 1.12,
        "1005": 7.02,
        "1008": 43,
        "1051": 85.95,
        "1079": 2.1,
        "1087": 208,
        "1089": 6.59,
        "1090": 55,
        "1091": 66,
        "1092": 738,
        "1093": 61,
        "1095": 0.91,
        "1098": 0.146,
        "1101": 1.264,
        "1105": 0,
        "1106": 386,
        "1110": 0,
        "1114": 0,
        "1162": 85,
        "1165": 0.058,
        "1166": 0.296,
        "1167": 1.57,
        "1170": 0.397,
        "1175": 0.185,
        "1177": 150,
        "1178": 0,
        "1187": 150,
        "1190": 150,
        "1210": 0.014,
        "1211": 0.068,
        "1212": 0.195,
        "1213": 0.159,
        "1214": 0.246,
        "1215": 0.011,
        "1216": 0.017,
        "1217": 0.065,
        "1218": 0.096,
        "1219": 0.154,
        "1220": 0.142,
        "1221": 0.071,
        "1222": 0.227,
        "1223": 0.343,
        "1224": 0.29,
        "1225": 0.169,
        "1226": 0.248,
        "1227": 0.158,
        "1253": 0,
        "1257": 0,
        "1258": 0.06,
        "1263": 0.001,
        "1264": 0.001,
        "1265": 0.049,
        "1266": 0.009,
        "1268": 0.798,
        "1269": 0.082,
        "1270": 0.013,
        "1275": 0.004,
        "1292": 0.802,
        "1293": 0.095
      },
      "scientificName": "Anethum graveolens"
    },
    {
      "id": "171322",
      "name": "kapor - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 19.96,
        "1004": 4.36,
        "1005": 55.82,
        "1008": 253,
        "1051": 7.3,
        "1079": 13.6,
        "1087": 1784,
        "1089": 48.78,
        "1090": 451,
        "1091": 543,
        "1092": 3308,
        "1093": 208,
        "1095": 3.3,
        "1098": 0.49,
        "1101": 3.95,
        "1105": 0,
        "1106": 293,
        "1110": 0,
        "1114": 0,
        "1162": 50,
        "1165": 0.418,
        "1166": 0.284,
        "1167": 2.807,
        "1175": 1.71,
        "1178": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0.234
      },
      "scientificName": "Anethum graveolens"
    },
    {
      "id": "170923",
      "name": "kömény - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 17.81,
        "1004": 22.27,
        "1005": 44.24,
        "1008": 375,
        "1051": 8.06,
        "1058": 0,
        "1079": 10.5,
        "1087": 931,
        "1089": 66.36,
        "1090": 366,
        "1091": 499,
        "1092": 1788,
        "1093": 168,
        "1095": 4.8,
        "1098": 0.867,
        "1101": 3.333,
        "1103": 5.2,
        "1105": 0,
        "1106": 64,
        "1107": 762,
        "1108": 0,
        "1109": 3.33,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 448,
        "1162": 7.7,
        "1165": 0.628,
        "1166": 0.327,
        "1167": 4.579,
        "1175": 0.435,
        "1177": 10,
        "1178": 0,
        "1180": 24.7,
        "1185": 5.4,
        "1187": 10,
        "1190": 10,
        "1253": 0,
        "1258": 1.535,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.018,
        "1263": 0.018,
        "1264": 0.018,
        "1265": 1.137,
        "1266": 0.344,
        "1268": 13.618,
        "1269": 3.103,
        "1270": 0.176,
        "1271": 0,
        "1272": 0,
        "1275": 0.212,
        "1276": 0,
        "1277": 0.212,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 68,
        "1292": 14.04,
        "1293": 3.279,
        "2000": 2.25
      },
      "scientificName": "Cuminum cyminum"
    },
    {
      "id": "170922",
      "name": "koriander - mag",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 10,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 12.37,
        "1004": 17.77,
        "1005": 54.99,
        "1008": 298,
        "1051": 8.86,
        "1079": 41.9,
        "1087": 709,
        "1089": 16.32,
        "1090": 330,
        "1091": 409,
        "1092": 1267,
        "1093": 35,
        "1095": 4.7,
        "1098": 0.975,
        "1101": 1.9,
        "1103": 26.2,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 21,
        "1165": 0.239,
        "1166": 0.29,
        "1167": 2.13,
        "1177": 0,
        "1178": 0,
        "1187": 0,
        "1190": 0,
        "1253": 0,
        "1258": 0.99,
        "1264": 0.02,
        "1265": 0.81,
        "1266": 0.11,
        "1268": 13.48,
        "1269": 1.75,
        "1275": 0.1,
        "1283": 46,
        "1292": 13.58,
        "1293": 1.75
      },
      "scientificName": "Coriandrum sativum"
    },
    {
      "id": "172231",
      "name": "kurkuma - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 9.68,
        "1004": 3.25,
        "1005": 67.14,
        "1008": 312,
        "1010": 2.38,
        "1011": 0.38,
        "1012": 0.45,
        "1013": 0,
        "1014": 0,
        "1051": 12.85,
        "1058": 0,
        "1075": 0,
        "1079": 22.7,
        "1087": 168,
        "1089": 55,
        "1090": 208,
        "1091": 299,
        "1092": 2080,
        "1093": 27,
        "1095": 4.5,
        "1098": 1.3,
        "1101": 19.8,
        "1103": 6.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 4.43,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.01,
        "1126": 0.72,
        "1127": 0,
        "1128": 0.12,
        "1129": 0,
        "1130": 0.05,
        "1131": 0,
        "1162": 0.7,
        "1165": 0.058,
        "1166": 0.15,
        "1167": 1.35,
        "1170": 0.542,
        "1175": 0.107,
        "1177": 20,
        "1178": 0,
        "1180": 49.2,
        "1184": 0,
        "1185": 13.4,
        "1187": 20,
        "1190": 20,
        "1198": 9.7,
        "1210": 0.17,
        "1211": 0.33,
        "1212": 0.47,
        "1213": 0.81,
        "1214": 0.38,
        "1215": 0.14,
        "1216": 0.15,
        "1217": 0.53,
        "1218": 0.32,
        "1219": 0.66,
        "1220": 0.54,
        "1221": 0.15,
        "1222": 0.33,
        "1223": 1.86,
        "1224": 1.14,
        "1225": 0.47,
        "1226": 0.48,
        "1227": 0.28,
        "1228": 0,
        "1253": 0,
        "1257": 0.056,
        "1258": 1.838,
        "1259": 0,
        "1260": 0,
        "1261": 0.003,
        "1262": 0.848,
        "1263": 0.003,
        "1264": 0.394,
        "1265": 0.155,
        "1266": 0.003,
        "1267": 0.097,
        "1268": 0.131,
        "1269": 0.672,
        "1270": 0.084,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0.154,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.449,
        "1293": 0.756,
        "1299": 0,
        "1300": 0.335,
        "1301": 0,
        "1304": 0.056,
        "1312": 0,
        "1313": 0,
        "1315": 0.075,
        "1321": 0.081,
        "1323": 0.164,
        "1325": 0,
        "1329": 0.056,
        "1332": 0,
        "1333": 0,
        "1404": 0.003,
        "2000": 3.21
      },
      "scientificName": "Curcuma longa L."
    },
    {
      "id": "170928",
      "name": "majoranna - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 12.66,
        "1004": 7.04,
        "1005": 60.56,
        "1008": 271,
        "1051": 7.64,
        "1058": 0,
        "1079": 40.3,
        "1087": 1990,
        "1089": 82.71,
        "1090": 346,
        "1091": 306,
        "1092": 1522,
        "1093": 77,
        "1095": 3.6,
        "1098": 1.133,
        "1101": 5.433,
        "1103": 4.5,
        "1105": 0,
        "1106": 403,
        "1107": 4806,
        "1108": 0,
        "1109": 1.69,
        "1110": 0,
        "1114": 0,
        "1120": 70,
        "1122": 0,
        "1123": 1895,
        "1162": 51.4,
        "1165": 0.289,
        "1166": 0.316,
        "1167": 4.12,
        "1175": 1.19,
        "1177": 274,
        "1178": 0,
        "1180": 43.6,
        "1185": 621.7,
        "1187": 274,
        "1190": 274,
        "1253": 0,
        "1257": 0,
        "1258": 0.529,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.294,
        "1266": 0.235,
        "1268": 0.94,
        "1269": 1.175,
        "1270": 3.23,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 60,
        "1292": 0.94,
        "1293": 4.405,
        "2000": 4.09
      },
      "scientificName": "Origanum majorana"
    },
    {
      "id": "171328",
      "name": "oregánó - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 9,
        "1004": 4.28,
        "1005": 68.92,
        "1008": 265,
        "1010": 0.91,
        "1011": 1.9,
        "1012": 1.13,
        "1013": 0,
        "1014": 0,
        "1051": 9.93,
        "1058": 0,
        "1075": 0.15,
        "1079": 42.5,
        "1087": 1597,
        "1089": 36.8,
        "1090": 270,
        "1091": 148,
        "1092": 1260,
        "1093": 25,
        "1095": 2.69,
        "1098": 0.633,
        "1101": 4.99,
        "1103": 4.5,
        "1105": 0,
        "1106": 85,
        "1107": 1007,
        "1108": 20,
        "1109": 18.26,
        "1110": 0,
        "1114": 0,
        "1120": 7,
        "1122": 0,
        "1123": 1895,
        "1125": 0,
        "1126": 24.42,
        "1127": 0.92,
        "1162": 2.3,
        "1165": 0.177,
        "1166": 0.528,
        "1167": 4.64,
        "1170": 0.921,
        "1175": 1.044,
        "1177": 237,
        "1178": 0,
        "1180": 32.3,
        "1184": 0,
        "1185": 621.7,
        "1187": 237,
        "1190": 237,
        "1198": 9.8,
        "1210": 0.203,
        "1211": 0.322,
        "1212": 0.441,
        "1213": 0.78,
        "1214": 0.5,
        "1215": 0.127,
        "1216": 0.11,
        "1217": 0.449,
        "1218": 0.297,
        "1219": 0.585,
        "1220": 0.449,
        "1221": 0.144,
        "1222": 0.5,
        "1223": 1.009,
        "1224": 0.975,
        "1225": 0.517,
        "1226": 1.712,
        "1227": 0.314,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 1.551,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.004,
        "1263": 0.246,
        "1264": 0.004,
        "1265": 0.792,
        "1266": 0.505,
        "1267": 0,
        "1268": 0.712,
        "1269": 0.748,
        "1270": 0.621,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.004,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 203,
        "1292": 0.716,
        "1293": 1.369,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 0.712,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 0.621,
        "2000": 4.09
      },
      "scientificName": "Origanum vulgare"
    },
    {
      "id": "170416",
      "name": "petrezselyem - friss",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 2.97,
        "1004": 0.79,
        "1005": 6.33,
        "1008": 36,
        "1051": 87.71,
        "1058": 0,
        "1079": 3.3,
        "1087": 138,
        "1089": 6.2,
        "1090": 50,
        "1091": 58,
        "1092": 554,
        "1093": 56,
        "1095": 1.07,
        "1098": 0.149,
        "1101": 0.16,
        "1103": 0.1,
        "1105": 0,
        "1106": 421,
        "1107": 5054,
        "1108": 0,
        "1109": 0.75,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 5561,
        "1125": 0,
        "1126": 0.53,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 133,
        "1165": 0.086,
        "1166": 0.098,
        "1167": 1.313,
        "1170": 0.4,
        "1175": 0.09,
        "1177": 152,
        "1178": 0,
        "1180": 12.8,
        "1185": 1640,
        "1187": 152,
        "1190": 152,
        "1210": 0.045,
        "1211": 0.122,
        "1212": 0.118,
        "1213": 0.204,
        "1214": 0.181,
        "1215": 0.042,
        "1216": 0.014,
        "1217": 0.145,
        "1218": 0.082,
        "1219": 0.172,
        "1220": 0.122,
        "1221": 0.061,
        "1222": 0.195,
        "1223": 0.294,
        "1224": 0.249,
        "1225": 0.145,
        "1226": 0.213,
        "1227": 0.136,
        "1253": 0,
        "1257": 0,
        "1258": 0.132,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.008,
        "1265": 0.084,
        "1266": 0.039,
        "1268": 0.287,
        "1269": 0.115,
        "1270": 0.008,
        "1271": 0,
        "1272": 0,
        "1275": 0.008,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 5,
        "1292": 0.295,
        "1293": 0.124,
        "2000": 0.85
      },
      "scientificName": "Petroselinum crispum"
    },
    {
      "id": "170930",
      "name": "petrezselyem - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 10,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.63,
        "1004": 5.48,
        "1005": 50.64,
        "1008": 292,
        "1010": 4.09,
        "1011": 2.76,
        "1012": 0.42,
        "1013": 0,
        "1014": 0,
        "1051": 5.89,
        "1058": 0,
        "1075": 0,
        "1079": 26.7,
        "1087": 1140,
        "1089": 22.04,
        "1090": 400,
        "1091": 436,
        "1092": 2683,
        "1093": 452,
        "1095": 5.44,
        "1098": 0.78,
        "1101": 9.81,
        "1103": 14.1,
        "1105": 0,
        "1106": 97,
        "1107": 1152,
        "1108": 17,
        "1109": 8.96,
        "1110": 0,
        "1114": 0,
        "1120": 4,
        "1122": 0,
        "1123": 2428,
        "1125": 0.02,
        "1126": 1.53,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 125,
        "1165": 0.196,
        "1166": 2.383,
        "1167": 9.943,
        "1170": 1.062,
        "1175": 0.9,
        "1177": 180,
        "1178": 0,
        "1180": 97.1,
        "1184": 0,
        "1185": 1359.5,
        "1187": 180,
        "1190": 180,
        "1198": 1.7,
        "1210": 0.475,
        "1211": 1.193,
        "1212": 1.546,
        "1213": 2.794,
        "1214": 2.098,
        "1215": 0.596,
        "1216": 0.298,
        "1217": 1.712,
        "1218": 1.159,
        "1219": 2.021,
        "1220": 1.756,
        "1221": 0.718,
        "1222": 1.778,
        "1223": 3.169,
        "1224": 3.688,
        "1225": 1.756,
        "1226": 2.01,
        "1227": 1.159,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 1.378,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 1.223,
        "1266": 0.058,
        "1267": 0.005,
        "1268": 0.761,
        "1269": 1.248,
        "1270": 1.876,
        "1271": 0,
        "1272": 0,
        "1273": 0.028,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.761,
        "1293": 3.124,
        "1299": 0,
        "1300": 0,
        "1301": 0.063,
        "1303": 0,
        "1304": 0,
        "1305": 0,
        "1311": 0,
        "1312": 0,
        "1313": 0,
        "1314": 0,
        "1315": 0.761,
        "1316": 1.248,
        "1317": 0,
        "1321": 0.016,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 1.86,
        "1405": 0,
        "1406": 0,
        "1411": 0,
        "2000": 7.27
      },
      "scientificName": "Petroselinum crispum"
    },
    {
      "id": "170932",
      "name": "piros paprika - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 1500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 10,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 12.01,
        "1004": 17.27,
        "1005": 56.63,
        "1008": 318,
        "1051": 8.05,
        "1058": 0,
        "1079": 27.2,
        "1087": 148,
        "1089": 7.8,
        "1090": 152,
        "1091": 293,
        "1092": 2014,
        "1093": 30,
        "1095": 2.48,
        "1098": 0.373,
        "1101": 2,
        "1103": 8.8,
        "1105": 0,
        "1106": 2081,
        "1107": 21840,
        "1108": 0,
        "1109": 29.83,
        "1110": 0,
        "1114": 0,
        "1120": 6252,
        "1122": 0,
        "1123": 13157,
        "1162": 76.4,
        "1165": 0.328,
        "1166": 0.919,
        "1167": 8.701,
        "1175": 2.45,
        "1177": 106,
        "1178": 0,
        "1180": 51.5,
        "1185": 80.3,
        "1187": 106,
        "1190": 106,
        "1253": 0,
        "1258": 3.26,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.03,
        "1263": 0.03,
        "1264": 0.09,
        "1265": 2.36,
        "1266": 0.49,
        "1268": 2.51,
        "1269": 7.71,
        "1270": 0.66,
        "1271": 0,
        "1272": 0,
        "1275": 0.24,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 83,
        "1292": 2.75,
        "1293": 8.37,
        "2000": 10.34
      },
      "scientificName": "Capsicum frutescens or Capsicum annuum"
    },
    {
      "id": "173468",
      "name": "só - nem jódozott",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 60,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 0,
        "1005": 0,
        "1008": 0,
        "1051": 0.2,
        "1058": 0,
        "1079": 0,
        "1087": 24,
        "1089": 0.33,
        "1090": 1,
        "1091": 0,
        "1092": 8,
        "1093": 38758,
        "1095": 0.1,
        "1098": 0.03,
        "1099": 2,
        "1101": 0.1,
        "1103": 0.1,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0,
        "1167": 0,
        "1170": 0,
        "1175": 0,
        "1177": 0,
        "1178": 0,
        "1180": 0,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1210": 0,
        "1211": 0,
        "1212": 0,
        "1213": 0,
        "1214": 0,
        "1215": 0,
        "1216": 0,
        "1217": 0,
        "1218": 0,
        "1219": 0,
        "1220": 0,
        "1221": 0,
        "1222": 0,
        "1223": 0,
        "1224": 0,
        "1225": 0,
        "1226": 0,
        "1227": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1268": 0,
        "1269": 0,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 0,
        "1292": 0,
        "1293": 0,
        "2000": 0
      }
    },
    {
      "id": "171321",
      "name": "szegfűszeg - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 5000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 5.97,
        "1004": 13,
        "1005": 65.53,
        "1008": 274,
        "1010": 0.02,
        "1011": 1.14,
        "1012": 1.07,
        "1013": 0,
        "1014": 0,
        "1051": 9.87,
        "1058": 0,
        "1075": 0.15,
        "1079": 33.9,
        "1087": 632,
        "1089": 11.83,
        "1090": 259,
        "1091": 104,
        "1092": 1020,
        "1093": 277,
        "1095": 2.32,
        "1098": 0.368,
        "1101": 60.127,
        "1103": 7.2,
        "1105": 0,
        "1106": 8,
        "1107": 45,
        "1108": 0,
        "1109": 8.82,
        "1110": 0,
        "1114": 0,
        "1120": 103,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.2,
        "1165": 0.158,
        "1166": 0.22,
        "1167": 1.56,
        "1170": 0.509,
        "1175": 0.391,
        "1177": 25,
        "1178": 0,
        "1180": 37.4,
        "1184": 0,
        "1185": 141.8,
        "1187": 25,
        "1190": 25,
        "1198": 1.4,
        "1210": 0.03,
        "1211": 0.18,
        "1212": 0.24,
        "1213": 0.4,
        "1214": 0.37,
        "1215": 0.08,
        "1216": 0.07,
        "1217": 0.23,
        "1218": 0.19,
        "1219": 0.34,
        "1220": 0.32,
        "1221": 0.13,
        "1222": 0.29,
        "1223": 0.6,
        "1224": 0.56,
        "1225": 0.28,
        "1226": 0.39,
        "1227": 0.24,
        "1228": 0,
        "1253": 0,
        "1257": 0.254,
        "1258": 3.952,
        "1259": 0,
        "1260": 0.009,
        "1261": 0.026,
        "1262": 0.131,
        "1263": 0.035,
        "1264": 0.263,
        "1265": 1.858,
        "1266": 0.683,
        "1267": 0.193,
        "1268": 0.99,
        "1269": 2.657,
        "1270": 0.585,
        "1271": 0.104,
        "1272": 0,
        "1273": 0.175,
        "1275": 0.026,
        "1276": 0,
        "1277": 0.359,
        "1278": 0.008,
        "1279": 0.018,
        "1280": 0.184,
        "1283": 256,
        "1292": 1.393,
        "1293": 3.606,
        "1299": 0.018,
        "1300": 0.044,
        "1301": 0.491,
        "1304": 0.21,
        "1306": 0.042,
        "1311": 0.058,
        "1312": 0,
        "1313": 0.017,
        "1314": 0.026,
        "1315": 0.78,
        "1316": 2.557,
        "1317": 0.018,
        "1325": 0.008,
        "1329": 0.21,
        "1331": 0.044,
        "1404": 0.585,
        "1406": 0.008,
        "1411": 0.058,
        "2000": 2.38
      },
      "scientificName": "Syzygium aromaticum"
    },
    {
      "id": "171326",
      "name": "szerecsendió - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 5000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 5.84,
        "1004": 36.31,
        "1005": 49.29,
        "1008": 525,
        "1051": 6.23,
        "1058": 0,
        "1079": 20.8,
        "1087": 184,
        "1089": 3.04,
        "1090": 183,
        "1091": 213,
        "1092": 350,
        "1093": 16,
        "1095": 2.15,
        "1098": 1.027,
        "1101": 2.9,
        "1103": 1.6,
        "1105": 0,
        "1106": 5,
        "1107": 28,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 66,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.53,
        "1127": 0,
        "1162": 3,
        "1165": 0.346,
        "1166": 0.057,
        "1167": 1.299,
        "1175": 0.16,
        "1177": 76,
        "1178": 0,
        "1180": 8.8,
        "1185": 0,
        "1187": 76,
        "1190": 76,
        "1253": 0,
        "1258": 25.94,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.37,
        "1264": 22.83,
        "1265": 2.26,
        "1266": 0.17,
        "1268": 1.59,
        "1269": 0.35,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 1.4,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 62,
        "1292": 3.22,
        "1293": 0.35,
        "2000": 2.99
      },
      "scientificName": "Myristica fragrans"
    },
    {
      "id": "170937",
      "name": "tárkony - őrölt",
      "category": "fűszer",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": false,
      "purchaseRawGrams": 100,
      "purchasePrice": 4000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 5,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 22.77,
        "1004": 7.24,
        "1005": 50.22,
        "1008": 295,
        "1051": 7.74,
        "1058": 0,
        "1079": 7.4,
        "1087": 1139,
        "1089": 32.3,
        "1090": 347,
        "1091": 313,
        "1092": 3020,
        "1093": 62,
        "1095": 3.9,
        "1098": 0.677,
        "1101": 7.967,
        "1103": 4.4,
        "1105": 0,
        "1106": 210,
        "1110": 0,
        "1114": 0,
        "1162": 50,
        "1165": 0.251,
        "1166": 1.339,
        "1167": 8.95,
        "1175": 2.41,
        "1177": 274,
        "1178": 0,
        "1187": 274,
        "1190": 274,
        "1253": 0,
        "1257": 0,
        "1258": 1.881,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.028,
        "1263": 0.014,
        "1264": 0.12,
        "1265": 1.202,
        "1266": 0.41,
        "1268": 0.361,
        "1269": 0.742,
        "1270": 2.955,
        "1271": 0,
        "1272": 0,
        "1275": 0.113,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 81,
        "1292": 0.474,
        "1293": 3.698
      },
      "scientificName": "Artemisia dracunculus"
    },
    {
      "id": "175117",
      "name": "hal - hering - atlanti",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.03,
        "1004": 11.59,
        "1005": 0,
        "1008": 203,
        "1051": 64.16,
        "1058": 0,
        "1079": 0,
        "1087": 74,
        "1089": 1.41,
        "1090": 41,
        "1091": 303,
        "1092": 419,
        "1093": 115,
        "1095": 1.27,
        "1098": 0.118,
        "1101": 0.04,
        "1103": 46.8,
        "1105": 36,
        "1106": 36,
        "1107": 0,
        "1108": 0,
        "1109": 1.37,
        "1112": 5.4,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.7,
        "1165": 0.112,
        "1166": 0.299,
        "1167": 4.124,
        "1170": 0.74,
        "1175": 0.348,
        "1177": 12,
        "1178": 13.14,
        "1180": 83.3,
        "1185": 0.1,
        "1187": 12,
        "1190": 12,
        "1210": 0.258,
        "1211": 1.01,
        "1212": 1.061,
        "1213": 1.872,
        "1214": 2.115,
        "1215": 0.682,
        "1216": 0.247,
        "1217": 0.899,
        "1218": 0.778,
        "1219": 1.187,
        "1220": 1.378,
        "1221": 0.678,
        "1222": 1.393,
        "1223": 2.358,
        "1224": 3.438,
        "1225": 1.106,
        "1226": 0.814,
        "1227": 0.94,
        "1253": 77,
        "1258": 2.615,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.015,
        "1264": 0.71,
        "1265": 1.735,
        "1266": 0.14,
        "1268": 1.944,
        "1269": 0.167,
        "1270": 0.132,
        "1271": 0.077,
        "1272": 1.105,
        "1275": 0.797,
        "1276": 0.274,
        "1277": 0.924,
        "1278": 0.909,
        "1279": 1.077,
        "1280": 0.071,
        "1292": 4.79,
        "1293": 2.735,
        "2000": 0
      },
      "scientificName": "Clupea harengus harengus (L.)"
    },
    {
      "id": "174233",
      "name": "hal - hering - csendes óceáni",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 21.01,
        "1004": 17.79,
        "1005": 0,
        "1008": 250,
        "1051": 63.49,
        "1079": 0,
        "1087": 106,
        "1089": 1.44,
        "1090": 41,
        "1091": 292,
        "1092": 542,
        "1093": 95,
        "1095": 0.68,
        "1098": 0.1,
        "1101": 0.058,
        "1103": 46.8,
        "1105": 35,
        "1106": 35,
        "1162": 0,
        "1165": 0.073,
        "1166": 0.256,
        "1167": 2.821,
        "1170": 1.154,
        "1175": 0.519,
        "1177": 6,
        "1178": 9.62,
        "1187": 6,
        "1190": 6,
        "1210": 0.235,
        "1211": 0.921,
        "1212": 0.968,
        "1213": 1.708,
        "1214": 1.93,
        "1215": 0.622,
        "1216": 0.225,
        "1217": 0.82,
        "1218": 0.709,
        "1219": 1.083,
        "1220": 1.257,
        "1221": 0.619,
        "1222": 1.271,
        "1223": 2.152,
        "1224": 3.137,
        "1225": 1.009,
        "1226": 0.743,
        "1227": 0.857,
        "1253": 99,
        "1258": 4.174,
        "1264": 1.17,
        "1265": 2.593,
        "1266": 0.329,
        "1268": 3.734,
        "1269": 0.246,
        "1270": 0.073,
        "1271": 0.123,
        "1272": 0.883,
        "1275": 1.355,
        "1276": 0.318,
        "1277": 1.742,
        "1278": 1.242,
        "1279": 1.912,
        "1280": 0.22,
        "1292": 8.807,
        "1293": 3.106
      },
      "scientificName": "Clupea harengus pallasi Valenciennes"
    },
    {
      "id": "173704",
      "name": "hal - kardhal",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.45,
        "1004": 7.93,
        "1005": 0,
        "1008": 172,
        "1051": 68.26,
        "1058": 0,
        "1079": 0,
        "1087": 6,
        "1089": 0.45,
        "1090": 35,
        "1091": 304,
        "1092": 499,
        "1093": 97,
        "1095": 0.78,
        "1098": 0.046,
        "1101": 0.013,
        "1103": 68.5,
        "1105": 43,
        "1106": 43,
        "1107": 0,
        "1108": 0,
        "1109": 2.41,
        "1112": 16.6,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.01,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.089,
        "1166": 0.063,
        "1167": 9.254,
        "1170": 0.417,
        "1175": 0.615,
        "1177": 2,
        "1178": 1.62,
        "1180": 77.5,
        "1185": 0.1,
        "1187": 2,
        "1190": 2,
        "1210": 0.265,
        "1211": 1.035,
        "1212": 1.088,
        "1213": 1.919,
        "1214": 2.168,
        "1215": 0.699,
        "1216": 0.253,
        "1217": 0.922,
        "1218": 0.797,
        "1219": 1.216,
        "1220": 1.413,
        "1221": 0.695,
        "1222": 1.429,
        "1223": 2.418,
        "1224": 3.525,
        "1225": 1.133,
        "1226": 0.835,
        "1227": 0.964,
        "1253": 78,
        "1257": 0.056,
        "1258": 1.911,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.008,
        "1264": 0.177,
        "1265": 1.208,
        "1266": 0.405,
        "1267": 0.02,
        "1268": 2.657,
        "1269": 0.088,
        "1270": 0.034,
        "1271": 0.083,
        "1272": 0.772,
        "1273": 0.011,
        "1274": 0.005,
        "1275": 0.281,
        "1276": 0.007,
        "1277": 0.449,
        "1278": 0.127,
        "1279": 0.057,
        "1280": 0.168,
        "1292": 3.544,
        "1293": 1.368,
        "1299": 0.033,
        "1300": 0.041,
        "1301": 0.007,
        "1312": 0.09,
        "1313": 0.022,
        "1323": 0.004,
        "1325": 0.027,
        "1333": 0.001,
        "1411": 0.034,
        "2000": 0
      },
      "scientificName": "Xiphias gladius L."
    },
    {
      "id": "175168",
      "name": "hal - lazac - atlanti - tenyésztett",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 22.1,
        "1004": 12.35,
        "1005": 0,
        "1008": 206,
        "1051": 64.75,
        "1058": 0,
        "1079": 0,
        "1087": 15,
        "1089": 0.34,
        "1090": 30,
        "1091": 252,
        "1092": 384,
        "1093": 61,
        "1095": 0.43,
        "1098": 0.049,
        "1101": 0.016,
        "1103": 41.4,
        "1105": 69,
        "1106": 69,
        "1107": 0,
        "1108": 0,
        "1109": 1.14,
        "1110": 526,
        "1114": 13.1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 3.7,
        "1165": 0.34,
        "1166": 0.135,
        "1167": 8.045,
        "1170": 1.475,
        "1175": 0.647,
        "1177": 34,
        "1178": 2.8,
        "1180": 90.5,
        "1185": 0.1,
        "1187": 34,
        "1190": 34,
        "1210": 0.248,
        "1211": 0.969,
        "1212": 1.018,
        "1213": 1.796,
        "1214": 2.03,
        "1215": 0.654,
        "1216": 0.237,
        "1217": 0.863,
        "1218": 0.746,
        "1219": 1.139,
        "1220": 1.322,
        "1221": 0.651,
        "1222": 1.337,
        "1223": 2.263,
        "1224": 3.299,
        "1225": 1.061,
        "1226": 0.781,
        "1227": 0.902,
        "1253": 63,
        "1258": 2.397,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.005,
        "1263": 0.013,
        "1264": 0.571,
        "1265": 1.493,
        "1266": 0.315,
        "1268": 2.046,
        "1269": 0.666,
        "1270": 0.113,
        "1271": 1.273,
        "1272": 1.457,
        "1275": 0.767,
        "1276": 0.184,
        "1277": 1.368,
        "1278": 0.69,
        "1279": 0,
        "1280": 0.17,
        "1292": 4.181,
        "1293": 4.553,
        "2000": 0
      },
      "scientificName": "Salmo salar L."
    },
    {
      "id": "171998",
      "name": "hal - lazac - atlanti - vad",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.44,
        "1004": 8.13,
        "1005": 0,
        "1008": 182,
        "1051": 59.62,
        "1079": 0,
        "1087": 15,
        "1089": 1.03,
        "1090": 37,
        "1091": 256,
        "1092": 628,
        "1093": 56,
        "1095": 0.82,
        "1098": 0.321,
        "1101": 0.021,
        "1103": 46.8,
        "1105": 13,
        "1106": 13,
        "1162": 0,
        "1165": 0.275,
        "1166": 0.487,
        "1167": 10.077,
        "1170": 1.92,
        "1175": 0.944,
        "1177": 29,
        "1178": 3.05,
        "1187": 29,
        "1190": 29,
        "1210": 0.285,
        "1211": 1.115,
        "1212": 1.172,
        "1213": 2.067,
        "1214": 2.336,
        "1215": 0.753,
        "1216": 0.273,
        "1217": 0.993,
        "1218": 0.859,
        "1219": 1.31,
        "1220": 1.522,
        "1221": 0.749,
        "1222": 1.538,
        "1223": 2.605,
        "1224": 3.797,
        "1225": 1.221,
        "1226": 0.899,
        "1227": 1.038,
        "1253": 71,
        "1258": 1.257,
        "1264": 0.176,
        "1265": 0.81,
        "1266": 0.272,
        "1268": 1.732,
        "1269": 0.22,
        "1270": 0.378,
        "1271": 0.342,
        "1272": 1.429,
        "1275": 0.322,
        "1276": 0.106,
        "1277": 0.286,
        "1278": 0.411,
        "1279": 0.358,
        "1280": 0.368,
        "1292": 2.697,
        "1293": 3.256
      },
      "scientificName": "Salmo salar L."
    },
    {
      "id": "171999",
      "name": "hal - lazac - Chinook",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.72,
        "1004": 13.38,
        "1005": 0,
        "1008": 231,
        "1051": 65.6,
        "1079": 0,
        "1087": 28,
        "1089": 0.91,
        "1090": 122,
        "1091": 371,
        "1092": 505,
        "1093": 60,
        "1095": 0.56,
        "1098": 0.053,
        "1101": 0.019,
        "1103": 46.8,
        "1105": 149,
        "1106": 149,
        "1162": 4.1,
        "1165": 0.044,
        "1166": 0.154,
        "1167": 10.045,
        "1170": 0.865,
        "1175": 0.462,
        "1177": 35,
        "1178": 2.87,
        "1187": 35,
        "1190": 35,
        "1210": 0.288,
        "1211": 1.127,
        "1212": 1.185,
        "1213": 2.09,
        "1214": 2.362,
        "1215": 0.761,
        "1216": 0.276,
        "1217": 1.004,
        "1218": 0.868,
        "1219": 1.325,
        "1220": 1.539,
        "1221": 0.757,
        "1222": 1.555,
        "1223": 2.634,
        "1224": 3.839,
        "1225": 1.234,
        "1226": 0.909,
        "1227": 1.049,
        "1253": 85,
        "1258": 3.214,
        "1264": 0.455,
        "1265": 2.045,
        "1266": 0.714,
        "1268": 3.585,
        "1269": 0.136,
        "1270": 0.11,
        "1271": 0.197,
        "1272": 0.727,
        "1275": 1.133,
        "1276": 0.185,
        "1277": 0.58,
        "1278": 1.01,
        "1279": 0.444,
        "1280": 0.296,
        "1292": 5.742,
        "1293": 2.662
      },
      "scientificName": "Oncorhynchus tshawytscha (Walbaum)"
    },
    {
      "id": "172000",
      "name": "hal - lazac - Chum",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.82,
        "1004": 4.83,
        "1005": 0,
        "1008": 154,
        "1051": 68.44,
        "1079": 0,
        "1087": 14,
        "1089": 0.71,
        "1090": 28,
        "1091": 363,
        "1092": 550,
        "1093": 64,
        "1095": 0.6,
        "1098": 0.071,
        "1101": 0.019,
        "1103": 46.8,
        "1105": 34,
        "1106": 34,
        "1162": 0,
        "1165": 0.092,
        "1166": 0.219,
        "1167": 8.526,
        "1170": 0.865,
        "1175": 0.462,
        "1177": 5,
        "1178": 3.46,
        "1187": 5,
        "1190": 5,
        "1210": 0.289,
        "1211": 1.132,
        "1212": 1.19,
        "1213": 2.099,
        "1214": 2.371,
        "1215": 0.764,
        "1216": 0.277,
        "1217": 1.008,
        "1218": 0.872,
        "1219": 1.33,
        "1220": 1.545,
        "1221": 0.76,
        "1222": 1.562,
        "1223": 2.644,
        "1224": 3.854,
        "1225": 1.239,
        "1226": 0.913,
        "1227": 1.053,
        "1253": 95,
        "1258": 1.077,
        "1264": 0.192,
        "1265": 0.751,
        "1266": 0.133,
        "1268": 1.046,
        "1269": 0.077,
        "1270": 0.044,
        "1271": 0.038,
        "1272": 0.505,
        "1275": 0.283,
        "1276": 0.087,
        "1277": 0.236,
        "1278": 0.299,
        "1279": 0.41,
        "1280": 0.101,
        "1292": 1.976,
        "1293": 1.152
      },
      "scientificName": "Oncorhynchus keta (Walbaum)"
    },
    {
      "id": "172001",
      "name": "hal - lazac - Pink",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.58,
        "1004": 5.28,
        "1005": 0,
        "1008": 153,
        "1051": 70.65,
        "1058": 0,
        "1079": 0,
        "1087": 8,
        "1089": 0.45,
        "1090": 32,
        "1091": 313,
        "1092": 439,
        "1093": 90,
        "1095": 0.46,
        "1098": 0.075,
        "1101": 0.013,
        "1103": 37.6,
        "1105": 42,
        "1106": 42,
        "1107": 0,
        "1108": 0,
        "1109": 0.48,
        "1112": 13,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.091,
        "1166": 0.126,
        "1167": 9.588,
        "1170": 1.235,
        "1175": 0.696,
        "1177": 5,
        "1178": 4.73,
        "1180": 113.4,
        "1185": 0.5,
        "1187": 5,
        "1190": 5,
        "1210": 0.265,
        "1211": 1.278,
        "1212": 1.145,
        "1213": 1.874,
        "1214": 2.11,
        "1215": 0.692,
        "1216": 0.19,
        "1217": 1.013,
        "1218": 0.89,
        "1219": 1.319,
        "1220": 1.543,
        "1221": 0.651,
        "1222": 1.568,
        "1223": 3.088,
        "1224": 3.482,
        "1225": 1.514,
        "1226": 1.039,
        "1227": 1.086,
        "1253": 55,
        "1257": 0.041,
        "1258": 0.971,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.003,
        "1264": 0.243,
        "1265": 0.566,
        "1266": 0.122,
        "1267": 0.007,
        "1268": 0.756,
        "1269": 0.097,
        "1270": 0.056,
        "1271": 0.016,
        "1272": 0.399,
        "1273": 0.002,
        "1274": 0.004,
        "1275": 0.215,
        "1276": 0.087,
        "1277": 0.538,
        "1278": 0.218,
        "1279": 0.056,
        "1280": 0.057,
        "1292": 1.617,
        "1293": 0.973,
        "1299": 0.015,
        "1300": 0.012,
        "1301": 0.001,
        "1312": 0.04,
        "1313": 0.021,
        "1323": 0.004,
        "1325": 0.015,
        "1333": 0.003,
        "1411": 0.002,
        "2000": 0
      },
      "scientificName": "Oncorhynchus gorbuscha (Walbaum)"
    },
    {
      "id": "173692",
      "name": "hal - lazac - Sockeye",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.48,
        "1004": 5.57,
        "1005": 0,
        "1008": 156,
        "1009": 0,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 67.33,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 11,
        "1089": 0.52,
        "1090": 36,
        "1091": 305,
        "1092": 436,
        "1093": 92,
        "1095": 0.55,
        "1098": 0.076,
        "1101": 0.013,
        "1103": 35.5,
        "1105": 58,
        "1106": 58,
        "1107": 0,
        "1108": 0,
        "1109": 0.99,
        "1112": 16.7,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.01,
        "1126": 0.19,
        "1127": 0.22,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.157,
        "1166": 0.246,
        "1167": 10.123,
        "1170": 1.274,
        "1175": 0.827,
        "1177": 7,
        "1178": 4.47,
        "1180": 112.6,
        "1183": 0.4,
        "1184": 0,
        "1185": 0.1,
        "1187": 7,
        "1190": 7,
        "1210": 0.335,
        "1211": 1.247,
        "1212": 1.274,
        "1213": 2.185,
        "1214": 2.574,
        "1215": 0.858,
        "1216": 0.295,
        "1217": 1.086,
        "1218": 1.207,
        "1219": 1.461,
        "1220": 1.716,
        "1221": 0.711,
        "1222": 1.649,
        "1223": 2.708,
        "1224": 3.902,
        "1225": 1.274,
        "1226": 0.979,
        "1227": 1.059,
        "1253": 61,
        "1257": 0.023,
        "1258": 0.969,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.001,
        "1263": 0.003,
        "1264": 0.15,
        "1265": 0.653,
        "1266": 0.124,
        "1267": 0.006,
        "1268": 0.843,
        "1269": 0.19,
        "1270": 0.058,
        "1271": 0.02,
        "1272": 0.56,
        "1273": 0.001,
        "1274": 0.004,
        "1275": 0.164,
        "1276": 0.064,
        "1277": 0.447,
        "1278": 0.299,
        "1279": 0.374,
        "1280": 0.093,
        "1292": 1.864,
        "1293": 1.327,
        "1299": 0.018,
        "1300": 0.013,
        "1301": 0,
        "1312": 0.017,
        "1313": 0.019,
        "1323": 0.015,
        "1325": 0.017,
        "1333": 0,
        "1411": 0.003,
        "2000": 0
      }
    },
    {
      "id": "175120",
      "name": "hal - makréla - atlanti",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.85,
        "1004": 17.81,
        "1005": 0,
        "1008": 262,
        "1051": 53.27,
        "1079": 0,
        "1087": 15,
        "1089": 1.57,
        "1090": 97,
        "1091": 278,
        "1092": 401,
        "1093": 83,
        "1095": 0.94,
        "1098": 0.094,
        "1101": 0.02,
        "1103": 51.6,
        "1105": 54,
        "1106": 54,
        "1162": 0.4,
        "1165": 0.159,
        "1166": 0.412,
        "1167": 6.85,
        "1170": 0.99,
        "1175": 0.46,
        "1177": 2,
        "1178": 19,
        "1187": 2,
        "1190": 2,
        "1210": 0.267,
        "1211": 1.045,
        "1212": 1.099,
        "1213": 1.938,
        "1214": 2.19,
        "1215": 0.706,
        "1216": 0.256,
        "1217": 0.931,
        "1218": 0.805,
        "1219": 1.228,
        "1220": 1.427,
        "1221": 0.702,
        "1222": 1.442,
        "1223": 2.442,
        "1224": 3.559,
        "1225": 1.145,
        "1226": 0.843,
        "1227": 0.973,
        "1253": 75,
        "1258": 4.176,
        "1264": 0.592,
        "1265": 1.375,
        "1266": 0.256,
        "1268": 1.202,
        "1269": 0.147,
        "1270": 0.113,
        "1271": 0.051,
        "1272": 0.699,
        "1275": 0.534,
        "1277": 1.598,
        "1278": 0.504,
        "1279": 2.498,
        "1280": 0.106,
        "1292": 7.006,
        "1293": 4.3
      },
      "scientificName": "Scomber scombrus L."
    },
    {
      "id": "171994",
      "name": "hal - makréla - csendes óceáni",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.73,
        "1004": 10.12,
        "1005": 0,
        "1008": 201,
        "1051": 61.73,
        "1058": 0,
        "1079": 0,
        "1087": 29,
        "1089": 1.49,
        "1090": 36,
        "1091": 160,
        "1092": 521,
        "1093": 110,
        "1095": 0.86,
        "1098": 0.119,
        "1101": 0.019,
        "1103": 46.8,
        "1105": 23,
        "1106": 23,
        "1107": 0,
        "1108": 0,
        "1109": 1.25,
        "1112": 11.4,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 2.1,
        "1165": 0.135,
        "1166": 0.54,
        "1167": 10.667,
        "1170": 0.365,
        "1175": 0.381,
        "1177": 2,
        "1178": 4.23,
        "1180": 83.6,
        "1185": 0.1,
        "1187": 2,
        "1190": 2,
        "1210": 0.288,
        "1211": 1.128,
        "1212": 1.186,
        "1213": 2.091,
        "1214": 2.363,
        "1215": 0.762,
        "1216": 0.276,
        "1217": 1.005,
        "1218": 0.869,
        "1219": 1.326,
        "1220": 1.54,
        "1221": 0.758,
        "1222": 1.556,
        "1223": 2.635,
        "1224": 3.841,
        "1225": 1.235,
        "1226": 0.91,
        "1227": 1.05,
        "1253": 60,
        "1258": 2.881,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.012,
        "1264": 0.436,
        "1265": 1.781,
        "1266": 0.565,
        "1268": 1.703,
        "1269": 0.149,
        "1270": 0.064,
        "1271": 0.104,
        "1272": 1.195,
        "1275": 0.603,
        "1276": 0.16,
        "1277": 0.417,
        "1278": 0.653,
        "1279": 0.622,
        "1280": 0.158,
        "1292": 3.371,
        "1293": 2.488,
        "2000": 0
      },
      "scientificName": "Scomber spp. and Trachurus spp."
    },
    {
      "id": "174236",
      "name": "hal - makréla - King",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26,
        "1004": 2.56,
        "1005": 0,
        "1008": 134,
        "1051": 69.04,
        "1079": 0,
        "1087": 40,
        "1089": 2.28,
        "1090": 41,
        "1091": 318,
        "1092": 558,
        "1093": 203,
        "1095": 0.72,
        "1098": 0.033,
        "1101": 0.006,
        "1103": 46.8,
        "1105": 252,
        "1106": 252,
        "1162": 1.6,
        "1165": 0.115,
        "1166": 0.58,
        "1167": 10.462,
        "1170": 0.968,
        "1175": 0.51,
        "1177": 9,
        "1178": 18,
        "1187": 9,
        "1190": 9,
        "1210": 0.291,
        "1211": 1.14,
        "1212": 1.198,
        "1213": 2.113,
        "1214": 2.388,
        "1215": 0.77,
        "1216": 0.279,
        "1217": 1.015,
        "1218": 0.878,
        "1219": 1.34,
        "1220": 1.556,
        "1221": 0.765,
        "1222": 1.572,
        "1223": 2.662,
        "1224": 3.881,
        "1225": 1.248,
        "1226": 0.919,
        "1227": 1.061,
        "1253": 68,
        "1258": 0.465,
        "1264": 0.105,
        "1265": 0.31,
        "1266": 0.05,
        "1268": 0.398,
        "1269": 0.051,
        "1272": 0.227,
        "1275": 0.151,
        "1276": 0.115,
        "1277": 0.156,
        "1278": 0.174,
        "1279": 0.273,
        "1280": 0.022,
        "1292": 0.979,
        "1293": 0.589
      },
      "scientificName": "Scombermorus cavalla (Cuvier)"
    },
    {
      "id": "173674",
      "name": "hal - makréla - Spanish",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.59,
        "1004": 6.32,
        "1005": 0,
        "1008": 158,
        "1051": 68.46,
        "1079": 0,
        "1087": 13,
        "1089": 0.74,
        "1090": 38,
        "1091": 271,
        "1092": 554,
        "1093": 66,
        "1095": 0.62,
        "1098": 0.065,
        "1101": 0.012,
        "1103": 40.6,
        "1105": 33,
        "1106": 33,
        "1162": 1.6,
        "1165": 0.13,
        "1166": 0.21,
        "1167": 5,
        "1170": 0.87,
        "1175": 0.46,
        "1177": 1,
        "1178": 7,
        "1187": 1,
        "1190": 1,
        "1210": 0.264,
        "1211": 1.034,
        "1212": 1.087,
        "1213": 1.917,
        "1214": 2.166,
        "1215": 0.698,
        "1216": 0.253,
        "1217": 0.921,
        "1218": 0.796,
        "1219": 1.215,
        "1220": 1.411,
        "1221": 0.694,
        "1222": 1.427,
        "1223": 2.415,
        "1224": 3.521,
        "1225": 1.132,
        "1226": 0.834,
        "1227": 0.962,
        "1253": 73,
        "1258": 1.801,
        "1264": 0.204,
        "1265": 1.155,
        "1266": 0.442,
        "1268": 1.104,
        "1269": 0.108,
        "1270": 0.116,
        "1271": 0.159,
        "1272": 0.952,
        "1275": 0.309,
        "1277": 0.123,
        "1278": 0.294,
        "1279": 0.07,
        "1280": 0.095,
        "1292": 2.139,
        "1293": 1.805
      },
      "scientificName": "Scombermorus maculatus (Mitchill)"
    },
    {
      "id": "172003",
      "name": "hal - naphal",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.87,
        "1004": 0.9,
        "1005": 0,
        "1008": 114,
        "1051": 73.72,
        "1079": 0,
        "1087": 103,
        "1089": 1.54,
        "1090": 38,
        "1091": 231,
        "1092": 449,
        "1093": 103,
        "1095": 1.99,
        "1098": 0.385,
        "1101": 0.897,
        "1103": 16.2,
        "1105": 17,
        "1106": 17,
        "1162": 1,
        "1165": 0.092,
        "1166": 0.085,
        "1167": 1.462,
        "1170": 0.865,
        "1175": 0.138,
        "1177": 17,
        "1178": 2.31,
        "1187": 17,
        "1190": 17,
        "1210": 0.279,
        "1211": 1.09,
        "1212": 1.146,
        "1213": 2.022,
        "1214": 2.284,
        "1215": 0.736,
        "1216": 0.267,
        "1217": 0.971,
        "1218": 0.84,
        "1219": 1.281,
        "1220": 1.488,
        "1221": 0.732,
        "1222": 1.504,
        "1223": 2.547,
        "1224": 3.713,
        "1225": 1.194,
        "1226": 0.879,
        "1227": 1.015,
        "1253": 86,
        "1258": 0.178,
        "1264": 0.015,
        "1265": 0.127,
        "1266": 0.036,
        "1268": 0.09,
        "1269": 0.019,
        "1270": 0.013,
        "1271": 0.101,
        "1272": 0.092,
        "1275": 0.054,
        "1277": 0.006,
        "1278": 0.047,
        "1280": 0.042,
        "1292": 0.15,
        "1293": 0.315
      },
      "scientificName": "Lepomis gibbosus (L.)"
    },
    {
      "id": "174197",
      "name": "hal - nyelvhal - Solea solea",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 15.24,
        "1004": 2.37,
        "1005": 0,
        "1008": 86,
        "1009": 0,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 81.11,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 25,
        "1089": 0.23,
        "1090": 22,
        "1091": 309,
        "1092": 197,
        "1093": 363,
        "1095": 0.39,
        "1098": 0.023,
        "1101": 0.017,
        "1103": 32.6,
        "1105": 12,
        "1106": 12,
        "1107": 0,
        "1108": 0,
        "1109": 0.77,
        "1112": 3.5,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.02,
        "1126": 0.01,
        "1127": 0.32,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.026,
        "1166": 0.025,
        "1167": 1.278,
        "1170": 0.227,
        "1175": 0.115,
        "1177": 6,
        "1178": 1.31,
        "1180": 79.9,
        "1183": 0.3,
        "1184": 0,
        "1185": 0.1,
        "1187": 6,
        "1190": 6,
        "1210": 0.197,
        "1211": 0.719,
        "1212": 0.754,
        "1213": 1.335,
        "1214": 1.561,
        "1215": 0.56,
        "1216": 0.183,
        "1217": 0.624,
        "1218": 0.588,
        "1219": 0.8,
        "1220": 1.099,
        "1221": 0.374,
        "1222": 0.948,
        "1223": 1.698,
        "1224": 2.614,
        "1225": 0.786,
        "1226": 0.599,
        "1227": 0.712,
        "1253": 56,
        "1257": 0.014,
        "1258": 0.542,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.004,
        "1263": 0.008,
        "1264": 0.106,
        "1265": 0.346,
        "1266": 0.065,
        "1267": 0.001,
        "1268": 0.439,
        "1269": 0.055,
        "1270": 0.021,
        "1271": 0.018,
        "1272": 0.132,
        "1273": 0,
        "1274": 0,
        "1275": 0.111,
        "1276": 0.015,
        "1277": 0.073,
        "1278": 0.168,
        "1279": 0.001,
        "1280": 0.034,
        "1292": 0.657,
        "1293": 0.459,
        "1299": 0.008,
        "1300": 0.004,
        "1301": 0.001,
        "1312": 0,
        "1313": 0.006,
        "1323": 0.033,
        "1325": 0.009,
        "1333": 0,
        "1411": 0.002,
        "2000": 0
      },
      "scientificName": "Bothidae and Pleuronectidae"
    },
    {
      "id": "171996",
      "name": "hal - ördöghal",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 4000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 18.56,
        "1004": 1.95,
        "1005": 0,
        "1008": 97,
        "1051": 78.51,
        "1079": 0,
        "1087": 10,
        "1089": 0.41,
        "1090": 27,
        "1091": 256,
        "1092": 513,
        "1093": 23,
        "1095": 0.53,
        "1098": 0.036,
        "1101": 0.031,
        "1103": 46.8,
        "1105": 14,
        "1106": 14,
        "1162": 1,
        "1165": 0.029,
        "1166": 0.073,
        "1167": 2.558,
        "1170": 0.173,
        "1175": 0.277,
        "1177": 8,
        "1178": 1.04,
        "1187": 8,
        "1190": 8,
        "1210": 0.208,
        "1211": 0.814,
        "1212": 0.855,
        "1213": 1.509,
        "1214": 1.705,
        "1215": 0.549,
        "1216": 0.199,
        "1217": 0.725,
        "1218": 0.627,
        "1219": 0.956,
        "1220": 1.111,
        "1221": 0.547,
        "1222": 1.123,
        "1223": 1.901,
        "1224": 2.771,
        "1225": 0.891,
        "1226": 0.656,
        "1227": 0.757,
        "1253": 32
      },
      "scientificName": "Lophius piscatorius L."
    },
    {
      "id": "172004",
      "name": "hal - pisztráng",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.63,
        "1004": 8.47,
        "1005": 0,
        "1008": 190,
        "1051": 63.36,
        "1079": 0,
        "1087": 55,
        "1089": 1.92,
        "1090": 28,
        "1091": 314,
        "1092": 463,
        "1093": 67,
        "1095": 0.85,
        "1098": 0.241,
        "1101": 1.091,
        "1103": 16.2,
        "1105": 19,
        "1106": 19,
        "1162": 0.5,
        "1165": 0.426,
        "1166": 0.423,
        "1167": 5.769,
        "1170": 2.238,
        "1175": 0.231,
        "1177": 15,
        "1178": 7.49,
        "1187": 15,
        "1190": 15,
        "1210": 0.298,
        "1211": 1.167,
        "1212": 1.227,
        "1213": 2.164,
        "1214": 2.446,
        "1215": 0.788,
        "1216": 0.285,
        "1217": 1.04,
        "1218": 0.899,
        "1219": 1.372,
        "1220": 1.593,
        "1221": 0.784,
        "1222": 1.61,
        "1223": 2.727,
        "1224": 3.975,
        "1225": 1.278,
        "1226": 0.942,
        "1227": 1.086,
        "1253": 74,
        "1258": 1.474,
        "1264": 0.237,
        "1265": 1.045,
        "1266": 0.19,
        "1268": 1.847,
        "1269": 0.224,
        "1270": 0.199,
        "1271": 0.242,
        "1272": 0.677,
        "1275": 0.899,
        "1276": 0.082,
        "1277": 0.359,
        "1278": 0.259,
        "1279": 1.064,
        "1280": 0.235,
        "1292": 4.172,
        "1293": 1.922
      },
      "scientificName": "Salmonidae"
    },
    {
      "id": "173718",
      "name": "hal - pisztráng - Szivárványos - tenyésztett",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.8,
        "1004": 7.38,
        "1005": 0,
        "1008": 168,
        "1051": 68.72,
        "1058": 0,
        "1079": 0,
        "1087": 30,
        "1089": 0.36,
        "1090": 30,
        "1091": 270,
        "1092": 450,
        "1093": 61,
        "1095": 0.54,
        "1098": 0.055,
        "1101": 0.013,
        "1103": 28.1,
        "1105": 100,
        "1106": 100,
        "1107": 0,
        "1108": 0,
        "1109": 2.79,
        "1112": 19,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.05,
        "1127": 0,
        "1128": 0.01,
        "1129": 0,
        "1130": 0.01,
        "1131": 0,
        "1162": 2.9,
        "1165": 0.143,
        "1166": 0.107,
        "1167": 6.646,
        "1170": 1.99,
        "1175": 0.386,
        "1177": 12,
        "1178": 4.11,
        "1180": 77.6,
        "1185": 0.1,
        "1187": 12,
        "1190": 12,
        "1210": 0.279,
        "1211": 1.092,
        "1212": 1.148,
        "1213": 2.025,
        "1214": 2.287,
        "1215": 0.738,
        "1216": 0.267,
        "1217": 0.973,
        "1218": 0.84,
        "1219": 1.283,
        "1220": 1.491,
        "1221": 0.733,
        "1222": 1.507,
        "1223": 2.551,
        "1224": 3.719,
        "1225": 1.196,
        "1226": 0.881,
        "1227": 1.016,
        "1253": 70,
        "1257": 0.056,
        "1258": 1.651,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.005,
        "1264": 0.217,
        "1265": 1.108,
        "1266": 0.274,
        "1267": 0.009,
        "1268": 1.64,
        "1269": 0.588,
        "1270": 0.08,
        "1271": 0.051,
        "1272": 0.616,
        "1273": 0.004,
        "1274": 0.004,
        "1275": 0.406,
        "1276": 0.001,
        "1277": 0.265,
        "1278": 0.259,
        "1279": 0.021,
        "1280": 0.109,
        "1292": 2.363,
        "1293": 1.799,
        "1299": 0.017,
        "1300": 0.015,
        "1301": 0.002,
        "1312": 0.02,
        "1313": 0.047,
        "1323": 0,
        "1325": 0.033,
        "1333": 0.006,
        "1411": 0.008,
        "2000": 0
      },
      "scientificName": "Salmo gairdneri Richardson"
    },
    {
      "id": "175155",
      "name": "hal - pisztráng - Szivárványos - vad",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 22.92,
        "1004": 5.82,
        "1005": 0,
        "1008": 150,
        "1051": 70.5,
        "1079": 0,
        "1087": 86,
        "1089": 0.38,
        "1090": 31,
        "1091": 269,
        "1092": 448,
        "1093": 56,
        "1095": 0.51,
        "1098": 0.058,
        "1101": 0.021,
        "1103": 13.2,
        "1105": 15,
        "1106": 15,
        "1162": 2,
        "1165": 0.152,
        "1166": 0.097,
        "1167": 5.77,
        "1170": 1.065,
        "1175": 0.346,
        "1177": 19,
        "1178": 6.3,
        "1187": 19,
        "1190": 19,
        "1210": 0.257,
        "1211": 1.005,
        "1212": 1.056,
        "1213": 1.863,
        "1214": 2.105,
        "1215": 0.679,
        "1216": 0.246,
        "1217": 0.895,
        "1218": 0.774,
        "1219": 1.181,
        "1220": 1.372,
        "1221": 0.675,
        "1222": 1.387,
        "1223": 2.348,
        "1224": 3.422,
        "1225": 1.1,
        "1226": 0.811,
        "1227": 0.935,
        "1253": 69,
        "1258": 1.619,
        "1264": 0.204,
        "1265": 0.918,
        "1266": 0.265,
        "1268": 0.918,
        "1269": 0.288,
        "1270": 0.187,
        "1271": 0.12,
        "1272": 0.52,
        "1275": 0.675,
        "1276": 0.23,
        "1277": 0.051,
        "1278": 0.468,
        "1292": 1.746,
        "1293": 1.831
      },
      "scientificName": "Salmo gairdneri Richardson"
    },
    {
      "id": "174242",
      "name": "hal - pisztráng - tengeri",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 21.46,
        "1004": 4.63,
        "1005": 0,
        "1008": 133,
        "1051": 71.91,
        "1079": 0,
        "1087": 22,
        "1089": 0.35,
        "1090": 40,
        "1091": 321,
        "1092": 437,
        "1093": 74,
        "1095": 0.58,
        "1098": 0.038,
        "1101": 0.019,
        "1103": 46.8,
        "1105": 35,
        "1106": 35,
        "1162": 0,
        "1165": 0.069,
        "1166": 0.207,
        "1167": 2.923,
        "1170": 0.865,
        "1175": 0.462,
        "1177": 6,
        "1178": 3.46,
        "1187": 6,
        "1190": 6,
        "1210": 0.24,
        "1211": 0.941,
        "1212": 0.989,
        "1213": 1.744,
        "1214": 1.971,
        "1215": 0.635,
        "1216": 0.23,
        "1217": 0.838,
        "1218": 0.725,
        "1219": 1.106,
        "1220": 1.284,
        "1221": 0.632,
        "1222": 1.298,
        "1223": 2.198,
        "1224": 3.204,
        "1225": 1.03,
        "1226": 0.759,
        "1227": 0.876,
        "1253": 106,
        "1258": 1.293,
        "1264": 0.095,
        "1265": 0.82,
        "1266": 0.214,
        "1268": 0.602,
        "1269": 0.088,
        "1270": 0.005,
        "1271": 0.247,
        "1272": 0.265,
        "1275": 0.464,
        "1276": 0.01,
        "1277": 0.064,
        "1278": 0.211,
        "1280": 0.097,
        "1292": 1.133,
        "1293": 0.929
      },
      "scientificName": "Cynoscion spp."
    },
    {
      "id": "175177",
      "name": "hal - tilápia",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.15,
        "1004": 2.65,
        "1005": 0,
        "1008": 128,
        "1051": 71.59,
        "1058": 0,
        "1079": 0,
        "1087": 14,
        "1089": 0.69,
        "1090": 34,
        "1091": 204,
        "1092": 380,
        "1093": 56,
        "1095": 0.41,
        "1098": 0.075,
        "1101": 0.037,
        "1103": 54.4,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.79,
        "1112": 3.7,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.06,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.093,
        "1166": 0.073,
        "1167": 4.745,
        "1170": 0.664,
        "1175": 0.123,
        "1177": 6,
        "1178": 1.86,
        "1180": 51.3,
        "1184": 0,
        "1185": 0.9,
        "1187": 6,
        "1190": 6,
        "1198": 26.3,
        "1210": 0.265,
        "1211": 1.156,
        "1212": 1.22,
        "1213": 2.04,
        "1214": 2.315,
        "1215": 0.766,
        "1216": 0.265,
        "1217": 1.05,
        "1218": 0.87,
        "1219": 1.28,
        "1220": 1.59,
        "1221": 0.585,
        "1222": 1.491,
        "1223": 2.81,
        "1224": 3.92,
        "1225": 1.22,
        "1226": 0.953,
        "1227": 0.961,
        "1253": 57,
        "1258": 0.94,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.085,
        "1265": 0.66,
        "1266": 0.19,
        "1267": 0,
        "1268": 0.765,
        "1269": 0.285,
        "1270": 0.045,
        "1271": 0.035,
        "1272": 0.13,
        "1273": 0,
        "1274": 0,
        "1275": 0.145,
        "1276": 0,
        "1277": 0.045,
        "1278": 0.005,
        "1279": 0,
        "1280": 0.06,
        "1292": 0.955,
        "1293": 0.6,
        "1299": 0.005,
        "1300": 0,
        "1301": 0,
        "1313": 0.015,
        "1323": 0,
        "1325": 0.025,
        "1333": 0,
        "1404": 0.045,
        "2000": 0
      }
    },
    {
      "id": "175148",
      "name": "hal - tokhal",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 5000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 20.7,
        "1004": 5.18,
        "1005": 0,
        "1008": 135,
        "1051": 69.94,
        "1058": 0,
        "1079": 0,
        "1087": 17,
        "1089": 0.9,
        "1090": 45,
        "1091": 271,
        "1092": 364,
        "1093": 69,
        "1095": 0.54,
        "1098": 0.053,
        "1101": 0.03,
        "1103": 16.2,
        "1105": 263,
        "1106": 263,
        "1107": 0,
        "1108": 0,
        "1109": 0.63,
        "1112": 12.9,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.08,
        "1166": 0.09,
        "1167": 10.1,
        "1170": 0.87,
        "1175": 0.23,
        "1177": 17,
        "1178": 2.5,
        "1180": 70,
        "1185": 0.1,
        "1187": 17,
        "1190": 17,
        "1210": 0.232,
        "1211": 0.907,
        "1212": 0.954,
        "1213": 1.682,
        "1214": 1.901,
        "1215": 0.613,
        "1216": 0.222,
        "1217": 0.808,
        "1218": 0.699,
        "1219": 1.066,
        "1220": 1.238,
        "1221": 0.609,
        "1222": 1.252,
        "1223": 2.119,
        "1224": 3.089,
        "1225": 0.993,
        "1226": 0.732,
        "1227": 0.844,
        "1253": 77,
        "1258": 1.173,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.197,
        "1265": 0.878,
        "1266": 0.097,
        "1268": 1.837,
        "1269": 0.087,
        "1270": 0.128,
        "1271": 0.079,
        "1272": 0.119,
        "1275": 0.523,
        "1276": 0.164,
        "1277": 0.069,
        "1278": 0.249,
        "1279": 0.029,
        "1280": 0.058,
        "1292": 2.486,
        "1293": 0.885,
        "2000": 0
      },
      "scientificName": "Acipenser spp."
    },
    {
      "id": "172005",
      "name": "hal - tonhal - Csíkoshasú",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 28.21,
        "1004": 1.29,
        "1005": 0,
        "1008": 132,
        "1051": 62.28,
        "1079": 0,
        "1087": 37,
        "1089": 1.6,
        "1090": 44,
        "1091": 285,
        "1092": 522,
        "1093": 47,
        "1095": 1.05,
        "1098": 0.11,
        "1101": 0.019,
        "1103": 46.8,
        "1105": 18,
        "1106": 18,
        "1162": 1,
        "1165": 0.038,
        "1166": 0.122,
        "1167": 18.756,
        "1170": 0.485,
        "1175": 0.981,
        "1177": 10,
        "1178": 2.19,
        "1187": 10,
        "1190": 10,
        "1210": 0.316,
        "1211": 1.237,
        "1212": 1.3,
        "1213": 2.293,
        "1214": 2.59,
        "1215": 0.835,
        "1216": 0.302,
        "1217": 1.101,
        "1218": 0.952,
        "1219": 1.453,
        "1220": 1.688,
        "1221": 0.83,
        "1222": 1.706,
        "1223": 2.888,
        "1224": 4.21,
        "1225": 1.354,
        "1226": 0.997,
        "1227": 1.151,
        "1253": 60,
        "1258": 0.42,
        "1264": 0.051,
        "1265": 0.298,
        "1266": 0.07,
        "1268": 0.168,
        "1269": 0.02,
        "1271": 0.033,
        "1272": 0.237,
        "1275": 0.046,
        "1276": 0.005,
        "1277": 0.022,
        "1278": 0.091,
        "1279": 0.008,
        "1280": 0.017,
        "1292": 0.243,
        "1293": 0.403
      },
      "scientificName": "Euthynnus pelamis (L.)"
    },
    {
      "id": "173707",
      "name": "hal - tonhal - Kékúszójú",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 5000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 29.91,
        "1004": 6.28,
        "1005": 0,
        "1008": 184,
        "1051": 59.09,
        "1079": 0,
        "1087": 10,
        "1089": 1.31,
        "1090": 64,
        "1091": 326,
        "1092": 323,
        "1093": 50,
        "1095": 0.77,
        "1098": 0.11,
        "1101": 0.02,
        "1103": 46.8,
        "1105": 757,
        "1106": 757,
        "1162": 0,
        "1165": 0.278,
        "1166": 0.306,
        "1167": 10.54,
        "1170": 1.37,
        "1175": 0.525,
        "1177": 2,
        "1178": 10.88,
        "1187": 2,
        "1190": 2,
        "1210": 0.335,
        "1211": 1.311,
        "1212": 1.378,
        "1213": 2.431,
        "1214": 2.747,
        "1215": 0.885,
        "1216": 0.321,
        "1217": 1.168,
        "1218": 1.01,
        "1219": 1.541,
        "1220": 1.79,
        "1221": 0.88,
        "1222": 1.809,
        "1223": 3.062,
        "1224": 4.464,
        "1225": 1.436,
        "1226": 1.057,
        "1227": 1.22,
        "1253": 49,
        "1258": 1.612,
        "1264": 0.178,
        "1265": 1.038,
        "1266": 0.394,
        "1268": 1.185,
        "1269": 0.068,
        "1271": 0.055,
        "1272": 1.141,
        "1275": 0.208,
        "1276": 0.05,
        "1277": 0.355,
        "1278": 0.363,
        "1279": 0.304,
        "1280": 0.16,
        "1292": 2.053,
        "1293": 1.844
      },
      "scientificName": "Thunnus thynnus (L.)"
    },
    {
      "id": "172006",
      "name": "hal - tonhal - Sárgaúszójú",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 29.15,
        "1004": 0.59,
        "1005": 0,
        "1008": 130,
        "1051": 68.98,
        "1058": 0,
        "1079": 0,
        "1087": 4,
        "1089": 0.92,
        "1090": 42,
        "1091": 333,
        "1092": 527,
        "1093": 54,
        "1095": 0.45,
        "1098": 0.043,
        "1101": 0.013,
        "1103": 108.2,
        "1105": 22,
        "1106": 22,
        "1107": 0,
        "1108": 0,
        "1109": 0.29,
        "1112": 2,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.134,
        "1166": 0.137,
        "1167": 22.07,
        "1170": 0.334,
        "1175": 1.038,
        "1177": 2,
        "1178": 2.35,
        "1180": 77.6,
        "1185": 0.1,
        "1187": 2,
        "1190": 2,
        "1210": 0.313,
        "1211": 1.224,
        "1212": 1.287,
        "1213": 2.27,
        "1214": 2.565,
        "1215": 0.827,
        "1216": 0.3,
        "1217": 1.091,
        "1218": 0.943,
        "1219": 1.438,
        "1220": 1.671,
        "1221": 0.822,
        "1222": 1.689,
        "1223": 2.86,
        "1224": 4.168,
        "1225": 1.34,
        "1226": 0.988,
        "1227": 1.14,
        "1253": 47,
        "1257": 0.02,
        "1258": 0.205,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.002,
        "1264": 0.01,
        "1265": 0.127,
        "1266": 0.054,
        "1267": 0.002,
        "1268": 0.099,
        "1269": 0.023,
        "1270": 0.002,
        "1271": 0.018,
        "1272": 0.105,
        "1273": 0.001,
        "1274": 0.001,
        "1275": 0.014,
        "1276": 0,
        "1277": 0.009,
        "1278": 0.015,
        "1279": 0.002,
        "1280": 0.005,
        "1292": 0.138,
        "1293": 0.175,
        "1299": 0.004,
        "1300": 0.005,
        "1301": 0.001,
        "1312": 0.01,
        "1313": 0.002,
        "1323": 0.002,
        "1325": 0.003,
        "1333": 0.002,
        "1411": 0.002,
        "2000": 0
      },
      "scientificName": "Thunnus albacares (Bonnaterre)"
    },
    {
      "id": "172883",
      "name": "marha - alaplé",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.97,
        "1004": 0.09,
        "1005": 1.2,
        "1008": 13,
        "1051": 95.89,
        "1058": 0,
        "1079": 0,
        "1087": 8,
        "1089": 0.27,
        "1090": 7,
        "1091": 31,
        "1092": 185,
        "1093": 198,
        "1095": 0.17,
        "1098": 0.05,
        "1103": 1.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.01,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1,
        "1162": 0,
        "1165": 0.033,
        "1166": 0.091,
        "1167": 0.872,
        "1175": 0.055,
        "1177": 2,
        "1178": 0,
        "1180": 4.8,
        "1185": 0.1,
        "1187": 2,
        "1190": 2,
        "1253": 0,
        "1258": 0.035,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.02,
        "1266": 0.013,
        "1268": 0.039,
        "1269": 0.004,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0.003,
        "1276": 0,
        "1277": 0.001,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.043,
        "1293": 0.005,
        "2000": 0.54
      }
    },
    {
      "id": "169543",
      "name": "marha - bélszín (tenderloin)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 4000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.46,
        "1004": 17.12,
        "1005": 0,
        "1008": 267,
        "1051": 56.04,
        "1058": 0,
        "1079": 0,
        "1087": 19,
        "1089": 1.69,
        "1090": 22,
        "1091": 205,
        "1092": 329,
        "1093": 54,
        "1095": 4.76,
        "1098": 0.079,
        "1099": 22.4,
        "1101": 0.009,
        "1103": 28.6,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.47,
        "1112": 0.3,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1162": 0,
        "1165": 0.072,
        "1166": 0.128,
        "1167": 7.041,
        "1170": 0.522,
        "1175": 0.554,
        "1177": 8,
        "1178": 1.56,
        "1180": 100.8,
        "1185": 1.7,
        "1187": 8,
        "1190": 8,
        "1198": 13.2,
        "1210": 0.174,
        "1211": 1.057,
        "1212": 1.204,
        "1213": 2.105,
        "1214": 2.236,
        "1215": 0.689,
        "1216": 0.341,
        "1217": 1.045,
        "1218": 0.843,
        "1219": 1.313,
        "1220": 1.711,
        "1221": 0.844,
        "1222": 1.608,
        "1223": 2.41,
        "1224": 3.972,
        "1225": 1.611,
        "1226": 1.261,
        "1227": 1.042,
        "1228": 0.269,
        "1253": 97,
        "1258": 6.743,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.043,
        "1263": 0.039,
        "1264": 0.521,
        "1265": 4.071,
        "1266": 2.069,
        "1268": 6.467,
        "1269": 0.443,
        "1270": 0.152,
        "1271": 0.039,
        "1272": 0.001,
        "1275": 0.645,
        "1276": 0,
        "1277": 0.025,
        "1278": 0.003,
        "1279": 0,
        "1280": 0.016,
        "1292": 7.136,
        "1293": 0.654,
        "2000": 0
      }
    },
    {
      "id": "171797",
      "name": "marha - darált (20% zsír)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.75,
        "1004": 17.78,
        "1005": 0,
        "1008": 270,
        "1051": 55.99,
        "1058": 0,
        "1079": 0,
        "1087": 24,
        "1089": 2.48,
        "1090": 20,
        "1091": 194,
        "1092": 304,
        "1093": 75,
        "1095": 6.25,
        "1098": 0.08,
        "1101": 0.011,
        "1103": 21.5,
        "1105": 3,
        "1106": 3,
        "1107": 0,
        "1108": 0,
        "1109": 0.12,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.047,
        "1166": 0.176,
        "1167": 5.098,
        "1170": 0.658,
        "1175": 0.366,
        "1177": 10,
        "1178": 2.73,
        "1180": 80.8,
        "1185": 1.6,
        "1187": 10,
        "1190": 10,
        "1198": 9,
        "1210": 0.131,
        "1211": 0.996,
        "1212": 1.138,
        "1213": 2.007,
        "1214": 2.131,
        "1215": 0.662,
        "1216": 0.265,
        "1217": 1.004,
        "1218": 0.792,
        "1219": 1.264,
        "1220": 1.675,
        "1221": 0.836,
        "1222": 1.612,
        "1223": 2.317,
        "1224": 3.858,
        "1225": 1.747,
        "1226": 1.311,
        "1227": 1.03,
        "1253": 88,
        "1257": 0.771,
        "1258": 6.764,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.012,
        "1264": 0.507,
        "1265": 3.787,
        "1266": 2.104,
        "1267": 0.013,
        "1268": 6.772,
        "1269": 0.398,
        "1270": 0.057,
        "1271": 0.048,
        "1272": 0,
        "1274": 0.142,
        "1275": 0.646,
        "1276": 0,
        "1277": 0.056,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 7.895,
        "1293": 0.517,
        "1299": 0.082,
        "1300": 0.191,
        "1304": 0.771,
        "1321": 0.013,
        "1323": 0.161,
        "1329": 0.771,
        "1404": 0.045,
        "2000": 0
      }
    },
    {
      "id": "168727",
      "name": "marha - hátszín (sirloin)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.96,
        "1004": 14.23,
        "1005": 0,
        "1008": 243,
        "1051": 58.36,
        "1058": 0,
        "1079": 0,
        "1087": 20,
        "1089": 1.73,
        "1090": 22,
        "1091": 209,
        "1092": 336,
        "1093": 56,
        "1095": 4.87,
        "1098": 0.081,
        "1099": 22.4,
        "1101": 0.009,
        "1103": 29.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.44,
        "1112": 0.2,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1162": 0,
        "1165": 0.073,
        "1166": 0.13,
        "1167": 7.176,
        "1170": 0.531,
        "1175": 0.564,
        "1177": 8,
        "1178": 1.59,
        "1180": 102.7,
        "1185": 1.6,
        "1187": 8,
        "1190": 8,
        "1198": 13.5,
        "1210": 0.177,
        "1211": 1.077,
        "1212": 1.227,
        "1213": 2.145,
        "1214": 2.279,
        "1215": 0.702,
        "1216": 0.348,
        "1217": 1.065,
        "1218": 0.859,
        "1219": 1.338,
        "1220": 1.743,
        "1221": 0.86,
        "1222": 1.639,
        "1223": 2.456,
        "1224": 4.047,
        "1225": 1.642,
        "1226": 1.285,
        "1227": 1.062,
        "1228": 0.283,
        "1253": 92,
        "1258": 5.603,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.035,
        "1263": 0.032,
        "1264": 0.433,
        "1265": 3.383,
        "1266": 1.72,
        "1268": 5.374,
        "1269": 0.368,
        "1270": 0.127,
        "1271": 0.032,
        "1272": 0.001,
        "1275": 0.536,
        "1276": 0,
        "1277": 0.021,
        "1278": 0.003,
        "1279": 0,
        "1280": 0.016,
        "1292": 5.93,
        "1293": 0.547,
        "2000": 0
      }
    },
    {
      "id": "169442",
      "name": "marha - lábszár",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 33.68,
        "1004": 6.36,
        "1005": 0,
        "1008": 201,
        "1051": 58.21,
        "1079": 0,
        "1087": 32,
        "1089": 3.86,
        "1090": 30,
        "1091": 263,
        "1092": 447,
        "1093": 64,
        "1095": 10.49,
        "1098": 0.172,
        "1101": 0.02,
        "1103": 30,
        "1105": 0,
        "1106": 0,
        "1162": 0,
        "1165": 0.14,
        "1166": 0.21,
        "1167": 5.89,
        "1170": 0.41,
        "1175": 0.37,
        "1177": 10,
        "1178": 3.79,
        "1187": 10,
        "1190": 10,
        "1210": 0.377,
        "1211": 1.471,
        "1212": 1.514,
        "1213": 2.662,
        "1214": 2.802,
        "1215": 0.862,
        "1216": 0.377,
        "1217": 1.315,
        "1218": 1.132,
        "1219": 1.638,
        "1220": 2.129,
        "1221": 1.153,
        "1222": 2.032,
        "1223": 3.077,
        "1224": 5.06,
        "1225": 1.838,
        "1226": 1.487,
        "1227": 1.288,
        "1253": 78,
        "1258": 2.29,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.01,
        "1264": 0.18,
        "1265": 1.35,
        "1266": 0.61,
        "1268": 2.41,
        "1269": 0.17,
        "1270": 0.01,
        "1271": 0.03,
        "1272": 0,
        "1275": 0.31,
        "1276": 0,
        "1277": 0.01,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 2.86,
        "1293": 0.21
      }
    },
    {
      "id": "168626",
      "name": "marha - máj",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 600,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 29.08,
        "1004": 5.26,
        "1005": 5.13,
        "1008": 191,
        "1051": 58.81,
        "1058": 0,
        "1079": 0,
        "1087": 6,
        "1089": 6.54,
        "1090": 21,
        "1091": 497,
        "1092": 352,
        "1093": 79,
        "1095": 5.3,
        "1098": 14.283,
        "1101": 0.356,
        "1103": 36.1,
        "1105": 9428,
        "1106": 9442,
        "1107": 162,
        "1108": 11,
        "1109": 0.51,
        "1112": 1.2,
        "1120": 11,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.06,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 1.9,
        "1165": 0.194,
        "1166": 3.425,
        "1167": 17.525,
        "1170": 7.11,
        "1175": 1.017,
        "1177": 253,
        "1178": 70.58,
        "1180": 426,
        "1184": 0,
        "1185": 3.3,
        "1187": 253,
        "1190": 253,
        "1198": 5.6,
        "1210": 0.368,
        "1211": 1.215,
        "1212": 1.352,
        "1213": 2.67,
        "1214": 2.247,
        "1215": 0.759,
        "1216": 0.526,
        "1217": 1.515,
        "1218": 1.128,
        "1219": 1.761,
        "1220": 1.735,
        "1221": 0.879,
        "1222": 1.627,
        "1223": 2.694,
        "1224": 3.652,
        "1225": 1.627,
        "1226": 1.343,
        "1227": 1.265,
        "1228": 0.046,
        "1253": 396,
        "1257": 0.365,
        "1258": 2.947,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.038,
        "1265": 0.794,
        "1266": 2.015,
        "1267": 0,
        "1268": 1.016,
        "1269": 0,
        "1270": 0,
        "1271": 0.397,
        "1272": 0,
        "1273": 0.016,
        "1274": 0,
        "1275": 0.083,
        "1276": 0,
        "1277": 0.003,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.124,
        "1293": 1.109,
        "1299": 0.013,
        "1300": 0.071,
        "1313": 0.011,
        "1316": 0.659,
        "1321": 0.025,
        "1323": 0.022,
        "1325": 0,
        "1333": 0,
        "1404": 0.017,
        "2000": 0
      }
    },
    {
      "id": "170598",
      "name": "marha - nyelv",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 19.29,
        "1004": 22.3,
        "1005": 0,
        "1008": 284,
        "1051": 57.87,
        "1058": 0,
        "1079": 0,
        "1087": 5,
        "1089": 2.61,
        "1090": 15,
        "1091": 145,
        "1092": 184,
        "1093": 65,
        "1095": 4.09,
        "1098": 0.148,
        "1101": 0.018,
        "1103": 13.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.3,
        "1112": 0.4,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.03,
        "1127": 0,
        "1128": 0.05,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 1.3,
        "1165": 0.022,
        "1166": 0.294,
        "1167": 3.49,
        "1170": 0.745,
        "1175": 0.155,
        "1177": 7,
        "1178": 3.13,
        "1180": 155,
        "1185": 1.2,
        "1187": 7,
        "1190": 7,
        "1198": 2.8,
        "1253": 132,
        "1257": 0.84,
        "1258": 8.125,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.024,
        "1264": 0.732,
        "1265": 4.643,
        "1266": 2.347,
        "1267": 0,
        "1268": 8.905,
        "1269": 0.526,
        "1270": 0.091,
        "1271": 0.058,
        "1272": 0,
        "1273": 0,
        "1274": 0.192,
        "1275": 0.929,
        "1276": 0,
        "1277": 0.076,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 10.102,
        "1293": 0.746,
        "1299": 0.126,
        "1300": 0.253,
        "1313": 0,
        "1321": 0,
        "1325": 0,
        "1333": 0,
        "1404": 0.071,
        "2000": 0
      }
    },
    {
      "id": "174769",
      "name": "marha - pacal (tripe)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 11.71,
        "1004": 4.05,
        "1005": 1.99,
        "1008": 94,
        "1051": 81.65,
        "1058": 0,
        "1079": 0,
        "1087": 81,
        "1089": 0.66,
        "1090": 15,
        "1091": 66,
        "1092": 42,
        "1093": 68,
        "1095": 1.71,
        "1098": 0,
        "1101": 0.103,
        "1103": 11.8,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.14,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.02,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0,
        "1166": 0.025,
        "1167": 0.461,
        "1170": 0.097,
        "1175": 0,
        "1177": 3,
        "1178": 0.72,
        "1185": 0,
        "1187": 3,
        "1190": 3,
        "1253": 157,
        "1257": 0.2,
        "1258": 1.357,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.074,
        "1265": 0.681,
        "1266": 0.48,
        "1267": 0,
        "1268": 1.477,
        "1269": 0.137,
        "1270": 0.008,
        "1271": 0.057,
        "1272": 0,
        "1273": 0.007,
        "1274": 0.015,
        "1275": 0.091,
        "1276": 0,
        "1277": 0.021,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.604,
        "1293": 0.208,
        "1299": 0.027,
        "1300": 0.088,
        "1313": 0.006,
        "1321": 0,
        "1325": 0,
        "1333": 0,
        "1404": 0.008,
        "2000": 0
      }
    },
    {
      "id": "168667",
      "name": "marha - rostélyos (chuck)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 30.12,
        "1004": 19.22,
        "1005": 0,
        "1008": 302,
        "1051": 50.45,
        "1058": 0,
        "1079": 0,
        "1087": 17,
        "1089": 2.53,
        "1090": 20,
        "1091": 183,
        "1092": 242,
        "1093": 50,
        "1095": 6.98,
        "1098": 0.104,
        "1099": 22.4,
        "1101": 0.01,
        "1103": 28.3,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.53,
        "1112": 0.3,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1162": 0,
        "1165": 0.061,
        "1166": 0.178,
        "1167": 4.273,
        "1170": 0.594,
        "1175": 0.295,
        "1177": 9,
        "1178": 2.22,
        "1180": 114.7,
        "1185": 1.9,
        "1187": 9,
        "1190": 9,
        "1198": 15.1,
        "1210": 0.2,
        "1211": 1.213,
        "1212": 1.382,
        "1213": 2.416,
        "1214": 2.567,
        "1215": 0.791,
        "1216": 0.392,
        "1217": 1.2,
        "1218": 0.968,
        "1219": 1.507,
        "1220": 1.964,
        "1221": 0.969,
        "1222": 1.847,
        "1223": 2.767,
        "1224": 4.56,
        "1225": 1.85,
        "1226": 1.448,
        "1227": 1.197,
        "1228": 0.316,
        "1253": 120,
        "1258": 7.62,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.054,
        "1263": 0.05,
        "1264": 0.609,
        "1265": 4.67,
        "1266": 2.236,
        "1268": 7.442,
        "1269": 0.477,
        "1270": 0.21,
        "1271": 0.023,
        "1272": 0.001,
        "1275": 0.804,
        "1276": 0,
        "1277": 0.031,
        "1278": 0.003,
        "1279": 0,
        "1280": 0.016,
        "1292": 8.276,
        "1293": 0.73,
        "2000": 0
      }
    },
    {
      "id": "168665",
      "name": "marha - szegy (brisket)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.85,
        "1004": 24.5,
        "1005": 0,
        "1008": 331,
        "1051": 49.58,
        "1058": 0,
        "1079": 0,
        "1087": 7,
        "1089": 2.46,
        "1090": 20,
        "1091": 207,
        "1092": 251,
        "1093": 64,
        "1095": 5.77,
        "1098": 0.104,
        "1101": 0.015,
        "1103": 22.8,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.19,
        "1112": 0.4,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.06,
        "1166": 0.2,
        "1167": 3.27,
        "1170": 0.31,
        "1175": 0.26,
        "1177": 7,
        "1178": 2.4,
        "1180": 98.5,
        "1185": 1.9,
        "1187": 7,
        "1190": 7,
        "1210": 0.29,
        "1211": 1.129,
        "1212": 1.162,
        "1213": 2.043,
        "1214": 2.151,
        "1215": 0.662,
        "1216": 0.29,
        "1217": 1.009,
        "1218": 0.869,
        "1219": 1.258,
        "1220": 1.634,
        "1221": 0.885,
        "1222": 1.559,
        "1223": 2.362,
        "1224": 3.884,
        "1225": 1.411,
        "1226": 1.142,
        "1227": 0.989,
        "1253": 93,
        "1258": 9.44,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.06,
        "1263": 0.06,
        "1264": 0.78,
        "1265": 5.87,
        "1266": 2.68,
        "1268": 9.74,
        "1269": 0.58,
        "1270": 0.23,
        "1271": 0.04,
        "1272": 0.001,
        "1275": 1.1,
        "1276": 0,
        "1277": 0.04,
        "1278": 0.003,
        "1279": 0,
        "1280": 0.016,
        "1292": 10.89,
        "1293": 0.85,
        "2000": 0
      }
    },
    {
      "id": "169448",
      "name": "marha - szív",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 600,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 28.48,
        "1004": 4.73,
        "1005": 0.15,
        "1008": 165,
        "1051": 65.67,
        "1058": 0,
        "1079": 0,
        "1087": 5,
        "1089": 6.38,
        "1090": 21,
        "1091": 254,
        "1092": 219,
        "1093": 59,
        "1095": 2.87,
        "1098": 0.559,
        "1101": 0.033,
        "1103": 38.9,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.29,
        "1112": 0.1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.03,
        "1127": 0,
        "1128": 0.03,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.101,
        "1166": 1.21,
        "1167": 6.68,
        "1170": 1.6,
        "1175": 0.245,
        "1177": 5,
        "1178": 10.8,
        "1180": 228.8,
        "1185": 0.5,
        "1187": 5,
        "1190": 5,
        "1198": 4.1,
        "1253": 212,
        "1257": 0.16,
        "1258": 1.404,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.05,
        "1265": 0.61,
        "1266": 0.669,
        "1267": 0.006,
        "1268": 0.936,
        "1269": 0.736,
        "1270": 0.019,
        "1271": 0.219,
        "1272": 0,
        "1273": 0.006,
        "1274": 0.006,
        "1275": 0.059,
        "1276": 0,
        "1277": 0.01,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.011,
        "1293": 0.985,
        "1299": 0.016,
        "1300": 0.047,
        "1313": 0.011,
        "1321": 0.007,
        "1325": 0,
        "1333": 0,
        "1404": 0.012,
        "2000": 0
      }
    },
    {
      "id": "169450",
      "name": "marha - vese",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 27.27,
        "1004": 4.65,
        "1005": 0,
        "1008": 158,
        "1051": 66.88,
        "1058": 0,
        "1079": 0,
        "1087": 19,
        "1089": 5.8,
        "1090": 12,
        "1091": 304,
        "1092": 135,
        "1093": 94,
        "1095": 2.84,
        "1098": 0.564,
        "1101": 0.185,
        "1103": 168,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.08,
        "1112": 1.1,
        "1120": 0,
        "1122": 23,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.03,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.16,
        "1166": 2.97,
        "1167": 3.92,
        "1170": 1.56,
        "1175": 0.391,
        "1177": 83,
        "1178": 24.9,
        "1180": 513.2,
        "1185": 0,
        "1187": 83,
        "1190": 83,
        "1253": 716,
        "1257": 0.27,
        "1258": 1.439,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.02,
        "1265": 0.649,
        "1266": 0.617,
        "1267": 0.023,
        "1268": 0.868,
        "1269": 0.626,
        "1270": 0.022,
        "1271": 0.443,
        "1272": 0,
        "1273": 0.076,
        "1274": 0,
        "1275": 0.069,
        "1276": 0,
        "1277": 0.023,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.96,
        "1293": 1.138,
        "1299": 0.016,
        "1300": 0.038,
        "1313": 0.026,
        "1321": 0.011,
        "1325": 0,
        "1333": 0,
        "1404": 0.011,
        "2000": 0
      }
    },
    {
      "id": "168225",
      "name": "sertés - comb (zsíros részek levágva)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 29.41,
        "1004": 9.44,
        "1005": 0,
        "1008": 211,
        "1051": 60.66,
        "1058": 0,
        "1079": 0,
        "1087": 7,
        "1089": 1.12,
        "1090": 25,
        "1091": 281,
        "1092": 373,
        "1093": 64,
        "1095": 3.26,
        "1098": 0.108,
        "1101": 0.037,
        "1103": 49.9,
        "1105": 3,
        "1106": 3,
        "1107": 0,
        "1108": 0,
        "1109": 0.26,
        "1112": 0.9,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.4,
        "1165": 0.69,
        "1166": 0.349,
        "1167": 4.935,
        "1170": 0.67,
        "1175": 0.45,
        "1177": 12,
        "1178": 0.72,
        "1180": 101.1,
        "1184": 0,
        "1185": 0,
        "1187": 12,
        "1190": 12,
        "1198": 3.9,
        "1210": 0.374,
        "1211": 1.343,
        "1212": 1.377,
        "1213": 2.36,
        "1214": 2.645,
        "1215": 0.779,
        "1216": 0.375,
        "1217": 1.174,
        "1218": 1.025,
        "1219": 1.595,
        "1220": 1.828,
        "1221": 1.175,
        "1222": 1.713,
        "1223": 2.728,
        "1224": 4.604,
        "1225": 1.396,
        "1226": 1.181,
        "1227": 1.215,
        "1253": 94,
        "1258": 3.3,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.02,
        "1263": 0.01,
        "1264": 0.11,
        "1265": 2.08,
        "1266": 1.04,
        "1268": 4.09,
        "1269": 0.77,
        "1270": 0.02,
        "1271": 0.06,
        "1272": 0,
        "1275": 0.3,
        "1276": 0,
        "1277": 0.06,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 4.45,
        "1293": 0.85,
        "2000": 0
      }
    },
    {
      "id": "168223",
      "name": "sertés - comb (zsíros részekkel)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.83,
        "1004": 17.61,
        "1005": 0,
        "1008": 273,
        "1051": 55.04,
        "1058": 0,
        "1079": 0,
        "1087": 14,
        "1089": 1.01,
        "1090": 22,
        "1091": 263,
        "1092": 352,
        "1093": 60,
        "1095": 2.96,
        "1098": 0.1,
        "1101": 0.032,
        "1103": 45.3,
        "1105": 3,
        "1106": 3,
        "1107": 0,
        "1108": 0,
        "1109": 0.22,
        "1112": 0.8,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.3,
        "1165": 0.635,
        "1166": 0.313,
        "1167": 4.574,
        "1170": 0.617,
        "1175": 0.402,
        "1177": 10,
        "1178": 0.68,
        "1180": 92.2,
        "1184": 0,
        "1185": 0,
        "1187": 10,
        "1190": 10,
        "1198": 3.6,
        "1210": 0.324,
        "1211": 1.198,
        "1212": 1.218,
        "1213": 2.122,
        "1214": 2.39,
        "1215": 0.687,
        "1216": 0.333,
        "1217": 1.062,
        "1218": 0.903,
        "1219": 1.437,
        "1220": 1.717,
        "1221": 1.022,
        "1222": 1.585,
        "1223": 2.445,
        "1224": 4.077,
        "1225": 1.493,
        "1226": 1.198,
        "1227": 1.108,
        "1253": 94,
        "1258": 6.47,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.02,
        "1263": 0.01,
        "1264": 0.22,
        "1265": 4.01,
        "1266": 2.11,
        "1268": 7.23,
        "1269": 1.52,
        "1270": 0.05,
        "1271": 0.07,
        "1272": 0,
        "1275": 0.5,
        "1276": 0,
        "1277": 0.12,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 7.88,
        "1293": 1.68,
        "2000": 0
      }
    },
    {
      "id": "169193",
      "name": "sertés - darált (4% zsír)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 30.55,
        "1004": 7.15,
        "1005": 0,
        "1008": 187,
        "1051": 61.03,
        "1058": 0,
        "1079": 0,
        "1087": 19,
        "1089": 1.05,
        "1090": 27,
        "1091": 261,
        "1092": 428,
        "1093": 84,
        "1095": 2.56,
        "1098": 0.041,
        "1101": 0.013,
        "1103": 46.7,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.26,
        "1112": 0.2,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.04,
        "1127": 0,
        "1162": 0,
        "1165": 0.5,
        "1166": 0.484,
        "1167": 11.05,
        "1170": 0.846,
        "1175": 0.717,
        "1177": 0,
        "1178": 0.86,
        "1180": 99.4,
        "1184": 0,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1198": 9.8,
        "1210": 0.394,
        "1211": 1.296,
        "1212": 1.396,
        "1213": 2.437,
        "1214": 2.628,
        "1215": 0.816,
        "1216": 0.353,
        "1217": 1.3,
        "1218": 1.293,
        "1219": 1.537,
        "1220": 1.992,
        "1221": 1.207,
        "1222": 1.8,
        "1223": 2.751,
        "1224": 4.514,
        "1225": 1.707,
        "1226": 1.499,
        "1227": 1.226,
        "1228": 0.286,
        "1253": 78,
        "1257": 0.07,
        "1258": 1.951,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.009,
        "1263": 0.008,
        "1264": 0.063,
        "1265": 1.162,
        "1266": 0.601,
        "1267": 0.013,
        "1268": 2.327,
        "1269": 0.659,
        "1270": 0.026,
        "1271": 0.07,
        "1272": 0.004,
        "1273": 0,
        "1274": 0,
        "1275": 0.145,
        "1277": 0.043,
        "1278": 0.003,
        "1279": 0,
        "1280": 0.01,
        "1292": 2.714,
        "1293": 0.776,
        "1299": 0.013,
        "1300": 0.017,
        "1301": 0,
        "1304": 0.056,
        "1310": 0.014,
        "1313": 0.027,
        "1315": 2.271,
        "1316": 0.645,
        "1317": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0.004,
        "1329": 0.056,
        "1331": 0.014,
        "1333": 0,
        "1404": 0.026,
        "2000": 0
      }
    },
    {
      "id": "169192",
      "name": "sertés - darált (16% zsír)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.69,
        "1004": 20.04,
        "1005": 0.58,
        "1008": 289,
        "1051": 51.35,
        "1058": 0,
        "1079": 0,
        "1087": 20,
        "1089": 1.1,
        "1090": 23,
        "1091": 226,
        "1092": 354,
        "1093": 89,
        "1095": 2.57,
        "1098": 0.04,
        "1101": 0.013,
        "1103": 42.4,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.31,
        "1112": 0.5,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.04,
        "1127": 0,
        "1162": 0,
        "1165": 0.421,
        "1166": 0.486,
        "1167": 9.286,
        "1170": 0.915,
        "1175": 0.613,
        "1177": 1,
        "1178": 1.02,
        "1180": 89.7,
        "1184": 0,
        "1185": 0,
        "1187": 1,
        "1190": 1,
        "1198": 8.5,
        "1210": 0.344,
        "1211": 1.132,
        "1212": 1.22,
        "1213": 2.129,
        "1214": 2.296,
        "1215": 0.713,
        "1216": 0.308,
        "1217": 1.136,
        "1218": 1.13,
        "1219": 1.343,
        "1220": 1.741,
        "1221": 1.055,
        "1222": 1.573,
        "1223": 2.404,
        "1224": 3.944,
        "1225": 1.492,
        "1226": 1.31,
        "1227": 1.071,
        "1228": 0.25,
        "1253": 89,
        "1257": 0.15,
        "1258": 6.631,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.017,
        "1263": 0.016,
        "1264": 0.243,
        "1265": 4.15,
        "1266": 2.072,
        "1267": 0.04,
        "1268": 8.292,
        "1269": 2.214,
        "1270": 0.118,
        "1271": 0.093,
        "1272": 0.006,
        "1273": 0,
        "1274": 0,
        "1275": 0.467,
        "1277": 0.177,
        "1278": 0.005,
        "1279": 0,
        "1280": 0.018,
        "1292": 9.021,
        "1293": 2.549,
        "1299": 0.012,
        "1300": 0.062,
        "1301": 0,
        "1304": 0.118,
        "1310": 0.032,
        "1313": 0.104,
        "1315": 8.174,
        "1316": 2.182,
        "1317": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0.019,
        "1329": 0.118,
        "1331": 0.032,
        "1333": 0,
        "1404": 0.118,
        "2000": 0
      }
    },
    {
      "id": "168232",
      "name": "sertés - karaj (zsíros részek levágva)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 28.57,
        "1004": 9.8,
        "1005": 0,
        "1008": 210,
        "1051": 60.72,
        "1058": 0,
        "1079": 0,
        "1087": 17,
        "1089": 0.91,
        "1090": 29,
        "1091": 253,
        "1092": 438,
        "1093": 64,
        "1095": 2.48,
        "1098": 0.075,
        "1101": 0.009,
        "1103": 48.2,
        "1105": 2,
        "1106": 2,
        "1107": 0,
        "1108": 0,
        "1109": 0.27,
        "1112": 0.9,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.7,
        "1165": 0.923,
        "1166": 0.338,
        "1167": 5.243,
        "1170": 0.729,
        "1175": 0.492,
        "1177": 6,
        "1178": 0.72,
        "1180": 98.2,
        "1184": 0,
        "1185": 0,
        "1187": 6,
        "1190": 6,
        "1198": 3.8,
        "1210": 0.363,
        "1211": 1.305,
        "1212": 1.338,
        "1213": 2.292,
        "1214": 2.569,
        "1215": 0.756,
        "1216": 0.364,
        "1217": 1.14,
        "1218": 0.995,
        "1219": 1.55,
        "1220": 1.776,
        "1221": 1.141,
        "1222": 1.664,
        "1223": 2.65,
        "1224": 4.472,
        "1225": 1.357,
        "1226": 1.148,
        "1227": 1.18,
        "1253": 79,
        "1258": 3.64,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.13,
        "1265": 2.25,
        "1266": 1.18,
        "1268": 4,
        "1269": 0.68,
        "1270": 0.02,
        "1271": 0.04,
        "1272": 0,
        "1275": 0.32,
        "1276": 0,
        "1277": 0.09,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 4.45,
        "1293": 0.77,
        "2000": 0
      }
    },
    {
      "id": "168233",
      "name": "sertés - karaj (zsíros részek levágva)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 28.62,
        "1004": 9.63,
        "1005": 0,
        "1008": 209,
        "1051": 61.02,
        "1058": 0,
        "1079": 0,
        "1087": 18,
        "1089": 1.09,
        "1090": 28,
        "1091": 249,
        "1092": 425,
        "1093": 58,
        "1095": 2.53,
        "1098": 0.059,
        "1101": 0.016,
        "1103": 35.1,
        "1105": 2,
        "1106": 2,
        "1107": 0,
        "1108": 0,
        "1109": 0.2,
        "1112": 0.7,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.05,
        "1127": 0,
        "1128": 0.03,
        "1129": 0,
        "1130": 0.01,
        "1131": 0,
        "1162": 0.6,
        "1165": 1.017,
        "1166": 0.329,
        "1167": 5.893,
        "1170": 0.782,
        "1175": 0.552,
        "1177": 1,
        "1178": 0.73,
        "1180": 98.4,
        "1184": 0,
        "1185": 0,
        "1187": 1,
        "1190": 1,
        "1198": 3.8,
        "1210": 0.364,
        "1211": 1.307,
        "1212": 1.34,
        "1213": 2.297,
        "1214": 2.574,
        "1215": 0.758,
        "1216": 0.365,
        "1217": 1.143,
        "1218": 0.997,
        "1219": 1.553,
        "1220": 1.779,
        "1221": 1.143,
        "1222": 1.668,
        "1223": 2.655,
        "1224": 4.481,
        "1225": 1.359,
        "1226": 1.15,
        "1227": 1.182,
        "1253": 81,
        "1258": 3.51,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.12,
        "1265": 2.17,
        "1266": 1.13,
        "1268": 3.88,
        "1269": 0.66,
        "1270": 0.02,
        "1271": 0.04,
        "1272": 0,
        "1275": 0.31,
        "1276": 0,
        "1277": 0.09,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 4.32,
        "1293": 0.76,
        "2000": 0
      }
    },
    {
      "id": "167820",
      "name": "sertés - karaj (zsíros részekkel)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 27.32,
        "1004": 13.92,
        "1005": 0,
        "1008": 242,
        "1051": 57.87,
        "1058": 0,
        "1079": 0,
        "1087": 19,
        "1089": 0.87,
        "1090": 28,
        "1091": 246,
        "1092": 423,
        "1093": 62,
        "1095": 2.39,
        "1098": 0.073,
        "1101": 0.009,
        "1103": 45.3,
        "1105": 2,
        "1106": 2,
        "1107": 0,
        "1108": 0,
        "1109": 0.29,
        "1112": 1.3,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.6,
        "1165": 0.877,
        "1166": 0.321,
        "1167": 5.037,
        "1170": 0.698,
        "1175": 0.464,
        "1177": 5,
        "1178": 0.7,
        "1180": 93.9,
        "1184": 0,
        "1185": 0,
        "1187": 5,
        "1190": 5,
        "1198": 3.6,
        "1210": 0.338,
        "1211": 1.234,
        "1212": 1.26,
        "1213": 2.177,
        "1214": 2.446,
        "1215": 0.712,
        "1216": 0.344,
        "1217": 1.086,
        "1218": 0.936,
        "1219": 1.473,
        "1220": 1.723,
        "1221": 1.067,
        "1222": 1.603,
        "1223": 2.512,
        "1224": 4.215,
        "1225": 1.409,
        "1226": 1.158,
        "1227": 1.128,
        "1253": 80,
        "1258": 5.23,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.18,
        "1265": 3.21,
        "1266": 1.71,
        "1268": 5.6,
        "1269": 1.07,
        "1270": 0.04,
        "1271": 0.05,
        "1272": 0,
        "1275": 0.42,
        "1276": 0,
        "1277": 0.11,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 6.19,
        "1293": 1.2,
        "2000": 0
      }
    },
    {
      "id": "167821",
      "name": "sertés - karaj (zsíros részekkel)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 27.09,
        "1004": 14.65,
        "1005": 0,
        "1008": 248,
        "1051": 57.51,
        "1058": 0,
        "1079": 0,
        "1087": 19,
        "1089": 0.99,
        "1090": 26,
        "1091": 242,
        "1092": 408,
        "1093": 59,
        "1095": 2.32,
        "1098": 0.056,
        "1101": 0.011,
        "1103": 33.4,
        "1105": 3,
        "1106": 3,
        "1107": 0,
        "1108": 0,
        "1109": 0.19,
        "1112": 1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.6,
        "1165": 0.988,
        "1166": 0.313,
        "1167": 5.572,
        "1170": 0.76,
        "1175": 0.516,
        "1177": 6,
        "1178": 0.71,
        "1180": 93.1,
        "1184": 0,
        "1185": 0,
        "1187": 6,
        "1190": 6,
        "1198": 3.6,
        "1210": 0.341,
        "1211": 1.232,
        "1212": 1.261,
        "1213": 2.168,
        "1214": 2.432,
        "1215": 0.713,
        "1216": 0.344,
        "1217": 1.08,
        "1218": 0.938,
        "1219": 1.466,
        "1220": 1.693,
        "1221": 1.073,
        "1222": 1.582,
        "1223": 2.504,
        "1224": 4.218,
        "1225": 1.327,
        "1226": 1.11,
        "1227": 1.119,
        "1253": 82,
        "1258": 5.37,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.19,
        "1265": 3.31,
        "1266": 1.75,
        "1268": 5.86,
        "1269": 1.07,
        "1270": 0.03,
        "1271": 0.06,
        "1272": 0,
        "1275": 0.46,
        "1276": 0,
        "1277": 0.13,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 6.51,
        "1293": 1.21,
        "2000": 0
      }
    },
    {
      "id": "167846",
      "name": "sertés - lapocka (zsíros részek levágva)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.33,
        "1004": 13.54,
        "1005": 0,
        "1008": 230,
        "1051": 60.64,
        "1058": 0,
        "1079": 0,
        "1087": 18,
        "1089": 1.5,
        "1090": 20,
        "1091": 221,
        "1092": 346,
        "1093": 75,
        "1095": 4.16,
        "1098": 0.124,
        "1101": 0.026,
        "1103": 37.4,
        "1105": 2,
        "1106": 2,
        "1107": 0,
        "1108": 0,
        "1109": 0.25,
        "1112": 1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.6,
        "1165": 0.628,
        "1166": 0.37,
        "1167": 4.26,
        "1170": 0.651,
        "1175": 0.317,
        "1177": 5,
        "1178": 0.86,
        "1180": 87,
        "1185": 0,
        "1187": 5,
        "1190": 5,
        "1198": 3.4,
        "1210": 0.322,
        "1211": 1.157,
        "1212": 1.186,
        "1213": 2.032,
        "1214": 2.278,
        "1215": 0.671,
        "1216": 0.323,
        "1217": 1.011,
        "1218": 0.883,
        "1219": 1.374,
        "1220": 1.575,
        "1221": 1.012,
        "1222": 1.476,
        "1223": 2.35,
        "1224": 3.965,
        "1225": 1.203,
        "1226": 1.018,
        "1227": 1.046,
        "1253": 90,
        "1258": 4.79,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.16,
        "1265": 2.96,
        "1266": 1.56,
        "1268": 5.59,
        "1269": 1.09,
        "1270": 0.04,
        "1271": 0.07,
        "1272": 0,
        "1275": 0.38,
        "1276": 0,
        "1277": 0.14,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 6.17,
        "1293": 1.25,
        "2000": 0
      }
    },
    {
      "id": "167844",
      "name": "sertés - lapocka (zsíros részekkel)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.28,
        "1004": 21.39,
        "1005": 0,
        "1008": 292,
        "1051": 54.8,
        "1058": 0,
        "1079": 0,
        "1087": 24,
        "1089": 1.32,
        "1090": 18,
        "1091": 212,
        "1092": 329,
        "1093": 68,
        "1095": 3.71,
        "1098": 0.113,
        "1101": 0.022,
        "1103": 33.4,
        "1105": 2,
        "1106": 2,
        "1107": 0,
        "1108": 0,
        "1109": 0.19,
        "1112": 1.5,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.5,
        "1165": 0.581,
        "1166": 0.329,
        "1167": 3.991,
        "1170": 0.6,
        "1175": 0.288,
        "1177": 5,
        "1178": 0.8,
        "1180": 80,
        "1184": 0,
        "1185": 0,
        "1187": 5,
        "1190": 5,
        "1198": 3.1,
        "1210": 0.278,
        "1211": 1.036,
        "1212": 1.051,
        "1213": 1.837,
        "1214": 2.071,
        "1215": 0.593,
        "1216": 0.288,
        "1217": 0.921,
        "1218": 0.778,
        "1219": 1.244,
        "1220": 1.498,
        "1221": 0.879,
        "1222": 1.38,
        "1223": 2.114,
        "1224": 3.518,
        "1225": 1.333,
        "1226": 1.06,
        "1227": 0.961,
        "1253": 90,
        "1258": 7.86,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.27,
        "1265": 4.83,
        "1266": 2.59,
        "1268": 8.62,
        "1269": 1.82,
        "1270": 0.07,
        "1271": 0.07,
        "1272": 0,
        "1275": 0.58,
        "1276": 0,
        "1277": 0.19,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 9.47,
        "1293": 2.05,
        "2000": 0
      }
    },
    {
      "id": "167863",
      "name": "sertés - máj",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.02,
        "1004": 4.4,
        "1005": 3.76,
        "1008": 165,
        "1051": 64.32,
        "1079": 0,
        "1087": 10,
        "1089": 17.92,
        "1090": 14,
        "1091": 241,
        "1092": 150,
        "1093": 49,
        "1095": 6.72,
        "1098": 0.634,
        "1101": 0.3,
        "1103": 67.5,
        "1105": 5405,
        "1106": 5405,
        "1162": 23.6,
        "1165": 0.258,
        "1166": 2.196,
        "1167": 8.435,
        "1170": 4.774,
        "1175": 0.57,
        "1177": 163,
        "1178": 18.67,
        "1187": 163,
        "1190": 163,
        "1210": 0.366,
        "1211": 1.107,
        "1212": 1.32,
        "1213": 2.319,
        "1214": 2.007,
        "1215": 0.645,
        "1216": 0.491,
        "1217": 1.274,
        "1218": 0.887,
        "1219": 1.607,
        "1220": 1.603,
        "1221": 0.708,
        "1222": 1.553,
        "1223": 2.356,
        "1224": 3.385,
        "1225": 1.507,
        "1226": 1.395,
        "1227": 1.407,
        "1253": 355,
        "1258": 1.41,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.02,
        "1265": 0.53,
        "1266": 0.84,
        "1268": 0.56,
        "1269": 0.42,
        "1270": 0.04,
        "1271": 0.53,
        "1272": 0.03,
        "1275": 0.03,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0.04,
        "1280": 0.04,
        "1283": 0,
        "1292": 0.63,
        "1293": 1.05
      }
    },
    {
      "id": "168268",
      "name": "sertés - szív",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.6,
        "1004": 5.05,
        "1005": 0.4,
        "1008": 148,
        "1051": 68.08,
        "1079": 0,
        "1087": 7,
        "1089": 5.83,
        "1090": 24,
        "1091": 178,
        "1092": 206,
        "1093": 35,
        "1095": 3.09,
        "1098": 0.508,
        "1101": 0.073,
        "1103": 18.3,
        "1105": 7,
        "1106": 7,
        "1162": 2,
        "1165": 0.555,
        "1166": 1.702,
        "1167": 6.05,
        "1170": 2.47,
        "1175": 0.39,
        "1177": 4,
        "1178": 3.79,
        "1187": 4,
        "1190": 4,
        "1210": 0.272,
        "1211": 1.035,
        "1212": 1.137,
        "1213": 2.13,
        "1214": 1.952,
        "1215": 0.604,
        "1216": 0.423,
        "1217": 1.042,
        "1218": 0.808,
        "1219": 1.25,
        "1220": 1.586,
        "1221": 0.6,
        "1222": 1.514,
        "1223": 2.137,
        "1224": 3.787,
        "1225": 1.284,
        "1226": 1.087,
        "1227": 1.11,
        "1253": 221,
        "1258": 1.34,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.01,
        "1264": 0.1,
        "1265": 0.69,
        "1266": 0.52,
        "1268": 1.05,
        "1269": 0.89,
        "1270": 0.1,
        "1271": 0.31,
        "1272": 0,
        "1275": 0.11,
        "1276": 0,
        "1277": 0.02,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 0,
        "1292": 1.18,
        "1293": 1.3
      }
    },
    {
      "id": "168313",
      "name": "sertés - szűzpecsenye (zsíros részek levágva)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 30.42,
        "1004": 6.33,
        "1005": 0,
        "1008": 187,
        "1051": 62.3,
        "1079": 0,
        "1087": 5,
        "1089": 1.43,
        "1090": 36,
        "1091": 295,
        "1092": 451,
        "1093": 65,
        "1095": 2.95,
        "1098": 0.068,
        "1101": 0.012,
        "1103": 51.6,
        "1105": 2,
        "1106": 2,
        "1162": 1,
        "1165": 0.988,
        "1166": 0.387,
        "1167": 5.135,
        "1170": 0.917,
        "1175": 0.528,
        "1177": 6,
        "1178": 1,
        "1187": 6,
        "1190": 6,
        "1210": 0.386,
        "1211": 1.389,
        "1212": 1.424,
        "1213": 2.441,
        "1214": 2.736,
        "1215": 0.805,
        "1216": 0.388,
        "1217": 1.214,
        "1218": 1.06,
        "1219": 1.65,
        "1220": 1.891,
        "1221": 1.215,
        "1222": 1.772,
        "1223": 2.822,
        "1224": 4.762,
        "1225": 1.444,
        "1226": 1.222,
        "1227": 1.257,
        "1253": 94,
        "1258": 2.24,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.07,
        "1265": 1.37,
        "1266": 0.74,
        "1268": 2.31,
        "1269": 0.49,
        "1270": 0.01,
        "1271": 0.04,
        "1275": 0.19,
        "1277": 0.05,
        "1292": 2.58,
        "1293": 0.56
      }
    },
    {
      "id": "168250",
      "name": "sertés - szűzpecsenye (zsíros részek levágva)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.17,
        "1004": 3.51,
        "1005": 0,
        "1008": 143,
        "1051": 69.45,
        "1058": 0,
        "1079": 0,
        "1087": 6,
        "1089": 1.15,
        "1090": 29,
        "1091": 267,
        "1092": 421,
        "1093": 57,
        "1095": 2.42,
        "1098": 0.111,
        "1101": 0.013,
        "1103": 38.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.08,
        "1112": 0.2,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.01,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0.02,
        "1131": 0,
        "1162": 0,
        "1165": 0.95,
        "1166": 0.387,
        "1167": 7.432,
        "1170": 1.012,
        "1175": 0.739,
        "1177": 0,
        "1178": 0.57,
        "1180": 88.9,
        "1184": 0,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1198": 4.3,
        "1210": 0.275,
        "1211": 1.175,
        "1212": 1.288,
        "1213": 2.229,
        "1214": 2.427,
        "1215": 0.721,
        "1216": 0.302,
        "1217": 1.1,
        "1218": 0.996,
        "1219": 1.367,
        "1220": 1.741,
        "1221": 1.13,
        "1222": 1.536,
        "1223": 2.56,
        "1224": 4.177,
        "1225": 1.179,
        "1226": 1.058,
        "1227": 1.131,
        "1228": 0.067,
        "1253": 73,
        "1257": 0.033,
        "1258": 1.198,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.039,
        "1265": 0.735,
        "1266": 0.411,
        "1267": 0.001,
        "1268": 1.234,
        "1269": 0.423,
        "1270": 0.013,
        "1271": 0.057,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.08,
        "1276": 0,
        "1277": 0.02,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.334,
        "1293": 0.506,
        "1299": 0,
        "1300": 0.011,
        "1304": 0.021,
        "1310": 0.012,
        "1313": 0.013,
        "1315": 1.213,
        "1316": 0.411,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0.021,
        "1331": 0.012,
        "1333": 0,
        "1404": 0.013,
        "2000": 0
      }
    },
    {
      "id": "167904",
      "name": "sertés - szűzpecsenye (zsíros részekkel)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 29.86,
        "1004": 8.11,
        "1005": 0,
        "1008": 201,
        "1051": 61.09,
        "1079": 0,
        "1087": 5,
        "1089": 1.39,
        "1090": 35,
        "1091": 290,
        "1092": 444,
        "1093": 64,
        "1095": 2.89,
        "1098": 0.067,
        "1101": 0.012,
        "1103": 47.7,
        "1105": 2,
        "1106": 2,
        "1162": 1,
        "1165": 0.968,
        "1166": 0.378,
        "1167": 5.054,
        "1170": 0.899,
        "1175": 0.515,
        "1177": 6,
        "1178": 0.98,
        "1187": 6,
        "1190": 6,
        "1210": 0.376,
        "1211": 1.358,
        "1212": 1.39,
        "1213": 2.389,
        "1214": 2.68,
        "1215": 0.786,
        "1216": 0.379,
        "1217": 1.19,
        "1218": 1.034,
        "1219": 1.616,
        "1220": 1.866,
        "1221": 1.182,
        "1222": 1.744,
        "1223": 2.76,
        "1224": 4.648,
        "1225": 1.463,
        "1226": 1.224,
        "1227": 1.233,
        "1253": 94,
        "1258": 2.93,
        "1262": 0.01,
        "1263": 0.01,
        "1264": 0.1,
        "1265": 1.79,
        "1266": 0.97,
        "1268": 3.01,
        "1269": 0.65,
        "1270": 0.02,
        "1271": 0.04,
        "1275": 0.23,
        "1277": 0.06,
        "1292": 3.34,
        "1293": 0.74
      }
    },
    {
      "id": "167905",
      "name": "sertés - szűzpecsenye (zsíros részekkel)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.04,
        "1004": 3.96,
        "1005": 0,
        "1008": 147,
        "1051": 69.11,
        "1058": 0,
        "1079": 0,
        "1087": 6,
        "1089": 1.15,
        "1090": 29,
        "1091": 265,
        "1092": 419,
        "1093": 57,
        "1095": 2.41,
        "1098": 0.111,
        "1101": 0.013,
        "1103": 38,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.08,
        "1112": 0.3,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.02,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0.02,
        "1131": 0,
        "1162": 0,
        "1165": 0.944,
        "1166": 0.385,
        "1167": 7.402,
        "1170": 1.008,
        "1175": 0.735,
        "1177": 0,
        "1178": 0.57,
        "1180": 88.5,
        "1184": 0,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1198": 4.3,
        "1210": 0.274,
        "1211": 1.169,
        "1212": 1.281,
        "1213": 2.219,
        "1214": 2.415,
        "1215": 0.717,
        "1216": 0.3,
        "1217": 1.095,
        "1218": 0.991,
        "1219": 1.361,
        "1220": 1.733,
        "1221": 1.125,
        "1222": 1.529,
        "1223": 2.548,
        "1224": 4.158,
        "1225": 1.173,
        "1226": 1.053,
        "1227": 1.126,
        "1228": 0.067,
        "1253": 73,
        "1257": 0.038,
        "1258": 1.358,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.045,
        "1265": 0.832,
        "1266": 0.465,
        "1267": 0.002,
        "1268": 1.408,
        "1269": 0.48,
        "1270": 0.016,
        "1271": 0.057,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.089,
        "1276": 0,
        "1277": 0.023,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.521,
        "1293": 0.569,
        "1299": 0,
        "1300": 0.013,
        "1304": 0.024,
        "1310": 0.014,
        "1313": 0.015,
        "1315": 1.384,
        "1316": 0.467,
        "1321": 0,
        "1323": 0.001,
        "1325": 0,
        "1329": 0.024,
        "1331": 0.014,
        "1333": 0,
        "1404": 0.016,
        "2000": 0
      }
    },
    {
      "id": "172884",
      "name": "szárnyas - csirke - alaplé",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 150,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 2.52,
        "1004": 1.2,
        "1005": 3.53,
        "1008": 36,
        "1051": 92.15,
        "1058": 0,
        "1079": 0,
        "1087": 3,
        "1089": 0.21,
        "1090": 4,
        "1091": 27,
        "1092": 105,
        "1093": 143,
        "1095": 0.14,
        "1098": 0.054,
        "1103": 2.2,
        "1105": 1,
        "1106": 1,
        "1107": 0,
        "1108": 0,
        "1109": 0.03,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1,
        "1162": 0.2,
        "1165": 0.035,
        "1166": 0.085,
        "1167": 1.584,
        "1175": 0.061,
        "1177": 5,
        "1178": 0,
        "1180": 9.2,
        "1185": 0.2,
        "1187": 5,
        "1190": 5,
        "1253": 3,
        "1258": 0.321,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.008,
        "1265": 0.252,
        "1266": 0.056,
        "1268": 0.484,
        "1269": 0.204,
        "1270": 0.009,
        "1271": 0,
        "1272": 0,
        "1275": 0.089,
        "1276": 0,
        "1277": 0.004,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.582,
        "1293": 0.213,
        "2000": 1.58
      }
    },
    {
      "id": "173626",
      "name": "szárnyas - csirke - comb (bőrös)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 550,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.26,
        "1004": 14.74,
        "1005": 0,
        "1008": 232,
        "1051": 63.11,
        "1058": 0,
        "1079": 0,
        "1087": 11,
        "1089": 1.37,
        "1090": 19,
        "1091": 139,
        "1092": 170,
        "1093": 71,
        "1095": 2.25,
        "1098": 0.07,
        "1101": 0.019,
        "1103": 17.9,
        "1105": 45,
        "1106": 45,
        "1107": 0,
        "1108": 0,
        "1109": 0.27,
        "1112": 0.1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.057,
        "1166": 0.191,
        "1167": 4.894,
        "1170": 0.776,
        "1175": 0.17,
        "1177": 6,
        "1178": 0.19,
        "1180": 54.1,
        "1184": 0,
        "1185": 3.9,
        "1187": 6,
        "1190": 6,
        "1198": 4.6,
        "1210": 0.26,
        "1211": 0.962,
        "1212": 1.164,
        "1213": 1.695,
        "1214": 1.898,
        "1215": 0.62,
        "1216": 0.31,
        "1217": 0.905,
        "1218": 0.751,
        "1219": 1.13,
        "1220": 1.456,
        "1221": 0.685,
        "1222": 1.352,
        "1223": 2.074,
        "1224": 3.405,
        "1225": 1.487,
        "1226": 1.119,
        "1227": 0.82,
        "1253": 84,
        "1258": 4.11,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.03,
        "1264": 0.12,
        "1265": 3,
        "1266": 0.84,
        "1268": 4.83,
        "1269": 2.84,
        "1270": 0.13,
        "1271": 0.12,
        "1272": 0.04,
        "1275": 0.81,
        "1276": 0,
        "1277": 0.14,
        "1278": 0.01,
        "1279": 0,
        "1280": 0.02,
        "1292": 5.84,
        "1293": 3.25,
        "2000": 0
      }
    },
    {
      "id": "173625",
      "name": "szárnyas - csirke - comb (bőrös)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 550,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 23.26,
        "1004": 14.71,
        "1005": 0,
        "1008": 232,
        "1051": 61.96,
        "1058": 0,
        "1079": 0,
        "1087": 9,
        "1089": 1.08,
        "1090": 22,
        "1091": 216,
        "1092": 253,
        "1093": 102,
        "1095": 1.73,
        "1098": 0.063,
        "1101": 0.017,
        "1103": 25.3,
        "1105": 16,
        "1106": 16,
        "1107": 0,
        "1108": 0,
        "1109": 0.19,
        "1112": 0.2,
        "1120": 0,
        "1122": 0,
        "1123": 17,
        "1125": 0,
        "1126": 0.09,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0.06,
        "1131": 0,
        "1162": 0,
        "1165": 0.088,
        "1166": 0.19,
        "1167": 5.789,
        "1170": 1.227,
        "1175": 0.414,
        "1177": 4,
        "1178": 0.44,
        "1180": 67.6,
        "1184": 0,
        "1185": 3.3,
        "1187": 4,
        "1190": 4,
        "1198": 6.9,
        "1210": 0.243,
        "1211": 1.053,
        "1212": 1.052,
        "1213": 1.891,
        "1214": 2.082,
        "1215": 0.63,
        "1216": 0.261,
        "1217": 0.9,
        "1218": 0.832,
        "1219": 1.091,
        "1220": 1.628,
        "1221": 0.666,
        "1222": 1.42,
        "1223": 2.215,
        "1224": 3.673,
        "1225": 1.318,
        "1226": 1.047,
        "1227": 0.957,
        "1253": 133,
        "1257": 0.081,
        "1258": 4.111,
        "1259": 0.001,
        "1260": 0.001,
        "1261": 0.002,
        "1262": 0.002,
        "1263": 0.008,
        "1264": 0.083,
        "1265": 3.181,
        "1266": 0.784,
        "1267": 0.01,
        "1268": 5.223,
        "1269": 2.669,
        "1270": 0.13,
        "1271": 0.097,
        "1272": 0.005,
        "1273": 0.011,
        "1274": 0.03,
        "1275": 0.912,
        "1276": 0.003,
        "1277": 0.074,
        "1278": 0.006,
        "1279": 0.002,
        "1280": 0.01,
        "1292": 6.257,
        "1293": 2.993,
        "1299": 0.011,
        "1300": 0.017,
        "1301": 0.001,
        "1303": 0.007,
        "1304": 0.048,
        "1305": 0,
        "1306": 0.026,
        "1311": 0.017,
        "1312": 0.002,
        "1313": 0.018,
        "1314": 0.905,
        "1315": 5.175,
        "1316": 2.626,
        "1317": 0.002,
        "1321": 0.01,
        "1323": 0.013,
        "1325": 0.032,
        "1329": 0.055,
        "1331": 0.026,
        "1333": 0,
        "1404": 0.12,
        "1405": 0.001,
        "1406": 0.031,
        "1411": 0.023,
        "2000": 0
      }
    },
    {
      "id": "171061",
      "name": "szárnyas - csirke - máj",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.46,
        "1004": 6.51,
        "1005": 0.87,
        "1008": 167,
        "1051": 66.81,
        "1058": 0,
        "1079": 0,
        "1087": 11,
        "1089": 11.63,
        "1090": 25,
        "1091": 405,
        "1092": 263,
        "1093": 76,
        "1095": 3.98,
        "1098": 0.496,
        "1101": 0.359,
        "1103": 82.4,
        "1105": 3978,
        "1106": 3981,
        "1107": 30,
        "1108": 11,
        "1109": 0.82,
        "1112": 0,
        "1120": 11,
        "1122": 21,
        "1123": 83,
        "1125": 0,
        "1126": 0.35,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 27.9,
        "1165": 0.291,
        "1166": 1.993,
        "1167": 11.045,
        "1170": 6.668,
        "1175": 0.755,
        "1177": 578,
        "1178": 16.85,
        "1180": 290,
        "1184": 0,
        "1185": 0,
        "1187": 578,
        "1190": 578,
        "1198": 12.8,
        "1210": 0.248,
        "1211": 1.021,
        "1212": 1.144,
        "1213": 2.128,
        "1214": 1.875,
        "1215": 0.608,
        "1216": 0.383,
        "1217": 1.16,
        "1218": 0.919,
        "1219": 1.405,
        "1220": 1.539,
        "1221": 0.714,
        "1222": 1.398,
        "1223": 2.243,
        "1224": 2.946,
        "1225": 1.195,
        "1226": 1.022,
        "1227": 1.035,
        "1228": 0.043,
        "1253": 563,
        "1257": 0.09,
        "1258": 2.06,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.003,
        "1263": 0,
        "1264": 0.013,
        "1265": 1.107,
        "1266": 0.923,
        "1267": 0,
        "1268": 1.276,
        "1269": 0.719,
        "1270": 0,
        "1271": 0.508,
        "1272": 0,
        "1273": 0.014,
        "1274": 0,
        "1275": 0.12,
        "1276": 0,
        "1277": 0.021,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.416,
        "1293": 1.988,
        "1299": 0,
        "1300": 0,
        "1313": 0.019,
        "1316": 0.719,
        "1321": 0.011,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "1404": 0.012,
        "2000": 0
      }
    },
    {
      "id": "174491",
      "name": "szárnyas - csirke - máj",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.78,
        "1004": 6.43,
        "1005": 1.11,
        "1008": 172,
        "1051": 65.22,
        "1058": 0,
        "1079": 0,
        "1087": 10,
        "1089": 12.88,
        "1090": 27,
        "1091": 442,
        "1092": 315,
        "1093": 92,
        "1095": 4.01,
        "1098": 0.535,
        "1101": 0.375,
        "1103": 88.2,
        "1105": 4293,
        "1106": 4296,
        "1107": 31,
        "1108": 11,
        "1109": 0.77,
        "1120": 11,
        "1122": 25,
        "1123": 0,
        "1125": 0,
        "1126": 0.33,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 2.7,
        "1165": 0.292,
        "1166": 2.313,
        "1167": 13.925,
        "1170": 8.315,
        "1175": 0.84,
        "1177": 560,
        "1178": 21.13,
        "1180": 326.8,
        "1184": 0,
        "1185": 0,
        "1187": 560,
        "1190": 560,
        "1198": 21,
        "1210": 0.261,
        "1211": 1.076,
        "1212": 1.206,
        "1213": 2.243,
        "1214": 1.976,
        "1215": 0.641,
        "1216": 0.404,
        "1217": 1.223,
        "1218": 0.969,
        "1219": 1.481,
        "1220": 1.622,
        "1221": 0.752,
        "1222": 1.473,
        "1223": 2.363,
        "1224": 3.105,
        "1225": 1.26,
        "1226": 1.077,
        "1227": 1.09,
        "1228": 0.043,
        "1253": 564,
        "1257": 0.098,
        "1258": 2.033,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.003,
        "1263": 0.003,
        "1264": 0.014,
        "1265": 1.088,
        "1266": 0.911,
        "1267": 0,
        "1268": 1.246,
        "1269": 0,
        "1270": 0,
        "1271": 0.508,
        "1272": 0,
        "1273": 0.015,
        "1274": 0,
        "1275": 0.12,
        "1276": 0,
        "1277": 0.021,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 1.387,
        "1293": 1.265,
        "1299": 0,
        "1300": 0,
        "1313": 0.018,
        "1316": 0.714,
        "1321": 0.014,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "1404": 0.012,
        "2000": 0
      }
    },
    {
      "id": "171140",
      "name": "szárnyas - csirke - mell (bőrnélkül)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 32.06,
        "1004": 3.24,
        "1005": 0,
        "1008": 157,
        "1051": 65.32,
        "1058": 0,
        "1079": 0,
        "1087": 6,
        "1089": 0.49,
        "1090": 32,
        "1091": 241,
        "1092": 343,
        "1093": 47,
        "1095": 0.96,
        "1098": 0.044,
        "1101": 0.012,
        "1103": 31.9,
        "1105": 10,
        "1106": 10,
        "1107": 0,
        "1108": 0,
        "1109": 0.33,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.07,
        "1127": 0.01,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.098,
        "1166": 0.187,
        "1167": 9.45,
        "1170": 1.585,
        "1175": 0.921,
        "1178": 0.2,
        "1180": 117,
        "1185": 4.3,
        "1198": 10,
        "1210": 0.404,
        "1211": 1.438,
        "1212": 1.573,
        "1213": 2.652,
        "1214": 3.083,
        "1215": 0.834,
        "1216": 0.336,
        "1217": 1.294,
        "1218": 1.155,
        "1219": 1.66,
        "1220": 2.168,
        "1221": 1.195,
        "1222": 1.872,
        "1223": 3.015,
        "1224": 4.749,
        "1225": 1.419,
        "1226": 1.019,
        "1227": 1.222,
        "1253": 116,
        "1257": 0.013,
        "1258": 1.01,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.015,
        "1263": 0.005,
        "1264": 0.019,
        "1265": 0.746,
        "1266": 0.211,
        "1267": 0.002,
        "1268": 1.096,
        "1269": 0.601,
        "1270": 0.026,
        "1271": 0.086,
        "1272": 0.007,
        "1273": 0.005,
        "1274": 0.005,
        "1275": 0.155,
        "1276": 0,
        "1277": 0.018,
        "1278": 0.004,
        "1279": 0,
        "1280": 0.01,
        "1292": 1.275,
        "1293": 0.791,
        "1299": 0.004,
        "1300": 0.004,
        "1301": 0,
        "1303": 0,
        "1304": 0.011,
        "1305": 0,
        "1306": 0.002,
        "1311": 0.001,
        "1312": 0,
        "1313": 0.011,
        "1314": 0.155,
        "1315": 1.085,
        "1316": 0.598,
        "1317": 0,
        "1321": 0,
        "1323": 0.002,
        "1325": 0.022,
        "1329": 0.011,
        "1331": 0.002,
        "1333": 0,
        "1404": 0.026,
        "1405": 0.001,
        "1406": 0.021,
        "1409": 0,
        "1411": 0.023,
        "2000": 0
      }
    },
    {
      "id": "171534",
      "name": "szárnyas - csirke - mell (bőrnélkül)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 30.54,
        "1004": 3.17,
        "1005": 0,
        "1008": 151,
        "1051": 66.14,
        "1058": 0,
        "1079": 0,
        "1087": 5,
        "1089": 0.45,
        "1090": 34,
        "1091": 258,
        "1092": 391,
        "1093": 52,
        "1095": 0.9,
        "1098": 0.042,
        "1101": 0.012,
        "1103": 28.4,
        "1105": 10,
        "1106": 10,
        "1107": 0,
        "1108": 0,
        "1109": 0.54,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.09,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.107,
        "1166": 0.213,
        "1167": 12.133,
        "1170": 1.71,
        "1175": 1.157,
        "1178": 0.21,
        "1180": 111.4,
        "1183": 11.1,
        "1184": 0,
        "1185": 0,
        "1198": 9.5,
        "1210": 0.385,
        "1211": 1.37,
        "1212": 1.498,
        "1213": 2.527,
        "1214": 2.936,
        "1215": 0.794,
        "1216": 0.32,
        "1217": 1.233,
        "1218": 1.1,
        "1219": 1.581,
        "1220": 2.065,
        "1221": 1.138,
        "1222": 1.783,
        "1223": 2.872,
        "1224": 4.524,
        "1225": 1.352,
        "1226": 0.97,
        "1227": 1.164,
        "1253": 104,
        "1257": 0.01,
        "1258": 0.992,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.014,
        "1263": 0.005,
        "1264": 0.019,
        "1265": 0.704,
        "1266": 0.236,
        "1267": 0.002,
        "1268": 1.041,
        "1269": 0.581,
        "1270": 0.024,
        "1271": 0.085,
        "1272": 0.007,
        "1273": 0.004,
        "1274": 0.005,
        "1275": 0.147,
        "1276": 0,
        "1277": 0.017,
        "1278": 0.004,
        "1279": 0,
        "1280": 0.01,
        "1292": 1.212,
        "1293": 0.764,
        "1299": 0.005,
        "1300": 0.004,
        "1301": 0,
        "1303": 0,
        "1304": 0.009,
        "1305": 0,
        "1306": 0.001,
        "1311": 0.001,
        "1312": 0,
        "1313": 0.011,
        "1314": 0.147,
        "1315": 1.031,
        "1316": 0.579,
        "1317": 0,
        "1321": 0,
        "1323": 0.002,
        "1325": 0.02,
        "1329": 0.009,
        "1331": 0.001,
        "1333": 0,
        "1404": 0.024,
        "1405": 0,
        "1406": 0.02,
        "1409": 0,
        "1411": 0.022,
        "2000": 0
      }
    },
    {
      "id": "171059",
      "name": "szárnyas - csirke - szív",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.41,
        "1004": 7.92,
        "1005": 0.1,
        "1008": 185,
        "1051": 64.85,
        "1079": 0,
        "1087": 19,
        "1089": 9.03,
        "1090": 20,
        "1091": 199,
        "1092": 132,
        "1093": 48,
        "1095": 7.3,
        "1098": 0.502,
        "1101": 0.107,
        "1103": 8,
        "1105": 8,
        "1106": 8,
        "1162": 1.8,
        "1165": 0.07,
        "1166": 0.741,
        "1167": 2.803,
        "1170": 2.654,
        "1175": 0.32,
        "1177": 80,
        "1178": 7.29,
        "1187": 80,
        "1190": 80,
        "1210": 0.338,
        "1211": 1.196,
        "1212": 1.415,
        "1213": 2.303,
        "1214": 2.214,
        "1215": 0.638,
        "1216": 0.359,
        "1217": 1.183,
        "1218": 0.946,
        "1219": 1.496,
        "1220": 1.694,
        "1221": 0.693,
        "1222": 1.665,
        "1223": 2.569,
        "1224": 3.921,
        "1225": 1.466,
        "1226": 1.348,
        "1227": 1.065,
        "1253": 242,
        "1258": 2.26,
        "1262": 0,
        "1263": 0,
        "1264": 0.05,
        "1265": 1.23,
        "1266": 0.66,
        "1268": 1.68,
        "1269": 1.62,
        "1270": 0.06,
        "1271": 0.61,
        "1272": 0,
        "1275": 0.33,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 2.01,
        "1293": 2.3
      }
    },
    {
      "id": "171457",
      "name": "szárnyas - csirke - zuza",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 30.39,
        "1004": 2.68,
        "1005": 0,
        "1008": 154,
        "1051": 67.93,
        "1058": 0,
        "1079": 0,
        "1087": 17,
        "1089": 3.19,
        "1090": 3,
        "1091": 189,
        "1092": 179,
        "1093": 56,
        "1095": 4.42,
        "1098": 0.161,
        "1101": 0.074,
        "1103": 41.1,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.2,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.12,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.026,
        "1166": 0.21,
        "1167": 3.12,
        "1170": 0.468,
        "1175": 0.071,
        "1177": 5,
        "1178": 1.04,
        "1180": 104.4,
        "1185": 0,
        "1187": 5,
        "1190": 5,
        "1198": 2.2,
        "1253": 370,
        "1257": 0.13,
        "1258": 0.67,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.408,
        "1266": 0.238,
        "1267": 0.005,
        "1268": 0.443,
        "1269": 0.223,
        "1270": 0.007,
        "1271": 0.104,
        "1272": 0,
        "1273": 0.007,
        "1274": 0,
        "1275": 0.074,
        "1276": 0,
        "1277": 0.011,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.528,
        "1293": 0.353,
        "1299": 0.003,
        "1300": 0.004,
        "1313": 0.019,
        "1321": 0.003,
        "1325": 0.003,
        "1333": 0,
        "1404": 0.004,
        "2000": 0
      }
    },
    {
      "id": "171487",
      "name": "szárnyas - pulyka - máj",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 27,
        "1004": 8.18,
        "1005": 0,
        "1008": 189,
        "1051": 63.99,
        "1058": 0,
        "1079": 0,
        "1087": 19,
        "1089": 1.79,
        "1090": 26,
        "1091": 312,
        "1092": 153,
        "1093": 98,
        "1095": 4.53,
        "1098": 1.046,
        "1101": 0.331,
        "1103": 102.3,
        "1105": 10751,
        "1106": 10751,
        "1107": 0,
        "1108": 0,
        "1109": 0.15,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.02,
        "1126": 0.07,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0.03,
        "1131": 0,
        "1162": 22.6,
        "1165": 0.256,
        "1166": 2.687,
        "1167": 11.09,
        "1170": 4.35,
        "1175": 0.882,
        "1177": 691,
        "1178": 28.17,
        "1180": 220.2,
        "1185": 0,
        "1187": 691,
        "1190": 691,
        "1198": 2.4,
        "1210": 0.294,
        "1211": 0.976,
        "1212": 0.767,
        "1213": 1.937,
        "1214": 2.037,
        "1215": 0.681,
        "1216": 0.314,
        "1217": 0.994,
        "1218": 0.854,
        "1219": 0.95,
        "1220": 1.577,
        "1221": 0.589,
        "1222": 1.486,
        "1223": 2.101,
        "1224": 3.523,
        "1225": 1.458,
        "1226": 1.638,
        "1227": 1.158,
        "1253": 648,
        "1257": 0.058,
        "1258": 2.304,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.006,
        "1263": 0.006,
        "1264": 0.019,
        "1265": 1.037,
        "1266": 1.198,
        "1267": 0.006,
        "1268": 0.952,
        "1269": 1.471,
        "1270": 0.035,
        "1271": 0.489,
        "1272": 0.053,
        "1273": 0.003,
        "1274": 0,
        "1275": 0.053,
        "1276": 0.012,
        "1277": 0.03,
        "1278": 0.016,
        "1279": 0,
        "1280": 0.024,
        "1292": 1.038,
        "1293": 2.167,
        "1299": 0.006,
        "1300": 0.021,
        "1301": 0.001,
        "1303": 0.001,
        "1304": 0.041,
        "1305": 0,
        "1306": 0.015,
        "1311": 0.003,
        "1312": 0,
        "1313": 0.011,
        "1314": 0.052,
        "1315": 0.911,
        "1316": 1.453,
        "1317": 0,
        "1321": 0.002,
        "1323": 0.002,
        "1325": 0.024,
        "1329": 0.042,
        "1331": 0.015,
        "1333": 0,
        "1404": 0.033,
        "1405": 0,
        "1406": 0.024,
        "1411": 0.028,
        "2000": 0
      }
    },
    {
      "id": "171492",
      "name": "szárnyas - pulyka - mell (bőrös)",
      "category": "hús",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 28.71,
        "1004": 7.41,
        "1005": 0,
        "1008": 189,
        "1051": 63.22,
        "1079": 0,
        "1087": 21,
        "1089": 1.4,
        "1090": 27,
        "1091": 210,
        "1092": 288,
        "1093": 63,
        "1095": 2.03,
        "1098": 0.047,
        "1101": 0.02,
        "1103": 29.1,
        "1105": 0,
        "1106": 0,
        "1162": 0,
        "1165": 0.057,
        "1166": 0.131,
        "1167": 6.365,
        "1170": 0.634,
        "1175": 0.48,
        "1177": 6,
        "1178": 0.36,
        "1187": 6,
        "1190": 6,
        "1210": 0.318,
        "1211": 1.257,
        "1212": 1.447,
        "1213": 2.24,
        "1214": 2.626,
        "1215": 0.811,
        "1216": 0.313,
        "1217": 1.126,
        "1218": 1.096,
        "1219": 1.5,
        "1220": 2.02,
        "1221": 0.868,
        "1222": 1.822,
        "1223": 2.771,
        "1224": 4.597,
        "1225": 1.677,
        "1226": 1.313,
        "1227": 1.268,
        "1253": 74,
        "1258": 2.1,
        "1262": 0,
        "1263": 0.01,
        "1264": 0.05,
        "1265": 1.28,
        "1266": 0.5,
        "1268": 1.98,
        "1269": 1.45,
        "1270": 0.08,
        "1271": 0.16,
        "1272": 0.03,
        "1275": 0.4,
        "1277": 0.01,
        "1278": 0,
        "1279": 0.01,
        "1280": 0.03,
        "1292": 2.45,
        "1293": 1.8
      }
    },
    {
      "id": "171485",
      "name": "szárnyas - pulyka - szív",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.88,
        "1004": 7.52,
        "1005": 0,
        "1008": 174,
        "1051": 67.15,
        "1058": 0,
        "1079": 0,
        "1087": 21,
        "1089": 6.96,
        "1090": 28,
        "1091": 241,
        "1092": 203,
        "1093": 140,
        "1095": 4.6,
        "1098": 0.825,
        "1101": 0.121,
        "1103": 56.8,
        "1105": 16,
        "1106": 16,
        "1107": 0,
        "1108": 0,
        "1109": 0.13,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.16,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0.08,
        "1131": 0,
        "1162": 0,
        "1165": 0.236,
        "1166": 1.54,
        "1167": 7.76,
        "1175": 0.608,
        "1177": 8,
        "1178": 13.9,
        "1180": 172.5,
        "1185": 0,
        "1187": 8,
        "1190": 8,
        "1198": 3.1,
        "1210": 0.271,
        "1211": 0.899,
        "1212": 0.707,
        "1213": 1.785,
        "1214": 1.877,
        "1215": 0.628,
        "1216": 0.289,
        "1217": 0.916,
        "1218": 0.787,
        "1219": 0.876,
        "1220": 1.454,
        "1221": 0.543,
        "1222": 1.369,
        "1223": 1.936,
        "1224": 3.246,
        "1225": 1.344,
        "1226": 1.509,
        "1227": 1.067,
        "1253": 359,
        "1257": 0.061,
        "1258": 1.898,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.004,
        "1263": 0.054,
        "1264": 0.064,
        "1265": 1.117,
        "1266": 0.625,
        "1267": 0.007,
        "1268": 1.519,
        "1269": 1.412,
        "1270": 0.05,
        "1271": 0.305,
        "1272": 0.005,
        "1273": 0.003,
        "1274": 0.005,
        "1275": 0.112,
        "1276": 0.009,
        "1277": 0.021,
        "1278": 0.009,
        "1279": 0,
        "1280": 0.007,
        "1292": 1.668,
        "1293": 1.832,
        "1299": 0.009,
        "1300": 0.016,
        "1301": 0,
        "1303": 0.003,
        "1304": 0.043,
        "1305": 0,
        "1306": 0.016,
        "1311": 0.007,
        "1312": 0,
        "1313": 0.009,
        "1314": 0.109,
        "1315": 1.476,
        "1316": 1.39,
        "1317": 0,
        "1321": 0.001,
        "1323": 0.011,
        "1325": 0.008,
        "1329": 0.046,
        "1331": 0.016,
        "1333": 0,
        "1404": 0.049,
        "1405": 0,
        "1406": 0.008,
        "1411": 0.016,
        "2000": 0
      }
    },
    {
      "id": "171483",
      "name": "szárnyas - pulyka - zuza",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.45,
        "1004": 4.64,
        "1005": 0,
        "1008": 155,
        "1051": 69.22,
        "1058": 0,
        "1079": 0,
        "1087": 17,
        "1089": 3.68,
        "1090": 21,
        "1091": 187,
        "1092": 193,
        "1093": 127,
        "1095": 3.92,
        "1098": 0.274,
        "1101": 0.098,
        "1103": 44.1,
        "1105": 11,
        "1106": 11,
        "1107": 0,
        "1108": 0,
        "1109": 0.11,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.07,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0.02,
        "1131": 0,
        "1162": 6.3,
        "1165": 0.057,
        "1166": 0.357,
        "1167": 6.45,
        "1170": 0.525,
        "1175": 0.175,
        "1177": 13,
        "1178": 3.91,
        "1180": 82.2,
        "1185": 0,
        "1187": 13,
        "1190": 13,
        "1198": 1.8,
        "1210": 0.237,
        "1211": 0.785,
        "1212": 0.617,
        "1213": 1.558,
        "1214": 1.639,
        "1215": 0.548,
        "1216": 0.252,
        "1217": 0.799,
        "1218": 0.687,
        "1219": 0.764,
        "1220": 1.269,
        "1221": 0.474,
        "1222": 1.195,
        "1223": 1.69,
        "1224": 2.834,
        "1225": 1.173,
        "1226": 1.317,
        "1227": 0.931,
        "1253": 452,
        "1257": 0.026,
        "1258": 1.059,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.008,
        "1263": 0.02,
        "1264": 0.033,
        "1265": 0.657,
        "1266": 0.317,
        "1267": 0.004,
        "1268": 0.734,
        "1269": 0.559,
        "1270": 0.023,
        "1271": 0.115,
        "1272": 0.008,
        "1273": 0.003,
        "1274": 0.002,
        "1275": 0.056,
        "1276": 0,
        "1277": 0.01,
        "1278": 0.004,
        "1279": 0.003,
        "1280": 0.011,
        "1292": 1.598,
        "1293": 1.359,
        "1299": 0.006,
        "1300": 0.01,
        "1301": 0.001,
        "1303": 0.002,
        "1304": 0.021,
        "1305": 0,
        "1306": 0.004,
        "1311": 0,
        "1312": 0,
        "1313": 0.011,
        "1314": 0.055,
        "1315": 0.713,
        "1316": 0.555,
        "1317": 0.003,
        "1321": 0,
        "1323": 0.002,
        "1325": 0.007,
        "1329": 0.022,
        "1331": 0.004,
        "1333": 0,
        "1404": 0.023,
        "1405": 0,
        "1406": 0.007,
        "1411": 0.032,
        "2000": 0
      }
    },
    {
      "id": "173424",
      "name": "szárnyas - tyúk - tojás (egész)",
      "category": "hús",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 12.58,
        "1004": 10.61,
        "1005": 1.12,
        "1008": 155,
        "1051": 74.62,
        "1058": 0,
        "1079": 0,
        "1087": 50,
        "1089": 1.19,
        "1090": 10,
        "1091": 172,
        "1092": 126,
        "1093": 124,
        "1095": 1.05,
        "1098": 0.013,
        "1099": 4.8,
        "1101": 0.026,
        "1103": 30.8,
        "1105": 148,
        "1106": 149,
        "1107": 11,
        "1108": 0,
        "1109": 1.03,
        "1112": 2.2,
        "1120": 10,
        "1122": 0,
        "1123": 353,
        "1162": 0,
        "1165": 0.066,
        "1166": 0.513,
        "1167": 0.064,
        "1170": 1.398,
        "1175": 0.121,
        "1177": 44,
        "1178": 1.11,
        "1180": 293.8,
        "1185": 0.3,
        "1187": 44,
        "1190": 44,
        "1198": 0.6,
        "1210": 0.153,
        "1211": 0.604,
        "1212": 0.686,
        "1213": 1.075,
        "1214": 0.904,
        "1215": 0.392,
        "1216": 0.292,
        "1217": 0.668,
        "1218": 0.513,
        "1219": 0.767,
        "1220": 0.755,
        "1221": 0.298,
        "1222": 0.7,
        "1223": 1.264,
        "1224": 1.644,
        "1225": 0.423,
        "1226": 0.501,
        "1227": 0.936,
        "1253": 373,
        "1258": 3.267,
        "1259": 0,
        "1260": 0,
        "1261": 0.003,
        "1262": 0.003,
        "1263": 0.003,
        "1264": 0.035,
        "1265": 2.349,
        "1266": 0.828,
        "1268": 3.725,
        "1269": 1.188,
        "1270": 0.035,
        "1271": 0.149,
        "1272": 0.038,
        "1275": 0.31,
        "1276": 0,
        "1277": 0.03,
        "1278": 0.005,
        "1279": 0.003,
        "1280": 0,
        "1292": 4.077,
        "1293": 1.414,
        "2000": 1.12
      }
    },
    {
      "id": "171891",
      "name": "ital - kávé - főzött espresso",
      "category": "ital",
      "state": "cooked",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.12,
        "1004": 0.18,
        "1005": 1.67,
        "1008": 9,
        "1051": 97.8,
        "1058": 0,
        "1079": 0,
        "1087": 2,
        "1089": 0.13,
        "1090": 80,
        "1091": 7,
        "1092": 115,
        "1093": 14,
        "1095": 0.05,
        "1098": 0.05,
        "1101": 0.05,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.01,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.01,
        "1127": 0,
        "1162": 0.2,
        "1165": 0.001,
        "1166": 0.177,
        "1167": 5.207,
        "1170": 0.028,
        "1175": 0.002,
        "1177": 1,
        "1178": 0,
        "1180": 2.6,
        "1185": 0.1,
        "1187": 1,
        "1190": 1,
        "1253": 0,
        "1257": 0,
        "1258": 0.092,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.046,
        "1266": 0,
        "1267": 0,
        "1268": 0,
        "1269": 0.092,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0.092,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1304": 0,
        "1313": 0,
        "1315": 0.015,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 0,
        "2000": 0
      }
    },
    {
      "id": "170174",
      "name": "ital - kókuszvíz",
      "category": "ital",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 1000,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.72,
        "1004": 0.2,
        "1005": 3.71,
        "1008": 19,
        "1051": 94.99,
        "1058": 0,
        "1079": 1.1,
        "1087": 24,
        "1089": 0.29,
        "1090": 25,
        "1091": 20,
        "1092": 250,
        "1093": 105,
        "1095": 0.1,
        "1098": 0.04,
        "1101": 0.142,
        "1103": 1,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 2.4,
        "1165": 0.03,
        "1166": 0.057,
        "1167": 0.08,
        "1170": 0.043,
        "1175": 0.032,
        "1177": 3,
        "1178": 0,
        "1180": 1.1,
        "1185": 0,
        "1187": 3,
        "1190": 3,
        "1210": 0.008,
        "1211": 0.026,
        "1212": 0.028,
        "1213": 0.053,
        "1214": 0.032,
        "1215": 0.013,
        "1216": 0.014,
        "1217": 0.037,
        "1218": 0.022,
        "1219": 0.044,
        "1220": 0.118,
        "1221": 0.017,
        "1222": 0.037,
        "1223": 0.07,
        "1224": 0.165,
        "1225": 0.034,
        "1226": 0.03,
        "1227": 0.037,
        "1253": 0,
        "1258": 0.176,
        "1259": 0,
        "1260": 0.001,
        "1261": 0.014,
        "1262": 0.011,
        "1263": 0.088,
        "1264": 0.035,
        "1265": 0.017,
        "1266": 0.01,
        "1268": 0.008,
        "1269": 0.002,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.008,
        "1293": 0.002,
        "2000": 2.61
      }
    },
    {
      "id": "174156",
      "name": "ital - tea - kamilla (főzött)",
      "category": "ital",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 1000,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 0,
        "1005": 0.2,
        "1008": 1,
        "1051": 99.7,
        "1058": 0,
        "1079": 0,
        "1087": 2,
        "1089": 0.08,
        "1090": 1,
        "1091": 0,
        "1092": 9,
        "1093": 1,
        "1095": 0.04,
        "1098": 0.015,
        "1101": 0.044,
        "1103": 0,
        "1105": 0,
        "1106": 1,
        "1107": 12,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.01,
        "1166": 0.004,
        "1167": 0,
        "1170": 0.011,
        "1175": 0,
        "1177": 1,
        "1178": 0,
        "1180": 0,
        "1185": 0,
        "1187": 1,
        "1190": 1,
        "1253": 0,
        "1257": 0,
        "1258": 0.002,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.002,
        "1266": 0,
        "1268": 0.001,
        "1269": 0.002,
        "1270": 0.003,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.001,
        "1293": 0.005,
        "2000": 0
      }
    },
    {
      "id": "171917",
      "name": "ital - tea - zöld (főzött)",
      "category": "ital",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 1000,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.22,
        "1004": 0,
        "1005": 0,
        "1008": 1,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 99.93,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 0,
        "1089": 0.02,
        "1090": 1,
        "1091": 0,
        "1092": 8,
        "1093": 1,
        "1095": 0.01,
        "1098": 0.004,
        "1101": 0.184,
        "1103": 0,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.007,
        "1166": 0.058,
        "1167": 0.03,
        "1175": 0.005,
        "1177": 0,
        "1178": 0,
        "1180": 0,
        "1185": 0,
        "1187": 0,
        "1190": 0,
        "1253": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1268": 0,
        "1269": 0,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0,
        "2000": 0
      }
    },
    {
      "id": "170591",
      "name": "fenyőmag",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 5000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 13.69,
        "1004": 68.37,
        "1005": 13.08,
        "1008": 673,
        "1009": 1.43,
        "1010": 3.45,
        "1011": 0.07,
        "1012": 0.07,
        "1013": 0,
        "1014": 0,
        "1051": 2.28,
        "1058": 0,
        "1075": 0,
        "1079": 3.7,
        "1087": 16,
        "1089": 5.53,
        "1090": 251,
        "1091": 575,
        "1092": 597,
        "1093": 2,
        "1095": 6.45,
        "1098": 1.324,
        "1101": 8.802,
        "1103": 0.7,
        "1105": 0,
        "1106": 1,
        "1107": 17,
        "1108": 0,
        "1109": 9.33,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 9,
        "1125": 0,
        "1126": 11.15,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0.69,
        "1131": 0,
        "1162": 0.8,
        "1165": 0.364,
        "1166": 0.227,
        "1167": 4.387,
        "1170": 0.313,
        "1175": 0.094,
        "1177": 34,
        "1178": 0,
        "1180": 55.8,
        "1184": 0,
        "1185": 53.9,
        "1187": 34,
        "1190": 34,
        "1198": 0.4,
        "1210": 0.107,
        "1211": 0.37,
        "1212": 0.542,
        "1213": 0.991,
        "1214": 0.54,
        "1215": 0.259,
        "1216": 0.289,
        "1217": 0.524,
        "1218": 0.509,
        "1219": 0.687,
        "1220": 2.413,
        "1221": 0.341,
        "1222": 0.684,
        "1223": 1.303,
        "1224": 2.926,
        "1225": 0.691,
        "1226": 0.673,
        "1227": 0.835,
        "1253": 0,
        "1258": 4.899,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 3.212,
        "1266": 1.39,
        "1267": 0.229,
        "1268": 17.947,
        "1269": 33.15,
        "1270": 0.164,
        "1271": 0,
        "1272": 0,
        "1273": 0.068,
        "1274": 0,
        "1275": 0.017,
        "1276": 0,
        "1277": 0.801,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 0,
        "1286": 20,
        "1288": 132,
        "1292": 18.764,
        "1293": 34.071,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0.404,
        "1321": 0.052,
        "1323": 0,
        "1325": 0.353,
        "1333": 0,
        "1404": 0.112,
        "2000": 3.59
      },
      "scientificName": "Pinus spp."
    },
    {
      "id": "169722",
      "name": "gabona - búzakorpa",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 15.55,
        "1004": 4.25,
        "1005": 64.51,
        "1008": 216,
        "1051": 9.89,
        "1058": 0,
        "1079": 42.8,
        "1087": 73,
        "1089": 10.57,
        "1090": 611,
        "1091": 1013,
        "1092": 1182,
        "1093": 2,
        "1095": 7.27,
        "1098": 0.998,
        "1101": 11.5,
        "1103": 77.6,
        "1105": 0,
        "1106": 0,
        "1107": 6,
        "1108": 0,
        "1109": 1.49,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 240,
        "1162": 0,
        "1165": 0.523,
        "1166": 0.577,
        "1167": 13.578,
        "1170": 2.181,
        "1175": 1.303,
        "1177": 79,
        "1178": 0,
        "1180": 74.4,
        "1185": 1.9,
        "1187": 79,
        "1190": 79,
        "1210": 0.282,
        "1211": 0.5,
        "1212": 0.486,
        "1213": 0.928,
        "1214": 0.6,
        "1215": 0.234,
        "1216": 0.371,
        "1217": 0.595,
        "1218": 0.436,
        "1219": 0.726,
        "1220": 1.087,
        "1221": 0.43,
        "1222": 0.765,
        "1223": 1.13,
        "1224": 2.874,
        "1225": 0.898,
        "1226": 0.882,
        "1227": 0.684,
        "1253": 0,
        "1258": 0.63,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.002,
        "1264": 0.007,
        "1265": 0.556,
        "1266": 0.037,
        "1268": 0.619,
        "1269": 2.039,
        "1270": 0.167,
        "1271": 0.005,
        "1272": 0,
        "1275": 0.017,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.637,
        "1293": 2.212,
        "2000": 0.41
      }
    },
    {
      "id": "169713",
      "name": "gabona - rizskorpa",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 13.35,
        "1004": 20.85,
        "1005": 49.69,
        "1008": 316,
        "1010": 0.5,
        "1011": 0.2,
        "1012": 0.2,
        "1051": 6.13,
        "1058": 0,
        "1079": 21,
        "1087": 57,
        "1089": 18.54,
        "1090": 781,
        "1091": 1677,
        "1092": 1485,
        "1093": 5,
        "1095": 6.04,
        "1098": 0.728,
        "1101": 14.21,
        "1103": 15.6,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 4.92,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 220,
        "1162": 0,
        "1165": 2.753,
        "1166": 0.284,
        "1167": 33.995,
        "1170": 7.39,
        "1175": 4.07,
        "1177": 63,
        "1178": 0,
        "1180": 32.2,
        "1185": 1.9,
        "1187": 63,
        "1190": 63,
        "1210": 0.108,
        "1211": 0.555,
        "1212": 0.568,
        "1213": 1.022,
        "1214": 0.65,
        "1215": 0.306,
        "1216": 0.317,
        "1217": 0.635,
        "1218": 0.411,
        "1219": 0.881,
        "1220": 1.058,
        "1221": 0.355,
        "1222": 0.97,
        "1223": 1.308,
        "1224": 1.854,
        "1225": 0.875,
        "1226": 0.668,
        "1227": 0.662,
        "1253": 0,
        "1258": 4.171,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.019,
        "1264": 0.078,
        "1265": 3.557,
        "1266": 0.373,
        "1268": 7.475,
        "1269": 7.143,
        "1270": 0.316,
        "1271": 0,
        "1272": 0,
        "1275": 0.075,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 7.549,
        "1293": 7.459,
        "2000": 0.9
      }
    },
    {
      "id": "169745",
      "name": "gabona - tönköly",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 14.57,
        "1004": 2.43,
        "1005": 70.19,
        "1008": 338,
        "1009": 53.92,
        "1010": 0.59,
        "1011": 0.84,
        "1012": 0.24,
        "1013": 0,
        "1014": 5.15,
        "1051": 11.02,
        "1075": 0,
        "1079": 10.7,
        "1087": 27,
        "1089": 4.44,
        "1090": 136,
        "1091": 401,
        "1092": 388,
        "1093": 8,
        "1095": 3.28,
        "1098": 0.511,
        "1101": 2.983,
        "1103": 11.7,
        "1105": 0,
        "1106": 0,
        "1107": 5,
        "1108": 0,
        "1109": 0.79,
        "1120": 0,
        "1122": 0,
        "1123": 169,
        "1125": 0.25,
        "1126": 1.71,
        "1127": 0,
        "1128": 0.35,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.364,
        "1166": 0.113,
        "1167": 6.843,
        "1170": 1.068,
        "1175": 0.23,
        "1177": 45,
        "1178": 0,
        "1183": 0,
        "1184": 0,
        "1185": 3.6,
        "1187": 45,
        "1190": 45,
        "1210": 0.132,
        "1211": 0.443,
        "1212": 0.552,
        "1213": 1.07,
        "1214": 0.409,
        "1215": 0.258,
        "1216": 0.33,
        "1217": 0.737,
        "1218": 0.377,
        "1219": 0.681,
        "1220": 0.687,
        "1221": 0.36,
        "1222": 0.534,
        "1223": 0.757,
        "1224": 4.651,
        "1225": 0.602,
        "1226": 1.625,
        "1227": 0.725,
        "1253": 0,
        "1258": 0.406,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.37,
        "1266": 0.024,
        "1267": 0.004,
        "1268": 0.423,
        "1269": 1.193,
        "1270": 0.065,
        "1271": 0,
        "1273": 0.008,
        "1274": 0,
        "1275": 0.003,
        "1277": 0.019,
        "1292": 0.445,
        "1293": 1.258,
        "1299": 0,
        "1300": 0,
        "1313": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "1404": 0.065,
        "2000": 6.82
      },
      "scientificName": "Triticum aestivum L. subsp. spelta"
    },
    {
      "id": "169746",
      "name": "gabona - tönköly",
      "category": "pékáru",
      "state": "cooked",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 5.5,
        "1004": 0.85,
        "1005": 26.44,
        "1008": 127,
        "1009": 19.57,
        "1051": 66.56,
        "1079": 3.9,
        "1087": 10,
        "1089": 1.67,
        "1090": 49,
        "1091": 150,
        "1092": 143,
        "1093": 5,
        "1095": 1.25,
        "1098": 0.215,
        "1101": 1.091,
        "1103": 4,
        "1105": 0,
        "1106": 0,
        "1109": 0.26,
        "1125": 0.08,
        "1126": 0.55,
        "1127": 0,
        "1128": 0.11,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.103,
        "1166": 0.03,
        "1167": 2.57,
        "1175": 0.08,
        "1177": 13,
        "1178": 0,
        "1187": 13,
        "1190": 13,
        "1253": 0
      },
      "scientificName": "Triticum aestivum L. subsp. spelta"
    },
    {
      "id": "169705",
      "name": "gabona - zab - pehely",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 16.89,
        "1004": 6.9,
        "1005": 66.27,
        "1008": 389,
        "1051": 8.22,
        "1079": 10.6,
        "1087": 54,
        "1089": 4.72,
        "1090": 177,
        "1091": 523,
        "1092": 429,
        "1093": 2,
        "1095": 3.97,
        "1098": 0.626,
        "1101": 4.916,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 0,
        "1165": 0.763,
        "1166": 0.139,
        "1167": 0.961,
        "1170": 1.349,
        "1175": 0.119,
        "1177": 56,
        "1178": 0,
        "1187": 56,
        "1190": 56,
        "1210": 0.234,
        "1211": 0.575,
        "1212": 0.694,
        "1213": 1.284,
        "1214": 0.701,
        "1215": 0.312,
        "1216": 0.408,
        "1217": 0.895,
        "1218": 0.573,
        "1219": 0.937,
        "1220": 1.192,
        "1221": 0.405,
        "1222": 0.881,
        "1223": 1.448,
        "1224": 3.712,
        "1225": 0.841,
        "1226": 0.934,
        "1227": 0.75,
        "1253": 0,
        "1258": 1.217,
        "1263": 0.024,
        "1264": 0.015,
        "1265": 1.034,
        "1266": 0.065,
        "1268": 2.165,
        "1269": 2.424,
        "1270": 0.111,
        "1275": 0.013,
        "1292": 2.178,
        "1293": 2.535
      },
      "scientificName": "Avena sativa L."
    },
    {
      "id": "168872",
      "name": "gabona - zabkorpa",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 17.3,
        "1004": 7.03,
        "1005": 66.22,
        "1008": 246,
        "1051": 6.55,
        "1058": 0,
        "1079": 15.4,
        "1087": 58,
        "1089": 5.41,
        "1090": 235,
        "1091": 734,
        "1092": 566,
        "1093": 4,
        "1095": 3.11,
        "1098": 0.403,
        "1101": 5.63,
        "1103": 45.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 1.01,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 180,
        "1125": 0.08,
        "1126": 0,
        "1127": 0.1,
        "1128": 2.21,
        "1129": 0.08,
        "1130": 0,
        "1162": 0,
        "1165": 1.17,
        "1166": 0.22,
        "1167": 0.934,
        "1170": 1.494,
        "1175": 0.165,
        "1177": 52,
        "1178": 0,
        "1180": 32.2,
        "1185": 3.2,
        "1187": 52,
        "1190": 52,
        "1198": 19.6,
        "1210": 0.335,
        "1211": 0.502,
        "1212": 0.668,
        "1213": 1.374,
        "1214": 0.76,
        "1215": 0.335,
        "1216": 0.576,
        "1217": 0.908,
        "1218": 0.668,
        "1219": 0.964,
        "1220": 1.279,
        "1221": 0.41,
        "1222": 0.872,
        "1223": 1.576,
        "1224": 3.748,
        "1225": 0.947,
        "1226": 0.982,
        "1227": 0.89,
        "1253": 0,
        "1258": 1.328,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.026,
        "1264": 0.016,
        "1265": 1.128,
        "1266": 0.071,
        "1268": 2.362,
        "1269": 2.645,
        "1270": 0.121,
        "1271": 0,
        "1272": 0,
        "1275": 0.014,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 2.376,
        "1293": 2.766,
        "2000": 1.45
      }
    },
    {
      "id": "168873",
      "name": "gabona - zabkorpa",
      "category": "pékáru",
      "state": "cooked",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 3.21,
        "1004": 0.86,
        "1005": 11.44,
        "1008": 40,
        "1051": 84,
        "1079": 2.6,
        "1087": 10,
        "1089": 0.88,
        "1090": 40,
        "1091": 119,
        "1092": 92,
        "1093": 1,
        "1095": 0.53,
        "1098": 0.066,
        "1101": 0.964,
        "1103": 7.7,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 0,
        "1165": 0.16,
        "1166": 0.034,
        "1167": 0.144,
        "1170": 0.217,
        "1175": 0.025,
        "1177": 6,
        "1178": 0,
        "1187": 6,
        "1190": 6,
        "1210": 0.057,
        "1211": 0.086,
        "1212": 0.114,
        "1213": 0.235,
        "1214": 0.13,
        "1215": 0.057,
        "1216": 0.099,
        "1217": 0.155,
        "1218": 0.114,
        "1219": 0.165,
        "1220": 0.219,
        "1221": 0.07,
        "1222": 0.149,
        "1223": 0.27,
        "1224": 0.642,
        "1225": 0.162,
        "1226": 0.168,
        "1227": 0.152,
        "1253": 0,
        "1258": 0.163,
        "1263": 0.003,
        "1264": 0.002,
        "1265": 0.138,
        "1266": 0.009,
        "1268": 0.29,
        "1269": 0.324,
        "1270": 0.015,
        "1275": 0.002,
        "1292": 0.291,
        "1293": 0.339
      }
    },
    {
      "id": "173032",
      "name": "goji bogyó - szárított",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 14.26,
        "1004": 0.39,
        "1005": 77.06,
        "1008": 349,
        "1051": 7.5,
        "1079": 13,
        "1087": 190,
        "1089": 6.8,
        "1093": 298,
        "1104": 26822,
        "1162": 48.4,
        "1211": 0.358,
        "1212": 0.261,
        "1213": 0.456,
        "1214": 0.233,
        "1215": 0.087,
        "1216": 0.144,
        "1217": 0.271,
        "1218": 0.222,
        "1219": 0.316,
        "1220": 0.722,
        "1221": 0.157,
        "1222": 0.698,
        "1223": 1.711,
        "1224": 1.431,
        "1225": 0.304,
        "1226": 1,
        "1227": 0.498,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "2000": 45.61
      },
      "scientificName": "Lycium barbarum L."
    },
    {
      "id": "170148",
      "name": "kender - mag",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 31.56,
        "1004": 48.75,
        "1005": 8.67,
        "1008": 553,
        "1010": 0.85,
        "1011": 0.2,
        "1012": 0.31,
        "1013": 0.07,
        "1014": 0.07,
        "1051": 4.96,
        "1079": 4,
        "1087": 70,
        "1089": 7.95,
        "1090": 700,
        "1091": 1650,
        "1092": 1200,
        "1093": 5,
        "1095": 9.9,
        "1098": 1.6,
        "1101": 7.6,
        "1106": 1,
        "1107": 7,
        "1109": 0.8,
        "1162": 0.5,
        "1165": 1.275,
        "1166": 0.285,
        "1167": 9.2,
        "1175": 0.6,
        "1177": 110,
        "1187": 110,
        "1190": 110,
        "1210": 0.369,
        "1211": 1.269,
        "1212": 1.286,
        "1213": 2.163,
        "1214": 1.276,
        "1215": 0.933,
        "1216": 0.672,
        "1217": 1.447,
        "1218": 1.263,
        "1219": 1.777,
        "1220": 4.55,
        "1221": 0.969,
        "1222": 1.528,
        "1223": 3.662,
        "1224": 6.269,
        "1225": 1.611,
        "1226": 1.597,
        "1227": 1.713,
        "1253": 0,
        "1257": 0,
        "1258": 4.6,
        "1265": 2.866,
        "1266": 1.244,
        "1267": 0.312,
        "1268": 5.276,
        "1269": 27.459,
        "1270": 10.024,
        "1273": 0.121,
        "1276": 0.617,
        "1277": 0.124,
        "1292": 5.4,
        "1293": 38.1,
        "1301": 0.056,
        "1311": 0.202,
        "1315": 5.023,
        "1316": 27.358,
        "1321": 1.34,
        "1404": 8.684,
        "2000": 1.5
      },
      "scientificName": "Cannabis sativa L."
    },
    {
      "id": "169414",
      "name": "lenmag",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 18.29,
        "1004": 42.16,
        "1005": 28.88,
        "1008": 534,
        "1010": 1.15,
        "1011": 0.4,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 6.96,
        "1058": 0,
        "1075": 0,
        "1079": 27.3,
        "1087": 255,
        "1089": 5.73,
        "1090": 392,
        "1091": 642,
        "1092": 813,
        "1093": 30,
        "1095": 4.34,
        "1098": 1.22,
        "1101": 2.482,
        "1103": 25.4,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.31,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 651,
        "1125": 0,
        "1126": 19.95,
        "1127": 0.35,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.6,
        "1165": 1.644,
        "1166": 0.161,
        "1167": 3.08,
        "1170": 0.985,
        "1175": 0.473,
        "1177": 87,
        "1178": 0,
        "1180": 78.7,
        "1184": 0,
        "1185": 4.3,
        "1187": 87,
        "1190": 87,
        "1198": 3.1,
        "1210": 0.297,
        "1211": 0.766,
        "1212": 0.896,
        "1213": 1.235,
        "1214": 0.862,
        "1215": 0.37,
        "1216": 0.34,
        "1217": 0.957,
        "1218": 0.493,
        "1219": 1.072,
        "1220": 1.925,
        "1221": 0.472,
        "1222": 0.925,
        "1223": 2.046,
        "1224": 4.039,
        "1225": 1.248,
        "1226": 0.806,
        "1227": 0.97,
        "1228": 0.175,
        "1253": 0,
        "1258": 3.663,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.008,
        "1265": 2.165,
        "1266": 1.33,
        "1267": 0.052,
        "1268": 7.359,
        "1269": 5.903,
        "1270": 22.813,
        "1271": 0,
        "1272": 0,
        "1273": 0.052,
        "1275": 0.024,
        "1276": 0,
        "1277": 0.067,
        "1278": 0,
        "1279": 0.013,
        "1280": 0,
        "1285": 11,
        "1286": 45,
        "1288": 90,
        "1292": 7.527,
        "1293": 28.73,
        "1299": 0.005,
        "1300": 0.018,
        "1301": 0.031,
        "1312": 0.064,
        "1313": 0.007,
        "2000": 1.55
      },
      "scientificName": "Linum usitatissimum"
    },
    {
      "id": "170178",
      "name": "makadámdió",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 7.91,
        "1004": 75.77,
        "1005": 13.82,
        "1008": 718,
        "1009": 1.05,
        "1010": 4.43,
        "1011": 0.07,
        "1012": 0.07,
        "1013": 0,
        "1014": 0,
        "1051": 1.36,
        "1058": 0,
        "1079": 8.6,
        "1087": 85,
        "1089": 3.69,
        "1090": 130,
        "1091": 188,
        "1092": 368,
        "1093": 5,
        "1095": 1.3,
        "1098": 0.756,
        "1101": 4.131,
        "1103": 3.6,
        "1105": 0,
        "1106": 0,
        "1109": 0.54,
        "1110": 0,
        "1114": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1162": 1.2,
        "1165": 1.195,
        "1166": 0.162,
        "1167": 2.473,
        "1170": 0.758,
        "1175": 0.275,
        "1177": 11,
        "1178": 0,
        "1187": 11,
        "1190": 11,
        "1210": 0.067,
        "1211": 0.37,
        "1212": 0.314,
        "1213": 0.602,
        "1214": 0.018,
        "1215": 0.023,
        "1216": 0.006,
        "1217": 0.665,
        "1218": 0.511,
        "1219": 0.363,
        "1220": 1.402,
        "1221": 0.195,
        "1222": 0.388,
        "1223": 1.099,
        "1224": 2.267,
        "1225": 0.454,
        "1226": 0.468,
        "1227": 0.419,
        "1253": 0,
        "1258": 12.061,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.076,
        "1264": 0.659,
        "1265": 6.036,
        "1266": 2.329,
        "1267": 1.94,
        "1268": 43.755,
        "1269": 1.296,
        "1270": 0.206,
        "1271": 0,
        "1272": 0,
        "1273": 0.616,
        "1274": 0,
        "1275": 12.981,
        "1276": 0,
        "1277": 1.89,
        "1278": 0,
        "1279": 0.233,
        "1280": 0,
        "1283": 116,
        "1285": 0,
        "1286": 8,
        "1288": 108,
        "1292": 58.877,
        "1293": 1.502,
        "1299": 0,
        "1300": 0.124,
        "1301": 0.281,
        "1312": 0.018,
        "1313": 0,
        "1325": 0,
        "1332": 0,
        "2000": 4.57
      },
      "scientificName": "Macadamia integrifolia, M. tetraphylla"
    },
    {
      "id": "170567",
      "name": "mandula",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 21.15,
        "1004": 49.93,
        "1005": 21.55,
        "1008": 579,
        "1009": 0.72,
        "1010": 3.95,
        "1011": 0.17,
        "1012": 0.11,
        "1013": 0,
        "1014": 0.04,
        "1051": 4.41,
        "1058": 0,
        "1075": 0.07,
        "1079": 12.5,
        "1087": 269,
        "1089": 3.71,
        "1090": 270,
        "1091": 481,
        "1092": 733,
        "1093": 1,
        "1095": 3.12,
        "1098": 1.031,
        "1101": 2.179,
        "1103": 4.1,
        "1105": 0,
        "1106": 0,
        "1107": 1,
        "1108": 0,
        "1109": 25.63,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1,
        "1125": 0.23,
        "1126": 0.64,
        "1127": 0.07,
        "1162": 0,
        "1165": 0.205,
        "1166": 1.138,
        "1167": 3.618,
        "1170": 0.471,
        "1175": 0.137,
        "1177": 44,
        "1178": 0,
        "1180": 52.1,
        "1184": 0,
        "1185": 0,
        "1187": 44,
        "1190": 44,
        "1198": 0.5,
        "1210": 0.211,
        "1211": 0.601,
        "1212": 0.751,
        "1213": 1.473,
        "1214": 0.568,
        "1215": 0.157,
        "1216": 0.215,
        "1217": 1.132,
        "1218": 0.45,
        "1219": 0.855,
        "1220": 2.465,
        "1221": 0.539,
        "1222": 0.999,
        "1223": 2.639,
        "1224": 6.206,
        "1225": 1.429,
        "1226": 0.969,
        "1227": 0.912,
        "1253": 0,
        "1257": 0.015,
        "1258": 3.802,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.003,
        "1265": 3.083,
        "1266": 0.704,
        "1267": 0.007,
        "1268": 31.294,
        "1269": 12.324,
        "1270": 0.003,
        "1271": 0,
        "1272": 0,
        "1273": 0.001,
        "1274": 0,
        "1275": 0.239,
        "1276": 0,
        "1277": 0.005,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 4,
        "1286": 5,
        "1288": 130,
        "1292": 31.551,
        "1293": 12.329,
        "1299": 0,
        "1300": 0.004,
        "1301": 0,
        "1303": 0.012,
        "1304": 0,
        "1306": 0.003,
        "1311": 0.002,
        "1312": 0,
        "1313": 0.002,
        "1314": 0.227,
        "1315": 31.294,
        "1316": 12.32,
        "1321": 0,
        "1323": 0.013,
        "1325": 0,
        "1329": 0.012,
        "1331": 0.003,
        "1332": 0,
        "1333": 0,
        "1404": 0.003,
        "2000": 4.35
      },
      "scientificName": "Prunus dulcis"
    },
    {
      "id": "168166",
      "name": "mazsola - magnélküli",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.52,
        "1004": 0.54,
        "1005": 78.47,
        "1008": 296,
        "1051": 16.57,
        "1079": 6.8,
        "1087": 28,
        "1089": 2.59,
        "1090": 30,
        "1091": 75,
        "1092": 825,
        "1093": 28,
        "1095": 0.18,
        "1098": 0.302,
        "1101": 0.267,
        "1103": 0.6,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 5.4,
        "1165": 0.112,
        "1166": 0.182,
        "1167": 1.114,
        "1170": 0.045,
        "1175": 0.188,
        "1177": 3,
        "1178": 0,
        "1187": 3,
        "1190": 3,
        "1253": 0,
        "1257": 0,
        "1258": 0.178,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.004,
        "1265": 0.153,
        "1266": 0.021,
        "1268": 0.022,
        "1269": 0.122,
        "1270": 0.037,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.022,
        "1293": 0.159
      },
      "scientificName": "Vitis vinifera"
    },
    {
      "id": "172434",
      "name": "mogyoró - földi - héjban - Virginia",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 25.19,
        "1004": 48.75,
        "1005": 16.54,
        "1008": 563,
        "1051": 6.91,
        "1058": 0,
        "1079": 8.5,
        "1087": 89,
        "1089": 2.55,
        "1090": 171,
        "1091": 380,
        "1092": 690,
        "1093": 10,
        "1095": 4.43,
        "1098": 1.112,
        "1101": 1.696,
        "1103": 7.1,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 6.56,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.653,
        "1166": 0.131,
        "1167": 12.375,
        "1170": 1.759,
        "1175": 0.346,
        "1177": 239,
        "1178": 0,
        "1185": 0,
        "1187": 239,
        "1190": 239,
        "1210": 0.245,
        "1211": 0.863,
        "1212": 0.886,
        "1213": 1.633,
        "1214": 0.904,
        "1215": 0.309,
        "1216": 0.323,
        "1217": 1.306,
        "1218": 1.024,
        "1219": 1.057,
        "1220": 3.013,
        "1221": 0.637,
        "1222": 1.001,
        "1223": 3.073,
        "1224": 5.265,
        "1225": 1.518,
        "1226": 1.112,
        "1227": 1.241,
        "1253": 0,
        "1257": 0,
        "1258": 6.434,
        "1259": 0,
        "1260": 0,
        "1261": 0.039,
        "1262": 0.039,
        "1263": 0.039,
        "1264": 0.013,
        "1265": 4.963,
        "1266": 1.267,
        "1268": 24.692,
        "1269": 14.654,
        "1270": 0.019,
        "1271": 0.036,
        "1272": 0,
        "1275": 0.053,
        "1276": 0,
        "1277": 0.544,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 25.58,
        "1293": 14.877,
        "2000": 3.95
      },
      "scientificName": "Arachis hypogaea"
    },
    {
      "id": "174263",
      "name": "mogyoró - földi - magozott - Spanish",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.15,
        "1004": 49.6,
        "1005": 15.83,
        "1008": 570,
        "1051": 6.39,
        "1058": 0,
        "1079": 9.5,
        "1087": 106,
        "1089": 3.91,
        "1090": 188,
        "1091": 388,
        "1092": 744,
        "1093": 22,
        "1095": 2.12,
        "1098": 0.9,
        "1101": 2.64,
        "1103": 7.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.675,
        "1166": 0.135,
        "1167": 15.925,
        "1170": 1.769,
        "1175": 0.348,
        "1177": 240,
        "1178": 0,
        "1185": 0,
        "1187": 240,
        "1190": 240,
        "1210": 0.254,
        "1211": 0.896,
        "1212": 0.92,
        "1213": 1.696,
        "1214": 0.939,
        "1215": 0.321,
        "1216": 0.335,
        "1217": 1.356,
        "1218": 1.063,
        "1219": 1.097,
        "1220": 3.128,
        "1221": 0.661,
        "1222": 1.039,
        "1223": 3.19,
        "1224": 5.465,
        "1225": 1.576,
        "1226": 1.154,
        "1227": 1.289,
        "1253": 0,
        "1257": 0,
        "1258": 7.098,
        "1259": 0,
        "1260": 0,
        "1261": 0.036,
        "1262": 0.036,
        "1263": 0.036,
        "1264": 0.028,
        "1265": 5.674,
        "1266": 1.288,
        "1268": 21.757,
        "1269": 17.192,
        "1270": 0.01,
        "1271": 0.036,
        "1272": 0,
        "1275": 0.045,
        "1276": 0,
        "1277": 0.523,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 22.325,
        "1293": 17.238
      },
      "scientificName": "Arachis hypogaea"
    },
    {
      "id": "170581",
      "name": "mogyoró török",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 14.95,
        "1004": 60.75,
        "1005": 16.7,
        "1008": 628,
        "1009": 0.48,
        "1010": 4.2,
        "1011": 0.07,
        "1012": 0.07,
        "1013": 0,
        "1014": 0,
        "1051": 5.31,
        "1058": 0,
        "1079": 9.7,
        "1087": 114,
        "1089": 4.7,
        "1090": 163,
        "1091": 290,
        "1092": 680,
        "1093": 0,
        "1095": 2.45,
        "1098": 1.725,
        "1101": 6.175,
        "1103": 2.4,
        "1105": 0,
        "1106": 1,
        "1107": 11,
        "1108": 3,
        "1109": 15.03,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 92,
        "1125": 0.33,
        "1126": 0,
        "1127": 0,
        "1162": 6.3,
        "1165": 0.643,
        "1166": 0.113,
        "1167": 1.8,
        "1170": 0.918,
        "1175": 0.563,
        "1177": 113,
        "1178": 0,
        "1180": 45.6,
        "1184": 0,
        "1185": 14.2,
        "1187": 113,
        "1190": 113,
        "1198": 0.4,
        "1210": 0.193,
        "1211": 0.497,
        "1212": 0.545,
        "1213": 1.063,
        "1214": 0.42,
        "1215": 0.221,
        "1216": 0.277,
        "1217": 0.663,
        "1218": 0.362,
        "1219": 0.701,
        "1220": 2.211,
        "1221": 0.432,
        "1222": 0.73,
        "1223": 1.679,
        "1224": 3.71,
        "1225": 0.724,
        "1226": 0.561,
        "1227": 0.735,
        "1253": 0,
        "1258": 4.464,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 3.097,
        "1266": 1.265,
        "1267": 0.102,
        "1268": 45.405,
        "1269": 7.833,
        "1270": 0.087,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.116,
        "1276": 0,
        "1277": 0.131,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 1,
        "1286": 7,
        "1288": 102,
        "1292": 45.652,
        "1293": 7.92,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1312": 0,
        "1313": 0,
        "1325": 0,
        "1332": 0,
        "2000": 4.34
      },
      "scientificName": "Corylus spp."
    },
    {
      "id": "170150",
      "name": "szezámmag - egész",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 17.73,
        "1004": 49.67,
        "1005": 23.45,
        "1008": 573,
        "1051": 4.69,
        "1058": 0,
        "1079": 11.8,
        "1087": 975,
        "1089": 14.55,
        "1090": 351,
        "1091": 629,
        "1092": 468,
        "1093": 11,
        "1095": 7.75,
        "1098": 4.082,
        "1101": 2.46,
        "1103": 34.4,
        "1105": 0,
        "1106": 0,
        "1107": 5,
        "1108": 0,
        "1109": 0.25,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.791,
        "1166": 0.247,
        "1167": 4.515,
        "1170": 0.05,
        "1175": 0.79,
        "1177": 97,
        "1178": 0,
        "1180": 25.6,
        "1185": 0,
        "1187": 97,
        "1190": 97,
        "1210": 0.388,
        "1211": 0.736,
        "1212": 0.763,
        "1213": 1.358,
        "1214": 0.569,
        "1215": 0.586,
        "1216": 0.358,
        "1217": 0.94,
        "1218": 0.743,
        "1219": 0.99,
        "1220": 2.63,
        "1221": 0.522,
        "1222": 0.927,
        "1223": 1.646,
        "1224": 3.955,
        "1225": 1.215,
        "1226": 0.81,
        "1227": 0.967,
        "1253": 0,
        "1258": 6.957,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.124,
        "1265": 4.441,
        "1266": 2.09,
        "1268": 18.521,
        "1269": 21.375,
        "1270": 0.376,
        "1271": 0,
        "1272": 0,
        "1275": 0.149,
        "1276": 0,
        "1277": 0.07,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 714,
        "1292": 18.759,
        "1293": 21.773,
        "2000": 0.3
      },
      "scientificName": "Sesamum indicum"
    },
    {
      "id": "169412",
      "name": "szezámmag - hántolt",
      "category": "pékáru",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 20.45,
        "1004": 61.21,
        "1005": 11.73,
        "1008": 631,
        "1010": 0.31,
        "1011": 0.1,
        "1012": 0.07,
        "1013": 0,
        "1014": 0,
        "1051": 3.75,
        "1058": 0,
        "1075": 0,
        "1079": 11.6,
        "1087": 60,
        "1089": 6.36,
        "1090": 345,
        "1091": 667,
        "1092": 370,
        "1093": 47,
        "1095": 6.73,
        "1098": 1.4,
        "1101": 1.44,
        "1103": 34.4,
        "1105": 0,
        "1106": 3,
        "1107": 40,
        "1108": 0,
        "1109": 1.68,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1162": 0,
        "1165": 0.699,
        "1166": 0.09,
        "1167": 5.8,
        "1170": 0.29,
        "1175": 0.4,
        "1177": 115,
        "1178": 0,
        "1180": 25.6,
        "1184": 0,
        "1185": 0,
        "1187": 115,
        "1190": 115,
        "1198": 0.4,
        "1210": 0.33,
        "1211": 0.73,
        "1212": 0.75,
        "1213": 1.5,
        "1214": 0.65,
        "1215": 0.88,
        "1216": 0.44,
        "1217": 0.94,
        "1218": 0.79,
        "1219": 0.98,
        "1220": 3.25,
        "1221": 0.55,
        "1222": 0.99,
        "1223": 2.07,
        "1224": 4.6,
        "1225": 1.09,
        "1226": 1.04,
        "1227": 1.2,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 9.055,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 5.273,
        "1266": 3.311,
        "1267": 0.347,
        "1268": 23.595,
        "1269": 25.227,
        "1270": 0.263,
        "1271": 0,
        "1272": 0,
        "1273": 0.071,
        "1275": 0.105,
        "1276": 0,
        "1277": 0.124,
        "1278": 0,
        "1279": 0.065,
        "1280": 0,
        "1285": 22,
        "1286": 53,
        "1288": 232,
        "1292": 23.924,
        "1293": 25.491,
        "1301": 0.053,
        "1304": 0,
        "1312": 0.035,
        "1313": 0,
        "1329": 0,
        "1332": 0,
        "2000": 0.48
      }
    },
    {
      "id": "170557",
      "name": "tökmag",
      "category": "pékáru",
      "state": "baked",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 29.84,
        "1004": 49.05,
        "1005": 14.71,
        "1008": 574,
        "1009": 0.74,
        "1010": 1.14,
        "1011": 0.07,
        "1012": 0.07,
        "1013": 0,
        "1014": 0,
        "1051": 2.03,
        "1058": 0,
        "1075": 0,
        "1079": 6.5,
        "1087": 52,
        "1089": 8.07,
        "1090": 550,
        "1091": 1174,
        "1092": 788,
        "1093": 18,
        "1095": 7.64,
        "1098": 1.275,
        "1101": 4.49,
        "1103": 9.4,
        "1105": 0,
        "1106": 0,
        "1107": 5,
        "1108": 1,
        "1109": 0.56,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 30,
        "1125": 0.09,
        "1126": 12.73,
        "1127": 0.28,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 1.8,
        "1165": 0.07,
        "1166": 0.15,
        "1167": 4.43,
        "1170": 0.57,
        "1175": 0.1,
        "1177": 57,
        "1178": 0,
        "1180": 63,
        "1183": 0,
        "1184": 0,
        "1185": 4.5,
        "1187": 57,
        "1190": 57,
        "1198": 1.5,
        "1210": 0.569,
        "1211": 0.985,
        "1212": 1.265,
        "1213": 2.388,
        "1214": 1.22,
        "1215": 0.595,
        "1216": 0.327,
        "1217": 1.711,
        "1218": 1.079,
        "1219": 1.559,
        "1220": 5.284,
        "1221": 0.77,
        "1222": 1.466,
        "1223": 2.922,
        "1224": 6.108,
        "1225": 1.819,
        "1226": 1.299,
        "1227": 1.652,
        "1253": 0,
        "1257": 0.042,
        "1258": 8.544,
        "1259": 0,
        "1260": 0.007,
        "1261": 0.002,
        "1262": 0.002,
        "1263": 0.006,
        "1264": 0.058,
        "1265": 5.191,
        "1266": 2.913,
        "1267": 0.216,
        "1268": 15.626,
        "1269": 19.59,
        "1270": 0.111,
        "1271": 0.123,
        "1272": 0,
        "1273": 0.06,
        "1274": 0,
        "1275": 0.044,
        "1276": 0,
        "1277": 0.053,
        "1278": 0,
        "1279": 0.001,
        "1280": 0,
        "1285": 0,
        "1286": 3,
        "1288": 13,
        "1292": 15.734,
        "1293": 19.856,
        "1299": 0.008,
        "1300": 0.038,
        "1301": 0.043,
        "1303": 0,
        "1304": 0.015,
        "1305": 0.001,
        "1306": 0.026,
        "1311": 0.005,
        "1312": 0.01,
        "1313": 0.012,
        "1314": 0.044,
        "1315": 15.611,
        "1316": 19.559,
        "1317": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0.016,
        "1331": 0.026,
        "1333": 0,
        "1404": 0.111,
        "1405": 0,
        "1406": 0,
        "1411": 0.005,
        "2000": 1.29
      }
    },
    {
      "id": "172178",
      "name": "camembert",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 19.8,
        "1004": 24.26,
        "1005": 0.46,
        "1008": 300,
        "1051": 51.8,
        "1058": 0,
        "1079": 0,
        "1087": 388,
        "1089": 0.33,
        "1090": 20,
        "1091": 347,
        "1092": 187,
        "1093": 842,
        "1095": 2.38,
        "1098": 0.021,
        "1101": 0.038,
        "1103": 14.5,
        "1105": 240,
        "1106": 241,
        "1107": 12,
        "1108": 0,
        "1109": 0.21,
        "1112": 0.4,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.028,
        "1166": 0.488,
        "1167": 0.63,
        "1170": 1.364,
        "1175": 0.227,
        "1177": 62,
        "1178": 1.3,
        "1180": 15.4,
        "1185": 2,
        "1187": 62,
        "1190": 62,
        "1210": 0.307,
        "1211": 0.717,
        "1212": 0.968,
        "1213": 1.84,
        "1214": 1.766,
        "1215": 0.565,
        "1216": 0.109,
        "1217": 1.105,
        "1218": 1.145,
        "1219": 1.279,
        "1220": 0.701,
        "1221": 0.683,
        "1222": 0.819,
        "1223": 1.288,
        "1224": 4.187,
        "1225": 0.379,
        "1226": 2.346,
        "1227": 1.114,
        "1253": 72,
        "1258": 15.259,
        "1259": 0.494,
        "1260": 0.283,
        "1261": 0.26,
        "1262": 0.59,
        "1263": 0.442,
        "1264": 2.686,
        "1265": 7.227,
        "1266": 2.524,
        "1268": 5.752,
        "1269": 0.45,
        "1270": 0.274,
        "1271": 0,
        "1272": 0,
        "1275": 0.883,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 7.023,
        "1293": 0.724,
        "2000": 0.46
      }
    },
    {
      "id": "170899",
      "name": "cheddar",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.25,
        "1004": 33.82,
        "1005": 2.13,
        "1008": 410,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 0.18,
        "1014": 0,
        "1051": 36.15,
        "1058": 0,
        "1075": 0.08,
        "1079": 0,
        "1087": 711,
        "1089": 0.16,
        "1090": 27,
        "1091": 460,
        "1092": 76,
        "1093": 644,
        "1095": 3.74,
        "1098": 0.035,
        "1101": 0.024,
        "1103": 28.3,
        "1105": 256,
        "1106": 263,
        "1107": 85,
        "1108": 0,
        "1109": 0.78,
        "1112": 1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.06,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.027,
        "1166": 0.434,
        "1167": 0.039,
        "1170": 0.481,
        "1175": 0.075,
        "1177": 27,
        "1178": 0.88,
        "1180": 16.5,
        "1183": 8.6,
        "1184": 0,
        "1185": 2.4,
        "1187": 27,
        "1190": 27,
        "1210": 0.321,
        "1211": 1.091,
        "1212": 1.289,
        "1213": 2.434,
        "1214": 2.037,
        "1215": 0.587,
        "1216": 0.144,
        "1217": 1.259,
        "1218": 1.317,
        "1219": 1.631,
        "1220": 1.084,
        "1221": 0.71,
        "1222": 0.838,
        "1223": 1.973,
        "1224": 5.675,
        "1225": 0.484,
        "1226": 2.68,
        "1227": 1.394,
        "1253": 99,
        "1257": 1.179,
        "1258": 19.368,
        "1259": 0.675,
        "1260": 0.565,
        "1261": 0.361,
        "1262": 0.857,
        "1263": 0.967,
        "1264": 3.103,
        "1265": 8.705,
        "1266": 3.547,
        "1267": 0.049,
        "1268": 7.509,
        "1269": 1.179,
        "1270": 0.122,
        "1271": 0.05,
        "1272": 0.001,
        "1273": 0.014,
        "1274": 0.305,
        "1275": 0.492,
        "1276": 0,
        "1277": 0.061,
        "1278": 0.01,
        "1279": 0.001,
        "1280": 0.017,
        "1292": 8.428,
        "1293": 1.433,
        "1299": 0.322,
        "1300": 0.195,
        "1301": 0.009,
        "1303": 0.104,
        "1304": 0.842,
        "1305": 0,
        "1306": 0.23,
        "1311": 0.174,
        "1312": 0,
        "1313": 0.007,
        "1314": 0.388,
        "1315": 6.667,
        "1316": 0.775,
        "1317": 0.001,
        "1321": 0.001,
        "1323": 0.059,
        "1325": 0.037,
        "1329": 0.946,
        "1331": 0.233,
        "1333": 0,
        "1404": 0.117,
        "1405": 0.002,
        "1406": 0.036,
        "1409": 0.003,
        "1411": 0.008,
        "2000": 0.27
      }
    },
    {
      "id": "170273",
      "name": "csokoládé - ét 70%",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 7.79,
        "1004": 42.63,
        "1005": 45.9,
        "1008": 598,
        "1010": 23.99,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 1.37,
        "1058": 802,
        "1075": 0,
        "1079": 10.9,
        "1087": 73,
        "1089": 11.9,
        "1090": 228,
        "1091": 308,
        "1092": 715,
        "1093": 20,
        "1095": 3.31,
        "1098": 1.766,
        "1101": 1.948,
        "1103": 6.8,
        "1106": 2,
        "1107": 19,
        "1108": 7,
        "1109": 0.59,
        "1120": 1,
        "1122": 0,
        "1123": 27,
        "1125": 0.01,
        "1126": 9.19,
        "1127": 0.29,
        "1128": 0,
        "1129": 0,
        "1130": 0.14,
        "1131": 0,
        "1165": 0.034,
        "1166": 0.078,
        "1167": 1.054,
        "1170": 0.418,
        "1175": 0.038,
        "1178": 0.28,
        "1183": 0,
        "1184": 0,
        "1185": 7.3,
        "1253": 3,
        "1257": 0.03,
        "1258": 24.489,
        "1259": 0.014,
        "1260": 0.008,
        "1261": 0.006,
        "1262": 0.045,
        "1263": 0.017,
        "1264": 0.078,
        "1265": 10.076,
        "1266": 13.63,
        "1267": 0.408,
        "1268": 12.651,
        "1269": 1.217,
        "1270": 0.034,
        "1271": 0.001,
        "1272": 0,
        "1273": 0.068,
        "1274": 0.004,
        "1275": 0.106,
        "1276": 0,
        "1277": 0.02,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 31,
        "1286": 12,
        "1288": 86,
        "1292": 12.781,
        "1293": 1.257,
        "1299": 0.016,
        "1300": 0.086,
        "1301": 0.038,
        "1303": 0.002,
        "1304": 0.023,
        "1305": 0,
        "1306": 0.005,
        "1311": 0.004,
        "1312": 0,
        "1313": 0.001,
        "1314": 0.104,
        "1315": 12.629,
        "1316": 1.208,
        "1317": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0.025,
        "1331": 0.005,
        "1333": 0,
        "1404": 0.034,
        "1405": 0,
        "1406": 0,
        "1411": 0.004,
        "2000": 23.99
      }
    },
    {
      "id": "167571",
      "name": "csokoládé - fehér",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 5.87,
        "1004": 32.09,
        "1005": 59.24,
        "1008": 539,
        "1051": 1.3,
        "1058": 0,
        "1079": 0.2,
        "1087": 199,
        "1089": 0.24,
        "1090": 12,
        "1091": 176,
        "1092": 286,
        "1093": 90,
        "1095": 0.74,
        "1098": 0.06,
        "1101": 0.008,
        "1103": 4.5,
        "1105": 9,
        "1106": 9,
        "1107": 0,
        "1108": 0,
        "1109": 0.96,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.5,
        "1165": 0.063,
        "1166": 0.282,
        "1167": 0.745,
        "1170": 0.608,
        "1175": 0.056,
        "1177": 7,
        "1178": 0.56,
        "1180": 29.5,
        "1185": 9.1,
        "1187": 7,
        "1190": 7,
        "1253": 21,
        "1257": 0,
        "1258": 19.412,
        "1259": 0.314,
        "1260": 0.155,
        "1261": 0.115,
        "1262": 0.22,
        "1263": 0.629,
        "1264": 0.797,
        "1265": 7.947,
        "1266": 9.145,
        "1267": 0.004,
        "1268": 8.99,
        "1269": 0.91,
        "1270": 0.103,
        "1271": 0,
        "1272": 0,
        "1275": 0.062,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 9.097,
        "1293": 1.013,
        "2000": 59
      }
    },
    {
      "id": "173419",
      "name": "edami",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.99,
        "1004": 28.57,
        "1005": 1.43,
        "1008": 357,
        "1051": 41,
        "1058": 0,
        "1079": 0,
        "1087": 731,
        "1089": 0.44,
        "1090": 30,
        "1091": 536,
        "1092": 188,
        "1093": 973,
        "1095": 3.75,
        "1098": 0.036,
        "1101": 0.011,
        "1103": 14.5,
        "1105": 242,
        "1106": 243,
        "1107": 11,
        "1108": 0,
        "1109": 0.24,
        "1112": 0.5,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.037,
        "1166": 0.389,
        "1167": 0.082,
        "1170": 0.281,
        "1175": 0.076,
        "1177": 16,
        "1178": 1.54,
        "1180": 15.4,
        "1185": 2.3,
        "1187": 16,
        "1190": 16,
        "1210": 0.352,
        "1211": 0.932,
        "1212": 1.308,
        "1213": 2.57,
        "1214": 2.66,
        "1215": 0.721,
        "1216": 0.255,
        "1217": 1.434,
        "1218": 1.457,
        "1219": 1.81,
        "1220": 0.964,
        "1221": 1.034,
        "1222": 0.764,
        "1223": 1.747,
        "1224": 6.15,
        "1225": 0.486,
        "1226": 3.251,
        "1227": 1.547,
        "1253": 89,
        "1258": 18.67,
        "1259": 1,
        "1260": 0.461,
        "1261": 0.3,
        "1262": 0.589,
        "1263": 0.496,
        "1264": 2.943,
        "1265": 8.067,
        "1266": 2.983,
        "1268": 6.911,
        "1269": 0.418,
        "1270": 0.247,
        "1271": 0,
        "1272": 0,
        "1275": 0.813,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 8.125,
        "1293": 0.665,
        "2000": 0
      }
    },
    {
      "id": "173420",
      "name": "feta",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 14.21,
        "1004": 21.49,
        "1005": 3.88,
        "1008": 265,
        "1051": 55.22,
        "1058": 0,
        "1079": 0,
        "1087": 493,
        "1089": 0.65,
        "1090": 19,
        "1091": 337,
        "1092": 62,
        "1093": 1139,
        "1095": 2.88,
        "1098": 0.032,
        "1101": 0.028,
        "1103": 15,
        "1105": 125,
        "1106": 125,
        "1107": 3,
        "1108": 0,
        "1109": 0.18,
        "1112": 0.4,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.154,
        "1166": 0.844,
        "1167": 0.991,
        "1170": 0.967,
        "1175": 0.424,
        "1177": 32,
        "1178": 1.69,
        "1180": 15.4,
        "1185": 1.8,
        "1187": 32,
        "1190": 32,
        "1210": 0.2,
        "1211": 0.637,
        "1212": 0.803,
        "1213": 1.395,
        "1214": 1.219,
        "1215": 0.368,
        "1216": 0.083,
        "1217": 0.675,
        "1218": 0.668,
        "1219": 1.065,
        "1220": 0.47,
        "1221": 0.397,
        "1222": 0.639,
        "1223": 0.779,
        "1224": 2.421,
        "1225": 0.097,
        "1226": 1.378,
        "1227": 1.169,
        "1253": 89,
        "1258": 13.3,
        "1259": 0.714,
        "1260": 0.528,
        "1261": 0.503,
        "1262": 1.822,
        "1263": 1.068,
        "1264": 2.545,
        "1265": 4.748,
        "1266": 1.371,
        "1268": 3.975,
        "1269": 0.326,
        "1270": 0.265,
        "1271": 0,
        "1272": 0,
        "1275": 0.385,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 4.623,
        "1293": 0.591,
        "2000": 0
      }
    },
    {
      "id": "171314",
      "name": "ghí",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0,
        "1004": 100,
        "1005": 0,
        "1008": 900,
        "1051": 0.5,
        "1079": 0,
        "1087": 0,
        "1089": 0,
        "1093": 0,
        "1104": 4000,
        "1162": 0,
        "1253": 300,
        "1257": 0,
        "1258": 60,
        "1293": 4,
        "2000": 0
      }
    },
    {
      "id": "171241",
      "name": "gouda",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.94,
        "1004": 27.44,
        "1005": 2.22,
        "1008": 356,
        "1051": 41.46,
        "1058": 0,
        "1079": 0,
        "1087": 700,
        "1089": 0.24,
        "1090": 29,
        "1091": 546,
        "1092": 121,
        "1093": 819,
        "1095": 3.9,
        "1098": 0.036,
        "1101": 0.011,
        "1103": 14.5,
        "1105": 164,
        "1106": 165,
        "1107": 10,
        "1108": 0,
        "1109": 0.24,
        "1112": 0.5,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.03,
        "1166": 0.334,
        "1167": 0.063,
        "1170": 0.34,
        "1175": 0.08,
        "1177": 21,
        "1178": 1.54,
        "1180": 15.4,
        "1185": 2.3,
        "1187": 21,
        "1190": 21,
        "1210": 0.352,
        "1211": 0.93,
        "1212": 1.306,
        "1213": 2.564,
        "1214": 2.654,
        "1215": 0.719,
        "1216": 0.254,
        "1217": 1.431,
        "1218": 1.454,
        "1219": 1.806,
        "1220": 0.962,
        "1221": 1.032,
        "1222": 0.762,
        "1223": 1.743,
        "1224": 6.137,
        "1225": 0.485,
        "1226": 3.245,
        "1227": 1.544,
        "1253": 114,
        "1258": 17.614,
        "1259": 0.999,
        "1260": 0.64,
        "1261": 0.427,
        "1262": 0.918,
        "1263": 1.211,
        "1264": 3.04,
        "1265": 6.851,
        "1266": 2.918,
        "1268": 6.388,
        "1269": 0.263,
        "1270": 0.394,
        "1271": 0,
        "1272": 0,
        "1275": 0.889,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 7.747,
        "1293": 0.657,
        "2000": 2.22
      }
    },
    {
      "id": "170903",
      "name": "joghurt - görög - low fat",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 9.95,
        "1004": 1.92,
        "1005": 3.94,
        "1008": 73,
        "1009": 0,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 2.92,
        "1014": 0,
        "1051": 83.56,
        "1058": 0,
        "1075": 0.64,
        "1079": 0,
        "1087": 115,
        "1089": 0.04,
        "1090": 11,
        "1091": 137,
        "1092": 141,
        "1093": 34,
        "1095": 0.6,
        "1098": 0.021,
        "1101": 0.007,
        "1103": 12.4,
        "1105": 90,
        "1106": 90,
        "1107": 6,
        "1108": 0,
        "1109": 0.04,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1,
        "1162": 0.8,
        "1165": 0.044,
        "1166": 0.233,
        "1167": 0.197,
        "1170": 0.47,
        "1175": 0.055,
        "1177": 12,
        "1178": 0.52,
        "1180": 15.2,
        "1185": 0.2,
        "1187": 12,
        "1190": 12,
        "1210": 0.03,
        "1211": 0.216,
        "1212": 0.286,
        "1213": 0.529,
        "1214": 0.471,
        "1215": 0.155,
        "1216": 0.048,
        "1217": 0.286,
        "1218": 0.265,
        "1219": 0.434,
        "1220": 0.158,
        "1221": 0.13,
        "1222": 0.225,
        "1223": 0.416,
        "1224": 1.028,
        "1225": 0.127,
        "1226": 0.622,
        "1227": 0.325,
        "1253": 10,
        "1257": 0.06,
        "1258": 1.23,
        "1259": 0.047,
        "1260": 0.035,
        "1261": 0.024,
        "1262": 0.067,
        "1263": 0.062,
        "1264": 0.194,
        "1265": 0.57,
        "1266": 0.195,
        "1267": 0.003,
        "1268": 0.427,
        "1269": 0.065,
        "1270": 0.007,
        "1271": 0.002,
        "1272": 0,
        "1273": 0,
        "1274": 0.021,
        "1275": 0.031,
        "1276": 0,
        "1277": 0.004,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.486,
        "1293": 0.076,
        "1299": 0.021,
        "1300": 0.012,
        "1301": 0,
        "1303": 0.005,
        "1304": 0.046,
        "1305": 0,
        "1306": 0.009,
        "1311": 0.008,
        "1312": 0,
        "1313": 0,
        "1314": 0.026,
        "1315": 0.381,
        "1316": 0.048,
        "1317": 0,
        "1321": 0,
        "1323": 0.003,
        "1325": 0.002,
        "1329": 0.051,
        "1331": 0.009,
        "1333": 0,
        "1404": 0.007,
        "1405": 0,
        "1406": 0.002,
        "1409": 0,
        "1411": 0,
        "2000": 3.56
      }
    },
    {
      "id": "170886",
      "name": "joghurt - natúr - low fat",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 5.25,
        "1004": 1.55,
        "1005": 7.04,
        "1008": 63,
        "1051": 85.07,
        "1058": 0,
        "1079": 0,
        "1087": 183,
        "1089": 0.08,
        "1090": 17,
        "1091": 144,
        "1092": 234,
        "1093": 70,
        "1095": 0.89,
        "1098": 0.013,
        "1099": 12,
        "1101": 0.004,
        "1103": 3.3,
        "1105": 14,
        "1106": 14,
        "1107": 2,
        "1108": 0,
        "1109": 0.03,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.8,
        "1165": 0.044,
        "1166": 0.214,
        "1167": 0.114,
        "1170": 0.591,
        "1175": 0.049,
        "1177": 11,
        "1178": 0.56,
        "1180": 15.2,
        "1185": 0.2,
        "1187": 11,
        "1190": 11,
        "1198": 0.9,
        "1210": 0.03,
        "1211": 0.216,
        "1212": 0.286,
        "1213": 0.529,
        "1214": 0.471,
        "1215": 0.155,
        "1216": 0.048,
        "1217": 0.286,
        "1218": 0.265,
        "1219": 0.434,
        "1220": 0.158,
        "1221": 0.13,
        "1222": 0.225,
        "1223": 0.416,
        "1224": 1.028,
        "1225": 0.127,
        "1226": 0.622,
        "1227": 0.325,
        "1253": 6,
        "1258": 1,
        "1259": 0.046,
        "1260": 0.032,
        "1261": 0.02,
        "1262": 0.044,
        "1263": 0.053,
        "1264": 0.163,
        "1265": 0.422,
        "1266": 0.151,
        "1268": 0.354,
        "1269": 0.031,
        "1270": 0.013,
        "1271": 0,
        "1272": 0,
        "1275": 0.034,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.426,
        "1293": 0.044,
        "2000": 7.04
      }
    },
    {
      "id": "171284",
      "name": "joghurt - natúr - whole milk",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.47,
        "1004": 3.25,
        "1005": 4.66,
        "1008": 61,
        "1051": 87.9,
        "1058": 0,
        "1079": 0,
        "1087": 121,
        "1089": 0.05,
        "1090": 12,
        "1091": 95,
        "1092": 155,
        "1093": 46,
        "1095": 0.59,
        "1098": 0.009,
        "1099": 12,
        "1101": 0.004,
        "1103": 2.2,
        "1105": 27,
        "1106": 27,
        "1107": 5,
        "1108": 0,
        "1109": 0.06,
        "1112": 0.1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.5,
        "1165": 0.029,
        "1166": 0.142,
        "1167": 0.075,
        "1170": 0.389,
        "1175": 0.032,
        "1177": 7,
        "1178": 0.37,
        "1180": 15.2,
        "1185": 0.2,
        "1187": 7,
        "1190": 7,
        "1210": 0.02,
        "1211": 0.142,
        "1212": 0.189,
        "1213": 0.35,
        "1214": 0.311,
        "1215": 0.102,
        "1216": 0.032,
        "1217": 0.189,
        "1218": 0.175,
        "1219": 0.287,
        "1220": 0.104,
        "1221": 0.086,
        "1222": 0.148,
        "1223": 0.275,
        "1224": 0.679,
        "1225": 0.084,
        "1226": 0.411,
        "1227": 0.215,
        "1253": 13,
        "1258": 2.096,
        "1259": 0.096,
        "1260": 0.066,
        "1261": 0.042,
        "1262": 0.093,
        "1263": 0.111,
        "1264": 0.343,
        "1265": 0.886,
        "1266": 0.317,
        "1268": 0.743,
        "1269": 0.065,
        "1270": 0.027,
        "1271": 0,
        "1272": 0,
        "1275": 0.071,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.893,
        "1293": 0.092,
        "2000": 4.66
      }
    },
    {
      "id": "170904",
      "name": "kefír - alacsony zsírtartalmú",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 250,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.79,
        "1004": 1.02,
        "1005": 4.77,
        "1008": 43,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 3.7,
        "1014": 0,
        "1051": 89.7,
        "1058": 0,
        "1075": 0.91,
        "1079": 0,
        "1087": 130,
        "1089": 0.04,
        "1090": 12,
        "1091": 105,
        "1092": 164,
        "1093": 40,
        "1095": 0.46,
        "1098": 0.009,
        "1101": 0.005,
        "1103": 3.6,
        "1105": 171,
        "1106": 171,
        "1107": 0,
        "1108": 0,
        "1109": 0.02,
        "1111": 0,
        "1112": 1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.2,
        "1165": 0.03,
        "1166": 0.135,
        "1167": 0.15,
        "1170": 0.385,
        "1175": 0.058,
        "1177": 13,
        "1178": 0.29,
        "1180": 15.2,
        "1185": 0.1,
        "1187": 13,
        "1190": 13,
        "1253": 5,
        "1257": 0.037,
        "1258": 0.658,
        "1259": 0.029,
        "1260": 0.018,
        "1261": 0.008,
        "1262": 0.021,
        "1263": 0.029,
        "1264": 0.105,
        "1265": 0.308,
        "1266": 0.118,
        "1267": 0.002,
        "1268": 0.273,
        "1269": 0.042,
        "1270": 0.006,
        "1271": 0.002,
        "1272": 0,
        "1273": 0,
        "1274": 0.011,
        "1275": 0.02,
        "1276": 0,
        "1277": 0.004,
        "1278": 0,
        "1279": 0,
        "1280": 0.001,
        "1292": 0.31,
        "1293": 0.053,
        "1299": 0.013,
        "1300": 0.007,
        "1301": 0,
        "1303": 0.003,
        "1304": 0.027,
        "1305": 0,
        "1306": 0.008,
        "1311": 0.006,
        "1312": 0,
        "1313": 0,
        "1314": 0.017,
        "1315": 0.246,
        "1316": 0.029,
        "1317": 0,
        "1321": 0,
        "1323": 0.003,
        "1325": 0.002,
        "1329": 0.03,
        "1331": 0.008,
        "1333": 0,
        "1404": 0.006,
        "1405": 0,
        "1406": 0.002,
        "1409": 0,
        "1411": 0,
        "2000": 4.61
      }
    },
    {
      "id": "170847",
      "name": "mozzarella - light",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 24.26,
        "1004": 15.92,
        "1005": 2.77,
        "1008": 254,
        "1051": 53.78,
        "1058": 0,
        "1079": 0,
        "1087": 782,
        "1089": 0.22,
        "1090": 23,
        "1091": 463,
        "1092": 84,
        "1093": 619,
        "1095": 2.76,
        "1098": 0.025,
        "1101": 0.01,
        "1103": 14.4,
        "1105": 124,
        "1106": 127,
        "1107": 41,
        "1108": 0,
        "1109": 0.14,
        "1112": 0.3,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.018,
        "1166": 0.303,
        "1167": 0.105,
        "1170": 0.079,
        "1175": 0.07,
        "1177": 9,
        "1178": 0.82,
        "1180": 15.4,
        "1185": 1.6,
        "1187": 9,
        "1190": 9,
        "1210": 0.339,
        "1211": 0.924,
        "1212": 1.164,
        "1213": 2.365,
        "1214": 2.464,
        "1215": 0.677,
        "1216": 0.144,
        "1217": 1.266,
        "1218": 1.403,
        "1219": 1.517,
        "1220": 1.042,
        "1221": 0.913,
        "1222": 0.741,
        "1223": 1.757,
        "1224": 5.677,
        "1225": 0.464,
        "1226": 2.498,
        "1227": 1.415,
        "1253": 64,
        "1258": 10.114,
        "1259": 0.516,
        "1260": 0.1,
        "1261": 0.117,
        "1262": 0.251,
        "1263": 0.164,
        "1264": 1.598,
        "1265": 4.855,
        "1266": 1.937,
        "1268": 3.874,
        "1269": 0.335,
        "1270": 0.137,
        "1271": 0,
        "1272": 0,
        "1275": 0.44,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 4.51,
        "1293": 0.472,
        "2000": 1.13
      }
    },
    {
      "id": "170845",
      "name": "mozzarella - teljes tejből",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 22.17,
        "1004": 22.14,
        "1005": 2.4,
        "1008": 299,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 50.01,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 505,
        "1089": 0.44,
        "1090": 20,
        "1091": 354,
        "1092": 76,
        "1093": 486,
        "1095": 2.92,
        "1098": 0.011,
        "1101": 0.03,
        "1103": 17,
        "1105": 174,
        "1106": 179,
        "1107": 57,
        "1108": 0,
        "1109": 0.19,
        "1112": 0.4,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.03,
        "1166": 0.283,
        "1167": 0.104,
        "1170": 0.141,
        "1175": 0.037,
        "1177": 7,
        "1178": 2.28,
        "1180": 15.4,
        "1184": 0,
        "1185": 2.3,
        "1187": 7,
        "1190": 7,
        "1210": 0.515,
        "1211": 0.983,
        "1212": 1.135,
        "1213": 1.826,
        "1214": 0.965,
        "1215": 0.515,
        "1216": 0.115,
        "1217": 1.011,
        "1218": 1.043,
        "1219": 1.322,
        "1220": 0.515,
        "1221": 0.515,
        "1222": 0.707,
        "1223": 1.633,
        "1224": 4.458,
        "1225": 0.515,
        "1226": 2.351,
        "1227": 0.735,
        "1253": 79,
        "1258": 13.9,
        "1259": 0.805,
        "1260": 0.446,
        "1261": 0.257,
        "1262": 0.582,
        "1263": 0.69,
        "1264": 2.189,
        "1265": 5.331,
        "1266": 2.442,
        "1268": 5.649,
        "1269": 0.393,
        "1270": 0.372,
        "1271": 0,
        "1272": 0,
        "1275": 0.597,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 6.573,
        "1293": 0.765,
        "2000": 0
      }
    },
    {
      "id": "170848",
      "name": "parmezán",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 35.75,
        "1004": 25,
        "1005": 3.22,
        "1008": 392,
        "1051": 30,
        "1058": 0,
        "1079": 0,
        "1087": 1184,
        "1089": 0.82,
        "1090": 44,
        "1091": 694,
        "1092": 92,
        "1093": 1175,
        "1095": 2.75,
        "1098": 0.032,
        "1101": 0.02,
        "1103": 22.5,
        "1105": 201,
        "1106": 207,
        "1107": 66,
        "1108": 0,
        "1109": 0.22,
        "1112": 0.5,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.039,
        "1166": 0.332,
        "1167": 0.271,
        "1170": 0.453,
        "1175": 0.091,
        "1177": 7,
        "1178": 1.2,
        "1180": 15.4,
        "1185": 1.7,
        "1187": 7,
        "1190": 7,
        "1210": 0.482,
        "1211": 1.317,
        "1212": 1.894,
        "1213": 3.452,
        "1214": 3.306,
        "1215": 0.958,
        "1216": 0.235,
        "1217": 1.922,
        "1218": 1.995,
        "1219": 2.454,
        "1220": 1.317,
        "1221": 1.384,
        "1222": 1.048,
        "1223": 2.236,
        "1224": 8.209,
        "1225": 0.622,
        "1226": 4.18,
        "1227": 2.068,
        "1253": 68,
        "1258": 14.85,
        "1259": 1.299,
        "1260": 0.487,
        "1261": 0.26,
        "1262": 0.648,
        "1263": 0.873,
        "1264": 2.911,
        "1265": 6.966,
        "1266": 2.301,
        "1268": 6.656,
        "1269": 0.272,
        "1270": 0.297,
        "1271": 0,
        "1272": 0,
        "1275": 0.394,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 7.515,
        "1293": 0.569,
        "2000": 0.11
      }
    },
    {
      "id": "171251",
      "name": "svájci sajt (pl.: ementáli)",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 26.96,
        "1004": 30.99,
        "1005": 1.44,
        "1008": 393,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 37.63,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 890,
        "1089": 0.13,
        "1090": 33,
        "1091": 574,
        "1092": 72,
        "1093": 187,
        "1095": 4.37,
        "1098": 0.047,
        "1101": 0.026,
        "1103": 30,
        "1105": 283,
        "1106": 288,
        "1107": 61,
        "1108": 1,
        "1109": 0.6,
        "1111": 0,
        "1112": 0,
        "1120": 2,
        "1122": 1,
        "1123": 8,
        "1125": 0.02,
        "1126": 0.07,
        "1127": 0,
        "1128": 0.13,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.011,
        "1166": 0.302,
        "1167": 0.064,
        "1170": 0.353,
        "1175": 0.071,
        "1177": 10,
        "1178": 3.06,
        "1180": 13.8,
        "1183": 6.3,
        "1184": 0,
        "1185": 1.4,
        "1187": 10,
        "1190": 10,
        "1198": 0.1,
        "1210": 0.401,
        "1211": 1.038,
        "1212": 1.537,
        "1213": 2.959,
        "1214": 2.585,
        "1215": 0.784,
        "1216": 0.29,
        "1217": 1.662,
        "1218": 1.693,
        "1219": 2.139,
        "1220": 0.927,
        "1221": 1.065,
        "1222": 0.914,
        "1223": 1.569,
        "1224": 5.704,
        "1225": 0.508,
        "1226": 3.69,
        "1227": 1.64,
        "1253": 93,
        "1257": 0.987,
        "1258": 18.227,
        "1259": 0.681,
        "1260": 0.542,
        "1261": 0.327,
        "1262": 0.768,
        "1263": 0.875,
        "1264": 2.919,
        "1265": 8.358,
        "1266": 3.196,
        "1267": 0.044,
        "1268": 7.06,
        "1269": 1.086,
        "1270": 0.129,
        "1271": 0.046,
        "1272": 0,
        "1273": 0.014,
        "1274": 0.297,
        "1275": 0.565,
        "1276": 0.001,
        "1277": 0.06,
        "1278": 0.009,
        "1279": 0.002,
        "1280": 0.018,
        "1292": 8.046,
        "1293": 1.341,
        "1299": 0.305,
        "1300": 0.189,
        "1301": 0.009,
        "1303": 0.102,
        "1304": 0.692,
        "1305": 0,
        "1306": 0.191,
        "1311": 0.161,
        "1312": 0,
        "1313": 0.007,
        "1314": 0.463,
        "1315": 6.369,
        "1316": 0.734,
        "1317": 0.002,
        "1321": 0.002,
        "1323": 0.062,
        "1325": 0.035,
        "1329": 0.793,
        "1331": 0.194,
        "1333": 0,
        "1404": 0.125,
        "1405": 0.003,
        "1406": 0.032,
        "1409": 0.002,
        "1411": 0.007,
        "2000": 0
      }
    },
    {
      "id": "170173",
      "name": "tej - kókusz",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.02,
        "1004": 21.33,
        "1005": 2.81,
        "1008": 197,
        "1051": 72.88,
        "1087": 18,
        "1089": 3.3,
        "1090": 46,
        "1091": 96,
        "1092": 220,
        "1093": 13,
        "1095": 0.56,
        "1098": 0.223,
        "1101": 0.768,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 1,
        "1165": 0.022,
        "1166": 0,
        "1167": 0.637,
        "1170": 0.153,
        "1175": 0.028,
        "1177": 14,
        "1178": 0,
        "1180": 8.5,
        "1187": 14,
        "1190": 14,
        "1198": 0,
        "1210": 0.024,
        "1211": 0.074,
        "1212": 0.079,
        "1213": 0.15,
        "1214": 0.089,
        "1215": 0.038,
        "1216": 0.04,
        "1217": 0.102,
        "1218": 0.062,
        "1219": 0.122,
        "1220": 0.331,
        "1221": 0.046,
        "1222": 0.103,
        "1223": 0.197,
        "1224": 0.462,
        "1225": 0.096,
        "1226": 0.083,
        "1227": 0.104,
        "1253": 0,
        "1258": 18.915,
        "1260": 0.121,
        "1261": 1.494,
        "1262": 1.187,
        "1263": 9.463,
        "1264": 3.736,
        "1265": 1.808,
        "1266": 1.104,
        "1268": 0.907,
        "1269": 0.233,
        "1292": 0.907,
        "1293": 0.233
      }
    },
    {
      "id": "172205",
      "name": "tej - tehén - 2%",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.3,
        "1004": 1.98,
        "1005": 4.8,
        "1008": 50,
        "1010": 0.01,
        "1011": 0.01,
        "1012": 0.01,
        "1013": 5.01,
        "1014": 0.01,
        "1051": 89.21,
        "1058": 0,
        "1075": 0.02,
        "1079": 0,
        "1087": 120,
        "1089": 0.02,
        "1090": 11,
        "1091": 92,
        "1092": 140,
        "1093": 47,
        "1095": 0.48,
        "1098": 0.006,
        "1099": 3.4,
        "1101": 0.014,
        "1103": 2.5,
        "1105": 27,
        "1106": 28,
        "1107": 7,
        "1108": 0,
        "1109": 0.03,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.2,
        "1165": 0.039,
        "1166": 0.185,
        "1167": 0.092,
        "1170": 0.356,
        "1175": 0.038,
        "1177": 5,
        "1178": 0.53,
        "1180": 16.4,
        "1184": 0,
        "1185": 0.2,
        "1187": 5,
        "1190": 5,
        "1198": 0.9,
        "1210": 0.042,
        "1211": 0.141,
        "1212": 0.171,
        "1213": 0.313,
        "1214": 0.276,
        "1215": 0.087,
        "1216": 0.02,
        "1217": 0.171,
        "1218": 0.167,
        "1219": 0.216,
        "1220": 0.094,
        "1221": 0.1,
        "1222": 0.112,
        "1223": 0.283,
        "1224": 0.742,
        "1225": 0.065,
        "1226": 0.326,
        "1227": 0.199,
        "1228": 0,
        "1253": 8,
        "1257": 0.085,
        "1258": 1.257,
        "1259": 0.077,
        "1260": 0.04,
        "1261": 0.02,
        "1262": 0.049,
        "1263": 0.055,
        "1264": 0.175,
        "1265": 0.558,
        "1266": 0.243,
        "1267": 0.004,
        "1268": 0.507,
        "1269": 0.062,
        "1270": 0.008,
        "1271": 0,
        "1272": 0,
        "1273": 0.002,
        "1274": 0.014,
        "1275": 0.027,
        "1276": 0,
        "1277": 0.002,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 0,
        "1286": 0,
        "1288": 0,
        "1292": 0.56,
        "1293": 0.073,
        "1299": 0.02,
        "1300": 0.011,
        "1304": 0.078,
        "1307": 0.007,
        "1314": 0.027,
        "1315": 0.43,
        "1316": 0.055,
        "1323": 0.005,
        "1325": 0.003,
        "1329": 0.078,
        "1331": 0.007,
        "1332": 0.002,
        "1333": 0.004,
        "1404": 0.008,
        "2000": 5.06
      }
    },
    {
      "id": "171266",
      "name": "tej - tehén - 3,7%",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 110,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.28,
        "1004": 3.66,
        "1005": 4.65,
        "1008": 64,
        "1051": 87.69,
        "1079": 0,
        "1087": 119,
        "1089": 0.05,
        "1090": 13,
        "1091": 93,
        "1092": 151,
        "1093": 49,
        "1095": 0.38,
        "1098": 0.01,
        "1101": 0.004,
        "1103": 2,
        "1105": 31,
        "1106": 33,
        "1162": 1.5,
        "1165": 0.038,
        "1166": 0.161,
        "1167": 0.084,
        "1170": 0.313,
        "1175": 0.042,
        "1177": 5,
        "1178": 0.36,
        "1187": 5,
        "1190": 5,
        "1210": 0.046,
        "1211": 0.148,
        "1212": 0.198,
        "1213": 0.321,
        "1214": 0.26,
        "1215": 0.082,
        "1216": 0.03,
        "1217": 0.158,
        "1218": 0.158,
        "1219": 0.22,
        "1220": 0.119,
        "1221": 0.089,
        "1222": 0.113,
        "1223": 0.249,
        "1224": 0.687,
        "1225": 0.069,
        "1226": 0.318,
        "1227": 0.178,
        "1253": 14,
        "1258": 2.278,
        "1259": 0.119,
        "1260": 0.07,
        "1261": 0.041,
        "1262": 0.092,
        "1263": 0.103,
        "1264": 0.368,
        "1265": 0.963,
        "1266": 0.444,
        "1268": 0.921,
        "1269": 0.083,
        "1270": 0.053,
        "1271": 0,
        "1272": 0,
        "1275": 0.082,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 0,
        "1292": 1.057,
        "1293": 0.136
      }
    },
    {
      "id": "171257",
      "name": "tejföl - 20%",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.44,
        "1004": 19.35,
        "1005": 4.63,
        "1008": 198,
        "1009": 0,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 3.41,
        "1014": 0,
        "1051": 73.07,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 101,
        "1089": 0.07,
        "1090": 10,
        "1091": 76,
        "1092": 125,
        "1093": 31,
        "1095": 0.33,
        "1098": 0.018,
        "1101": 0.015,
        "1103": 3.7,
        "1105": 121,
        "1106": 124,
        "1107": 25,
        "1108": 0,
        "1109": 0.38,
        "1111": 0,
        "1112": 0,
        "1120": 1,
        "1122": 0,
        "1123": 4,
        "1125": 0,
        "1126": 0.3,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.9,
        "1165": 0.02,
        "1166": 0.168,
        "1167": 0.093,
        "1170": 0.472,
        "1175": 0.041,
        "1177": 6,
        "1178": 0.21,
        "1180": 19.2,
        "1183": 6,
        "1184": 0,
        "1185": 1.5,
        "1187": 6,
        "1190": 6,
        "1198": 0.6,
        "1210": 0.042,
        "1211": 0.142,
        "1212": 0.163,
        "1213": 0.322,
        "1214": 0.275,
        "1215": 0.078,
        "1216": 0.029,
        "1217": 0.157,
        "1218": 0.152,
        "1219": 0.195,
        "1220": 0.117,
        "1221": 0.092,
        "1222": 0.116,
        "1223": 0.262,
        "1224": 0.673,
        "1225": 0.076,
        "1226": 0.31,
        "1227": 0.191,
        "1253": 59,
        "1257": 0.796,
        "1258": 10.14,
        "1259": 0.031,
        "1260": 0.203,
        "1261": 0.145,
        "1262": 0.378,
        "1263": 0.447,
        "1264": 1.626,
        "1265": 5.154,
        "1266": 1.832,
        "1267": 0.027,
        "1268": 4.129,
        "1269": 0.648,
        "1270": 0.074,
        "1271": 0.025,
        "1272": 0.001,
        "1273": 0.011,
        "1274": 0.134,
        "1275": 0.294,
        "1276": 0,
        "1277": 0.029,
        "1278": 0.006,
        "1279": 0,
        "1280": 0.011,
        "1292": 4.594,
        "1293": 0.8,
        "1299": 0.171,
        "1300": 0.108,
        "1301": 0.006,
        "1304": 0.666,
        "1306": 0.13,
        "1311": 0.081,
        "1312": 0.001,
        "1313": 0.008,
        "1314": 0.294,
        "1315": 3.463,
        "1316": 0.438,
        "1321": 0.006,
        "1323": 0.007,
        "1325": 0.019,
        "1329": 0.666,
        "1331": 0.13,
        "1333": 0,
        "1404": 0.068,
        "1405": 0.001,
        "1406": 0.018,
        "1411": 0.001,
        "1412": 0.158,
        "2000": 3.41
      }
    },
    {
      "id": "171255",
      "name": "tejszín - 12%",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.13,
        "1004": 11.5,
        "1005": 4.3,
        "1008": 131,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 4.13,
        "1014": 0,
        "1051": 80.57,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 107,
        "1089": 0.05,
        "1090": 10,
        "1091": 95,
        "1092": 132,
        "1093": 61,
        "1095": 0.39,
        "1098": 0.009,
        "1099": 3,
        "1101": 0.005,
        "1103": 3.2,
        "1105": 95,
        "1106": 97,
        "1107": 22,
        "1108": 0,
        "1109": 0.25,
        "1111": 0,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.9,
        "1165": 0.03,
        "1166": 0.194,
        "1167": 0.109,
        "1170": 0.539,
        "1175": 0.05,
        "1177": 3,
        "1178": 0.19,
        "1180": 18.7,
        "1185": 1.3,
        "1187": 3,
        "1190": 3,
        "1198": 0.7,
        "1210": 0.073,
        "1211": 0.139,
        "1212": 0.16,
        "1213": 0.258,
        "1214": 0.136,
        "1215": 0.073,
        "1216": 0.016,
        "1217": 0.143,
        "1218": 0.147,
        "1219": 0.187,
        "1220": 0.073,
        "1221": 0.073,
        "1222": 0.1,
        "1223": 0.23,
        "1224": 0.629,
        "1225": 0.073,
        "1226": 0.332,
        "1227": 0.104,
        "1253": 35,
        "1257": 0.464,
        "1258": 7.032,
        "1259": 0.247,
        "1260": 0.202,
        "1261": 0.127,
        "1262": 0.303,
        "1263": 0.351,
        "1264": 1.148,
        "1265": 3.207,
        "1266": 1.221,
        "1267": 0.015,
        "1268": 2.905,
        "1269": 0.466,
        "1270": 0.041,
        "1271": 0.018,
        "1272": 0,
        "1273": 0.004,
        "1274": 0.124,
        "1275": 0.246,
        "1276": 0,
        "1277": 0.02,
        "1278": 0.003,
        "1279": 0,
        "1280": 0.006,
        "1292": 3.32,
        "1293": 0.554,
        "1299": 0.126,
        "1300": 0.076,
        "1301": 0.003,
        "1303": 0.041,
        "1304": 0.339,
        "1305": 0,
        "1306": 0.083,
        "1311": 0.069,
        "1312": 0,
        "1313": 0.003,
        "1314": 0.205,
        "1315": 2.566,
        "1316": 0.314,
        "1317": 0,
        "1321": 0,
        "1323": 0.025,
        "1325": 0.014,
        "1329": 0.38,
        "1331": 0.084,
        "1333": 0,
        "1404": 0.04,
        "1405": 0,
        "1406": 0.014,
        "1409": 0.001,
        "1411": 0.003,
        "2000": 4.13
      }
    },
    {
      "id": "172451",
      "name": "tofu (szójababsajt)",
      "category": "tejtermék",
      "state": "baked",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 600,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 18.82,
        "1004": 20.18,
        "1005": 8.86,
        "1008": 270,
        "1051": 50.52,
        "1058": 0,
        "1079": 3.9,
        "1087": 372,
        "1089": 4.87,
        "1090": 60,
        "1091": 287,
        "1092": 146,
        "1093": 16,
        "1095": 1.99,
        "1098": 0.398,
        "1101": 1.495,
        "1103": 28.5,
        "1105": 0,
        "1106": 1,
        "1107": 16,
        "1108": 0,
        "1109": 0.04,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0,
        "1165": 0.17,
        "1166": 0.05,
        "1167": 0.1,
        "1170": 0.14,
        "1175": 0.099,
        "1177": 27,
        "1178": 0,
        "1180": 106.3,
        "1185": 7.8,
        "1187": 27,
        "1190": 27,
        "1210": 0.268,
        "1211": 0.701,
        "1212": 0.852,
        "1213": 1.306,
        "1214": 1.131,
        "1215": 0.22,
        "1216": 0.238,
        "1217": 0.837,
        "1218": 0.575,
        "1219": 0.867,
        "1220": 1.143,
        "1221": 0.499,
        "1222": 0.704,
        "1223": 1.899,
        "1224": 2.97,
        "1225": 0.671,
        "1226": 0.927,
        "1227": 0.809,
        "1253": 0,
        "1257": 0,
        "1258": 2.918,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.056,
        "1265": 2.141,
        "1266": 0.72,
        "1268": 4.4,
        "1269": 10.044,
        "1270": 1.346,
        "1271": 0,
        "1272": 0,
        "1275": 0.056,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 4.456,
        "1293": 11.39,
        "2000": 2.72
      }
    },
    {
      "id": "172179",
      "name": "túró - krémállagú",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 11.12,
        "1004": 4.3,
        "1005": 3.38,
        "1008": 98,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 2.67,
        "1014": 0,
        "1051": 79.79,
        "1058": 0,
        "1075": 0,
        "1079": 0,
        "1087": 83,
        "1089": 0.07,
        "1090": 8,
        "1091": 159,
        "1092": 104,
        "1093": 315,
        "1095": 0.4,
        "1098": 0.029,
        "1099": 31.6,
        "1101": 0.002,
        "1103": 9.7,
        "1105": 36,
        "1106": 37,
        "1107": 12,
        "1108": 0,
        "1109": 0.08,
        "1112": 0.1,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.027,
        "1166": 0.163,
        "1167": 0.099,
        "1170": 0.557,
        "1175": 0.046,
        "1177": 12,
        "1178": 0.43,
        "1180": 18.4,
        "1183": 0.9,
        "1184": 0,
        "1185": 0,
        "1187": 12,
        "1190": 12,
        "1198": 0.7,
        "1210": 0.147,
        "1211": 0.5,
        "1212": 0.591,
        "1213": 1.116,
        "1214": 0.934,
        "1215": 0.269,
        "1216": 0.066,
        "1217": 0.577,
        "1218": 0.604,
        "1219": 0.748,
        "1220": 0.497,
        "1221": 0.326,
        "1222": 0.384,
        "1223": 0.905,
        "1224": 2.603,
        "1225": 0.222,
        "1226": 1.229,
        "1227": 0.639,
        "1253": 17,
        "1258": 1.718,
        "1259": 0.109,
        "1260": 0.025,
        "1261": 0.023,
        "1262": 0.064,
        "1263": 0.07,
        "1264": 0.263,
        "1265": 0.778,
        "1266": 0.345,
        "1268": 0.714,
        "1269": 0.105,
        "1270": 0.017,
        "1271": 0,
        "1272": 0,
        "1274": 0.017,
        "1275": 0.047,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.778,
        "1293": 0.123,
        "1299": 0.029,
        "1300": 0.012,
        "2000": 2.67
      }
    },
    {
      "id": "172182",
      "name": "túró - zsírszegény",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 10.45,
        "1004": 2.27,
        "1005": 4.76,
        "1008": 81,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 3.87,
        "1014": 0,
        "1051": 81.24,
        "1058": 0,
        "1075": 0.12,
        "1079": 0,
        "1087": 111,
        "1089": 0.13,
        "1090": 9,
        "1091": 150,
        "1092": 125,
        "1093": 308,
        "1095": 0.51,
        "1098": 0.033,
        "1101": 0.015,
        "1103": 11.9,
        "1105": 68,
        "1106": 68,
        "1107": 6,
        "1108": 0,
        "1109": 0.08,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.02,
        "1166": 0.251,
        "1167": 0.103,
        "1170": 0.524,
        "1175": 0.057,
        "1177": 8,
        "1178": 0.47,
        "1180": 16.3,
        "1183": 0,
        "1184": 0,
        "1185": 0,
        "1187": 8,
        "1190": 8,
        "1198": 0.6,
        "1210": 0.138,
        "1211": 0.47,
        "1212": 0.556,
        "1213": 1.049,
        "1214": 0.878,
        "1215": 0.253,
        "1216": 0.062,
        "1217": 0.543,
        "1218": 0.568,
        "1219": 0.703,
        "1220": 0.467,
        "1221": 0.306,
        "1222": 0.409,
        "1223": 0.963,
        "1224": 2.446,
        "1225": 0.209,
        "1226": 1.155,
        "1227": 0.601,
        "1253": 12,
        "1257": 0.067,
        "1258": 1.235,
        "1259": 0.04,
        "1260": 0.034,
        "1261": 0.027,
        "1262": 0.06,
        "1263": 0.061,
        "1264": 0.199,
        "1265": 0.561,
        "1266": 0.218,
        "1267": 0.003,
        "1268": 0.46,
        "1269": 0.07,
        "1270": 0.007,
        "1271": 0.003,
        "1272": 0,
        "1273": 0.001,
        "1274": 0.02,
        "1275": 0.03,
        "1276": 0,
        "1277": 0.003,
        "1278": 0.001,
        "1279": 0,
        "1280": 0.001,
        "1292": 0.516,
        "1293": 0.083,
        "1299": 0.021,
        "1300": 0.01,
        "1301": 0,
        "1303": 0.005,
        "1304": 0.05,
        "1305": 0,
        "1306": 0.013,
        "1311": 0.009,
        "1312": 0,
        "1313": 0,
        "1314": 0.025,
        "1315": 0.41,
        "1316": 0.047,
        "1317": 0,
        "1321": 0,
        "1323": 0.004,
        "1325": 0.002,
        "1329": 0.054,
        "1331": 0.013,
        "1333": 0,
        "1404": 0.007,
        "1405": 0,
        "1406": 0.002,
        "1409": 0,
        "1411": 0,
        "2000": 4
      }
    },
    {
      "id": "173430",
      "name": "vaj - 80% zsír",
      "category": "tejtermék",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": false,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.85,
        "1004": 81.11,
        "1005": 0.06,
        "1008": 717,
        "1051": 16.17,
        "1058": 0,
        "1079": 0,
        "1087": 24,
        "1089": 0.02,
        "1090": 2,
        "1091": 24,
        "1092": 24,
        "1093": 11,
        "1095": 0.09,
        "1098": 0.016,
        "1099": 2.8,
        "1101": 0.004,
        "1103": 1,
        "1105": 671,
        "1106": 684,
        "1107": 158,
        "1108": 0,
        "1109": 2.32,
        "1111": 0,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.005,
        "1166": 0.034,
        "1167": 0.042,
        "1170": 0.11,
        "1175": 0.003,
        "1177": 3,
        "1178": 0.17,
        "1180": 18.8,
        "1185": 7,
        "1187": 3,
        "1190": 3,
        "1210": 0.012,
        "1211": 0.038,
        "1212": 0.051,
        "1213": 0.083,
        "1214": 0.067,
        "1215": 0.021,
        "1216": 0.008,
        "1217": 0.041,
        "1218": 0.041,
        "1219": 0.057,
        "1220": 0.031,
        "1221": 0.023,
        "1222": 0.029,
        "1223": 0.064,
        "1224": 0.178,
        "1225": 0.018,
        "1226": 0.082,
        "1227": 0.046,
        "1253": 215,
        "1258": 50.489,
        "1259": 3.226,
        "1260": 2.007,
        "1261": 1.19,
        "1262": 2.529,
        "1263": 2.587,
        "1264": 7.436,
        "1265": 21.697,
        "1266": 9.999,
        "1267": 0.138,
        "1268": 20.4,
        "1269": 1.83,
        "1270": 1.18,
        "1271": 0,
        "1272": 0,
        "1275": 1.82,
        "1276": 0,
        "1277": 0.1,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 0,
        "1286": 0,
        "1288": 4,
        "1292": 23.43,
        "1293": 3.01,
        "1300": 0.56,
        "1304": 2.982,
        "1307": 0.296,
        "1311": 0.267,
        "1314": 0.961,
        "1315": 16.978,
        "1316": 2.166,
        "1404": 0.315,
        "2000": 0.06
      }
    },
    {
      "id": "171711",
      "name": "áfonya",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.74,
        "1004": 0.33,
        "1005": 14.49,
        "1008": 57,
        "1009": 0.03,
        "1010": 0.11,
        "1011": 4.88,
        "1012": 4.97,
        "1013": 0,
        "1014": 0,
        "1051": 84.21,
        "1058": 0,
        "1075": 0,
        "1079": 2.4,
        "1087": 6,
        "1089": 0.28,
        "1090": 6,
        "1091": 12,
        "1092": 77,
        "1093": 1,
        "1095": 0.16,
        "1098": 0.057,
        "1101": 0.336,
        "1103": 0.1,
        "1105": 0,
        "1106": 3,
        "1107": 32,
        "1108": 0,
        "1109": 0.57,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 80,
        "1125": 0.01,
        "1126": 0.36,
        "1127": 0.03,
        "1128": 0,
        "1129": 0,
        "1130": 0.07,
        "1131": 0,
        "1162": 9.7,
        "1165": 0.037,
        "1166": 0.041,
        "1167": 0.418,
        "1170": 0.124,
        "1175": 0.052,
        "1177": 6,
        "1178": 0,
        "1180": 6,
        "1184": 0,
        "1185": 19.3,
        "1187": 6,
        "1190": 6,
        "1198": 0.2,
        "1210": 0.003,
        "1211": 0.02,
        "1212": 0.023,
        "1213": 0.044,
        "1214": 0.013,
        "1215": 0.012,
        "1216": 0.008,
        "1217": 0.026,
        "1218": 0.009,
        "1219": 0.031,
        "1220": 0.037,
        "1221": 0.011,
        "1222": 0.031,
        "1223": 0.057,
        "1224": 0.091,
        "1225": 0.031,
        "1226": 0.028,
        "1227": 0.022,
        "1253": 0,
        "1257": 0,
        "1258": 0.028,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.017,
        "1266": 0.005,
        "1268": 0.047,
        "1269": 0.088,
        "1270": 0.058,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.047,
        "1293": 0.146,
        "2000": 9.96
      },
      "scientificName": "Vaccinium spp."
    },
    {
      "id": "168204",
      "name": "alma - gala",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.25,
        "1004": 0.12,
        "1005": 13.68,
        "1008": 57,
        "1009": 0.05,
        "1010": 2.78,
        "1011": 1.66,
        "1012": 5.93,
        "1013": 0,
        "1014": 0,
        "1051": 85.76,
        "1075": 0,
        "1079": 2.3,
        "1087": 7,
        "1089": 0.12,
        "1090": 5,
        "1091": 11,
        "1092": 108,
        "1093": 1,
        "1095": 0.05,
        "1098": 0.021,
        "1101": 0.037,
        "1103": 0,
        "1106": 1,
        "1107": 11,
        "1108": 0,
        "1109": 0.18,
        "1120": 11,
        "1122": 0,
        "1123": 11,
        "1165": 0.017,
        "1166": 0.029,
        "1167": 0.075,
        "1170": 0.055,
        "1175": 0.049,
        "1177": 3,
        "1180": 3.4,
        "1184": 0,
        "1185": 1.3,
        "1187": 3,
        "1257": 0,
        "2000": 10.37
      },
      "scientificName": "Malus domestica"
    },
    {
      "id": "168202",
      "name": "alma - golden delicious",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.28,
        "1004": 0.15,
        "1005": 13.6,
        "1008": 57,
        "1009": 0.05,
        "1010": 2.07,
        "1011": 1.87,
        "1012": 6.1,
        "1013": 0,
        "1014": 0,
        "1051": 85.81,
        "1075": 0,
        "1079": 2.4,
        "1087": 6,
        "1089": 0.13,
        "1090": 5,
        "1091": 10,
        "1092": 100,
        "1093": 2,
        "1095": 0.04,
        "1098": 0.03,
        "1101": 0.035,
        "1103": 0,
        "1106": 3,
        "1107": 25,
        "1108": 0,
        "1109": 0.18,
        "1120": 12,
        "1122": 0,
        "1123": 28,
        "1165": 0.018,
        "1166": 0.026,
        "1167": 0.094,
        "1170": 0.074,
        "1175": 0.051,
        "1177": 3,
        "1180": 5.1,
        "1184": 0,
        "1185": 1.8,
        "1187": 3,
        "1210": 0.001,
        "1211": 0.006,
        "1212": 0.006,
        "1213": 0.014,
        "1214": 0.013,
        "1215": 0.001,
        "1216": 0.001,
        "1217": 0.007,
        "1218": 0.001,
        "1219": 0.013,
        "1220": 0.006,
        "1221": 0.005,
        "1222": 0.012,
        "1223": 0.075,
        "1224": 0.026,
        "1225": 0.009,
        "1226": 0.006,
        "1227": 0.011,
        "1257": 0,
        "2000": 10.04
      },
      "scientificName": "Malus domestica"
    },
    {
      "id": "169134",
      "name": "alma - gránát",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.67,
        "1004": 1.17,
        "1005": 18.7,
        "1008": 83,
        "1051": 77.93,
        "1058": 0,
        "1079": 4,
        "1087": 10,
        "1089": 0.3,
        "1090": 12,
        "1091": 36,
        "1092": 236,
        "1093": 3,
        "1095": 0.35,
        "1098": 0.158,
        "1101": 0.119,
        "1103": 0.5,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.6,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 10.2,
        "1165": 0.067,
        "1166": 0.053,
        "1167": 0.293,
        "1170": 0.377,
        "1175": 0.075,
        "1177": 38,
        "1178": 0,
        "1180": 7.6,
        "1185": 16.4,
        "1187": 38,
        "1190": 38,
        "1253": 0,
        "1257": 0,
        "1258": 0.12,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.006,
        "1264": 0.006,
        "1265": 0.07,
        "1266": 0.038,
        "1268": 0.077,
        "1269": 0.079,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0.012,
        "1276": 0,
        "1277": 0.004,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 0,
        "1286": 1,
        "1288": 4,
        "1292": 0.093,
        "1293": 0.079,
        "2000": 13.67
      },
      "scientificName": "Punica granatum"
    },
    {
      "id": "168203",
      "name": "alma - granny smith",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.44,
        "1004": 0.19,
        "1005": 13.61,
        "1008": 58,
        "1009": 0.05,
        "1010": 1.93,
        "1011": 2.66,
        "1012": 5,
        "1013": 0,
        "1014": 0,
        "1051": 85.46,
        "1075": 0,
        "1079": 2.8,
        "1087": 5,
        "1089": 0.15,
        "1090": 5,
        "1091": 12,
        "1092": 120,
        "1093": 1,
        "1095": 0.04,
        "1098": 0.031,
        "1101": 0.044,
        "1103": 0.1,
        "1106": 5,
        "1107": 59,
        "1108": 0,
        "1109": 0.18,
        "1120": 2,
        "1122": 0,
        "1123": 64,
        "1165": 0.019,
        "1166": 0.025,
        "1167": 0.126,
        "1170": 0.056,
        "1175": 0.037,
        "1177": 3,
        "1180": 3.4,
        "1184": 0,
        "1185": 3.2,
        "1187": 3,
        "1257": 0,
        "2000": 9.59
      },
      "scientificName": "Malus domestica"
    },
    {
      "id": "169124",
      "name": "ananász",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.54,
        "1004": 0.12,
        "1005": 13.12,
        "1008": 50,
        "1009": 0,
        "1010": 5.99,
        "1011": 1.73,
        "1012": 2.12,
        "1013": 0,
        "1014": 0,
        "1051": 86,
        "1058": 0,
        "1075": 0,
        "1079": 1.4,
        "1087": 13,
        "1089": 0.29,
        "1090": 12,
        "1091": 8,
        "1092": 109,
        "1093": 1,
        "1095": 0.12,
        "1098": 0.11,
        "1101": 0.927,
        "1103": 0.1,
        "1105": 0,
        "1106": 3,
        "1107": 35,
        "1108": 0,
        "1109": 0.02,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 47.8,
        "1165": 0.079,
        "1166": 0.032,
        "1167": 0.5,
        "1170": 0.213,
        "1175": 0.112,
        "1177": 18,
        "1178": 0,
        "1180": 5.5,
        "1184": 0,
        "1185": 0.7,
        "1187": 18,
        "1190": 18,
        "1198": 0.1,
        "1210": 0.005,
        "1211": 0.019,
        "1212": 0.019,
        "1213": 0.024,
        "1214": 0.026,
        "1215": 0.012,
        "1216": 0.014,
        "1217": 0.021,
        "1218": 0.019,
        "1219": 0.024,
        "1220": 0.019,
        "1221": 0.01,
        "1222": 0.033,
        "1223": 0.121,
        "1224": 0.079,
        "1225": 0.024,
        "1226": 0.017,
        "1227": 0.035,
        "1253": 0,
        "1257": 0,
        "1258": 0.009,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.005,
        "1266": 0.003,
        "1268": 0.012,
        "1269": 0.023,
        "1270": 0.017,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 6,
        "1292": 0.013,
        "1293": 0.04,
        "2000": 9.85
      },
      "scientificName": "Ananas comosus"
    },
    {
      "id": "171705",
      "name": "avokádó",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2,
        "1004": 14.66,
        "1005": 8.53,
        "1008": 160,
        "1009": 0.11,
        "1010": 0.06,
        "1011": 0.37,
        "1012": 0.12,
        "1013": 0,
        "1014": 0,
        "1051": 73.23,
        "1058": 0,
        "1075": 0.1,
        "1079": 6.7,
        "1087": 12,
        "1089": 0.55,
        "1090": 29,
        "1091": 52,
        "1092": 485,
        "1093": 7,
        "1095": 0.64,
        "1098": 0.19,
        "1099": 7,
        "1101": 0.142,
        "1103": 0.4,
        "1105": 0,
        "1106": 7,
        "1107": 62,
        "1108": 24,
        "1109": 2.07,
        "1110": 0,
        "1114": 0,
        "1120": 28,
        "1122": 0,
        "1123": 271,
        "1125": 0.05,
        "1126": 0.33,
        "1127": 0.02,
        "1128": 0.01,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 10,
        "1165": 0.067,
        "1166": 0.13,
        "1167": 1.738,
        "1170": 1.389,
        "1175": 0.257,
        "1177": 81,
        "1178": 0,
        "1180": 14.2,
        "1184": 0,
        "1185": 21,
        "1187": 81,
        "1190": 81,
        "1198": 0.7,
        "1210": 0.025,
        "1211": 0.073,
        "1212": 0.084,
        "1213": 0.143,
        "1214": 0.132,
        "1215": 0.038,
        "1216": 0.027,
        "1217": 0.097,
        "1218": 0.049,
        "1219": 0.107,
        "1220": 0.088,
        "1221": 0.049,
        "1222": 0.109,
        "1223": 0.236,
        "1224": 0.287,
        "1225": 0.104,
        "1226": 0.098,
        "1227": 0.114,
        "1253": 0,
        "1257": 0,
        "1258": 2.126,
        "1259": 0,
        "1260": 0,
        "1261": 0.001,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 2.075,
        "1266": 0.049,
        "1267": 0,
        "1268": 9.066,
        "1269": 1.674,
        "1270": 0.125,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.698,
        "1276": 0,
        "1277": 0.025,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 2,
        "1286": 5,
        "1288": 76,
        "1292": 9.799,
        "1293": 1.816,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1321": 0.015,
        "1323": 0.01,
        "1325": 0.016,
        "1333": 0,
        "1404": 0.111,
        "2000": 0.66
      },
      "scientificName": "Persea americana"
    },
    {
      "id": "169322",
      "name": "bab - hüvelyes - sárga - friss",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.89,
        "1004": 0.28,
        "1005": 7.88,
        "1008": 35,
        "1051": 89.22,
        "1058": 0,
        "1079": 3.3,
        "1087": 46,
        "1089": 1.28,
        "1090": 25,
        "1091": 39,
        "1092": 299,
        "1093": 3,
        "1095": 0.36,
        "1098": 0.103,
        "1101": 0.294,
        "1103": 0.4,
        "1105": 0,
        "1106": 4,
        "1107": 49,
        "1108": 0,
        "1109": 0.46,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 712,
        "1162": 9.7,
        "1165": 0.074,
        "1166": 0.097,
        "1167": 0.614,
        "1170": 0.074,
        "1175": 0.056,
        "1177": 33,
        "1178": 0,
        "1180": 16.9,
        "1185": 47.9,
        "1187": 33,
        "1190": 33,
        "1198": 0.1,
        "1210": 0.02,
        "1211": 0.082,
        "1212": 0.069,
        "1213": 0.116,
        "1214": 0.091,
        "1215": 0.023,
        "1216": 0.018,
        "1217": 0.069,
        "1218": 0.044,
        "1219": 0.093,
        "1220": 0.076,
        "1221": 0.035,
        "1222": 0.087,
        "1223": 0.265,
        "1224": 0.194,
        "1225": 0.068,
        "1226": 0.07,
        "1227": 0.103,
        "1253": 0,
        "1257": 0,
        "1258": 0.064,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.053,
        "1266": 0.009,
        "1268": 0.011,
        "1269": 0.056,
        "1270": 0.089,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.011,
        "1293": 0.145,
        "2000": 3.63
      },
      "scientificName": "Phaseolus vulgaris"
    },
    {
      "id": "169141",
      "name": "bab - hüvelyes - zöld - friss",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.89,
        "1004": 0.28,
        "1005": 7.88,
        "1008": 35,
        "1051": 89.22,
        "1058": 0,
        "1079": 3.2,
        "1087": 44,
        "1089": 0.65,
        "1090": 18,
        "1091": 29,
        "1092": 146,
        "1093": 1,
        "1095": 0.25,
        "1098": 0.057,
        "1101": 0.285,
        "1103": 0.2,
        "1105": 0,
        "1106": 32,
        "1107": 380,
        "1108": 0,
        "1109": 0.46,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 641,
        "1162": 9.7,
        "1165": 0.074,
        "1166": 0.097,
        "1167": 0.614,
        "1170": 0.074,
        "1175": 0.056,
        "1177": 33,
        "1178": 0,
        "1180": 16.9,
        "1185": 47.9,
        "1187": 33,
        "1190": 33,
        "1198": 0.1,
        "1210": 0.02,
        "1211": 0.082,
        "1212": 0.069,
        "1213": 0.116,
        "1214": 0.091,
        "1215": 0.023,
        "1216": 0.018,
        "1217": 0.069,
        "1218": 0.044,
        "1219": 0.093,
        "1220": 0.076,
        "1221": 0.035,
        "1222": 0.087,
        "1223": 0.265,
        "1224": 0.194,
        "1225": 0.068,
        "1226": 0.07,
        "1227": 0.103,
        "1253": 0,
        "1257": 0,
        "1258": 0.064,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.053,
        "1266": 0.009,
        "1268": 0.011,
        "1269": 0.056,
        "1270": 0.089,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.011,
        "1293": 0.145,
        "2000": 3.63
      },
      "scientificName": "Phaseolus vulgaris"
    },
    {
      "id": "173750",
      "name": "bab - kis fehér",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 8.97,
        "1004": 0.64,
        "1005": 25.81,
        "1008": 142,
        "1051": 63.24,
        "1079": 10.4,
        "1087": 73,
        "1089": 2.84,
        "1090": 68,
        "1091": 169,
        "1092": 463,
        "1093": 2,
        "1095": 1.09,
        "1098": 0.149,
        "1101": 0.51,
        "1103": 1.3,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 0,
        "1165": 0.236,
        "1166": 0.059,
        "1167": 0.272,
        "1170": 0.251,
        "1175": 0.127,
        "1177": 137,
        "1178": 0,
        "1187": 137,
        "1190": 137,
        "1210": 0.106,
        "1211": 0.377,
        "1212": 0.396,
        "1213": 0.716,
        "1214": 0.616,
        "1215": 0.135,
        "1216": 0.098,
        "1217": 0.485,
        "1218": 0.253,
        "1219": 0.469,
        "1220": 0.555,
        "1221": 0.25,
        "1222": 0.376,
        "1223": 1.085,
        "1224": 1.368,
        "1225": 0.35,
        "1226": 0.38,
        "1227": 0.488,
        "1253": 0,
        "1257": 0,
        "1258": 0.166,
        "1264": 0,
        "1265": 0.155,
        "1266": 0.01,
        "1268": 0.056,
        "1269": 0.15,
        "1270": 0.126,
        "1292": 0.056,
        "1293": 0.276
      },
      "scientificName": "Phaseolus vulgaris"
    },
    {
      "id": "175200",
      "name": "bab - tarka",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 9.01,
        "1004": 0.65,
        "1005": 26.22,
        "1008": 143,
        "1009": 15.15,
        "1010": 0.34,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 62.95,
        "1058": 0,
        "1075": 0,
        "1079": 9,
        "1087": 46,
        "1089": 2.09,
        "1090": 50,
        "1091": 147,
        "1092": 436,
        "1093": 1,
        "1095": 0.98,
        "1098": 0.219,
        "1099": 2.2,
        "1101": 0.453,
        "1103": 6.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.94,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.8,
        "1165": 0.193,
        "1166": 0.062,
        "1167": 0.318,
        "1170": 0.21,
        "1175": 0.229,
        "1177": 172,
        "1178": 0,
        "1180": 35.3,
        "1184": 0,
        "1185": 3.5,
        "1187": 172,
        "1190": 172,
        "1198": 0.1,
        "1210": 0.108,
        "1211": 0.331,
        "1212": 0.426,
        "1213": 0.765,
        "1214": 0.63,
        "1215": 0.117,
        "1216": 0.084,
        "1217": 0.531,
        "1218": 0.213,
        "1219": 0.519,
        "1220": 0.494,
        "1221": 0.247,
        "1222": 0.409,
        "1223": 1.128,
        "1224": 1.447,
        "1225": 0.365,
        "1226": 0.515,
        "1227": 0.565,
        "1253": 0,
        "1257": 0,
        "1258": 0.136,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.133,
        "1266": 0.003,
        "1268": 0.133,
        "1269": 0.098,
        "1270": 0.137,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.133,
        "1293": 0.235,
        "2000": 0.34
      },
      "scientificName": "Phaseolus vulgaris"
    },
    {
      "id": "173740",
      "name": "bab - vese",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 8.67,
        "1004": 0.5,
        "1005": 22.8,
        "1008": 127,
        "1051": 66.94,
        "1058": 0,
        "1079": 6.4,
        "1087": 35,
        "1089": 2.22,
        "1090": 42,
        "1091": 138,
        "1092": 405,
        "1093": 1,
        "1095": 1,
        "1098": 0.216,
        "1101": 0.43,
        "1103": 1.1,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.03,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0.92,
        "1127": 0.01,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 1.2,
        "1165": 0.16,
        "1166": 0.058,
        "1167": 0.578,
        "1170": 0.22,
        "1175": 0.12,
        "1177": 130,
        "1178": 0,
        "1180": 30.5,
        "1185": 8.4,
        "1187": 130,
        "1190": 130,
        "1198": 0.1,
        "1210": 0.104,
        "1211": 0.319,
        "1212": 0.41,
        "1213": 0.736,
        "1214": 0.607,
        "1215": 0.113,
        "1216": 0.081,
        "1217": 0.511,
        "1218": 0.205,
        "1219": 0.5,
        "1220": 0.475,
        "1221": 0.238,
        "1222": 0.394,
        "1223": 1.086,
        "1224": 1.393,
        "1225": 0.351,
        "1226": 0.496,
        "1227": 0.544,
        "1253": 0,
        "1257": 0,
        "1258": 0.073,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.065,
        "1266": 0.008,
        "1268": 0.039,
        "1269": 0.108,
        "1270": 0.17,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.039,
        "1293": 0.278,
        "2000": 0.32
      },
      "scientificName": "Phaseolus vulgaris"
    },
    {
      "id": "169131",
      "name": "banán - főző - sárga",
      "category": "zöldség",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.52,
        "1004": 0.16,
        "1005": 41.37,
        "1008": 155,
        "1009": 17.93,
        "1010": 13.72,
        "1011": 3.79,
        "1012": 3.82,
        "1013": 0,
        "1014": 0,
        "1051": 55.87,
        "1058": 0,
        "1075": 0,
        "1079": 2.2,
        "1087": 3,
        "1089": 0.28,
        "1090": 41,
        "1091": 37,
        "1092": 477,
        "1093": 2,
        "1095": 0.21,
        "1098": 0.044,
        "1101": 0.165,
        "1103": 0,
        "1105": 0,
        "1106": 45,
        "1107": 369,
        "1108": 353,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 28,
        "1162": 16.4,
        "1165": 0.09,
        "1166": 0.13,
        "1167": 0.685,
        "1170": 0.53,
        "1175": 0.21,
        "1177": 53,
        "1178": 0,
        "1180": 12.7,
        "1183": 0,
        "1184": 0,
        "1185": 12.9,
        "1187": 53,
        "1190": 53,
        "1210": 0.021,
        "1211": 0.053,
        "1212": 0.042,
        "1213": 0.084,
        "1214": 0.074,
        "1215": 0.01,
        "1216": 0.021,
        "1217": 0.053,
        "1218": 0.031,
        "1219": 0.042,
        "1220": 0.084,
        "1221": 0.126,
        "1222": 0.063,
        "1223": 0.115,
        "1224": 0.105,
        "1225": 0.063,
        "1226": 0.074,
        "1227": 0.063,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1267": 0,
        "1268": 0,
        "1269": 0,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1303": 0,
        "1304": 0,
        "1305": 0,
        "1306": 0,
        "1311": 0,
        "1312": 0,
        "1313": 0,
        "1314": 0,
        "1315": 0,
        "1316": 0,
        "1317": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1331": 0,
        "1333": 0,
        "1404": 0,
        "1405": 0,
        "1406": 0,
        "1409": 0,
        "1411": 0,
        "2000": 21.33
      },
      "scientificName": "Musa X paradisiaca"
    },
    {
      "id": "168216",
      "name": "banán - főző - zöld",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.09,
        "1004": 0.08,
        "1005": 29.15,
        "1008": 121,
        "1009": 24.47,
        "1010": 1.52,
        "1011": 0.38,
        "1012": 0.35,
        "1013": 0,
        "1014": 0,
        "1051": 69.08,
        "1075": 0,
        "1079": 2.6,
        "1087": 3,
        "1089": 0.3,
        "1090": 28,
        "1091": 24,
        "1092": 289,
        "1093": 2,
        "1095": 0.14,
        "1098": 0.08,
        "1101": 0.109,
        "1103": 0,
        "1162": 9.1,
        "1165": 0.05,
        "1166": 0.065,
        "1167": 0.39,
        "1170": 0.38,
        "1175": 0.22,
        "1177": 48,
        "1183": 0,
        "1184": 0,
        "1185": 3.8,
        "1187": 48,
        "1210": 0.01,
        "1211": 0.02,
        "1212": 0.02,
        "1213": 0.04,
        "1214": 0.05,
        "1215": 0.007,
        "1216": 0.02,
        "1217": 0.03,
        "1218": 0.02,
        "1219": 0.02,
        "1220": 0.06,
        "1221": 0.06,
        "1222": 0.03,
        "1223": 0.09,
        "1224": 0.08,
        "1225": 0.03,
        "1226": 0.03,
        "1227": 0.03,
        "1228": 0,
        "1257": 0.001,
        "1258": 0.072,
        "1259": 0.008,
        "1260": 0,
        "1261": 0.002,
        "1262": 0.002,
        "1263": 0.001,
        "1264": 0.003,
        "1265": 0.044,
        "1266": 0.007,
        "1267": 0,
        "1268": 0.012,
        "1269": 0.052,
        "1270": 0.026,
        "1271": 0,
        "1272": 0,
        "1273": 0.001,
        "1274": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.013,
        "1293": 0.078,
        "1299": 0.002,
        "1300": 0.001,
        "1301": 0.001,
        "1303": 0,
        "1304": 0.001,
        "1305": 0,
        "1306": 0,
        "1311": 0,
        "1312": 0,
        "1313": 0,
        "1314": 0.001,
        "1315": 0.011,
        "1316": 0.052,
        "1317": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0.001,
        "1331": 0,
        "1333": 0,
        "1404": 0.026,
        "1405": 0,
        "1406": 0,
        "1409": 0,
        "1411": 0,
        "2000": 2.25
      },
      "scientificName": "Musa X paradisiaca"
    },
    {
      "id": "173944",
      "name": "banán - normál",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.09,
        "1004": 0.33,
        "1005": 22.84,
        "1008": 89,
        "1009": 5.38,
        "1010": 2.39,
        "1011": 4.98,
        "1012": 4.85,
        "1013": 0,
        "1014": 0.01,
        "1051": 74.91,
        "1058": 0,
        "1075": 0,
        "1079": 2.6,
        "1087": 5,
        "1089": 0.26,
        "1090": 27,
        "1091": 22,
        "1092": 358,
        "1093": 1,
        "1095": 0.15,
        "1098": 0.078,
        "1099": 2.2,
        "1101": 0.27,
        "1103": 1,
        "1105": 0,
        "1106": 3,
        "1107": 26,
        "1108": 25,
        "1109": 0.1,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 22,
        "1125": 0,
        "1126": 0.02,
        "1127": 0.01,
        "1128": 0.06,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 8.7,
        "1165": 0.031,
        "1166": 0.073,
        "1167": 0.665,
        "1170": 0.334,
        "1175": 0.367,
        "1177": 20,
        "1178": 0,
        "1180": 9.8,
        "1184": 0,
        "1185": 0.5,
        "1187": 20,
        "1190": 20,
        "1198": 0.1,
        "1210": 0.009,
        "1211": 0.028,
        "1212": 0.028,
        "1213": 0.068,
        "1214": 0.05,
        "1215": 0.008,
        "1216": 0.009,
        "1217": 0.049,
        "1218": 0.009,
        "1219": 0.047,
        "1220": 0.049,
        "1221": 0.077,
        "1222": 0.04,
        "1223": 0.124,
        "1224": 0.152,
        "1225": 0.038,
        "1226": 0.028,
        "1227": 0.04,
        "1253": 0,
        "1257": 0,
        "1258": 0.112,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.001,
        "1263": 0.002,
        "1264": 0.002,
        "1265": 0.102,
        "1266": 0.005,
        "1268": 0.022,
        "1269": 0.046,
        "1270": 0.027,
        "1271": 0,
        "1272": 0,
        "1275": 0.01,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 16,
        "1292": 0.032,
        "1293": 0.073,
        "2000": 12.23
      },
      "scientificName": "Musa acuminata Colla"
    },
    {
      "id": "169928",
      "name": "barack - sárga",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.91,
        "1004": 0.25,
        "1005": 9.54,
        "1008": 39,
        "1009": 0,
        "1010": 4.76,
        "1011": 1.95,
        "1012": 1.53,
        "1013": 0,
        "1014": 0.08,
        "1051": 88.87,
        "1058": 0,
        "1075": 0.06,
        "1079": 1.5,
        "1087": 6,
        "1089": 0.25,
        "1090": 9,
        "1091": 20,
        "1092": 190,
        "1093": 0,
        "1095": 0.17,
        "1098": 0.068,
        "1099": 4,
        "1101": 0.061,
        "1103": 0.1,
        "1105": 0,
        "1106": 16,
        "1107": 162,
        "1108": 0,
        "1109": 0.73,
        "1110": 0,
        "1114": 0,
        "1120": 67,
        "1122": 0,
        "1123": 91,
        "1125": 0,
        "1126": 0.02,
        "1127": 0,
        "1128": 0.03,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 6.6,
        "1165": 0.024,
        "1166": 0.031,
        "1167": 0.806,
        "1170": 0.153,
        "1175": 0.025,
        "1177": 4,
        "1178": 0,
        "1180": 6.1,
        "1184": 0,
        "1185": 2.6,
        "1187": 4,
        "1190": 4,
        "1198": 0.3,
        "1210": 0.01,
        "1211": 0.016,
        "1212": 0.017,
        "1213": 0.027,
        "1214": 0.03,
        "1215": 0.01,
        "1216": 0.012,
        "1217": 0.019,
        "1218": 0.014,
        "1219": 0.022,
        "1220": 0.018,
        "1221": 0.013,
        "1222": 0.028,
        "1223": 0.418,
        "1224": 0.056,
        "1225": 0.021,
        "1226": 0.018,
        "1227": 0.032,
        "1253": 0,
        "1257": 0,
        "1258": 0.019,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.017,
        "1266": 0.002,
        "1268": 0.065,
        "1269": 0.084,
        "1270": 0.002,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 10,
        "1292": 0.067,
        "1293": 0.086,
        "2000": 8.39
      },
      "scientificName": "Prunus persica"
    },
    {
      "id": "173757",
      "name": "borsó - csicseri",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 8.86,
        "1004": 2.59,
        "1005": 27.42,
        "1008": 164,
        "1051": 60.21,
        "1058": 0,
        "1079": 7.6,
        "1087": 49,
        "1089": 2.89,
        "1090": 48,
        "1091": 168,
        "1092": 291,
        "1093": 7,
        "1095": 1.53,
        "1098": 0.352,
        "1101": 1.03,
        "1103": 3.7,
        "1105": 0,
        "1106": 1,
        "1107": 16,
        "1108": 0,
        "1109": 0.35,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 1.3,
        "1165": 0.116,
        "1166": 0.063,
        "1167": 0.526,
        "1170": 0.286,
        "1175": 0.139,
        "1177": 172,
        "1178": 0,
        "1180": 42.8,
        "1185": 4,
        "1187": 172,
        "1190": 172,
        "1210": 0.085,
        "1211": 0.329,
        "1212": 0.38,
        "1213": 0.631,
        "1214": 0.593,
        "1215": 0.116,
        "1216": 0.119,
        "1217": 0.475,
        "1218": 0.22,
        "1219": 0.372,
        "1220": 0.835,
        "1221": 0.244,
        "1222": 0.38,
        "1223": 1.042,
        "1224": 1.55,
        "1225": 0.369,
        "1226": 0.366,
        "1227": 0.447,
        "1253": 0,
        "1257": 0,
        "1258": 0.269,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.004,
        "1265": 0.215,
        "1266": 0.037,
        "1268": 0.578,
        "1269": 1.113,
        "1270": 0.043,
        "1271": 0,
        "1272": 0,
        "1275": 0.005,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.583,
        "1293": 1.156,
        "2000": 4.8
      }
    },
    {
      "id": "172429",
      "name": "borsó - sárga",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 150,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 8.34,
        "1004": 0.39,
        "1005": 21.1,
        "1008": 118,
        "1051": 69.49,
        "1058": 0,
        "1079": 8.3,
        "1087": 14,
        "1089": 1.29,
        "1090": 36,
        "1091": 99,
        "1092": 362,
        "1093": 2,
        "1095": 1,
        "1098": 0.181,
        "1101": 0.396,
        "1103": 0.6,
        "1105": 0,
        "1106": 0,
        "1107": 4,
        "1108": 0,
        "1109": 0.03,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 0.4,
        "1165": 0.19,
        "1166": 0.056,
        "1167": 0.89,
        "1170": 0.595,
        "1175": 0.048,
        "1177": 65,
        "1178": 0,
        "1180": 32.8,
        "1185": 5,
        "1187": 65,
        "1190": 65,
        "1210": 0.093,
        "1211": 0.296,
        "1212": 0.344,
        "1213": 0.598,
        "1214": 0.602,
        "1215": 0.085,
        "1216": 0.127,
        "1217": 0.384,
        "1218": 0.242,
        "1219": 0.394,
        "1220": 0.744,
        "1221": 0.203,
        "1222": 0.367,
        "1223": 0.984,
        "1224": 1.426,
        "1225": 0.371,
        "1226": 0.344,
        "1227": 0.367,
        "1253": 0,
        "1257": 0,
        "1258": 0.054,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.001,
        "1264": 0.001,
        "1265": 0.042,
        "1266": 0.01,
        "1268": 0.077,
        "1269": 0.137,
        "1270": 0.028,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0.003,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.081,
        "1293": 0.165,
        "2000": 2.9
      },
      "scientificName": "Pisum sativum"
    },
    {
      "id": "170420",
      "name": "borsó - zöld",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 5.36,
        "1004": 0.22,
        "1005": 15.63,
        "1008": 84,
        "1010": 5.22,
        "1011": 0.13,
        "1012": 0.41,
        "1013": 0,
        "1014": 0.18,
        "1051": 77.87,
        "1058": 0,
        "1075": 0,
        "1079": 5.5,
        "1087": 27,
        "1089": 1.54,
        "1090": 39,
        "1091": 117,
        "1092": 271,
        "1093": 3,
        "1095": 1.19,
        "1098": 0.173,
        "1101": 0.525,
        "1103": 1.9,
        "1105": 0,
        "1106": 40,
        "1107": 470,
        "1108": 22,
        "1109": 0.14,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 2593,
        "1125": 0,
        "1126": 0.99,
        "1127": 0.02,
        "1162": 14.2,
        "1165": 0.259,
        "1166": 0.149,
        "1167": 2.021,
        "1170": 0.153,
        "1175": 0.216,
        "1177": 63,
        "1178": 0,
        "1180": 29.7,
        "1185": 25.9,
        "1187": 63,
        "1190": 63,
        "1198": 0.2,
        "1210": 0.037,
        "1211": 0.201,
        "1212": 0.193,
        "1213": 0.32,
        "1214": 0.314,
        "1215": 0.081,
        "1216": 0.032,
        "1217": 0.198,
        "1218": 0.112,
        "1219": 0.232,
        "1220": 0.423,
        "1221": 0.105,
        "1222": 0.237,
        "1223": 0.49,
        "1224": 0.733,
        "1225": 0.182,
        "1226": 0.171,
        "1227": 0.179,
        "1253": 0,
        "1257": 0,
        "1258": 0.039,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.035,
        "1266": 0.004,
        "1268": 0.019,
        "1269": 0.082,
        "1270": 0.019,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.019,
        "1293": 0.102,
        "2000": 5.93
      },
      "scientificName": "Pisum sativum"
    },
    {
      "id": "170569",
      "name": "brazildió",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 2.5,
      "portionGrams": 2.5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 14.32,
        "1004": 67.1,
        "1005": 11.74,
        "1008": 659,
        "1009": 0.25,
        "1010": 2.33,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 3.42,
        "1058": 0,
        "1075": 0,
        "1079": 7.5,
        "1087": 160,
        "1089": 2.43,
        "1090": 376,
        "1091": 725,
        "1092": 659,
        "1093": 3,
        "1095": 4.06,
        "1098": 1.743,
        "1101": 1.223,
        "1103": 1917,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 5.65,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.01,
        "1126": 9.56,
        "1127": 0.63,
        "1128": 0,
        "1129": 0,
        "1130": 0.17,
        "1131": 0,
        "1162": 0.7,
        "1165": 0.617,
        "1166": 0.035,
        "1167": 0.295,
        "1170": 0.184,
        "1175": 0.101,
        "1177": 22,
        "1178": 0,
        "1180": 28.8,
        "1184": 0,
        "1185": 0,
        "1187": 22,
        "1190": 22,
        "1198": 0.4,
        "1210": 0.135,
        "1211": 0.365,
        "1212": 0.518,
        "1213": 1.19,
        "1214": 0.49,
        "1215": 1.124,
        "1216": 0.306,
        "1217": 0.639,
        "1218": 0.416,
        "1219": 0.76,
        "1220": 2.14,
        "1221": 0.409,
        "1222": 0.609,
        "1223": 1.325,
        "1224": 3.19,
        "1225": 0.733,
        "1226": 0.706,
        "1227": 0.676,
        "1253": 0,
        "1258": 16.134,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.046,
        "1265": 9.626,
        "1266": 6.244,
        "1267": 0.167,
        "1268": 23.594,
        "1269": 24.363,
        "1270": 0.036,
        "1271": 0,
        "1272": 0,
        "1273": 0.01,
        "1274": 0,
        "1275": 0.214,
        "1276": 0,
        "1277": 0.027,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 6,
        "1286": 2,
        "1288": 64,
        "1292": 23.879,
        "1293": 24.399,
        "1299": 0,
        "1300": 0.041,
        "1301": 0,
        "1313": 0,
        "1316": 23.859,
        "1321": 0.018,
        "1323": 0.045,
        "1325": 0,
        "1333": 0,
        "1404": 0.018,
        "2000": 2.33
      },
      "scientificName": "Bertholletia excelsa"
    },
    {
      "id": "169967",
      "name": "brokkoli",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.38,
        "1004": 0.41,
        "1005": 7.18,
        "1008": 35,
        "1009": 0,
        "1010": 0.08,
        "1011": 0.49,
        "1012": 0.74,
        "1013": 0,
        "1014": 0,
        "1051": 89.25,
        "1058": 0,
        "1075": 0,
        "1079": 3.3,
        "1087": 40,
        "1089": 0.67,
        "1090": 21,
        "1091": 67,
        "1092": 293,
        "1093": 41,
        "1095": 0.45,
        "1098": 0.061,
        "1099": 4,
        "1101": 0.194,
        "1103": 1.6,
        "1105": 0,
        "1106": 77,
        "1107": 929,
        "1108": 0,
        "1109": 1.45,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1080,
        "1125": 0.01,
        "1126": 0.25,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 64.9,
        "1165": 0.063,
        "1166": 0.123,
        "1167": 0.553,
        "1170": 0.616,
        "1175": 0.2,
        "1177": 108,
        "1178": 0,
        "1180": 40.1,
        "1184": 0,
        "1185": 141.1,
        "1187": 108,
        "1190": 108,
        "1198": 0.1,
        "1210": 0.034,
        "1211": 0.096,
        "1212": 0.092,
        "1213": 0.147,
        "1214": 0.155,
        "1215": 0.043,
        "1216": 0.031,
        "1217": 0.116,
        "1218": 0.06,
        "1219": 0.138,
        "1220": 0.2,
        "1221": 0.063,
        "1222": 0.114,
        "1223": 0.329,
        "1224": 0.549,
        "1225": 0.101,
        "1226": 0.111,
        "1227": 0.129,
        "1253": 0,
        "1257": 0,
        "1258": 0.079,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.002,
        "1264": 0,
        "1265": 0.056,
        "1266": 0.013,
        "1267": 0.004,
        "1268": 0.029,
        "1269": 0.051,
        "1270": 0.119,
        "1271": 0,
        "1272": 0,
        "1273": 0.005,
        "1274": 0,
        "1275": 0.009,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.04,
        "1293": 0.17,
        "1299": 0,
        "1300": 0,
        "1313": 0,
        "1321": 0,
        "1323": 0.002,
        "1325": 0,
        "1333": 0,
        "2000": 1.39
      },
      "scientificName": "Brassica oleracea var. italica"
    },
    {
      "id": "170287",
      "name": "bulgur",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.08,
        "1004": 0.24,
        "1005": 18.58,
        "1008": 83,
        "1051": 77.76,
        "1058": 0,
        "1079": 4.5,
        "1087": 10,
        "1089": 0.96,
        "1090": 32,
        "1091": 40,
        "1092": 68,
        "1093": 5,
        "1095": 0.57,
        "1098": 0.075,
        "1101": 0.609,
        "1103": 0.6,
        "1105": 0,
        "1106": 0,
        "1107": 1,
        "1108": 0,
        "1109": 0.01,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 54,
        "1162": 0,
        "1165": 0.057,
        "1166": 0.028,
        "1167": 1,
        "1170": 0.344,
        "1175": 0.083,
        "1177": 18,
        "1178": 0,
        "1180": 6.9,
        "1185": 0.5,
        "1187": 18,
        "1190": 18,
        "1198": 83.4,
        "1210": 0.048,
        "1211": 0.089,
        "1212": 0.114,
        "1213": 0.208,
        "1214": 0.085,
        "1215": 0.048,
        "1216": 0.071,
        "1217": 0.145,
        "1218": 0.09,
        "1219": 0.139,
        "1220": 0.144,
        "1221": 0.071,
        "1222": 0.109,
        "1223": 0.158,
        "1224": 0.973,
        "1225": 0.124,
        "1226": 0.32,
        "1227": 0.145,
        "1253": 0,
        "1258": 0.042,
        "1259": 0,
        "1260": 0,
        "1261": 0.002,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.037,
        "1266": 0.002,
        "1268": 0.03,
        "1269": 0.094,
        "1270": 0.004,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.031,
        "1293": 0.098,
        "2000": 0.1
      }
    },
    {
      "id": "168484",
      "name": "burgonya - édes",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.37,
        "1004": 0.14,
        "1005": 17.72,
        "1008": 76,
        "1009": 5.22,
        "1010": 1.43,
        "1011": 0.54,
        "1012": 0.43,
        "1013": 0,
        "1014": 3.34,
        "1051": 80.13,
        "1058": 0,
        "1075": 0,
        "1079": 2.5,
        "1087": 27,
        "1089": 0.72,
        "1090": 18,
        "1091": 32,
        "1092": 230,
        "1093": 27,
        "1095": 0.2,
        "1098": 0.094,
        "1101": 0.266,
        "1103": 0.2,
        "1105": 0,
        "1106": 787,
        "1107": 9444,
        "1108": 0,
        "1109": 0.94,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0.01,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 12.8,
        "1165": 0.056,
        "1166": 0.047,
        "1167": 0.538,
        "1170": 0.581,
        "1175": 0.165,
        "1177": 6,
        "1178": 0,
        "1180": 10.8,
        "1184": 0,
        "1185": 2.1,
        "1187": 6,
        "1190": 6,
        "1210": 0.028,
        "1211": 0.073,
        "1212": 0.048,
        "1213": 0.081,
        "1214": 0.058,
        "1215": 0.025,
        "1216": 0.019,
        "1217": 0.078,
        "1218": 0.03,
        "1219": 0.075,
        "1220": 0.048,
        "1221": 0.027,
        "1222": 0.067,
        "1223": 0.335,
        "1224": 0.135,
        "1225": 0.055,
        "1226": 0.046,
        "1227": 0.077,
        "1253": 0,
        "1257": 0,
        "1258": 0.031,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.031,
        "1266": 0,
        "1267": 0,
        "1268": 0,
        "1269": 0.061,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0.061,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 5.74
      },
      "scientificName": "Ipomoea batatas"
    },
    {
      "id": "168892",
      "name": "búzacsíra",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 23.15,
        "1004": 9.72,
        "1005": 51.8,
        "1008": 360,
        "1051": 11.12,
        "1079": 13.2,
        "1087": 39,
        "1089": 6.26,
        "1090": 239,
        "1091": 842,
        "1092": 892,
        "1093": 12,
        "1095": 12.29,
        "1098": 0.796,
        "1101": 13.301,
        "1103": 79.2,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 0,
        "1165": 1.882,
        "1166": 0.499,
        "1167": 6.813,
        "1170": 2.257,
        "1175": 1.3,
        "1177": 281,
        "1178": 0,
        "1187": 281,
        "1190": 281,
        "1210": 0.317,
        "1211": 0.968,
        "1212": 0.847,
        "1213": 1.571,
        "1214": 1.468,
        "1215": 0.456,
        "1216": 0.458,
        "1217": 0.928,
        "1218": 0.704,
        "1219": 1.198,
        "1220": 1.867,
        "1221": 0.643,
        "1222": 1.477,
        "1223": 2.07,
        "1224": 3.995,
        "1225": 1.424,
        "1226": 1.231,
        "1227": 1.102,
        "1253": 0,
        "1258": 1.665,
        "1264": 0.013,
        "1265": 1.587,
        "1266": 0.055,
        "1268": 1.332,
        "1269": 5.287,
        "1270": 0.723,
        "1275": 0.034,
        "1292": 1.365,
        "1293": 6.01
      }
    },
    {
      "id": "169146",
      "name": "cékla",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 20,
      "portionGrams": 20,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 150,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.68,
        "1004": 0.18,
        "1005": 9.96,
        "1008": 44,
        "1051": 87.06,
        "1058": 0,
        "1079": 2,
        "1087": 16,
        "1089": 0.79,
        "1090": 23,
        "1091": 38,
        "1092": 305,
        "1093": 77,
        "1095": 0.35,
        "1098": 0.074,
        "1101": 0.326,
        "1103": 0.7,
        "1105": 0,
        "1106": 2,
        "1107": 21,
        "1108": 0,
        "1109": 0.04,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 3.6,
        "1165": 0.027,
        "1166": 0.04,
        "1167": 0.331,
        "1170": 0.145,
        "1175": 0.067,
        "1177": 80,
        "1178": 0,
        "1180": 6.3,
        "1185": 0.2,
        "1187": 80,
        "1190": 80,
        "1210": 0.02,
        "1211": 0.049,
        "1212": 0.05,
        "1213": 0.071,
        "1214": 0.06,
        "1215": 0.019,
        "1216": 0.02,
        "1217": 0.048,
        "1218": 0.04,
        "1219": 0.059,
        "1220": 0.044,
        "1221": 0.022,
        "1222": 0.063,
        "1223": 0.121,
        "1224": 0.446,
        "1225": 0.033,
        "1226": 0.043,
        "1227": 0.062,
        "1253": 0,
        "1257": 0,
        "1258": 0.028,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.027,
        "1266": 0.001,
        "1268": 0.035,
        "1269": 0.058,
        "1270": 0.005,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.035,
        "1293": 0.064,
        "2000": 7.96
      },
      "scientificName": "Beta vulgaris"
    },
    {
      "id": "170480",
      "name": "cékla - savanyúság",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.8,
        "1004": 0.08,
        "1005": 16.28,
        "1008": 65,
        "1051": 81.88,
        "1058": 0,
        "1079": 0.8,
        "1087": 11,
        "1089": 0.41,
        "1090": 15,
        "1091": 17,
        "1092": 115,
        "1093": 149,
        "1095": 0.26,
        "1098": 0.116,
        "1101": 0.22,
        "1103": 1,
        "1105": 0,
        "1106": 2,
        "1107": 29,
        "1108": 0,
        "1109": 0.06,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 2.3,
        "1165": 0.01,
        "1166": 0.048,
        "1167": 0.251,
        "1170": 0.137,
        "1175": 0.05,
        "1177": 27,
        "1178": 0,
        "1180": 15,
        "1185": 0.3,
        "1187": 27,
        "1190": 27,
        "1210": 0.009,
        "1211": 0.024,
        "1212": 0.024,
        "1213": 0.034,
        "1214": 0.029,
        "1215": 0.009,
        "1216": 0.01,
        "1217": 0.023,
        "1218": 0.019,
        "1219": 0.028,
        "1220": 0.021,
        "1221": 0.011,
        "1222": 0.03,
        "1223": 0.057,
        "1224": 0.212,
        "1225": 0.015,
        "1226": 0.021,
        "1227": 0.029,
        "1253": 0,
        "1257": 0,
        "1258": 0.013,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.013,
        "1266": 0.001,
        "1268": 0.016,
        "1269": 0.027,
        "1270": 0.002,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.016,
        "1293": 0.029,
        "2000": 11.05
      }
    },
    {
      "id": "170554",
      "name": "chia mag",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 16.54,
        "1004": 30.74,
        "1005": 42.12,
        "1008": 486,
        "1051": 5.8,
        "1079": 34.4,
        "1087": 631,
        "1089": 7.72,
        "1090": 335,
        "1091": 860,
        "1092": 407,
        "1093": 16,
        "1095": 4.58,
        "1098": 0.924,
        "1101": 2.723,
        "1103": 55.2,
        "1104": 54,
        "1109": 0.5,
        "1162": 1.6,
        "1165": 0.62,
        "1166": 0.17,
        "1167": 8.83,
        "1177": 49,
        "1178": 0,
        "1187": 49,
        "1210": 0.436,
        "1211": 0.709,
        "1212": 0.801,
        "1213": 1.371,
        "1214": 0.97,
        "1215": 0.588,
        "1216": 0.407,
        "1217": 1.016,
        "1218": 0.563,
        "1219": 0.95,
        "1220": 2.143,
        "1221": 0.531,
        "1222": 1.044,
        "1223": 1.689,
        "1224": 3.5,
        "1225": 0.943,
        "1226": 0.776,
        "1227": 1.049,
        "1253": 0,
        "1257": 0.14,
        "1258": 3.33,
        "1264": 0.03,
        "1265": 2.17,
        "1266": 0.912,
        "1267": 0.093,
        "1268": 2.203,
        "1269": 5.835,
        "1270": 17.83,
        "1273": 0.032,
        "1274": 0.03,
        "1275": 0.029,
        "1277": 0.046,
        "1292": 2.309,
        "1293": 23.665,
        "1299": 0.03,
        "1300": 0.063,
        "1316": 5.835,
        "1323": 0,
        "1404": 17.83
      },
      "scientificName": "Salvia hispanica"
    },
    {
      "id": "167746",
      "name": "citrom",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.1,
        "1004": 0.3,
        "1005": 9.32,
        "1008": 29,
        "1051": 88.98,
        "1058": 0,
        "1079": 2.8,
        "1087": 26,
        "1089": 0.6,
        "1090": 8,
        "1091": 16,
        "1092": 138,
        "1093": 2,
        "1095": 0.06,
        "1098": 0.037,
        "1101": 0.03,
        "1103": 0.4,
        "1105": 0,
        "1106": 1,
        "1107": 3,
        "1108": 1,
        "1109": 0.15,
        "1110": 0,
        "1114": 0,
        "1120": 20,
        "1122": 0,
        "1123": 11,
        "1162": 53,
        "1165": 0.04,
        "1166": 0.02,
        "1167": 0.1,
        "1170": 0.19,
        "1175": 0.08,
        "1177": 11,
        "1178": 0,
        "1180": 5.1,
        "1185": 0,
        "1187": 11,
        "1190": 11,
        "1253": 0,
        "1257": 0,
        "1258": 0.039,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.035,
        "1266": 0.002,
        "1268": 0.01,
        "1269": 0.063,
        "1270": 0.026,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.011,
        "1293": 0.089,
        "2000": 2.5
      },
      "scientificName": "Citrus limon"
    },
    {
      "id": "171719",
      "name": "cseresznye",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.06,
        "1004": 0.2,
        "1005": 16.01,
        "1008": 63,
        "1009": 0,
        "1010": 0.15,
        "1011": 6.59,
        "1012": 5.37,
        "1013": 0,
        "1014": 0.12,
        "1051": 82.25,
        "1058": 0,
        "1075": 0.59,
        "1079": 2.1,
        "1087": 13,
        "1089": 0.36,
        "1090": 11,
        "1091": 21,
        "1092": 222,
        "1093": 0,
        "1095": 0.07,
        "1098": 0.06,
        "1099": 2,
        "1101": 0.07,
        "1103": 0,
        "1105": 0,
        "1106": 3,
        "1107": 38,
        "1108": 0,
        "1109": 0.07,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 85,
        "1125": 0.01,
        "1126": 0.04,
        "1127": 0,
        "1128": 0.03,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 7,
        "1165": 0.027,
        "1166": 0.033,
        "1167": 0.154,
        "1170": 0.199,
        "1175": 0.049,
        "1177": 4,
        "1178": 0,
        "1180": 6.1,
        "1184": 0,
        "1185": 2.1,
        "1187": 4,
        "1190": 4,
        "1210": 0.009,
        "1211": 0.022,
        "1212": 0.02,
        "1213": 0.03,
        "1214": 0.032,
        "1215": 0.01,
        "1216": 0.01,
        "1217": 0.024,
        "1218": 0.014,
        "1219": 0.024,
        "1220": 0.018,
        "1221": 0.015,
        "1222": 0.026,
        "1223": 0.569,
        "1224": 0.083,
        "1225": 0.023,
        "1226": 0.039,
        "1227": 0.03,
        "1253": 0,
        "1257": 0,
        "1258": 0.038,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.027,
        "1266": 0.009,
        "1268": 0.047,
        "1269": 0.027,
        "1270": 0.026,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 12,
        "1292": 0.047,
        "1293": 0.052,
        "2000": 12.82
      },
      "scientificName": "Prunus avium"
    },
    {
      "id": "169292",
      "name": "cukkini - héjával",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.14,
        "1004": 0.36,
        "1005": 2.69,
        "1008": 15,
        "1009": 0,
        "1051": 95.22,
        "1058": 0,
        "1079": 1,
        "1087": 18,
        "1089": 0.37,
        "1090": 19,
        "1091": 37,
        "1092": 264,
        "1093": 3,
        "1095": 0.33,
        "1098": 0.052,
        "1101": 0.173,
        "1103": 0.2,
        "1105": 0,
        "1106": 56,
        "1107": 670,
        "1108": 0,
        "1109": 0.12,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1150,
        "1162": 12.9,
        "1165": 0.035,
        "1166": 0.024,
        "1167": 0.51,
        "1170": 0.288,
        "1175": 0.08,
        "1177": 28,
        "1178": 0,
        "1180": 9.4,
        "1185": 4.2,
        "1187": 28,
        "1190": 28,
        "1198": 0.3,
        "1210": 0.006,
        "1211": 0.015,
        "1212": 0.023,
        "1213": 0.037,
        "1214": 0.035,
        "1215": 0.009,
        "1216": 0.007,
        "1217": 0.022,
        "1218": 0.017,
        "1219": 0.029,
        "1220": 0.027,
        "1221": 0.014,
        "1222": 0.033,
        "1223": 0.078,
        "1224": 0.068,
        "1225": 0.024,
        "1226": 0.02,
        "1227": 0.026,
        "1253": 0,
        "1257": 0,
        "1258": 0.072,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.065,
        "1266": 0.007,
        "1268": 0.029,
        "1269": 0.058,
        "1270": 0.094,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.029,
        "1293": 0.151,
        "2000": 1.71
      }
    },
    {
      "id": "171726",
      "name": "datolya - deglet noor",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.45,
        "1004": 0.39,
        "1005": 75.03,
        "1008": 282,
        "1010": 23.84,
        "1011": 19.87,
        "1012": 19.56,
        "1013": 0,
        "1014": 0.12,
        "1051": 20.53,
        "1058": 0,
        "1075": 0,
        "1079": 8,
        "1087": 39,
        "1089": 1.02,
        "1090": 43,
        "1091": 62,
        "1092": 656,
        "1093": 2,
        "1095": 0.29,
        "1098": 0.206,
        "1101": 0.262,
        "1103": 3,
        "1105": 0,
        "1106": 0,
        "1107": 6,
        "1108": 0,
        "1109": 0.05,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 75,
        "1125": 0,
        "1126": 0.05,
        "1127": 0,
        "1128": 0.01,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.4,
        "1165": 0.052,
        "1166": 0.066,
        "1167": 1.274,
        "1170": 0.589,
        "1175": 0.165,
        "1177": 19,
        "1178": 0,
        "1180": 6.3,
        "1184": 0,
        "1185": 2.7,
        "1187": 19,
        "1190": 19,
        "1198": 0.4,
        "1210": 0.012,
        "1211": 0.043,
        "1212": 0.049,
        "1213": 0.084,
        "1214": 0.066,
        "1215": 0.022,
        "1216": 0.067,
        "1217": 0.05,
        "1218": 0.015,
        "1219": 0.071,
        "1220": 0.136,
        "1221": 0.032,
        "1222": 0.083,
        "1223": 0.213,
        "1224": 0.359,
        "1225": 0.101,
        "1226": 0.13,
        "1227": 0.057,
        "1253": 0,
        "1257": 0,
        "1258": 0.032,
        "1259": 0,
        "1260": 0,
        "1261": 0.001,
        "1262": 0.001,
        "1263": 0.001,
        "1264": 0.001,
        "1265": 0.017,
        "1266": 0.011,
        "1267": 0,
        "1268": 0.035,
        "1269": 0.016,
        "1270": 0.003,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.036,
        "1293": 0.019,
        "1299": 0,
        "1300": 0.001,
        "1313": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 63.35
      },
      "scientificName": "Phoenix dactylifera"
    },
    {
      "id": "168191",
      "name": "datolya - medjool",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.81,
        "1004": 0.15,
        "1005": 74.97,
        "1008": 277,
        "1010": 0.53,
        "1011": 33.68,
        "1012": 31.95,
        "1013": 0,
        "1014": 0.3,
        "1051": 21.32,
        "1075": 0,
        "1079": 6.7,
        "1087": 64,
        "1089": 0.9,
        "1090": 54,
        "1091": 62,
        "1092": 696,
        "1093": 1,
        "1095": 0.44,
        "1098": 0.362,
        "1101": 0.296,
        "1106": 7,
        "1107": 89,
        "1108": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 23,
        "1162": 0,
        "1165": 0.05,
        "1166": 0.06,
        "1167": 1.61,
        "1170": 0.805,
        "1175": 0.249,
        "1177": 15,
        "1180": 9.9,
        "1184": 0,
        "1185": 2.7,
        "1187": 15,
        "1190": 15,
        "1198": 0.4,
        "1210": 0.007,
        "1211": 0.042,
        "1212": 0.045,
        "1213": 0.082,
        "1214": 0.054,
        "1215": 0.017,
        "1216": 0.046,
        "1217": 0.048,
        "1218": 0.016,
        "1219": 0.066,
        "1220": 0.06,
        "1221": 0.029,
        "1222": 0.078,
        "1223": 0.22,
        "1224": 0.265,
        "1225": 0.09,
        "1226": 0.111,
        "1227": 0.062,
        "1257": 0,
        "2000": 66.47
      },
      "scientificName": "Phoenix dactylifera"
    },
    {
      "id": "167765",
      "name": "dinnye - görög",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.61,
        "1004": 0.15,
        "1005": 7.55,
        "1008": 30,
        "1009": 0,
        "1010": 1.21,
        "1011": 1.58,
        "1012": 3.36,
        "1013": 0,
        "1014": 0.06,
        "1051": 91.45,
        "1058": 0,
        "1075": 0,
        "1079": 0.4,
        "1087": 7,
        "1089": 0.24,
        "1090": 10,
        "1091": 11,
        "1092": 112,
        "1093": 1,
        "1095": 0.1,
        "1098": 0.042,
        "1099": 1.5,
        "1101": 0.038,
        "1103": 0.4,
        "1105": 0,
        "1106": 28,
        "1107": 303,
        "1108": 0,
        "1109": 0.05,
        "1110": 0,
        "1114": 0,
        "1120": 78,
        "1122": 4532,
        "1123": 8,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.01,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 8.1,
        "1165": 0.033,
        "1166": 0.021,
        "1167": 0.178,
        "1170": 0.221,
        "1175": 0.045,
        "1177": 3,
        "1178": 0,
        "1180": 4.1,
        "1184": 0,
        "1185": 0.1,
        "1187": 3,
        "1190": 3,
        "1198": 0.3,
        "1210": 0.007,
        "1211": 0.027,
        "1212": 0.019,
        "1213": 0.018,
        "1214": 0.062,
        "1215": 0.006,
        "1216": 0.002,
        "1217": 0.015,
        "1218": 0.012,
        "1219": 0.016,
        "1220": 0.059,
        "1221": 0.006,
        "1222": 0.017,
        "1223": 0.039,
        "1224": 0.063,
        "1225": 0.01,
        "1226": 0.024,
        "1227": 0.016,
        "1253": 0,
        "1257": 0,
        "1258": 0.016,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.001,
        "1263": 0.001,
        "1264": 0,
        "1265": 0.008,
        "1266": 0.006,
        "1268": 0.037,
        "1269": 0.05,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 2,
        "1292": 0.037,
        "1293": 0.05,
        "2000": 6.2
      },
      "scientificName": "Citrullus lanatus"
    },
    {
      "id": "169092",
      "name": "dinnye - sárga",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 150,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.84,
        "1004": 0.19,
        "1005": 8.16,
        "1008": 34,
        "1009": 0.03,
        "1010": 4.35,
        "1011": 1.54,
        "1012": 1.87,
        "1013": 0,
        "1014": 0.04,
        "1051": 90.15,
        "1058": 0,
        "1075": 0.06,
        "1079": 0.9,
        "1087": 9,
        "1089": 0.21,
        "1090": 12,
        "1091": 15,
        "1092": 267,
        "1093": 16,
        "1095": 0.18,
        "1098": 0.041,
        "1099": 1,
        "1101": 0.041,
        "1103": 0.4,
        "1105": 0,
        "1106": 169,
        "1107": 2020,
        "1108": 16,
        "1109": 0.05,
        "1110": 0,
        "1114": 0,
        "1120": 1,
        "1122": 0,
        "1123": 26,
        "1125": 0,
        "1126": 0.11,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 36.7,
        "1165": 0.041,
        "1166": 0.019,
        "1167": 0.734,
        "1170": 0.105,
        "1175": 0.072,
        "1177": 21,
        "1178": 0,
        "1180": 7.6,
        "1184": 0,
        "1185": 2.5,
        "1187": 21,
        "1190": 21,
        "1198": 0.1,
        "1210": 0.002,
        "1211": 0.017,
        "1212": 0.021,
        "1213": 0.029,
        "1214": 0.03,
        "1215": 0.012,
        "1216": 0.002,
        "1217": 0.023,
        "1218": 0.014,
        "1219": 0.033,
        "1220": 0.029,
        "1221": 0.015,
        "1222": 0.095,
        "1223": 0.136,
        "1224": 0.209,
        "1225": 0.026,
        "1226": 0.019,
        "1227": 0.042,
        "1253": 0,
        "1257": 0,
        "1258": 0.051,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.001,
        "1264": 0.001,
        "1265": 0.043,
        "1266": 0.005,
        "1268": 0.003,
        "1269": 0.035,
        "1270": 0.046,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 10,
        "1292": 0.003,
        "1293": 0.081,
        "2000": 7.86
      },
      "scientificName": "Cucumis melo"
    },
    {
      "id": "170162",
      "name": "dió - kesu",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 2000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 18.22,
        "1004": 43.85,
        "1005": 30.19,
        "1008": 553,
        "1009": 23.49,
        "1010": 5.81,
        "1011": 0.05,
        "1012": 0.05,
        "1013": 0,
        "1014": 0,
        "1051": 5.2,
        "1075": 0,
        "1079": 3.3,
        "1087": 37,
        "1089": 6.68,
        "1090": 292,
        "1091": 593,
        "1092": 660,
        "1093": 12,
        "1095": 5.78,
        "1098": 2.195,
        "1101": 1.655,
        "1103": 19.9,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.9,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 22,
        "1125": 0.03,
        "1126": 5.31,
        "1127": 0.36,
        "1128": 0,
        "1129": 0.1,
        "1130": 0.2,
        "1131": 0,
        "1162": 0.5,
        "1165": 0.423,
        "1166": 0.058,
        "1167": 1.062,
        "1170": 0.864,
        "1175": 0.417,
        "1177": 25,
        "1178": 0,
        "1185": 34.1,
        "1187": 25,
        "1190": 25,
        "1210": 0.287,
        "1211": 0.688,
        "1212": 0.789,
        "1213": 1.472,
        "1214": 0.928,
        "1215": 0.362,
        "1216": 0.393,
        "1217": 0.951,
        "1218": 0.508,
        "1219": 1.094,
        "1220": 2.123,
        "1221": 0.456,
        "1222": 0.837,
        "1223": 1.795,
        "1224": 4.506,
        "1225": 0.937,
        "1226": 0.812,
        "1227": 1.079,
        "1253": 0,
        "1258": 7.783,
        "1259": 0,
        "1260": 0,
        "1261": 0.015,
        "1262": 0.015,
        "1263": 0.015,
        "1264": 0.015,
        "1265": 3.916,
        "1266": 3.223,
        "1267": 0.266,
        "1268": 23.523,
        "1269": 7.782,
        "1270": 0.062,
        "1271": 0,
        "1272": 0,
        "1273": 0.173,
        "1274": 0,
        "1275": 0.136,
        "1276": 0,
        "1277": 0.138,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 0,
        "1286": 9,
        "1288": 113,
        "1292": 23.797,
        "1293": 7.845,
        "1299": 0,
        "1300": 0.046,
        "1301": 0.101,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 5.91
      },
      "scientificName": "Anacardium occidentale"
    },
    {
      "id": "170187",
      "name": "dió - normál",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 15.23,
        "1004": 65.21,
        "1005": 13.71,
        "1008": 654,
        "1009": 0.06,
        "1010": 2.43,
        "1011": 0.08,
        "1012": 0.09,
        "1013": 0,
        "1014": 0,
        "1051": 4.07,
        "1058": 0,
        "1079": 6.7,
        "1087": 98,
        "1089": 2.91,
        "1090": 158,
        "1091": 346,
        "1092": 441,
        "1093": 2,
        "1095": 3.09,
        "1098": 1.586,
        "1101": 3.414,
        "1103": 4.9,
        "1105": 0,
        "1106": 1,
        "1107": 12,
        "1108": 0,
        "1109": 0.7,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 9,
        "1125": 0.15,
        "1126": 20.83,
        "1127": 1.89,
        "1162": 1.3,
        "1165": 0.341,
        "1166": 0.15,
        "1167": 1.125,
        "1170": 0.57,
        "1175": 0.537,
        "1177": 98,
        "1178": 0,
        "1180": 39.2,
        "1184": 0,
        "1185": 2.7,
        "1187": 98,
        "1190": 98,
        "1198": 0.3,
        "1210": 0.17,
        "1211": 0.596,
        "1212": 0.625,
        "1213": 1.17,
        "1214": 0.424,
        "1215": 0.236,
        "1216": 0.208,
        "1217": 0.711,
        "1218": 0.406,
        "1219": 0.753,
        "1220": 2.278,
        "1221": 0.391,
        "1222": 0.696,
        "1223": 1.829,
        "1224": 2.816,
        "1225": 0.816,
        "1226": 0.706,
        "1227": 0.934,
        "1253": 0,
        "1258": 6.126,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 4.404,
        "1266": 1.659,
        "1267": 0.063,
        "1268": 8.799,
        "1269": 38.093,
        "1270": 9.08,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0.134,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 0,
        "1286": 5,
        "1288": 87,
        "1292": 8.933,
        "1293": 47.174,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1312": 0,
        "1313": 0,
        "1325": 0,
        "1332": 0,
        "2000": 2.61
      },
      "scientificName": "Juglans regia"
    },
    {
      "id": "170182",
      "name": "dió - pekán",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 9.17,
        "1004": 71.97,
        "1005": 13.86,
        "1008": 691,
        "1009": 0.46,
        "1010": 3.9,
        "1011": 0.04,
        "1012": 0.04,
        "1013": 0,
        "1014": 0,
        "1051": 3.52,
        "1058": 0,
        "1079": 9.6,
        "1087": 70,
        "1089": 2.53,
        "1090": 121,
        "1091": 277,
        "1092": 410,
        "1093": 0,
        "1095": 4.53,
        "1098": 1.2,
        "1099": 10,
        "1101": 4.5,
        "1103": 3.8,
        "1105": 0,
        "1106": 3,
        "1107": 29,
        "1108": 0,
        "1109": 1.4,
        "1110": 0,
        "1114": 0,
        "1120": 9,
        "1122": 0,
        "1123": 17,
        "1125": 0.39,
        "1126": 24.44,
        "1127": 0.47,
        "1162": 1.1,
        "1165": 0.66,
        "1166": 0.13,
        "1167": 1.167,
        "1170": 0.863,
        "1175": 0.21,
        "1177": 22,
        "1178": 0,
        "1180": 40.5,
        "1184": 0,
        "1185": 3.5,
        "1187": 22,
        "1190": 22,
        "1198": 0.7,
        "1210": 0.093,
        "1211": 0.306,
        "1212": 0.336,
        "1213": 0.598,
        "1214": 0.287,
        "1215": 0.183,
        "1216": 0.152,
        "1217": 0.426,
        "1218": 0.215,
        "1219": 0.411,
        "1220": 1.177,
        "1221": 0.262,
        "1222": 0.397,
        "1223": 0.929,
        "1224": 1.829,
        "1225": 0.453,
        "1226": 0.363,
        "1227": 0.474,
        "1253": 0,
        "1258": 6.18,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 4.366,
        "1266": 1.745,
        "1267": 0.069,
        "1268": 40.594,
        "1269": 20.628,
        "1270": 0.986,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0.207,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 3,
        "1286": 6,
        "1288": 117,
        "1292": 40.801,
        "1293": 21.614,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1312": 0,
        "1313": 0,
        "1325": 0,
        "1332": 0,
        "2000": 3.97
      },
      "scientificName": "Carya illinoinensis"
    },
    {
      "id": "167762",
      "name": "eper - normál",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 600,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.67,
        "1004": 0.3,
        "1005": 7.68,
        "1008": 32,
        "1009": 0.04,
        "1010": 0.47,
        "1011": 1.99,
        "1012": 2.44,
        "1013": 0,
        "1014": 0,
        "1051": 90.95,
        "1058": 0,
        "1075": 0,
        "1079": 2,
        "1087": 16,
        "1089": 0.41,
        "1090": 13,
        "1091": 24,
        "1092": 153,
        "1093": 1,
        "1095": 0.14,
        "1098": 0.048,
        "1099": 4.4,
        "1101": 0.386,
        "1103": 0.4,
        "1105": 0,
        "1106": 1,
        "1107": 7,
        "1108": 0,
        "1109": 0.29,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 26,
        "1125": 0.01,
        "1126": 0.08,
        "1127": 0.01,
        "1128": 0.01,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 58.8,
        "1165": 0.024,
        "1166": 0.022,
        "1167": 0.386,
        "1170": 0.125,
        "1175": 0.047,
        "1177": 24,
        "1178": 0,
        "1180": 5.7,
        "1184": 0,
        "1185": 2.2,
        "1187": 24,
        "1190": 24,
        "1198": 0.2,
        "1210": 0.008,
        "1211": 0.02,
        "1212": 0.016,
        "1213": 0.034,
        "1214": 0.026,
        "1215": 0.002,
        "1216": 0.006,
        "1217": 0.019,
        "1218": 0.022,
        "1219": 0.019,
        "1220": 0.028,
        "1221": 0.012,
        "1222": 0.033,
        "1223": 0.149,
        "1224": 0.098,
        "1225": 0.026,
        "1226": 0.02,
        "1227": 0.025,
        "1253": 0,
        "1257": 0,
        "1258": 0.015,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.012,
        "1266": 0.003,
        "1268": 0.042,
        "1269": 0.09,
        "1270": 0.065,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 12,
        "1292": 0.043,
        "1293": 0.155,
        "2000": 4.89
      },
      "scientificName": "Fragaria X ananassa"
    },
    {
      "id": "173963",
      "name": "feketeribizli",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.4,
        "1004": 0.41,
        "1005": 15.38,
        "1008": 63,
        "1051": 81.96,
        "1087": 55,
        "1089": 1.54,
        "1090": 24,
        "1091": 59,
        "1092": 322,
        "1093": 2,
        "1095": 0.27,
        "1098": 0.086,
        "1101": 0.256,
        "1105": 0,
        "1106": 12,
        "1109": 1,
        "1162": 181,
        "1165": 0.05,
        "1166": 0.05,
        "1167": 0.3,
        "1170": 0.398,
        "1175": 0.066,
        "1178": 0,
        "1253": 0,
        "1257": 0,
        "1258": 0.034,
        "1265": 0.02,
        "1266": 0.007,
        "1268": 0.056,
        "1269": 0.107,
        "1270": 0.072,
        "1275": 0.001,
        "1292": 0.058,
        "1293": 0.179
      },
      "scientificName": "Ribes nigrum"
    },
    {
      "id": "174665",
      "name": "füge - száritott",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1000,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.3,
        "1004": 0.93,
        "1005": 63.87,
        "1008": 249,
        "1009": 5.07,
        "1010": 0.07,
        "1011": 24.79,
        "1012": 22.93,
        "1013": 0,
        "1014": 0,
        "1051": 30.05,
        "1058": 0,
        "1075": 0.13,
        "1079": 9.8,
        "1087": 162,
        "1089": 2.03,
        "1090": 68,
        "1091": 67,
        "1092": 680,
        "1093": 10,
        "1095": 0.55,
        "1098": 0.287,
        "1101": 0.51,
        "1103": 0.6,
        "1105": 0,
        "1106": 0,
        "1107": 6,
        "1108": 0,
        "1109": 0.35,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 32,
        "1125": 0.01,
        "1126": 0.37,
        "1127": 0.01,
        "1128": 0.03,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 1.2,
        "1165": 0.085,
        "1166": 0.082,
        "1167": 0.619,
        "1170": 0.434,
        "1175": 0.106,
        "1177": 9,
        "1178": 0,
        "1180": 15.8,
        "1184": 0,
        "1185": 15.6,
        "1187": 9,
        "1190": 9,
        "1198": 0.7,
        "1210": 0.02,
        "1211": 0.085,
        "1212": 0.089,
        "1213": 0.128,
        "1214": 0.088,
        "1215": 0.034,
        "1216": 0.036,
        "1217": 0.076,
        "1218": 0.041,
        "1219": 0.122,
        "1220": 0.077,
        "1221": 0.037,
        "1222": 0.134,
        "1223": 0.645,
        "1224": 0.295,
        "1225": 0.108,
        "1226": 0.61,
        "1227": 0.128,
        "1253": 0,
        "1258": 0.144,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.006,
        "1265": 0.11,
        "1266": 0.029,
        "1268": 0.158,
        "1269": 0.345,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.159,
        "1293": 0.345,
        "2000": 47.92
      },
      "scientificName": "Ficus carica"
    },
    {
      "id": "170175",
      "name": "ginkgo mag - szárított",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 3500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 25,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 10.35,
        "1004": 2,
        "1005": 72.45,
        "1008": 348,
        "1051": 12.4,
        "1087": 20,
        "1089": 1.6,
        "1090": 53,
        "1091": 269,
        "1092": 998,
        "1093": 13,
        "1095": 0.67,
        "1098": 0.536,
        "1101": 0.22,
        "1105": 0,
        "1106": 55,
        "1110": 0,
        "1114": 0,
        "1162": 29.3,
        "1165": 0.43,
        "1166": 0.176,
        "1167": 11.732,
        "1170": 1.345,
        "1175": 0.641,
        "1177": 106,
        "1178": 0,
        "1187": 106,
        "1190": 106,
        "1210": 0.17,
        "1211": 0.64,
        "1212": 0.5,
        "1213": 0.755,
        "1214": 0.494,
        "1215": 0.133,
        "1216": 0.055,
        "1217": 0.408,
        "1218": 0.146,
        "1219": 0.677,
        "1220": 1.005,
        "1221": 0.244,
        "1222": 0.591,
        "1223": 1.298,
        "1224": 2.001,
        "1225": 0.554,
        "1226": 0.83,
        "1227": 0.695,
        "1253": 0,
        "1258": 0.381,
        "1264": 0.008,
        "1265": 0.343,
        "1266": 0.019,
        "1268": 0.611,
        "1269": 0.69,
        "1270": 0.025,
        "1275": 0.095,
        "1277": 0.011,
        "1292": 0.739,
        "1293": 0.737
      },
      "scientificName": "Ginkgo biloba"
    },
    {
      "id": "169253",
      "name": "gomba - csiperke",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 3.58,
        "1004": 0.33,
        "1005": 4.04,
        "1008": 26,
        "1009": 0,
        "1010": 0,
        "1011": 0,
        "1012": 0,
        "1013": 0,
        "1014": 0,
        "1051": 91.1,
        "1058": 0,
        "1075": 0,
        "1079": 1.8,
        "1087": 4,
        "1089": 0.25,
        "1090": 11,
        "1091": 105,
        "1092": 396,
        "1093": 12,
        "1095": 0.57,
        "1098": 0.291,
        "1101": 0.047,
        "1103": 13.9,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1111": 0.2,
        "1112": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.04,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.096,
        "1166": 0.463,
        "1167": 3.987,
        "1170": 1.45,
        "1175": 0.042,
        "1177": 20,
        "1178": 0,
        "1180": 21.9,
        "1183": 0,
        "1184": 0.7,
        "1185": 0,
        "1187": 20,
        "1190": 20,
        "1198": 9.5,
        "1210": 0.037,
        "1211": 0.116,
        "1212": 0.082,
        "1213": 0.13,
        "1214": 0.116,
        "1215": 0.034,
        "1216": 0.013,
        "1217": 0.092,
        "1218": 0.047,
        "1219": 0.251,
        "1220": 0.084,
        "1221": 0.061,
        "1222": 0.215,
        "1223": 0.211,
        "1224": 0.371,
        "1225": 0.099,
        "1226": 0.082,
        "1227": 0.102,
        "1253": 0,
        "1257": 0,
        "1258": 0.04,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.03,
        "1266": 0.01,
        "1267": 0,
        "1268": 0,
        "1269": 0.16,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0.16,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1312": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "1411": 0,
        "2000": 0
      },
      "scientificName": "Agaricus bisporus"
    },
    {
      "id": "174676",
      "name": "grapefruit - fehér",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.69,
        "1004": 0.1,
        "1005": 8.41,
        "1008": 33,
        "1051": 90.48,
        "1058": 0,
        "1079": 1.1,
        "1087": 12,
        "1089": 0.06,
        "1090": 9,
        "1091": 8,
        "1092": 148,
        "1093": 0,
        "1095": 0.07,
        "1098": 0.05,
        "1101": 0.013,
        "1103": 1.4,
        "1105": 0,
        "1106": 2,
        "1107": 14,
        "1108": 8,
        "1109": 0.13,
        "1110": 0,
        "1114": 0,
        "1120": 3,
        "1122": 0,
        "1123": 10,
        "1162": 33.3,
        "1165": 0.037,
        "1166": 0.02,
        "1167": 0.269,
        "1170": 0.283,
        "1175": 0.043,
        "1177": 10,
        "1178": 0,
        "1180": 7.7,
        "1185": 0,
        "1187": 10,
        "1190": 10,
        "1210": 0.007,
        "1211": 0.012,
        "1212": 0.007,
        "1213": 0.013,
        "1214": 0.017,
        "1215": 0.007,
        "1216": 0.007,
        "1217": 0.041,
        "1218": 0.007,
        "1219": 0.014,
        "1220": 0.078,
        "1221": 0.007,
        "1222": 0.022,
        "1223": 0.123,
        "1224": 0.176,
        "1225": 0.013,
        "1226": 0.056,
        "1227": 0.025,
        "1253": 0,
        "1257": 0,
        "1258": 0.014,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.012,
        "1266": 0.001,
        "1268": 0.012,
        "1269": 0.019,
        "1270": 0.005,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 17,
        "1292": 0.013,
        "1293": 0.024,
        "2000": 7.31
      },
      "scientificName": "Citrus paradisi"
    },
    {
      "id": "174673",
      "name": "grapefruit - piros",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.77,
        "1004": 0.14,
        "1005": 10.66,
        "1008": 42,
        "1009": 0,
        "1010": 3.51,
        "1011": 1.61,
        "1012": 1.77,
        "1013": 0,
        "1014": 0,
        "1051": 88.06,
        "1058": 0,
        "1075": 0,
        "1079": 1.6,
        "1087": 22,
        "1089": 0.08,
        "1090": 9,
        "1091": 18,
        "1092": 135,
        "1093": 0,
        "1095": 0.07,
        "1098": 0.032,
        "1101": 0.022,
        "1103": 0.1,
        "1105": 0,
        "1106": 58,
        "1107": 686,
        "1108": 3,
        "1109": 0.13,
        "1110": 0,
        "1114": 0,
        "1120": 6,
        "1122": 1419,
        "1123": 5,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 31.2,
        "1165": 0.043,
        "1166": 0.031,
        "1167": 0.204,
        "1170": 0.262,
        "1175": 0.053,
        "1177": 13,
        "1178": 0,
        "1180": 7.7,
        "1184": 0,
        "1185": 0,
        "1187": 13,
        "1190": 13,
        "1198": 0.1,
        "1210": 0.008,
        "1211": 0.013,
        "1212": 0.008,
        "1213": 0.015,
        "1214": 0.019,
        "1215": 0.007,
        "1216": 0.008,
        "1217": 0.013,
        "1218": 0.008,
        "1219": 0.015,
        "1220": 0.087,
        "1221": 0.008,
        "1222": 0.024,
        "1223": 0.138,
        "1224": 0.197,
        "1225": 0.015,
        "1226": 0.063,
        "1227": 0.028,
        "1253": 0,
        "1257": 0,
        "1258": 0.021,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.018,
        "1266": 0.002,
        "1268": 0.018,
        "1269": 0.029,
        "1270": 0.008,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.02,
        "1293": 0.036,
        "2000": 6.89
      },
      "scientificName": "Citrus paradisi"
    },
    {
      "id": "169230",
      "name": "hagyma - fok",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 6.36,
        "1004": 0.5,
        "1005": 33.06,
        "1008": 149,
        "1051": 58.58,
        "1058": 0,
        "1079": 2.1,
        "1087": 181,
        "1089": 1.7,
        "1090": 25,
        "1091": 153,
        "1092": 401,
        "1093": 17,
        "1095": 1.16,
        "1098": 0.299,
        "1101": 1.672,
        "1103": 14.2,
        "1105": 0,
        "1106": 0,
        "1107": 5,
        "1108": 0,
        "1109": 0.08,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 16,
        "1162": 31.2,
        "1165": 0.2,
        "1166": 0.11,
        "1167": 0.7,
        "1170": 0.596,
        "1175": 1.235,
        "1177": 3,
        "1178": 0,
        "1180": 23.2,
        "1185": 1.7,
        "1187": 3,
        "1190": 3,
        "1210": 0.066,
        "1211": 0.157,
        "1212": 0.217,
        "1213": 0.308,
        "1214": 0.273,
        "1215": 0.076,
        "1216": 0.065,
        "1217": 0.183,
        "1218": 0.081,
        "1219": 0.291,
        "1220": 0.634,
        "1221": 0.113,
        "1222": 0.132,
        "1223": 0.489,
        "1224": 0.805,
        "1225": 0.2,
        "1226": 0.1,
        "1227": 0.19,
        "1253": 0,
        "1257": 0,
        "1258": 0.089,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0.002,
        "1263": 0,
        "1264": 0,
        "1265": 0.087,
        "1266": 0,
        "1268": 0.011,
        "1269": 0.229,
        "1270": 0.02,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.011,
        "1293": 0.249,
        "2000": 1
      },
      "scientificName": "Allium sativum"
    },
    {
      "id": "170000",
      "name": "hagyma - normál",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.1,
        "1004": 0.1,
        "1005": 9.34,
        "1008": 40,
        "1009": 0,
        "1010": 0.99,
        "1011": 1.97,
        "1012": 1.29,
        "1013": 0,
        "1014": 0,
        "1051": 89.11,
        "1058": 0,
        "1075": 0,
        "1079": 1.7,
        "1087": 23,
        "1089": 0.21,
        "1090": 10,
        "1091": 29,
        "1092": 146,
        "1093": 4,
        "1095": 0.17,
        "1098": 0.039,
        "1099": 1.1,
        "1101": 0.129,
        "1103": 0.5,
        "1105": 0,
        "1106": 0,
        "1107": 1,
        "1108": 0,
        "1109": 0.02,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 4,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.04,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 7.4,
        "1165": 0.046,
        "1166": 0.027,
        "1167": 0.116,
        "1170": 0.123,
        "1175": 0.12,
        "1177": 19,
        "1178": 0,
        "1180": 6.1,
        "1184": 0,
        "1185": 0.4,
        "1187": 19,
        "1190": 19,
        "1198": 0.1,
        "1210": 0.014,
        "1211": 0.021,
        "1212": 0.014,
        "1213": 0.025,
        "1214": 0.039,
        "1215": 0.002,
        "1216": 0.004,
        "1217": 0.025,
        "1218": 0.014,
        "1219": 0.021,
        "1220": 0.104,
        "1221": 0.014,
        "1222": 0.021,
        "1223": 0.091,
        "1224": 0.258,
        "1225": 0.025,
        "1226": 0.012,
        "1227": 0.021,
        "1253": 0,
        "1257": 0,
        "1258": 0.042,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.004,
        "1265": 0.034,
        "1266": 0.004,
        "1267": 0,
        "1268": 0.013,
        "1269": 0.013,
        "1270": 0.004,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 15,
        "1292": 0.013,
        "1293": 0.017,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 4.24
      },
      "scientificName": "Allium cepa"
    },
    {
      "id": "170001",
      "name": "hagyma - normál",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.36,
        "1004": 0.19,
        "1005": 10.15,
        "1008": 44,
        "1010": 1.1,
        "1011": 2.19,
        "1012": 1.44,
        "1013": 0,
        "1014": 0,
        "1051": 87.86,
        "1058": 0,
        "1075": 0,
        "1079": 1.4,
        "1087": 22,
        "1089": 0.24,
        "1090": 11,
        "1091": 35,
        "1092": 166,
        "1093": 3,
        "1095": 0.21,
        "1098": 0.067,
        "1101": 0.153,
        "1103": 0.6,
        "1105": 0,
        "1106": 0,
        "1107": 1,
        "1108": 0,
        "1109": 0.02,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 4,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1162": 5.2,
        "1165": 0.042,
        "1166": 0.023,
        "1167": 0.165,
        "1170": 0.113,
        "1175": 0.129,
        "1177": 15,
        "1178": 0,
        "1180": 6.8,
        "1185": 0.5,
        "1187": 15,
        "1190": 15,
        "1210": 0.02,
        "1211": 0.033,
        "1212": 0.048,
        "1213": 0.048,
        "1214": 0.065,
        "1215": 0.011,
        "1216": 0.024,
        "1217": 0.035,
        "1218": 0.034,
        "1219": 0.031,
        "1220": 0.183,
        "1221": 0.022,
        "1222": 0.038,
        "1223": 0.074,
        "1224": 0.22,
        "1225": 0.057,
        "1226": 0.042,
        "1227": 0.04,
        "1253": 0,
        "1257": 0,
        "1258": 0.031,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.028,
        "1266": 0.002,
        "1268": 0.027,
        "1269": 0.07,
        "1270": 0.004,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 18,
        "1292": 0.027,
        "1293": 0.073,
        "2000": 4.73
      },
      "scientificName": "Allium cepa"
    },
    {
      "id": "170686",
      "name": "hajdina",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 250,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 3.38,
        "1004": 0.62,
        "1005": 19.94,
        "1008": 92,
        "1010": 0.4,
        "1011": 0.2,
        "1012": 0.1,
        "1051": 75.63,
        "1058": 0,
        "1079": 2.7,
        "1087": 7,
        "1089": 0.8,
        "1090": 51,
        "1091": 70,
        "1092": 88,
        "1093": 4,
        "1095": 0.61,
        "1098": 0.146,
        "1101": 0.403,
        "1103": 2.2,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0.09,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 60,
        "1162": 0,
        "1165": 0.04,
        "1166": 0.039,
        "1167": 0.94,
        "1170": 0.359,
        "1175": 0.077,
        "1177": 14,
        "1178": 0,
        "1180": 20.1,
        "1185": 1.9,
        "1187": 14,
        "1190": 14,
        "1198": 0.5,
        "1210": 0.049,
        "1211": 0.129,
        "1212": 0.127,
        "1213": 0.212,
        "1214": 0.172,
        "1215": 0.044,
        "1216": 0.058,
        "1217": 0.133,
        "1218": 0.062,
        "1219": 0.173,
        "1220": 0.25,
        "1221": 0.079,
        "1222": 0.191,
        "1223": 0.289,
        "1224": 0.522,
        "1225": 0.263,
        "1226": 0.129,
        "1227": 0.175,
        "1253": 0,
        "1258": 0.134,
        "1259": 0,
        "1260": 0,
        "1261": 0.006,
        "1262": 0.003,
        "1263": 0.002,
        "1264": 0.004,
        "1265": 0.082,
        "1266": 0.009,
        "1268": 0.179,
        "1269": 0.174,
        "1270": 0.014,
        "1271": 0,
        "1272": 0,
        "1275": 0.004,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0.002,
        "1280": 0,
        "1292": 0.188,
        "1293": 0.188,
        "2000": 0.9
      },
      "scientificName": "Fagopyrum esculentum Moench"
    },
    {
      "id": "170285",
      "name": "Hántolt árpa (gersli)",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.26,
        "1004": 0.44,
        "1005": 28.22,
        "1008": 123,
        "1051": 68.8,
        "1058": 0,
        "1079": 3.8,
        "1087": 11,
        "1089": 1.33,
        "1090": 22,
        "1091": 54,
        "1092": 93,
        "1093": 3,
        "1095": 0.82,
        "1098": 0.105,
        "1101": 0.259,
        "1103": 8.6,
        "1105": 0,
        "1106": 0,
        "1107": 5,
        "1108": 0,
        "1109": 0.01,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 56,
        "1162": 0,
        "1165": 0.083,
        "1166": 0.062,
        "1167": 2.063,
        "1170": 0.135,
        "1175": 0.115,
        "1177": 16,
        "1178": 0,
        "1180": 13.4,
        "1185": 0.8,
        "1187": 16,
        "1190": 16,
        "1210": 0.038,
        "1211": 0.077,
        "1212": 0.083,
        "1213": 0.154,
        "1214": 0.084,
        "1215": 0.043,
        "1216": 0.05,
        "1217": 0.127,
        "1218": 0.065,
        "1219": 0.111,
        "1220": 0.113,
        "1221": 0.051,
        "1222": 0.088,
        "1223": 0.141,
        "1224": 0.591,
        "1225": 0.082,
        "1226": 0.269,
        "1227": 0.095,
        "1253": 0,
        "1258": 0.093,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.001,
        "1264": 0.002,
        "1265": 0.079,
        "1266": 0.003,
        "1268": 0.047,
        "1269": 0.193,
        "1270": 0.021,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.057,
        "1293": 0.214,
        "2000": 0.28
      },
      "scientificName": "Hordeum vulgare L."
    },
    {
      "id": "169976",
      "name": "káposzta - fejes",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 80,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.27,
        "1004": 0.06,
        "1005": 5.51,
        "1008": 23,
        "1009": 0,
        "1010": 0,
        "1011": 1.62,
        "1012": 1.16,
        "1013": 0,
        "1014": 0,
        "1051": 92.57,
        "1058": 0,
        "1075": 0,
        "1079": 1.9,
        "1087": 48,
        "1089": 0.17,
        "1090": 15,
        "1091": 33,
        "1092": 196,
        "1093": 8,
        "1095": 0.2,
        "1098": 0.017,
        "1099": 1,
        "1101": 0.205,
        "1103": 0.6,
        "1105": 0,
        "1106": 4,
        "1107": 48,
        "1108": 0,
        "1109": 0.14,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 27,
        "1162": 37.5,
        "1165": 0.061,
        "1166": 0.038,
        "1167": 0.248,
        "1170": 0.174,
        "1175": 0.112,
        "1177": 30,
        "1178": 0,
        "1180": 20.3,
        "1184": 0,
        "1185": 108.7,
        "1187": 30,
        "1190": 30,
        "1198": 0.3,
        "1210": 0.011,
        "1211": 0.035,
        "1212": 0.03,
        "1213": 0.041,
        "1214": 0.043,
        "1215": 0.012,
        "1216": 0.011,
        "1217": 0.032,
        "1218": 0.019,
        "1219": 0.042,
        "1220": 0.074,
        "1221": 0.022,
        "1222": 0.042,
        "1223": 0.121,
        "1224": 0.292,
        "1225": 0.03,
        "1226": 0.048,
        "1227": 0.052,
        "1253": 0,
        "1257": 0,
        "1258": 0,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0,
        "1266": 0,
        "1267": 0,
        "1268": 0.009,
        "1269": 0.009,
        "1270": 0.014,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.009,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 10,
        "1292": 0.019,
        "1293": 0.023,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 2.79
      },
      "scientificName": "Brassica oleracea (Capitata Group)"
    },
    {
      "id": "169238",
      "name": "káposzta - kel",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.94,
        "1004": 1.21,
        "1005": 5.3,
        "1008": 36,
        "1010": 0.25,
        "1011": 0.54,
        "1012": 0.42,
        "1013": 0,
        "1014": 0,
        "1051": 89.82,
        "1058": 0,
        "1075": 0,
        "1079": 4,
        "1087": 150,
        "1089": 0.84,
        "1090": 25,
        "1091": 42,
        "1092": 144,
        "1093": 16,
        "1095": 0.27,
        "1098": 0.067,
        "1101": 0.542,
        "1103": 0.9,
        "1105": 0,
        "1106": 146,
        "1107": 1731,
        "1108": 10,
        "1109": 1.61,
        "1110": 0,
        "1114": 0,
        "1120": 26,
        "1122": 0,
        "1123": 4983,
        "1125": 0,
        "1126": 0.12,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 17.8,
        "1165": 0.063,
        "1166": 0.14,
        "1167": 0.457,
        "1170": 0.17,
        "1175": 0.063,
        "1177": 65,
        "1178": 0,
        "1180": 0.4,
        "1183": 0,
        "1184": 0,
        "1185": 418.5,
        "1187": 65,
        "1190": 65,
        "1198": 0.3,
        "1210": 0.035,
        "1211": 0.131,
        "1212": 0.176,
        "1213": 0.205,
        "1214": 0.176,
        "1215": 0.029,
        "1216": 0.039,
        "1217": 0.15,
        "1218": 0.104,
        "1219": 0.16,
        "1220": 0.163,
        "1221": 0.172,
        "1222": 0.148,
        "1223": 0.263,
        "1224": 0.332,
        "1225": 0.141,
        "1226": 0.174,
        "1227": 0.124,
        "1253": 0,
        "1257": 0,
        "1258": 0.175,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.006,
        "1264": 0.006,
        "1265": 0.156,
        "1266": 0.006,
        "1268": 0.102,
        "1269": 0.286,
        "1270": 0.371,
        "1271": 0.003,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.102,
        "1293": 0.66,
        "2000": 1.21
      },
      "scientificName": "Brassica oleracea (Acephala Group)"
    },
    {
      "id": "169978",
      "name": "káposzta - vörös",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 120,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.51,
        "1004": 0.09,
        "1005": 6.94,
        "1008": 29,
        "1009": 0,
        "1010": 0.71,
        "1011": 1.42,
        "1012": 1.2,
        "1013": 0,
        "1014": 0,
        "1051": 90.84,
        "1058": 0,
        "1075": 0,
        "1079": 2.6,
        "1087": 42,
        "1089": 0.66,
        "1090": 17,
        "1091": 33,
        "1092": 262,
        "1093": 28,
        "1095": 0.25,
        "1098": 0.054,
        "1101": 0.223,
        "1103": 2.3,
        "1105": 0,
        "1106": 2,
        "1107": 20,
        "1108": 0,
        "1109": 0.12,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 20,
        "1162": 34.4,
        "1165": 0.071,
        "1166": 0.06,
        "1167": 0.382,
        "1170": 0.154,
        "1175": 0.225,
        "1177": 24,
        "1178": 0,
        "1180": 21.4,
        "1184": 0,
        "1185": 47.6,
        "1187": 24,
        "1190": 24,
        "1198": 0.1,
        "1210": 0.013,
        "1211": 0.041,
        "1212": 0.036,
        "1213": 0.049,
        "1214": 0.051,
        "1215": 0.014,
        "1216": 0.013,
        "1217": 0.038,
        "1218": 0.023,
        "1219": 0.05,
        "1220": 0.088,
        "1221": 0.026,
        "1222": 0.05,
        "1223": 0.144,
        "1224": 0.346,
        "1225": 0.036,
        "1226": 0.056,
        "1227": 0.062,
        "1253": 0,
        "1257": 0,
        "1258": 0.011,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.01,
        "1266": 0,
        "1268": 0.007,
        "1269": 0.019,
        "1270": 0.024,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.007,
        "1293": 0.043,
        "2000": 3.32
      },
      "scientificName": "Brassica oleracea (Capitata Group)"
    },
    {
      "id": "168424",
      "name": "karalábé",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 120,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.7,
        "1004": 0.1,
        "1005": 6.2,
        "1008": 27,
        "1051": 91,
        "1058": 0,
        "1079": 3.6,
        "1087": 24,
        "1089": 0.4,
        "1090": 19,
        "1091": 46,
        "1092": 350,
        "1093": 20,
        "1095": 0.03,
        "1098": 0.129,
        "1101": 0.139,
        "1103": 0.7,
        "1105": 0,
        "1106": 2,
        "1107": 22,
        "1108": 0,
        "1109": 0.48,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 62,
        "1165": 0.05,
        "1166": 0.02,
        "1167": 0.4,
        "1170": 0.165,
        "1175": 0.15,
        "1177": 16,
        "1178": 0,
        "1180": 12.3,
        "1185": 0.1,
        "1187": 16,
        "1190": 16,
        "1210": 0.01,
        "1211": 0.049,
        "1212": 0.078,
        "1213": 0.067,
        "1214": 0.056,
        "1215": 0.013,
        "1216": 0.007,
        "1217": 0.039,
        "1219": 0.05,
        "1220": 0.105,
        "1221": 0.019,
        "1253": 0,
        "1257": 0,
        "1258": 0.013,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.011,
        "1266": 0.001,
        "1268": 0.007,
        "1269": 0.02,
        "1270": 0.026,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.007,
        "1293": 0.048,
        "2000": 2.6
      },
      "scientificName": "Brassica oleracea (Gongylodes Group)"
    },
    {
      "id": "168425",
      "name": "karalábé",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 120,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.8,
        "1004": 0.11,
        "1005": 6.69,
        "1008": 29,
        "1051": 90.3,
        "1058": 0,
        "1079": 1.1,
        "1087": 25,
        "1089": 0.4,
        "1090": 19,
        "1091": 45,
        "1092": 340,
        "1093": 21,
        "1095": 0.31,
        "1098": 0.132,
        "1101": 0.142,
        "1103": 0.8,
        "1105": 0,
        "1106": 2,
        "1107": 21,
        "1108": 0,
        "1109": 0.52,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 54,
        "1165": 0.04,
        "1166": 0.02,
        "1167": 0.39,
        "1170": 0.16,
        "1175": 0.154,
        "1177": 12,
        "1178": 0,
        "1180": 13.2,
        "1185": 0.1,
        "1187": 12,
        "1190": 12,
        "1210": 0.011,
        "1211": 0.052,
        "1212": 0.083,
        "1213": 0.071,
        "1214": 0.059,
        "1215": 0.014,
        "1216": 0.007,
        "1217": 0.041,
        "1219": 0.053,
        "1220": 0.111,
        "1221": 0.02,
        "1253": 0,
        "1257": 0,
        "1258": 0.014,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.012,
        "1266": 0.001,
        "1268": 0.008,
        "1269": 0.022,
        "1270": 0.028,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.008,
        "1293": 0.053,
        "2000": 2.8
      },
      "scientificName": "Brassica oleracea (Gongylodes Group)"
    },
    {
      "id": "170397",
      "name": "karfiol",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 250,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.84,
        "1004": 0.45,
        "1005": 4.11,
        "1008": 23,
        "1051": 93,
        "1058": 0,
        "1079": 2.3,
        "1087": 16,
        "1089": 0.32,
        "1090": 9,
        "1091": 32,
        "1092": 142,
        "1093": 15,
        "1095": 0.17,
        "1098": 0.018,
        "1101": 0.132,
        "1103": 0.6,
        "1105": 0,
        "1106": 1,
        "1107": 7,
        "1108": 0,
        "1109": 0.07,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 29,
        "1162": 44.3,
        "1165": 0.042,
        "1166": 0.052,
        "1167": 0.41,
        "1170": 0.508,
        "1175": 0.173,
        "1177": 44,
        "1178": 0,
        "1180": 39.1,
        "1185": 13.8,
        "1187": 44,
        "1190": 44,
        "1198": 0.1,
        "1210": 0.024,
        "1211": 0.067,
        "1212": 0.07,
        "1213": 0.107,
        "1214": 0.099,
        "1215": 0.026,
        "1216": 0.021,
        "1217": 0.066,
        "1218": 0.04,
        "1219": 0.092,
        "1220": 0.089,
        "1221": 0.037,
        "1222": 0.097,
        "1223": 0.216,
        "1224": 0.245,
        "1225": 0.059,
        "1226": 0.079,
        "1227": 0.096,
        "1253": 0,
        "1257": 0,
        "1258": 0.07,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.062,
        "1266": 0.008,
        "1268": 0.032,
        "1269": 0.05,
        "1270": 0.167,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.032,
        "1293": 0.217,
        "2000": 2.08
      },
      "scientificName": "Brassica oleracea (Botrytis Group)"
    },
    {
      "id": "169971",
      "name": "kel - bimbó",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.55,
        "1004": 0.5,
        "1005": 7.1,
        "1008": 36,
        "1051": 88.9,
        "1058": 0,
        "1079": 2.6,
        "1087": 36,
        "1089": 1.2,
        "1090": 20,
        "1091": 56,
        "1092": 317,
        "1093": 21,
        "1095": 0.33,
        "1098": 0.083,
        "1101": 0.227,
        "1103": 1.5,
        "1105": 0,
        "1106": 39,
        "1107": 465,
        "1108": 0,
        "1109": 0.43,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1290,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 62,
        "1165": 0.107,
        "1166": 0.08,
        "1167": 0.607,
        "1170": 0.252,
        "1175": 0.178,
        "1177": 60,
        "1178": 0,
        "1180": 40.6,
        "1185": 140.3,
        "1187": 60,
        "1190": 60,
        "1198": 0.2,
        "1210": 0.028,
        "1211": 0.091,
        "1212": 0.1,
        "1213": 0.114,
        "1214": 0.116,
        "1215": 0.024,
        "1216": 0.016,
        "1217": 0.074,
        "1219": 0.117,
        "1220": 0.153,
        "1221": 0.057,
        "1253": 0,
        "1257": 0,
        "1258": 0.102,
        "1259": 0,
        "1260": 0,
        "1261": 0.003,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.093,
        "1266": 0.005,
        "1268": 0.034,
        "1269": 0.079,
        "1270": 0.173,
        "1271": 0.002,
        "1272": 0,
        "1275": 0.004,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.038,
        "1293": 0.255,
        "2000": 1.74
      },
      "scientificName": "Brassica oleracea (Gemmifera Group)"
    },
    {
      "id": "1102667",
      "name": "kiwi",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.06,
        "1004": 0.44,
        "1005": 14,
        "1008": 58,
        "1051": 83.9,
        "1058": 0,
        "1079": 3,
        "1087": 35,
        "1089": 0.24,
        "1090": 16,
        "1091": 34,
        "1092": 198,
        "1093": 5,
        "1095": 0.14,
        "1098": 0.134,
        "1103": 0.2,
        "1105": 0,
        "1106": 4,
        "1107": 52,
        "1108": 0,
        "1109": 1.3,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 122,
        "1162": 74.7,
        "1165": 0.027,
        "1166": 0.025,
        "1167": 0.37,
        "1175": 0.061,
        "1177": 26,
        "1178": 0,
        "1180": 7.8,
        "1185": 40.3,
        "1187": 26,
        "1190": 26,
        "1253": 0,
        "1258": 0.029,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.017,
        "1266": 0.012,
        "1268": 0.047,
        "1269": 0.246,
        "1270": 0.042,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.047,
        "1293": 0.287,
        "2000": 8.99
      },
      "scientificName": "Actinidia deliciosa"
    },
    {
      "id": "168871",
      "name": "köles",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 250,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 3.51,
        "1004": 1,
        "1005": 23.67,
        "1008": 119,
        "1051": 71.41,
        "1058": 0,
        "1079": 1.3,
        "1087": 3,
        "1089": 0.63,
        "1090": 44,
        "1091": 100,
        "1092": 62,
        "1093": 2,
        "1095": 0.91,
        "1098": 0.161,
        "1101": 0.272,
        "1103": 0.9,
        "1105": 0,
        "1106": 0,
        "1107": 2,
        "1108": 0,
        "1109": 0.02,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 70,
        "1162": 0,
        "1165": 0.106,
        "1166": 0.082,
        "1167": 1.33,
        "1170": 0.171,
        "1175": 0.108,
        "1177": 19,
        "1178": 0,
        "1180": 11.2,
        "1185": 0.3,
        "1187": 19,
        "1190": 19,
        "1210": 0.038,
        "1211": 0.113,
        "1212": 0.148,
        "1213": 0.446,
        "1214": 0.067,
        "1215": 0.07,
        "1216": 0.067,
        "1217": 0.185,
        "1218": 0.108,
        "1219": 0.184,
        "1220": 0.122,
        "1221": 0.075,
        "1222": 0.314,
        "1223": 0.231,
        "1224": 0.763,
        "1225": 0.092,
        "1226": 0.279,
        "1227": 0.205,
        "1253": 0,
        "1258": 0.172,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.001,
        "1264": 0,
        "1265": 0.126,
        "1266": 0.037,
        "1268": 0.176,
        "1269": 0.48,
        "1270": 0.028,
        "1271": 0,
        "1272": 0,
        "1275": 0.003,
        "1276": 0,
        "1277": 0.005,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.184,
        "1293": 0.508,
        "2000": 0.13
      },
      "scientificName": "Panicum miliaceum L."
    },
    {
      "id": "167776",
      "name": "körte - bartlett (vilmos)",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.39,
        "1004": 0.16,
        "1005": 15.01,
        "1008": 63,
        "1010": 0.43,
        "1011": 2.5,
        "1012": 6.76,
        "1013": 0,
        "1014": 0,
        "1051": 84.14,
        "1075": 0,
        "1079": 3.1,
        "1087": 9,
        "1089": 0.19,
        "1090": 6,
        "1091": 11,
        "1092": 101,
        "1093": 1,
        "1095": 0.08,
        "1098": 0.078,
        "1101": 0.037,
        "1103": 0.1,
        "1106": 1,
        "1107": 14,
        "1108": 2,
        "1109": 0.12,
        "1120": 3,
        "1122": 0,
        "1123": 51,
        "1162": 4.4,
        "1165": 0.012,
        "1166": 0.026,
        "1167": 0.164,
        "1170": 0.042,
        "1175": 0.026,
        "1177": 6,
        "1180": 5.1,
        "1184": 0,
        "1185": 3.8,
        "1187": 6,
        "1210": 0.002,
        "1211": 0.012,
        "1212": 0.012,
        "1213": 0.02,
        "1214": 0.018,
        "1215": 0.002,
        "1216": 0.002,
        "1217": 0.011,
        "1218": 0.002,
        "1219": 0.018,
        "1220": 0.011,
        "1221": 0.002,
        "1222": 0.015,
        "1223": 0.111,
        "1224": 0.032,
        "1225": 0.013,
        "1226": 0.022,
        "1227": 0.016,
        "1257": 0,
        "2000": 9.69
      },
      "scientificName": "Pyrus communis"
    },
    {
      "id": "167778",
      "name": "körte - bosc",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.36,
        "1004": 0.09,
        "1005": 16.1,
        "1008": 67,
        "1010": 2.11,
        "1011": 2.48,
        "1012": 5.64,
        "1013": 0,
        "1014": 0,
        "1051": 83.18,
        "1075": 0,
        "1079": 3.1,
        "1087": 10,
        "1089": 0.15,
        "1090": 7,
        "1091": 14,
        "1092": 122,
        "1093": 1,
        "1095": 0.13,
        "1098": 0.104,
        "1101": 0.047,
        "1103": 0,
        "1106": 1,
        "1107": 11,
        "1108": 0,
        "1109": 0.12,
        "1120": 0,
        "1122": 0,
        "1123": 11,
        "1162": 2.8,
        "1165": 0.012,
        "1166": 0.023,
        "1167": 0.152,
        "1170": 0.057,
        "1175": 0.021,
        "1177": 7,
        "1180": 5.1,
        "1184": 0,
        "1185": 5.2,
        "1187": 7,
        "1210": 0.002,
        "1211": 0.011,
        "1212": 0.011,
        "1213": 0.018,
        "1214": 0.016,
        "1215": 0.002,
        "1216": 0.001,
        "1217": 0.01,
        "1218": 0.002,
        "1219": 0.016,
        "1220": 0.01,
        "1221": 0.001,
        "1222": 0.013,
        "1223": 0.101,
        "1224": 0.029,
        "1225": 0.012,
        "1226": 0.02,
        "1227": 0.015,
        "1257": 0,
        "2000": 10.23
      },
      "scientificName": "Pyrus communis"
    },
    {
      "id": "167779",
      "name": "körte - green anjou",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.44,
        "1004": 0.1,
        "1005": 15.79,
        "1008": 66,
        "1010": 0.33,
        "1011": 3.33,
        "1012": 6.06,
        "1013": 0,
        "1014": 0,
        "1051": 83.31,
        "1075": 0,
        "1079": 3.1,
        "1087": 11,
        "1089": 0.24,
        "1090": 7,
        "1091": 13,
        "1092": 127,
        "1093": 1,
        "1095": 0.1,
        "1098": 0.077,
        "1101": 0.048,
        "1103": 0,
        "1106": 1,
        "1107": 14,
        "1108": 0,
        "1109": 0.12,
        "1120": 1,
        "1122": 0,
        "1123": 46,
        "1162": 4.4,
        "1165": 0.01,
        "1166": 0.022,
        "1167": 0.151,
        "1170": 0.043,
        "1175": 0.026,
        "1177": 9,
        "1180": 5.1,
        "1184": 0,
        "1185": 4.3,
        "1187": 9,
        "1210": 0.002,
        "1211": 0.014,
        "1212": 0.013,
        "1213": 0.022,
        "1214": 0.02,
        "1215": 0.003,
        "1216": 0.002,
        "1217": 0.013,
        "1218": 0.002,
        "1219": 0.02,
        "1220": 0.012,
        "1221": 0.002,
        "1222": 0.016,
        "1223": 0.124,
        "1224": 0.036,
        "1225": 0.015,
        "1226": 0.025,
        "1227": 0.018,
        "1257": 0,
        "2000": 9.73
      },
      "scientificName": "Pyrus communis"
    },
    {
      "id": "170409",
      "name": "kukorica - csemege konzerv",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.95,
        "1004": 0.77,
        "1005": 13.86,
        "1008": 61,
        "1010": 3.65,
        "1011": 0.26,
        "1012": 0.17,
        "1013": 0,
        "1014": 0.07,
        "1051": 82.61,
        "1058": 0,
        "1075": 0,
        "1079": 1.7,
        "1087": 4,
        "1089": 0.36,
        "1090": 15,
        "1091": 46,
        "1092": 136,
        "1093": 195,
        "1095": 0.39,
        "1098": 0.028,
        "1099": 18,
        "1101": 0.082,
        "1103": 0.5,
        "1105": 0,
        "1106": 2,
        "1107": 9,
        "1108": 10,
        "1109": 0.03,
        "1110": 0,
        "1114": 0,
        "1120": 14,
        "1122": 0,
        "1123": 650,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.12,
        "1129": 0,
        "1130": 1.3,
        "1131": 0,
        "1162": 2.6,
        "1165": 0.015,
        "1166": 0.015,
        "1167": 0.884,
        "1170": 0.522,
        "1175": 0.037,
        "1177": 38,
        "1178": 0,
        "1180": 16.6,
        "1185": 0,
        "1187": 38,
        "1190": 38,
        "1210": 0.014,
        "1211": 0.078,
        "1212": 0.078,
        "1213": 0.21,
        "1214": 0.082,
        "1215": 0.04,
        "1216": 0.016,
        "1217": 0.09,
        "1218": 0.074,
        "1219": 0.112,
        "1220": 0.079,
        "1221": 0.053,
        "1222": 0.178,
        "1223": 0.148,
        "1224": 0.385,
        "1225": 0.076,
        "1226": 0.177,
        "1227": 0.092,
        "1253": 0,
        "1257": 0,
        "1258": 0.077,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.071,
        "1266": 0.004,
        "1268": 0.144,
        "1269": 0.227,
        "1270": 0.007,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.144,
        "1293": 0.233,
        "2000": 4.15
      }
    },
    {
      "id": "172421",
      "name": "lencse - normál - száraz",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 9.02,
        "1004": 0.38,
        "1005": 20.13,
        "1008": 116,
        "1051": 69.64,
        "1058": 0,
        "1079": 7.9,
        "1087": 19,
        "1089": 3.33,
        "1090": 36,
        "1091": 180,
        "1092": 369,
        "1093": 2,
        "1095": 1.27,
        "1098": 0.251,
        "1101": 0.494,
        "1103": 2.8,
        "1105": 0,
        "1106": 0,
        "1107": 5,
        "1108": 0,
        "1109": 0.11,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 1.5,
        "1165": 0.169,
        "1166": 0.073,
        "1167": 1.06,
        "1170": 0.638,
        "1175": 0.178,
        "1177": 181,
        "1178": 0,
        "1180": 32.7,
        "1185": 1.7,
        "1187": 181,
        "1190": 181,
        "1210": 0.081,
        "1211": 0.323,
        "1212": 0.39,
        "1213": 0.654,
        "1214": 0.63,
        "1215": 0.077,
        "1216": 0.118,
        "1217": 0.445,
        "1218": 0.241,
        "1219": 0.448,
        "1220": 0.697,
        "1221": 0.254,
        "1222": 0.377,
        "1223": 0.998,
        "1224": 1.399,
        "1225": 0.367,
        "1226": 0.377,
        "1227": 0.416,
        "1253": 0,
        "1257": 0,
        "1258": 0.053,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.045,
        "1266": 0.005,
        "1268": 0.061,
        "1269": 0.137,
        "1270": 0.037,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0.002,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.064,
        "1293": 0.175,
        "2000": 1.8
      },
      "scientificName": "Lens culinaris"
    },
    {
      "id": "168155",
      "name": "lime",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.7,
        "1004": 0.2,
        "1005": 10.54,
        "1008": 30,
        "1051": 88.26,
        "1058": 0,
        "1079": 2.8,
        "1087": 33,
        "1089": 0.6,
        "1090": 6,
        "1091": 18,
        "1092": 102,
        "1093": 2,
        "1095": 0.11,
        "1098": 0.065,
        "1101": 0.008,
        "1103": 0.4,
        "1105": 0,
        "1106": 2,
        "1107": 30,
        "1108": 0,
        "1109": 0.22,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 29.1,
        "1165": 0.03,
        "1166": 0.02,
        "1167": 0.2,
        "1170": 0.217,
        "1175": 0.043,
        "1177": 8,
        "1178": 0,
        "1180": 5.1,
        "1185": 0.6,
        "1187": 8,
        "1190": 8,
        "1210": 0.003,
        "1214": 0.014,
        "1215": 0.002,
        "1253": 0,
        "1257": 0,
        "1258": 0.022,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.02,
        "1266": 0.001,
        "1268": 0.016,
        "1269": 0.036,
        "1270": 0.019,
        "1271": 0,
        "1272": 0,
        "1275": 0.003,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.019,
        "1293": 0.055,
        "2000": 1.69
      },
      "scientificName": "Citrus latifolia"
    },
    {
      "id": "171330",
      "name": "mák - darált",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 1200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 17.99,
        "1004": 41.56,
        "1005": 28.13,
        "1008": 525,
        "1010": 2.33,
        "1011": 0.37,
        "1012": 0.29,
        "1013": 0,
        "1014": 0,
        "1051": 5.95,
        "1058": 0,
        "1075": 0,
        "1079": 19.5,
        "1087": 1438,
        "1089": 9.76,
        "1090": 347,
        "1091": 870,
        "1092": 719,
        "1093": 26,
        "1095": 7.9,
        "1098": 1.627,
        "1101": 6.707,
        "1103": 13.5,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 1.77,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1125": 8.3,
        "1126": 8.82,
        "1127": 0.23,
        "1128": 0.15,
        "1129": 0,
        "1130": 0.13,
        "1131": 0,
        "1162": 1,
        "1165": 0.854,
        "1166": 0.1,
        "1167": 0.896,
        "1170": 0.324,
        "1175": 0.247,
        "1177": 82,
        "1178": 0,
        "1180": 8.8,
        "1184": 0,
        "1185": 0,
        "1187": 82,
        "1190": 82,
        "1198": 0.9,
        "1210": 0.184,
        "1211": 0.686,
        "1212": 0.819,
        "1213": 1.321,
        "1214": 0.952,
        "1215": 0.502,
        "1216": 0.297,
        "1217": 0.758,
        "1218": 0.727,
        "1219": 1.095,
        "1220": 1.945,
        "1221": 0.471,
        "1222": 0.839,
        "1223": 2.365,
        "1224": 4.299,
        "1225": 0.952,
        "1226": 2.754,
        "1227": 0.952,
        "1228": 0,
        "1253": 0,
        "1257": 0,
        "1258": 4.517,
        "1259": 0,
        "1260": 0.037,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.077,
        "1265": 3.581,
        "1266": 0.782,
        "1267": 0.039,
        "1268": 5.864,
        "1269": 28.295,
        "1270": 0.273,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.039,
        "1276": 0,
        "1277": 0.078,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1285": 7,
        "1286": 29,
        "1288": 109,
        "1292": 5.982,
        "1293": 28.569,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1304": 0,
        "1312": 0,
        "1313": 0,
        "1315": 5.864,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1332": 0,
        "1333": 0,
        "1404": 0.273,
        "2000": 2.99
      },
      "scientificName": "Papaver somniferum"
    },
    {
      "id": "167755",
      "name": "málna",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.2,
        "1004": 0.65,
        "1005": 11.94,
        "1008": 52,
        "1009": 0,
        "1010": 0.2,
        "1011": 1.86,
        "1012": 2.35,
        "1013": 0,
        "1014": 0,
        "1051": 85.75,
        "1058": 0,
        "1075": 0,
        "1079": 6.5,
        "1087": 25,
        "1089": 0.69,
        "1090": 22,
        "1091": 29,
        "1092": 151,
        "1093": 1,
        "1095": 0.42,
        "1098": 0.09,
        "1101": 0.67,
        "1103": 0.2,
        "1105": 0,
        "1106": 2,
        "1107": 12,
        "1108": 16,
        "1109": 0.87,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 136,
        "1125": 0.06,
        "1126": 1.42,
        "1127": 1.04,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 26.2,
        "1165": 0.032,
        "1166": 0.038,
        "1167": 0.598,
        "1170": 0.329,
        "1175": 0.055,
        "1177": 21,
        "1178": 0,
        "1180": 12.3,
        "1184": 0,
        "1185": 7.8,
        "1187": 21,
        "1190": 21,
        "1198": 0.8,
        "1253": 0,
        "1257": 0,
        "1258": 0.019,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.016,
        "1266": 0.004,
        "1268": 0.059,
        "1269": 0.249,
        "1270": 0.126,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0.005,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.064,
        "1293": 0.375,
        "2000": 4.42
      },
      "scientificName": "Rubus spp."
    },
    {
      "id": "169105",
      "name": "mandarin",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.81,
        "1004": 0.31,
        "1005": 13.34,
        "1008": 53,
        "1009": 0,
        "1010": 6.05,
        "1011": 2.13,
        "1012": 2.4,
        "1013": 0,
        "1014": 0,
        "1051": 85.17,
        "1058": 0,
        "1075": 0,
        "1079": 1.8,
        "1087": 37,
        "1089": 0.15,
        "1090": 12,
        "1091": 20,
        "1092": 166,
        "1093": 2,
        "1095": 0.07,
        "1098": 0.042,
        "1101": 0.039,
        "1103": 0.1,
        "1105": 0,
        "1106": 34,
        "1107": 155,
        "1108": 101,
        "1109": 0.2,
        "1110": 0,
        "1114": 0,
        "1120": 407,
        "1122": 0,
        "1123": 138,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.05,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 26.7,
        "1165": 0.058,
        "1166": 0.036,
        "1167": 0.376,
        "1170": 0.216,
        "1175": 0.078,
        "1177": 16,
        "1178": 0,
        "1180": 10.2,
        "1184": 0,
        "1185": 0,
        "1187": 16,
        "1190": 16,
        "1198": 0.1,
        "1210": 0.002,
        "1211": 0.016,
        "1212": 0.017,
        "1213": 0.028,
        "1214": 0.032,
        "1215": 0.002,
        "1216": 0.002,
        "1217": 0.018,
        "1218": 0.015,
        "1219": 0.021,
        "1220": 0.068,
        "1221": 0.011,
        "1222": 0.028,
        "1223": 0.129,
        "1224": 0.061,
        "1225": 0.019,
        "1226": 0.074,
        "1227": 0.033,
        "1253": 0,
        "1257": 0,
        "1258": 0.039,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.002,
        "1265": 0.035,
        "1266": 0.002,
        "1268": 0.053,
        "1269": 0.048,
        "1270": 0.018,
        "1271": 0,
        "1272": 0,
        "1275": 0.007,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.06,
        "1293": 0.065,
        "2000": 10.58
      },
      "scientificName": "Citrus reticulata"
    },
    {
      "id": "169910",
      "name": "mangó",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 600,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.82,
        "1004": 0.38,
        "1005": 14.98,
        "1008": 60,
        "1010": 6.97,
        "1011": 2.01,
        "1012": 4.68,
        "1013": 0,
        "1014": 0,
        "1051": 83.46,
        "1058": 0,
        "1075": 0,
        "1079": 1.6,
        "1087": 11,
        "1089": 0.16,
        "1090": 10,
        "1091": 14,
        "1092": 168,
        "1093": 1,
        "1095": 0.09,
        "1098": 0.111,
        "1101": 0.063,
        "1103": 0.6,
        "1105": 0,
        "1106": 54,
        "1107": 640,
        "1108": 9,
        "1109": 0.9,
        "1110": 0,
        "1114": 0,
        "1120": 10,
        "1122": 3,
        "1123": 23,
        "1125": 0.01,
        "1126": 0.01,
        "1127": 0,
        "1128": 0.03,
        "1129": 0.01,
        "1130": 0,
        "1131": 0,
        "1162": 36.4,
        "1165": 0.028,
        "1166": 0.038,
        "1167": 0.669,
        "1170": 0.197,
        "1175": 0.119,
        "1177": 43,
        "1178": 0,
        "1180": 7.6,
        "1185": 4.2,
        "1187": 43,
        "1190": 43,
        "1210": 0.013,
        "1211": 0.031,
        "1212": 0.029,
        "1213": 0.05,
        "1214": 0.066,
        "1215": 0.008,
        "1217": 0.027,
        "1218": 0.016,
        "1219": 0.042,
        "1220": 0.031,
        "1221": 0.019,
        "1222": 0.082,
        "1223": 0.068,
        "1224": 0.096,
        "1225": 0.034,
        "1226": 0.029,
        "1227": 0.035,
        "1253": 0,
        "1257": 0,
        "1258": 0.092,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.001,
        "1264": 0.013,
        "1265": 0.072,
        "1266": 0.004,
        "1268": 0.075,
        "1269": 0.019,
        "1270": 0.051,
        "1271": 0,
        "1272": 0,
        "1275": 0.067,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.14,
        "1293": 0.071,
        "2000": 13.66
      },
      "scientificName": "Mangifera indica"
    },
    {
      "id": "173954",
      "name": "meggy",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1,
        "1004": 0.3,
        "1005": 12.18,
        "1008": 50,
        "1010": 0.8,
        "1011": 4.18,
        "1012": 3.51,
        "1013": 0,
        "1014": 0,
        "1051": 86.13,
        "1058": 0,
        "1075": 0,
        "1079": 1.6,
        "1087": 16,
        "1089": 0.32,
        "1090": 9,
        "1091": 15,
        "1092": 173,
        "1093": 3,
        "1095": 0.1,
        "1098": 0.104,
        "1101": 0.112,
        "1103": 0,
        "1105": 0,
        "1106": 64,
        "1107": 770,
        "1108": 0,
        "1109": 0.07,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 85,
        "1162": 10,
        "1165": 0.03,
        "1166": 0.04,
        "1167": 0.4,
        "1170": 0.143,
        "1175": 0.044,
        "1177": 8,
        "1178": 0,
        "1180": 6.1,
        "1185": 2.1,
        "1187": 8,
        "1190": 8,
        "1253": 0,
        "1257": 0,
        "1258": 0.068,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.002,
        "1265": 0.048,
        "1266": 0.016,
        "1268": 0.081,
        "1269": 0.046,
        "1270": 0.044,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.082,
        "1293": 0.09,
        "2000": 8.49
      },
      "scientificName": "Prunus cerasus"
    },
    {
      "id": "169918",
      "name": "narancs",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.7,
        "1004": 0.21,
        "1005": 11.54,
        "1008": 46,
        "1051": 87.14,
        "1058": 0,
        "1079": 2.4,
        "1087": 43,
        "1089": 0.09,
        "1090": 10,
        "1091": 12,
        "1092": 169,
        "1093": 0,
        "1095": 0.08,
        "1098": 0.039,
        "1101": 0.024,
        "1103": 0.5,
        "1105": 0,
        "1106": 11,
        "1107": 71,
        "1108": 11,
        "1109": 0.18,
        "1110": 0,
        "1114": 0,
        "1120": 116,
        "1122": 0,
        "1123": 129,
        "1162": 45,
        "1165": 0.1,
        "1166": 0.04,
        "1167": 0.4,
        "1170": 0.25,
        "1175": 0.051,
        "1177": 17,
        "1178": 0,
        "1180": 8.4,
        "1185": 0,
        "1187": 17,
        "1190": 17,
        "1210": 0.007,
        "1211": 0.011,
        "1212": 0.019,
        "1213": 0.017,
        "1214": 0.035,
        "1215": 0.015,
        "1216": 0.007,
        "1217": 0.023,
        "1218": 0.012,
        "1219": 0.03,
        "1220": 0.049,
        "1221": 0.013,
        "1222": 0.038,
        "1223": 0.085,
        "1224": 0.071,
        "1225": 0.071,
        "1226": 0.035,
        "1227": 0.024,
        "1253": 0,
        "1257": 0,
        "1258": 0.025,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.023,
        "1266": 0.001,
        "1268": 0.034,
        "1269": 0.031,
        "1270": 0.011,
        "1271": 0,
        "1272": 0,
        "1275": 0.005,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.039,
        "1293": 0.042,
        "2000": 9.14
      },
      "scientificName": "Citrus sinensis"
    },
    {
      "id": "169914",
      "name": "nektarin",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.06,
        "1004": 0.32,
        "1005": 10.55,
        "1008": 44,
        "1009": 0.07,
        "1010": 4.87,
        "1011": 1.57,
        "1012": 1.37,
        "1013": 0,
        "1014": 0,
        "1051": 87.59,
        "1058": 0,
        "1075": 0,
        "1079": 1.7,
        "1087": 6,
        "1089": 0.28,
        "1090": 9,
        "1091": 26,
        "1092": 201,
        "1093": 0,
        "1095": 0.17,
        "1098": 0.086,
        "1101": 0.054,
        "1103": 0,
        "1105": 0,
        "1106": 17,
        "1107": 150,
        "1108": 0,
        "1109": 0.77,
        "1110": 0,
        "1114": 0,
        "1120": 98,
        "1122": 0,
        "1123": 130,
        "1125": 0.01,
        "1126": 0.01,
        "1127": 0.01,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 5.4,
        "1165": 0.034,
        "1166": 0.027,
        "1167": 1.125,
        "1170": 0.185,
        "1175": 0.025,
        "1177": 5,
        "1178": 0,
        "1180": 6.2,
        "1184": 0,
        "1185": 2.2,
        "1187": 5,
        "1190": 5,
        "1198": 0.2,
        "1210": 0.005,
        "1211": 0.009,
        "1212": 0.009,
        "1213": 0.014,
        "1214": 0.016,
        "1215": 0.006,
        "1216": 0.005,
        "1217": 0.021,
        "1218": 0.007,
        "1219": 0.013,
        "1220": 0.009,
        "1221": 0.008,
        "1222": 0.017,
        "1223": 0.568,
        "1224": 0.034,
        "1225": 0.011,
        "1226": 0.01,
        "1227": 0.018,
        "1253": 0,
        "1257": 0,
        "1258": 0.025,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.023,
        "1266": 0.002,
        "1268": 0.086,
        "1269": 0.111,
        "1270": 0.002,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.088,
        "1293": 0.113,
        "2000": 7.89
      },
      "scientificName": "Prunus persica var. nucipersica"
    },
    {
      "id": "169094",
      "name": "olivabogyó - magozott",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 800,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.84,
        "1004": 10.9,
        "1005": 6.04,
        "1008": 116,
        "1051": 79.99,
        "1058": 0,
        "1079": 1.6,
        "1087": 88,
        "1089": 6.28,
        "1090": 4,
        "1091": 3,
        "1092": 8,
        "1093": 735,
        "1095": 0.22,
        "1098": 0.251,
        "1101": 0.02,
        "1103": 0.9,
        "1105": 0,
        "1106": 17,
        "1107": 198,
        "1108": 0,
        "1109": 1.65,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 510,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0.9,
        "1165": 0.003,
        "1166": 0,
        "1167": 0.037,
        "1170": 0.015,
        "1175": 0.009,
        "1177": 0,
        "1178": 0,
        "1180": 10.3,
        "1185": 1.4,
        "1187": 0,
        "1190": 0,
        "1211": 0.026,
        "1212": 0.031,
        "1213": 0.05,
        "1214": 0.032,
        "1215": 0.012,
        "1217": 0.029,
        "1218": 0.023,
        "1219": 0.038,
        "1220": 0.067,
        "1221": 0.023,
        "1222": 0.043,
        "1223": 0.092,
        "1224": 0.093,
        "1225": 0.049,
        "1226": 0.04,
        "1227": 0.031,
        "1253": 0,
        "1257": 0,
        "1258": 2.279,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 1.73,
        "1266": 0.318,
        "1267": 0.055,
        "1268": 7.47,
        "1269": 0.629,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1273": 0.015,
        "1274": 0,
        "1275": 0.15,
        "1276": 0,
        "1277": 0.032,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 7.652,
        "1293": 0.629,
        "1299": 0,
        "1300": 0.15,
        "1301": 0.011,
        "1313": 0,
        "1323": 0,
        "1333": 0,
        "2000": 0
      }
    },
    {
      "id": "169229",
      "name": "padlizsán",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.83,
        "1004": 0.23,
        "1005": 8.73,
        "1008": 35,
        "1051": 89.67,
        "1058": 0,
        "1079": 2.5,
        "1087": 6,
        "1089": 0.25,
        "1090": 11,
        "1091": 15,
        "1092": 123,
        "1093": 1,
        "1095": 0.12,
        "1098": 0.059,
        "1101": 0.113,
        "1103": 0.1,
        "1105": 0,
        "1106": 2,
        "1107": 22,
        "1108": 0,
        "1109": 0.41,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 1.3,
        "1165": 0.076,
        "1166": 0.02,
        "1167": 0.6,
        "1170": 0.075,
        "1175": 0.086,
        "1177": 14,
        "1178": 0,
        "1180": 9.4,
        "1185": 2.9,
        "1187": 14,
        "1190": 14,
        "1210": 0.008,
        "1211": 0.03,
        "1212": 0.036,
        "1213": 0.052,
        "1214": 0.039,
        "1215": 0.009,
        "1216": 0.004,
        "1217": 0.035,
        "1218": 0.022,
        "1219": 0.043,
        "1220": 0.046,
        "1221": 0.019,
        "1222": 0.042,
        "1223": 0.134,
        "1224": 0.152,
        "1225": 0.033,
        "1226": 0.034,
        "1227": 0.034,
        "1253": 0,
        "1257": 0,
        "1258": 0.044,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.032,
        "1266": 0.012,
        "1268": 0.018,
        "1269": 0.078,
        "1270": 0.015,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.02,
        "1293": 0.093,
        "2000": 3.2
      },
      "scientificName": "Solanum melongena"
    },
    {
      "id": "169926",
      "name": "papaja",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.47,
        "1004": 0.26,
        "1005": 10.82,
        "1008": 43,
        "1009": 0,
        "1010": 0,
        "1011": 4.09,
        "1012": 3.73,
        "1013": 0,
        "1014": 0,
        "1051": 88.06,
        "1058": 0,
        "1075": 0,
        "1079": 1.7,
        "1087": 20,
        "1089": 0.25,
        "1090": 21,
        "1091": 10,
        "1092": 182,
        "1093": 8,
        "1095": 0.08,
        "1098": 0.045,
        "1101": 0.04,
        "1103": 0.6,
        "1105": 0,
        "1106": 47,
        "1107": 274,
        "1108": 2,
        "1109": 0.3,
        "1110": 0,
        "1114": 0,
        "1120": 589,
        "1122": 1828,
        "1123": 89,
        "1125": 0.02,
        "1126": 0.09,
        "1127": 0.01,
        "1128": 0,
        "1129": 0.07,
        "1130": 0.01,
        "1131": 0,
        "1162": 60.9,
        "1165": 0.023,
        "1166": 0.027,
        "1167": 0.357,
        "1170": 0.191,
        "1175": 0.038,
        "1177": 37,
        "1178": 0,
        "1180": 6.1,
        "1185": 2.6,
        "1187": 37,
        "1190": 37,
        "1210": 0.008,
        "1211": 0.011,
        "1212": 0.008,
        "1213": 0.016,
        "1214": 0.025,
        "1215": 0.002,
        "1217": 0.009,
        "1218": 0.005,
        "1219": 0.01,
        "1220": 0.01,
        "1221": 0.005,
        "1222": 0.014,
        "1223": 0.049,
        "1224": 0.033,
        "1225": 0.018,
        "1226": 0.01,
        "1227": 0.015,
        "1253": 0,
        "1257": 0,
        "1258": 0.081,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.002,
        "1264": 0.013,
        "1265": 0.06,
        "1266": 0.004,
        "1268": 0.034,
        "1269": 0.011,
        "1270": 0.047,
        "1271": 0,
        "1272": 0,
        "1275": 0.038,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.072,
        "1293": 0.058,
        "2000": 7.82
      },
      "scientificName": "Carica papaya"
    },
    {
      "id": "170106",
      "name": "paprika - chilli - red",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 5,
      "portionGrams": 5,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.87,
        "1004": 0.44,
        "1005": 8.81,
        "1008": 40,
        "1051": 88.02,
        "1058": 0,
        "1079": 1.5,
        "1087": 14,
        "1089": 1.03,
        "1090": 23,
        "1091": 43,
        "1092": 322,
        "1093": 9,
        "1095": 0.26,
        "1098": 0.129,
        "1101": 0.187,
        "1103": 0.5,
        "1105": 0,
        "1106": 48,
        "1107": 534,
        "1108": 36,
        "1109": 0.69,
        "1110": 0,
        "1114": 0,
        "1120": 40,
        "1122": 0,
        "1123": 709,
        "1162": 143.7,
        "1165": 0.072,
        "1166": 0.086,
        "1167": 1.244,
        "1170": 0.201,
        "1175": 0.506,
        "1177": 23,
        "1178": 0,
        "1180": 10.9,
        "1185": 14,
        "1187": 23,
        "1190": 23,
        "1210": 0.026,
        "1211": 0.074,
        "1212": 0.065,
        "1213": 0.105,
        "1214": 0.089,
        "1215": 0.024,
        "1216": 0.038,
        "1217": 0.062,
        "1218": 0.042,
        "1219": 0.084,
        "1220": 0.096,
        "1221": 0.041,
        "1222": 0.082,
        "1223": 0.286,
        "1224": 0.264,
        "1225": 0.074,
        "1226": 0.087,
        "1227": 0.08,
        "1253": 0,
        "1257": 0,
        "1258": 0.042,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.002,
        "1265": 0.033,
        "1266": 0.007,
        "1268": 0.024,
        "1269": 0.228,
        "1270": 0.011,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.024,
        "1293": 0.239,
        "2000": 5.3
      }
    },
    {
      "id": "168576",
      "name": "paprika - jalapeno",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.91,
        "1004": 0.37,
        "1005": 6.5,
        "1008": 29,
        "1010": 0,
        "1011": 1.48,
        "1012": 2.63,
        "1013": 0,
        "1014": 0,
        "1051": 91.69,
        "1058": 0,
        "1075": 0,
        "1079": 2.8,
        "1087": 12,
        "1089": 0.25,
        "1090": 15,
        "1091": 26,
        "1092": 248,
        "1093": 3,
        "1095": 0.14,
        "1098": 0.046,
        "1101": 0.097,
        "1103": 0.4,
        "1105": 0,
        "1106": 54,
        "1107": 561,
        "1108": 67,
        "1109": 3.58,
        "1110": 0,
        "1114": 0,
        "1120": 105,
        "1122": 0,
        "1123": 861,
        "1125": 0.17,
        "1126": 0.05,
        "1127": 0.01,
        "1128": 0.02,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 118.6,
        "1165": 0.04,
        "1166": 0.07,
        "1167": 1.28,
        "1170": 0.315,
        "1175": 0.419,
        "1177": 27,
        "1178": 0,
        "1180": 7.5,
        "1185": 18.5,
        "1187": 27,
        "1190": 27,
        "1253": 0,
        "1257": 0,
        "1258": 0.092,
        "1259": 0.004,
        "1260": 0,
        "1261": 0,
        "1262": 0.002,
        "1263": 0.003,
        "1264": 0.008,
        "1265": 0.052,
        "1266": 0.016,
        "1267": 0.004,
        "1268": 0.025,
        "1269": 0.062,
        "1270": 0.05,
        "1271": 0,
        "1272": 0,
        "1273": 0.003,
        "1274": 0,
        "1275": 0.003,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.029,
        "1293": 0.112,
        "1299": 0,
        "1300": 0.001,
        "1301": 0,
        "1303": 0,
        "1304": 0,
        "1305": 0,
        "1306": 0,
        "1311": 0,
        "1312": 0,
        "1313": 0,
        "1314": 0.003,
        "1315": 0.025,
        "1316": 0.062,
        "1317": 0,
        "1321": 0,
        "1323": 0,
        "1325": 0,
        "1329": 0,
        "1331": 0,
        "1333": 0,
        "1404": 0.05,
        "1405": 0,
        "1406": 0,
        "1411": 0,
        "2000": 4.12
      },
      "scientificName": "Capsicum annuum"
    },
    {
      "id": "170108",
      "name": "paprika - kaliforniai - piros",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.99,
        "1004": 0.3,
        "1005": 6.03,
        "1008": 26,
        "1009": 0,
        "1010": 0,
        "1011": 1.94,
        "1012": 2.26,
        "1013": 0,
        "1014": 0,
        "1051": 92.21,
        "1058": 0,
        "1075": 0,
        "1079": 2.1,
        "1087": 7,
        "1089": 0.43,
        "1090": 12,
        "1091": 26,
        "1092": 211,
        "1093": 4,
        "1095": 0.25,
        "1098": 0.017,
        "1101": 0.112,
        "1103": 0.1,
        "1105": 0,
        "1106": 157,
        "1107": 1624,
        "1108": 20,
        "1109": 1.58,
        "1110": 0,
        "1114": 0,
        "1120": 490,
        "1122": 0,
        "1123": 51,
        "1125": 0.05,
        "1126": 0.14,
        "1127": 0.01,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 127.7,
        "1165": 0.054,
        "1166": 0.085,
        "1167": 0.979,
        "1170": 0.317,
        "1175": 0.291,
        "1177": 46,
        "1178": 0,
        "1180": 5.6,
        "1184": 0,
        "1185": 4.9,
        "1187": 46,
        "1190": 46,
        "1198": 0.1,
        "1210": 0.012,
        "1211": 0.04,
        "1212": 0.021,
        "1213": 0.036,
        "1214": 0.036,
        "1215": 0.006,
        "1216": 0.019,
        "1217": 0.05,
        "1218": 0.009,
        "1219": 0.031,
        "1220": 0.036,
        "1221": 0.017,
        "1222": 0.026,
        "1223": 0.284,
        "1224": 0.211,
        "1225": 0.028,
        "1226": 0.024,
        "1227": 0.05,
        "1253": 0,
        "1257": 0,
        "1258": 0.059,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.056,
        "1266": 0.004,
        "1267": 0,
        "1268": 0.004,
        "1269": 0.1,
        "1270": 0.056,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.004,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.007,
        "1293": 0.156,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 4.2
      },
      "scientificName": "Capsicum annuum"
    },
    {
      "id": "168578",
      "name": "paprika - tv",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.8,
        "1004": 0.41,
        "1005": 6.7,
        "1008": 29,
        "1051": 91.51,
        "1058": 0,
        "1079": 1,
        "1087": 12,
        "1089": 0.46,
        "1090": 16,
        "1091": 29,
        "1092": 202,
        "1093": 1,
        "1095": 0.3,
        "1098": 0.115,
        "1101": 0.204,
        "1103": 0.3,
        "1105": 0,
        "1106": 41,
        "1107": 465,
        "1108": 16,
        "1109": 0.48,
        "1110": 0,
        "1114": 0,
        "1120": 34,
        "1122": 0,
        "1123": 502,
        "1162": 92.9,
        "1165": 0.079,
        "1166": 0.055,
        "1167": 1.092,
        "1170": 0.205,
        "1175": 0.517,
        "1177": 53,
        "1178": 0,
        "1180": 7.7,
        "1185": 9.9,
        "1187": 53,
        "1190": 53,
        "1210": 0.01,
        "1211": 0.03,
        "1212": 0.026,
        "1213": 0.042,
        "1214": 0.036,
        "1215": 0.01,
        "1216": 0.015,
        "1217": 0.025,
        "1218": 0.017,
        "1219": 0.034,
        "1220": 0.039,
        "1221": 0.016,
        "1222": 0.033,
        "1223": 0.115,
        "1224": 0.106,
        "1225": 0.03,
        "1226": 0.035,
        "1227": 0.032,
        "1253": 0,
        "1257": 0,
        "1258": 0.046,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.002,
        "1265": 0.033,
        "1266": 0.007,
        "1268": 0.024,
        "1269": 0.229,
        "1270": 0.011,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.024,
        "1293": 0.24,
        "2000": 3.53
      }
    },
    {
      "id": "170457",
      "name": "paradicsom - normál",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 250,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.88,
        "1004": 0.2,
        "1005": 3.89,
        "1008": 18,
        "1009": 0,
        "1010": 0,
        "1011": 1.25,
        "1012": 1.37,
        "1013": 0,
        "1014": 0,
        "1051": 94.52,
        "1058": 0,
        "1075": 0,
        "1079": 1.2,
        "1087": 10,
        "1089": 0.27,
        "1090": 11,
        "1091": 24,
        "1092": 237,
        "1093": 5,
        "1095": 0.17,
        "1098": 0.059,
        "1099": 2.3,
        "1101": 0.114,
        "1103": 0,
        "1105": 0,
        "1106": 42,
        "1107": 449,
        "1108": 101,
        "1109": 0.54,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 2573,
        "1123": 123,
        "1125": 0.01,
        "1126": 0.12,
        "1127": 0,
        "1128": 0.01,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 13.7,
        "1165": 0.037,
        "1166": 0.019,
        "1167": 0.594,
        "1170": 0.089,
        "1175": 0.08,
        "1177": 15,
        "1178": 0,
        "1180": 6.7,
        "1184": 0,
        "1185": 7.9,
        "1187": 15,
        "1190": 15,
        "1198": 0.1,
        "1210": 0.006,
        "1211": 0.027,
        "1212": 0.018,
        "1213": 0.025,
        "1214": 0.027,
        "1215": 0.006,
        "1216": 0.009,
        "1217": 0.027,
        "1218": 0.014,
        "1219": 0.018,
        "1220": 0.021,
        "1221": 0.014,
        "1222": 0.027,
        "1223": 0.135,
        "1224": 0.431,
        "1225": 0.019,
        "1226": 0.015,
        "1227": 0.026,
        "1253": 0,
        "1257": 0,
        "1258": 0.028,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.02,
        "1266": 0.008,
        "1268": 0.03,
        "1269": 0.08,
        "1270": 0.003,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 7,
        "1292": 0.031,
        "1293": 0.083,
        "2000": 2.63
      },
      "scientificName": "Solanum lycopersicum"
    },
    {
      "id": "170089",
      "name": "paradicsom - normál",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 250,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.96,
        "1004": 2.68,
        "1005": 13.05,
        "1008": 79,
        "1051": 80.63,
        "1079": 1.7,
        "1087": 26,
        "1089": 1.06,
        "1090": 15,
        "1091": 38,
        "1092": 247,
        "1093": 455,
        "1095": 0.18,
        "1098": 0.095,
        "1101": 0.193,
        "1103": 1.2,
        "1105": 0,
        "1106": 33,
        "1110": 0,
        "1114": 0,
        "1162": 18.2,
        "1165": 0.108,
        "1166": 0.08,
        "1167": 1.11,
        "1170": 0.256,
        "1175": 0.086,
        "1177": 11,
        "1178": 0,
        "1187": 11,
        "1190": 11,
        "1210": 0.019,
        "1211": 0.054,
        "1212": 0.064,
        "1213": 0.106,
        "1214": 0.062,
        "1215": 0.024,
        "1216": 0.029,
        "1217": 0.075,
        "1218": 0.041,
        "1219": 0.075,
        "1220": 0.067,
        "1221": 0.036,
        "1222": 0.063,
        "1223": 0.174,
        "1224": 0.643,
        "1225": 0.063,
        "1226": 0.13,
        "1227": 0.077,
        "1253": 0,
        "1257": 0,
        "1258": 0.521,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.007,
        "1265": 0.327,
        "1266": 0.186,
        "1268": 1.046,
        "1269": 0.839,
        "1270": 0.038,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 14,
        "1292": 1.048,
        "1293": 0.878
      },
      "scientificName": "Solanum lycopersicum"
    },
    {
      "id": "170460",
      "name": "paradicsom - pürésített",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.65,
        "1004": 0.21,
        "1005": 8.98,
        "1008": 38,
        "1010": 0,
        "1011": 2.45,
        "1012": 2.38,
        "1013": 0,
        "1014": 0,
        "1051": 87.88,
        "1058": 0,
        "1075": 0,
        "1079": 1.9,
        "1087": 18,
        "1089": 1.78,
        "1090": 23,
        "1091": 40,
        "1092": 439,
        "1093": 28,
        "1095": 0.36,
        "1098": 0.287,
        "1101": 0.169,
        "1103": 0.7,
        "1105": 0,
        "1106": 26,
        "1107": 306,
        "1108": 0,
        "1109": 1.97,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 21754,
        "1123": 0,
        "1125": 0,
        "1126": 0.24,
        "1127": 0,
        "1162": 10.6,
        "1165": 0.025,
        "1166": 0.08,
        "1167": 1.466,
        "1170": 0.44,
        "1175": 0.126,
        "1177": 11,
        "1178": 0,
        "1180": 17.6,
        "1184": 0,
        "1185": 3.4,
        "1187": 11,
        "1190": 11,
        "1198": 0.2,
        "1210": 0.011,
        "1211": 0.037,
        "1212": 0.031,
        "1213": 0.046,
        "1214": 0.048,
        "1215": 0.009,
        "1216": 0.01,
        "1217": 0.034,
        "1218": 0.021,
        "1219": 0.033,
        "1220": 0.032,
        "1221": 0.025,
        "1222": 0.052,
        "1223": 0.206,
        "1224": 0.658,
        "1225": 0.027,
        "1226": 0.036,
        "1227": 0.039,
        "1253": 0,
        "1257": 0,
        "1258": 0.029,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.022,
        "1266": 0.007,
        "1268": 0.031,
        "1269": 0.082,
        "1270": 0.004,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.031,
        "1293": 0.086,
        "2000": 4.83
      }
    },
    {
      "id": "170459",
      "name": "paradicsom - sűrítmény",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 100,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 4.32,
        "1004": 0.47,
        "1005": 18.91,
        "1008": 82,
        "1009": 0.22,
        "1010": 0.3,
        "1011": 5.75,
        "1012": 5.85,
        "1013": 0,
        "1014": 0.28,
        "1051": 73.5,
        "1058": 0,
        "1075": 0,
        "1079": 4.1,
        "1087": 36,
        "1089": 2.98,
        "1090": 42,
        "1091": 83,
        "1092": 1014,
        "1093": 59,
        "1095": 0.63,
        "1098": 0.365,
        "1101": 0.302,
        "1103": 5.3,
        "1105": 0,
        "1106": 76,
        "1107": 901,
        "1108": 29,
        "1109": 4.3,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 28764,
        "1123": 0,
        "1125": 0,
        "1126": 0.52,
        "1127": 0,
        "1162": 21.9,
        "1165": 0.06,
        "1166": 0.153,
        "1167": 3.076,
        "1170": 0.142,
        "1175": 0.216,
        "1177": 12,
        "1178": 0,
        "1180": 38.5,
        "1184": 0,
        "1185": 11.4,
        "1187": 12,
        "1190": 12,
        "1198": 0.4,
        "1210": 0.031,
        "1211": 0.133,
        "1212": 0.089,
        "1213": 0.124,
        "1214": 0.134,
        "1215": 0.027,
        "1216": 0.046,
        "1217": 0.13,
        "1218": 0.066,
        "1219": 0.088,
        "1220": 0.102,
        "1221": 0.071,
        "1222": 0.133,
        "1223": 0.661,
        "1224": 2.11,
        "1225": 0.095,
        "1226": 0.075,
        "1227": 0.126,
        "1253": 0,
        "1257": 0,
        "1258": 0.1,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.083,
        "1266": 0.016,
        "1268": 0.064,
        "1269": 0.152,
        "1270": 0.007,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0.001,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.067,
        "1293": 0.16,
        "2000": 12.18
      }
    },
    {
      "id": "168917",
      "name": "quinoa",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 4.4,
        "1004": 1.92,
        "1005": 21.3,
        "1008": 120,
        "1009": 17.63,
        "1051": 71.61,
        "1058": 0,
        "1079": 2.8,
        "1087": 17,
        "1089": 1.49,
        "1090": 64,
        "1091": 152,
        "1092": 172,
        "1093": 7,
        "1095": 1.09,
        "1098": 0.192,
        "1101": 0.631,
        "1103": 2.8,
        "1105": 0,
        "1106": 0,
        "1107": 3,
        "1108": 0,
        "1109": 0.63,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 53,
        "1125": 0.03,
        "1126": 1.19,
        "1127": 0.11,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 0,
        "1165": 0.107,
        "1166": 0.11,
        "1167": 0.412,
        "1175": 0.123,
        "1177": 42,
        "1178": 0,
        "1180": 23,
        "1185": 0,
        "1187": 42,
        "1190": 42,
        "1210": 0.052,
        "1211": 0.131,
        "1212": 0.157,
        "1213": 0.261,
        "1214": 0.239,
        "1215": 0.096,
        "1216": 0.063,
        "1217": 0.185,
        "1218": 0.083,
        "1219": 0.185,
        "1220": 0.34,
        "1221": 0.127,
        "1222": 0.183,
        "1223": 0.353,
        "1224": 0.58,
        "1225": 0.216,
        "1226": 0.24,
        "1227": 0.176,
        "1253": 0,
        "1258": 0.231,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.196,
        "1266": 0.012,
        "1268": 0.465,
        "1269": 0.974,
        "1270": 0.085,
        "1271": 0.003,
        "1272": 0.015,
        "1275": 0,
        "1276": 0,
        "1277": 0.031,
        "1278": 0,
        "1279": 0.027,
        "1280": 0,
        "1292": 0.528,
        "1293": 1.078,
        "2000": 0.87
      },
      "scientificName": "Chenopodium quinoa Willd."
    },
    {
      "id": "170417",
      "name": "répa - fehér",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 120,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.2,
        "1004": 0.3,
        "1005": 17.99,
        "1008": 75,
        "1051": 79.53,
        "1058": 0,
        "1079": 4.9,
        "1087": 36,
        "1089": 0.59,
        "1090": 29,
        "1091": 71,
        "1092": 375,
        "1093": 10,
        "1095": 0.59,
        "1098": 0.12,
        "1101": 0.56,
        "1103": 1.8,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 1.49,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 17,
        "1165": 0.09,
        "1166": 0.05,
        "1167": 0.7,
        "1170": 0.6,
        "1175": 0.09,
        "1177": 67,
        "1178": 0,
        "1185": 22.5,
        "1187": 67,
        "1190": 67,
        "1253": 0,
        "1257": 0,
        "1258": 0.05,
        "1264": 0.003,
        "1265": 0.03,
        "1266": 0.014,
        "1268": 0.102,
        "1269": 0.041,
        "1270": 0.003,
        "1275": 0.003,
        "1292": 0.112,
        "1293": 0.047,
        "2000": 4.8
      },
      "scientificName": "Pastinaca sativa"
    },
    {
      "id": "170009",
      "name": "répa - fehér",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 120,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.32,
        "1004": 0.3,
        "1005": 17.01,
        "1008": 71,
        "1051": 80.24,
        "1058": 0,
        "1079": 3.6,
        "1087": 37,
        "1089": 0.58,
        "1090": 29,
        "1091": 69,
        "1092": 367,
        "1093": 10,
        "1095": 0.26,
        "1098": 0.138,
        "1101": 0.294,
        "1103": 1.7,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 1,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 13,
        "1165": 0.083,
        "1166": 0.051,
        "1167": 0.724,
        "1170": 0.588,
        "1175": 0.093,
        "1177": 58,
        "1178": 0,
        "1180": 27,
        "1185": 1,
        "1187": 58,
        "1190": 58,
        "1253": 0,
        "1257": 0,
        "1258": 0.05,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.003,
        "1265": 0.03,
        "1266": 0.014,
        "1268": 0.102,
        "1269": 0.041,
        "1270": 0.003,
        "1271": 0,
        "1272": 0,
        "1275": 0.003,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.112,
        "1293": 0.047,
        "2000": 4.8
      },
      "scientificName": "Pastinaca sativa"
    },
    {
      "id": "170393",
      "name": "répa - sárga",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.93,
        "1004": 0.24,
        "1005": 9.58,
        "1008": 41,
        "1009": 1.43,
        "1010": 3.59,
        "1011": 0.59,
        "1012": 0.55,
        "1013": 0,
        "1014": 0,
        "1051": 88.29,
        "1058": 0,
        "1075": 0,
        "1079": 2.8,
        "1087": 33,
        "1089": 0.3,
        "1090": 12,
        "1091": 35,
        "1092": 320,
        "1093": 69,
        "1095": 0.24,
        "1098": 0.045,
        "1099": 3.2,
        "1101": 0.143,
        "1103": 0.1,
        "1105": 0,
        "1106": 835,
        "1107": 8285,
        "1108": 3477,
        "1109": 0.66,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 1,
        "1123": 256,
        "1125": 0.01,
        "1126": 0,
        "1127": 0,
        "1128": 0.01,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 5.9,
        "1165": 0.066,
        "1166": 0.058,
        "1167": 0.983,
        "1170": 0.273,
        "1175": 0.138,
        "1177": 19,
        "1178": 0,
        "1180": 8.8,
        "1184": 0,
        "1185": 13.2,
        "1187": 19,
        "1190": 19,
        "1198": 0.4,
        "1210": 0.012,
        "1211": 0.191,
        "1212": 0.077,
        "1213": 0.102,
        "1214": 0.101,
        "1215": 0.02,
        "1216": 0.083,
        "1217": 0.061,
        "1218": 0.043,
        "1219": 0.069,
        "1220": 0.091,
        "1221": 0.04,
        "1222": 0.113,
        "1223": 0.19,
        "1224": 0.366,
        "1225": 0.047,
        "1226": 0.054,
        "1227": 0.054,
        "1253": 0,
        "1257": 0,
        "1258": 0.032,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.03,
        "1266": 0.002,
        "1267": 0,
        "1268": 0.011,
        "1269": 0.1,
        "1270": 0.002,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.012,
        "1293": 0.102,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 4.74
      },
      "scientificName": "Daucus carota"
    },
    {
      "id": "170394",
      "name": "répa - sárga",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 100,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.76,
        "1004": 0.18,
        "1005": 8.22,
        "1008": 35,
        "1009": 0.17,
        "1010": 2.7,
        "1011": 0.4,
        "1012": 0.36,
        "1013": 0,
        "1014": 0,
        "1051": 90.17,
        "1058": 0,
        "1075": 0,
        "1079": 3,
        "1087": 30,
        "1089": 0.34,
        "1090": 10,
        "1091": 30,
        "1092": 235,
        "1093": 58,
        "1095": 0.2,
        "1098": 0.017,
        "1099": 47.5,
        "1101": 0.155,
        "1103": 0.7,
        "1105": 0,
        "1106": 852,
        "1107": 8332,
        "1108": 3776,
        "1109": 1.03,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 687,
        "1125": 0.02,
        "1126": 0.01,
        "1127": 0,
        "1128": 0.05,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 3.6,
        "1165": 0.066,
        "1166": 0.044,
        "1167": 0.645,
        "1170": 0.232,
        "1175": 0.153,
        "1177": 14,
        "1178": 0,
        "1180": 8.8,
        "1184": 0,
        "1185": 13.7,
        "1187": 14,
        "1190": 14,
        "1198": 0.1,
        "1210": 0.01,
        "1211": 0.157,
        "1212": 0.063,
        "1213": 0.084,
        "1214": 0.083,
        "1215": 0.017,
        "1216": 0.068,
        "1217": 0.05,
        "1218": 0.035,
        "1219": 0.056,
        "1220": 0.075,
        "1221": 0.033,
        "1222": 0.093,
        "1223": 0.156,
        "1224": 0.301,
        "1225": 0.038,
        "1226": 0.044,
        "1227": 0.044,
        "1253": 0,
        "1257": 0,
        "1258": 0.03,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.029,
        "1266": 0.001,
        "1267": 0,
        "1268": 0.005,
        "1269": 0.087,
        "1270": 0.001,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.006,
        "1293": 0.089,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 3.45
      },
      "scientificName": "Daucus carota"
    },
    {
      "id": "169276",
      "name": "retek - normál",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 150,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.68,
        "1004": 0.1,
        "1005": 3.4,
        "1008": 16,
        "1009": 0,
        "1010": 0.1,
        "1011": 1.05,
        "1012": 0.71,
        "1013": 0,
        "1014": 0,
        "1051": 95.27,
        "1058": 0,
        "1075": 0,
        "1079": 1.6,
        "1087": 25,
        "1089": 0.34,
        "1090": 10,
        "1091": 20,
        "1092": 233,
        "1093": 39,
        "1095": 0.28,
        "1098": 0.05,
        "1099": 6,
        "1101": 0.069,
        "1103": 0.6,
        "1105": 0,
        "1106": 0,
        "1107": 4,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 10,
        "1125": 0,
        "1126": 0,
        "1127": 0,
        "1128": 0.02,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 14.8,
        "1165": 0.012,
        "1166": 0.039,
        "1167": 0.254,
        "1170": 0.165,
        "1175": 0.071,
        "1177": 25,
        "1178": 0,
        "1180": 6.5,
        "1184": 0,
        "1185": 1.3,
        "1187": 25,
        "1190": 25,
        "1198": 0.1,
        "1210": 0.009,
        "1211": 0.023,
        "1212": 0.02,
        "1213": 0.031,
        "1214": 0.033,
        "1215": 0.01,
        "1216": 0.01,
        "1217": 0.036,
        "1218": 0.009,
        "1219": 0.035,
        "1220": 0.038,
        "1221": 0.013,
        "1222": 0.026,
        "1223": 0.064,
        "1224": 0.157,
        "1225": 0.026,
        "1226": 0.022,
        "1227": 0.027,
        "1253": 0,
        "1257": 0,
        "1258": 0.032,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.027,
        "1266": 0.004,
        "1268": 0.017,
        "1269": 0.017,
        "1270": 0.031,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 7,
        "1292": 0.017,
        "1293": 0.048,
        "2000": 1.86
      },
      "scientificName": "Raphanus sativus"
    },
    {
      "id": "168451",
      "name": "retek - vaj",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.6,
        "1004": 0.1,
        "1005": 4.1,
        "1008": 18,
        "1051": 94.62,
        "1058": 0,
        "1079": 1.6,
        "1087": 27,
        "1089": 0.4,
        "1090": 16,
        "1091": 23,
        "1092": 227,
        "1093": 21,
        "1095": 0.15,
        "1098": 0.115,
        "1101": 0.038,
        "1103": 0.7,
        "1105": 0,
        "1106": 0,
        "1107": 0,
        "1108": 0,
        "1109": 0,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 0,
        "1162": 22,
        "1165": 0.02,
        "1166": 0.02,
        "1167": 0.2,
        "1170": 0.138,
        "1175": 0.046,
        "1177": 28,
        "1178": 0,
        "1180": 7.3,
        "1185": 0.3,
        "1187": 28,
        "1190": 28,
        "1198": 0.1,
        "1210": 0.003,
        "1211": 0.025,
        "1212": 0.026,
        "1213": 0.031,
        "1214": 0.03,
        "1215": 0.006,
        "1216": 0.005,
        "1217": 0.02,
        "1218": 0.011,
        "1219": 0.028,
        "1220": 0.035,
        "1221": 0.011,
        "1222": 0.019,
        "1223": 0.041,
        "1224": 0.113,
        "1225": 0.019,
        "1226": 0.015,
        "1227": 0.018,
        "1253": 0,
        "1257": 0,
        "1258": 0.03,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.026,
        "1266": 0.004,
        "1268": 0.016,
        "1269": 0.016,
        "1270": 0.029,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.017,
        "1293": 0.045,
        "2000": 2.5
      },
      "scientificName": "Raphanus sativus (Longipinratus Group)"
    },
    {
      "id": "168875",
      "name": "rizs - barna",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 2.32,
        "1004": 0.83,
        "1005": 23.51,
        "1008": 112,
        "1051": 72.96,
        "1079": 1.8,
        "1087": 10,
        "1089": 0.53,
        "1090": 44,
        "1091": 77,
        "1092": 79,
        "1093": 1,
        "1095": 0.62,
        "1098": 0.081,
        "1101": 1.097,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 0,
        "1165": 0.102,
        "1166": 0.012,
        "1167": 1.33,
        "1170": 0.392,
        "1175": 0.149,
        "1177": 4,
        "1178": 0,
        "1187": 4,
        "1190": 4,
        "1210": 0.03,
        "1211": 0.085,
        "1212": 0.098,
        "1213": 0.191,
        "1214": 0.088,
        "1215": 0.052,
        "1216": 0.028,
        "1217": 0.119,
        "1218": 0.087,
        "1219": 0.136,
        "1220": 0.175,
        "1221": 0.059,
        "1222": 0.135,
        "1223": 0.217,
        "1224": 0.472,
        "1225": 0.114,
        "1226": 0.109,
        "1227": 0.12,
        "1253": 0,
        "1258": 0.165,
        "1263": 0.001,
        "1264": 0.003,
        "1265": 0.141,
        "1266": 0.015,
        "1268": 0.297,
        "1269": 0.283,
        "1270": 0.013,
        "1275": 0.003,
        "1292": 0.3,
        "1293": 0.296
      }
    },
    {
      "id": "169387",
      "name": "rukkola",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 2.58,
        "1004": 0.66,
        "1005": 3.65,
        "1008": 25,
        "1051": 91.71,
        "1058": 0,
        "1079": 1.6,
        "1087": 160,
        "1089": 1.46,
        "1090": 47,
        "1091": 52,
        "1092": 369,
        "1093": 27,
        "1095": 0.47,
        "1098": 0.076,
        "1101": 0.321,
        "1103": 0.3,
        "1105": 0,
        "1106": 119,
        "1107": 1424,
        "1108": 0,
        "1109": 0.43,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 3555,
        "1162": 15,
        "1165": 0.044,
        "1166": 0.086,
        "1167": 0.305,
        "1170": 0.437,
        "1175": 0.073,
        "1177": 97,
        "1178": 0,
        "1180": 15.3,
        "1185": 108.6,
        "1187": 97,
        "1190": 97,
        "1198": 0.1,
        "1253": 0,
        "1257": 0,
        "1258": 0.086,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.003,
        "1264": 0,
        "1265": 0.072,
        "1266": 0.004,
        "1268": 0.046,
        "1269": 0.13,
        "1270": 0.17,
        "1271": 0.002,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.049,
        "1293": 0.319,
        "2000": 2.05
      },
      "scientificName": "Eruca sativa"
    },
    {
      "id": "169249",
      "name": "saláta - fejes",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 300,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.36,
        "1004": 0.15,
        "1005": 2.87,
        "1008": 15,
        "1009": 0,
        "1010": 0,
        "1011": 0.36,
        "1012": 0.43,
        "1013": 0,
        "1014": 0,
        "1051": 94.98,
        "1058": 0,
        "1075": 0,
        "1079": 1.3,
        "1087": 36,
        "1089": 0.86,
        "1090": 13,
        "1091": 29,
        "1092": 194,
        "1093": 28,
        "1095": 0.18,
        "1098": 0.029,
        "1101": 0.25,
        "1103": 0.6,
        "1105": 0,
        "1106": 370,
        "1107": 4443,
        "1108": 0,
        "1109": 0.22,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 1730,
        "1125": 0,
        "1126": 0.41,
        "1127": 0.02,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 9.2,
        "1165": 0.07,
        "1166": 0.08,
        "1167": 0.375,
        "1170": 0.134,
        "1175": 0.09,
        "1177": 38,
        "1178": 0,
        "1180": 13.6,
        "1184": 0,
        "1185": 126.3,
        "1187": 38,
        "1190": 38,
        "1198": 0.2,
        "1210": 0.009,
        "1211": 0.059,
        "1212": 0.084,
        "1213": 0.079,
        "1214": 0.084,
        "1215": 0.016,
        "1216": 0.016,
        "1217": 0.055,
        "1218": 0.032,
        "1219": 0.07,
        "1220": 0.071,
        "1221": 0.022,
        "1222": 0.056,
        "1223": 0.142,
        "1224": 0.182,
        "1225": 0.057,
        "1226": 0.048,
        "1227": 0.039,
        "1253": 0,
        "1257": 0,
        "1258": 0.02,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.018,
        "1266": 0.002,
        "1268": 0.005,
        "1269": 0.024,
        "1270": 0.058,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 38,
        "1292": 0.006,
        "1293": 0.082,
        "2000": 0.78
      },
      "scientificName": "Lactuca sativa var. crispa"
    },
    {
      "id": "169248",
      "name": "saláta - jég",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.9,
        "1004": 0.14,
        "1005": 2.97,
        "1008": 14,
        "1010": 0.05,
        "1011": 0.91,
        "1012": 1,
        "1013": 0,
        "1014": 0,
        "1051": 95.64,
        "1058": 0,
        "1075": 0,
        "1079": 1.2,
        "1087": 18,
        "1089": 0.41,
        "1090": 7,
        "1091": 20,
        "1092": 141,
        "1093": 10,
        "1095": 0.15,
        "1098": 0.025,
        "1101": 0.125,
        "1103": 0.1,
        "1105": 0,
        "1106": 25,
        "1107": 299,
        "1108": 4,
        "1109": 0.18,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 277,
        "1125": 0,
        "1126": 0.09,
        "1127": 0,
        "1128": 0.01,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 2.8,
        "1165": 0.041,
        "1166": 0.025,
        "1167": 0.123,
        "1170": 0.091,
        "1175": 0.042,
        "1177": 29,
        "1178": 0,
        "1180": 6.7,
        "1184": 0,
        "1185": 24.1,
        "1187": 29,
        "1190": 29,
        "1198": 0.1,
        "1210": 0.009,
        "1211": 0.025,
        "1212": 0.018,
        "1213": 0.025,
        "1214": 0.024,
        "1215": 0.005,
        "1216": 0.005,
        "1217": 0.023,
        "1218": 0.007,
        "1219": 0.024,
        "1220": 0.015,
        "1221": 0.009,
        "1222": 0.025,
        "1223": 0.125,
        "1224": 0.194,
        "1225": 0.015,
        "1226": 0.01,
        "1227": 0.025,
        "1253": 0,
        "1257": 0,
        "1258": 0.018,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.016,
        "1266": 0.002,
        "1268": 0.004,
        "1269": 0.021,
        "1270": 0.052,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 10,
        "1292": 0.006,
        "1293": 0.074,
        "2000": 1.97
      },
      "scientificName": "Lactuca sativa var. capitata"
    },
    {
      "id": "168390",
      "name": "spárga",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 700,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 2.4,
        "1004": 0.22,
        "1005": 4.11,
        "1008": 22,
        "1009": 0,
        "1010": 0.08,
        "1011": 0.42,
        "1012": 0.79,
        "1013": 0,
        "1014": 0,
        "1051": 92.63,
        "1058": 0,
        "1075": 0,
        "1079": 2,
        "1087": 23,
        "1089": 0.91,
        "1090": 14,
        "1091": 54,
        "1092": 224,
        "1093": 14,
        "1095": 0.6,
        "1098": 0.165,
        "1099": 21.9,
        "1101": 0.154,
        "1103": 6.1,
        "1105": 0,
        "1106": 50,
        "1107": 604,
        "1108": 0,
        "1109": 1.5,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 30,
        "1123": 771,
        "1125": 0.02,
        "1126": 0.21,
        "1127": 0,
        "1162": 7.7,
        "1165": 0.162,
        "1166": 0.139,
        "1167": 1.084,
        "1170": 0.225,
        "1175": 0.079,
        "1177": 149,
        "1178": 0,
        "1180": 26.1,
        "1184": 0,
        "1185": 50.6,
        "1187": 149,
        "1190": 149,
        "1198": 0.9,
        "1210": 0.029,
        "1211": 0.092,
        "1212": 0.082,
        "1213": 0.14,
        "1214": 0.113,
        "1215": 0.034,
        "1216": 0.034,
        "1217": 0.082,
        "1218": 0.057,
        "1219": 0.125,
        "1220": 0.099,
        "1221": 0.053,
        "1222": 0.125,
        "1223": 0.555,
        "1224": 0.255,
        "1225": 0.101,
        "1226": 0.077,
        "1227": 0.116,
        "1253": 0,
        "1257": 0,
        "1258": 0.048,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.048,
        "1266": 0,
        "1267": 0,
        "1268": 0,
        "1269": 0.076,
        "1270": 0.029,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0,
        "1293": 0.105,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 1.3
      },
      "scientificName": "Asparagus officinalis"
    },
    {
      "id": "168463",
      "name": "spenót",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 350,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 2.97,
        "1004": 0.26,
        "1005": 3.75,
        "1008": 23,
        "1051": 91.21,
        "1058": 0,
        "1079": 2.4,
        "1087": 136,
        "1089": 3.57,
        "1090": 87,
        "1091": 56,
        "1092": 466,
        "1093": 70,
        "1095": 0.76,
        "1098": 0.174,
        "1099": 37.8,
        "1101": 0.935,
        "1103": 1.5,
        "1105": 0,
        "1106": 524,
        "1107": 6288,
        "1108": 0,
        "1109": 2.08,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 11308,
        "1162": 9.8,
        "1165": 0.095,
        "1166": 0.236,
        "1167": 0.49,
        "1170": 0.145,
        "1175": 0.242,
        "1177": 146,
        "1178": 0,
        "1180": 19.7,
        "1185": 493.6,
        "1187": 146,
        "1190": 146,
        "1198": 89,
        "1210": 0.04,
        "1211": 0.127,
        "1212": 0.152,
        "1213": 0.231,
        "1214": 0.182,
        "1215": 0.055,
        "1216": 0.035,
        "1217": 0.134,
        "1218": 0.113,
        "1219": 0.168,
        "1220": 0.168,
        "1221": 0.066,
        "1222": 0.147,
        "1223": 0.25,
        "1224": 0.357,
        "1225": 0.14,
        "1226": 0.116,
        "1227": 0.107,
        "1253": 0,
        "1257": 0,
        "1258": 0.043,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.006,
        "1265": 0.033,
        "1266": 0.003,
        "1268": 0.003,
        "1269": 0.017,
        "1270": 0.092,
        "1271": 0,
        "1272": 0,
        "1275": 0.003,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.006,
        "1293": 0.109,
        "2000": 0.43
      },
      "scientificName": "Spinacia oleracea"
    },
    {
      "id": "173946",
      "name": "szeder",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 900,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 250,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 1.39,
        "1004": 0.49,
        "1005": 9.61,
        "1008": 43,
        "1009": 0,
        "1010": 0.07,
        "1011": 2.31,
        "1012": 2.4,
        "1013": 0,
        "1014": 0.07,
        "1051": 88.15,
        "1058": 0,
        "1075": 0.03,
        "1079": 5.3,
        "1087": 29,
        "1089": 0.62,
        "1090": 20,
        "1091": 22,
        "1092": 162,
        "1093": 1,
        "1095": 0.53,
        "1098": 0.165,
        "1101": 0.646,
        "1103": 0.4,
        "1105": 0,
        "1106": 11,
        "1107": 128,
        "1108": 0,
        "1109": 1.17,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 118,
        "1125": 0.04,
        "1126": 1.34,
        "1127": 0.9,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 21,
        "1165": 0.02,
        "1166": 0.026,
        "1167": 0.646,
        "1170": 0.276,
        "1175": 0.03,
        "1177": 25,
        "1178": 0,
        "1180": 8.5,
        "1184": 0,
        "1185": 19.8,
        "1187": 25,
        "1190": 25,
        "1198": 0.3,
        "1253": 0,
        "1257": 0,
        "1258": 0.014,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.012,
        "1266": 0.003,
        "1268": 0.044,
        "1269": 0.186,
        "1270": 0.094,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0.004,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.047,
        "1293": 0.28,
        "2000": 4.88
      },
      "scientificName": "Rubus spp."
    },
    {
      "id": "169949",
      "name": "szilva",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 300,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.7,
        "1004": 0.28,
        "1005": 11.42,
        "1008": 46,
        "1009": 0,
        "1010": 1.57,
        "1011": 5.07,
        "1012": 3.07,
        "1013": 0,
        "1014": 0.08,
        "1051": 87.23,
        "1058": 0,
        "1075": 0.14,
        "1079": 1.4,
        "1087": 6,
        "1089": 0.17,
        "1090": 7,
        "1091": 16,
        "1092": 157,
        "1093": 0,
        "1095": 0.1,
        "1098": 0.057,
        "1099": 2,
        "1101": 0.052,
        "1103": 0,
        "1105": 0,
        "1106": 17,
        "1107": 190,
        "1108": 0,
        "1109": 0.26,
        "1110": 0,
        "1114": 0,
        "1120": 35,
        "1122": 0,
        "1123": 73,
        "1125": 0,
        "1126": 0.08,
        "1127": 0,
        "1128": 0.04,
        "1129": 0,
        "1130": 0.01,
        "1131": 0,
        "1162": 9.5,
        "1165": 0.028,
        "1166": 0.026,
        "1167": 0.417,
        "1170": 0.135,
        "1175": 0.029,
        "1177": 5,
        "1178": 0,
        "1180": 1.9,
        "1184": 0,
        "1185": 6.4,
        "1187": 5,
        "1190": 5,
        "1210": 0.009,
        "1211": 0.01,
        "1212": 0.014,
        "1213": 0.015,
        "1214": 0.016,
        "1215": 0.008,
        "1216": 0.002,
        "1217": 0.014,
        "1218": 0.008,
        "1219": 0.016,
        "1220": 0.009,
        "1221": 0.009,
        "1222": 0.028,
        "1223": 0.352,
        "1224": 0.035,
        "1225": 0.009,
        "1226": 0.027,
        "1227": 0.023,
        "1253": 0,
        "1257": 0,
        "1258": 0.017,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0,
        "1265": 0.014,
        "1266": 0.003,
        "1268": 0.132,
        "1269": 0.044,
        "1270": 0,
        "1271": 0,
        "1272": 0,
        "1275": 0.002,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 7,
        "1292": 0.134,
        "1293": 0.044,
        "2000": 9.92
      },
      "scientificName": "Prunus spp."
    },
    {
      "id": "174683",
      "name": "szőlő - fehér vagy piros - thompson seedless",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 400,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.72,
        "1004": 0.16,
        "1005": 18.1,
        "1008": 69,
        "1009": 0,
        "1010": 0.15,
        "1011": 7.2,
        "1012": 8.13,
        "1013": 0,
        "1014": 0,
        "1051": 80.54,
        "1058": 0,
        "1075": 0,
        "1079": 0.9,
        "1087": 10,
        "1089": 0.36,
        "1090": 7,
        "1091": 20,
        "1092": 191,
        "1093": 2,
        "1095": 0.07,
        "1098": 0.127,
        "1099": 7.8,
        "1101": 0.071,
        "1103": 0.1,
        "1105": 0,
        "1106": 3,
        "1107": 39,
        "1108": 1,
        "1109": 0.19,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 72,
        "1125": 0,
        "1126": 0.07,
        "1127": 0,
        "1128": 0,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 3.2,
        "1165": 0.069,
        "1166": 0.07,
        "1167": 0.188,
        "1170": 0.05,
        "1175": 0.086,
        "1177": 2,
        "1178": 0,
        "1180": 5.6,
        "1184": 0,
        "1185": 14.6,
        "1187": 2,
        "1190": 2,
        "1198": 0.1,
        "1210": 0.011,
        "1211": 0.022,
        "1212": 0.011,
        "1213": 0.022,
        "1214": 0.027,
        "1215": 0.009,
        "1216": 0.01,
        "1217": 0.019,
        "1218": 0.01,
        "1219": 0.022,
        "1220": 0.13,
        "1221": 0.022,
        "1222": 0.022,
        "1223": 0.038,
        "1224": 0.081,
        "1225": 0.016,
        "1226": 0.08,
        "1227": 0.022,
        "1253": 0,
        "1257": 0,
        "1258": 0.054,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.001,
        "1265": 0.046,
        "1266": 0.006,
        "1268": 0.007,
        "1269": 0.037,
        "1270": 0.011,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 4,
        "1292": 0.007,
        "1293": 0.048,
        "2000": 15.48
      },
      "scientificName": "Vitis vinifera"
    },
    {
      "id": "169296",
      "name": "tök - sütő",
      "category": "zöldség",
      "state": "baked",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 150,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.9,
        "1004": 0.09,
        "1005": 10.49,
        "1008": 40,
        "1051": 87.8,
        "1079": 3.2,
        "1087": 41,
        "1089": 0.6,
        "1090": 29,
        "1091": 27,
        "1092": 284,
        "1093": 4,
        "1095": 0.13,
        "1098": 0.065,
        "1101": 0.172,
        "1103": 0.5,
        "1105": 0,
        "1106": 558,
        "1107": 4570,
        "1108": 1130,
        "1109": 1.29,
        "1110": 0,
        "1114": 0,
        "1120": 3116,
        "1122": 0,
        "1123": 0,
        "1162": 15.1,
        "1165": 0.072,
        "1166": 0.017,
        "1167": 0.969,
        "1170": 0.359,
        "1175": 0.124,
        "1177": 19,
        "1178": 0,
        "1185": 1,
        "1187": 19,
        "1190": 19,
        "1210": 0.013,
        "1211": 0.027,
        "1212": 0.035,
        "1213": 0.051,
        "1214": 0.033,
        "1215": 0.011,
        "1216": 0.008,
        "1217": 0.035,
        "1218": 0.03,
        "1219": 0.039,
        "1220": 0.05,
        "1221": 0.017,
        "1222": 0.038,
        "1223": 0.097,
        "1224": 0.157,
        "1225": 0.033,
        "1226": 0.032,
        "1227": 0.035,
        "1253": 0,
        "1257": 0,
        "1258": 0.019,
        "1263": 0,
        "1264": 0,
        "1265": 0.016,
        "1266": 0.002,
        "1268": 0.007,
        "1269": 0.014,
        "1270": 0.024,
        "1275": 0,
        "1292": 0.007,
        "1293": 0.038,
        "2000": 1.97
      },
      "scientificName": "Cucurbita moschata"
    },
    {
      "id": "173472",
      "name": "torma - reszelt",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 10,
      "portionGrams": 10,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 500,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 50,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 1.18,
        "1004": 0.69,
        "1005": 11.29,
        "1008": 48,
        "1009": 0,
        "1051": 85.08,
        "1058": 0,
        "1079": 3.3,
        "1087": 56,
        "1089": 0.42,
        "1090": 27,
        "1091": 31,
        "1092": 246,
        "1093": 420,
        "1095": 0.83,
        "1098": 0.058,
        "1101": 0.126,
        "1103": 2.8,
        "1105": 0,
        "1106": 0,
        "1107": 1,
        "1108": 0,
        "1109": 0.01,
        "1110": 0,
        "1114": 0,
        "1120": 0,
        "1122": 0,
        "1123": 10,
        "1162": 24.9,
        "1165": 0.008,
        "1166": 0.024,
        "1167": 0.386,
        "1170": 0.093,
        "1175": 0.073,
        "1177": 57,
        "1178": 0,
        "1180": 6.5,
        "1185": 1.3,
        "1187": 57,
        "1190": 57,
        "1253": 0,
        "1257": 0,
        "1258": 0.09,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.002,
        "1264": 0.001,
        "1265": 0.061,
        "1266": 0.021,
        "1268": 0.127,
        "1269": 0.285,
        "1270": 0.053,
        "1271": 0,
        "1272": 0,
        "1275": 0.001,
        "1276": 0,
        "1277": 0.001,
        "1278": 0,
        "1279": 0.001,
        "1280": 0,
        "1283": 9,
        "1292": 0.13,
        "1293": 0.339,
        "2000": 7.99
      }
    },
    {
      "id": "169225",
      "name": "uborka - kígyó - hámozott",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 150,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.59,
        "1004": 0.16,
        "1005": 2.16,
        "1008": 10,
        "1009": 0.08,
        "1010": 0,
        "1011": 0.63,
        "1012": 0.75,
        "1013": 0,
        "1014": 0,
        "1051": 96.73,
        "1058": 0,
        "1075": 0,
        "1079": 0.7,
        "1087": 14,
        "1089": 0.22,
        "1090": 12,
        "1091": 21,
        "1092": 136,
        "1093": 2,
        "1095": 0.17,
        "1098": 0.071,
        "1099": 1.3,
        "1101": 0.073,
        "1103": 0.1,
        "1105": 0,
        "1106": 4,
        "1107": 31,
        "1108": 8,
        "1109": 0.03,
        "1110": 0,
        "1114": 0,
        "1120": 18,
        "1122": 0,
        "1123": 16,
        "1125": 0,
        "1126": 0.02,
        "1127": 0,
        "1128": 0.04,
        "1129": 0,
        "1130": 0,
        "1131": 0,
        "1162": 3.2,
        "1165": 0.031,
        "1166": 0.025,
        "1167": 0.037,
        "1170": 0.24,
        "1175": 0.051,
        "1177": 14,
        "1178": 0,
        "1180": 5.7,
        "1184": 0,
        "1185": 7.2,
        "1187": 14,
        "1190": 14,
        "1198": 0.1,
        "1210": 0.007,
        "1211": 0.012,
        "1212": 0.012,
        "1213": 0.025,
        "1214": 0.025,
        "1215": 0.012,
        "1216": 0.007,
        "1217": 0.031,
        "1218": 0.002,
        "1219": 0.012,
        "1220": 0.031,
        "1221": 0.002,
        "1222": 0.031,
        "1223": 0.037,
        "1224": 0.204,
        "1225": 0.025,
        "1226": 0.012,
        "1227": 0.025,
        "1253": 0,
        "1257": 0,
        "1258": 0.078,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0,
        "1264": 0.01,
        "1265": 0.058,
        "1266": 0.01,
        "1267": 0,
        "1268": 0.01,
        "1269": 0.01,
        "1270": 0.01,
        "1271": 0,
        "1272": 0,
        "1273": 0,
        "1274": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1292": 0.01,
        "1293": 0.019,
        "1299": 0,
        "1300": 0,
        "1301": 0,
        "1313": 0,
        "1323": 0,
        "1325": 0,
        "1333": 0,
        "2000": 1.38
      }
    },
    {
      "id": "168558",
      "name": "uborka - kovászos - dill",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.5,
        "1004": 0.3,
        "1005": 2.41,
        "1008": 12,
        "1010": 0,
        "1011": 0.52,
        "1012": 0.55,
        "1013": 0,
        "1014": 0,
        "1051": 94.34,
        "1058": 0,
        "1075": 0,
        "1079": 1,
        "1087": 57,
        "1089": 0.26,
        "1090": 7,
        "1091": 16,
        "1092": 117,
        "1093": 809,
        "1095": 0.1,
        "1098": 0.028,
        "1099": 30.1,
        "1101": 0.062,
        "1103": 0,
        "1105": 0,
        "1106": 6,
        "1107": 53,
        "1108": 13,
        "1109": 0.03,
        "1110": 0,
        "1114": 0,
        "1120": 30,
        "1122": 0,
        "1123": 28,
        "1162": 2.3,
        "1165": 0.045,
        "1166": 0.057,
        "1167": 0.109,
        "1170": 0.201,
        "1175": 0.035,
        "1177": 8,
        "1178": 0,
        "1180": 3.4,
        "1183": 0,
        "1184": 0,
        "1185": 17.3,
        "1187": 8,
        "1190": 8,
        "1198": 0,
        "1210": 0.005,
        "1211": 0.017,
        "1212": 0.019,
        "1213": 0.026,
        "1214": 0.026,
        "1215": 0.005,
        "1216": 0.004,
        "1217": 0.017,
        "1218": 0.01,
        "1219": 0.02,
        "1220": 0.04,
        "1221": 0.009,
        "1222": 0.021,
        "1223": 0.037,
        "1224": 0.177,
        "1225": 0.022,
        "1226": 0.014,
        "1227": 0.018,
        "1253": 0,
        "1257": 0,
        "1258": 0.079,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.003,
        "1264": 0.003,
        "1265": 0.065,
        "1266": 0.008,
        "1268": 0.005,
        "1269": 0.052,
        "1270": 0.07,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 14,
        "1292": 0.005,
        "1293": 0.122,
        "2000": 1.07
      }
    },
    {
      "id": "169379",
      "name": "uborka - kovászos - sour",
      "category": "zöldség",
      "state": "raw",
      "rawPortionGrams": 50,
      "portionGrams": 50,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": false,
      "nutrients": {
        "1003": 0.33,
        "1004": 0.2,
        "1005": 2.26,
        "1008": 11,
        "1051": 94.08,
        "1058": 0,
        "1079": 1.2,
        "1087": 0,
        "1089": 0.4,
        "1090": 4,
        "1091": 14,
        "1092": 23,
        "1093": 1208,
        "1095": 0.02,
        "1098": 0.085,
        "1101": 0.011,
        "1103": 0,
        "1105": 0,
        "1106": 10,
        "1107": 81,
        "1108": 20,
        "1109": 0.09,
        "1110": 0,
        "1114": 0,
        "1120": 47,
        "1122": 0,
        "1123": 43,
        "1162": 1,
        "1165": 0,
        "1166": 0.01,
        "1167": 0,
        "1170": 0.038,
        "1175": 0.009,
        "1177": 1,
        "1178": 0,
        "1180": 3.6,
        "1185": 47,
        "1187": 1,
        "1190": 1,
        "1198": 0,
        "1210": 0.003,
        "1211": 0.009,
        "1212": 0.01,
        "1213": 0.014,
        "1214": 0.014,
        "1215": 0.003,
        "1216": 0.002,
        "1217": 0.009,
        "1218": 0.006,
        "1219": 0.011,
        "1220": 0.021,
        "1221": 0.005,
        "1222": 0.011,
        "1223": 0.02,
        "1224": 0.095,
        "1225": 0.012,
        "1226": 0.008,
        "1227": 0.01,
        "1253": 0,
        "1257": 0,
        "1258": 0.052,
        "1259": 0,
        "1260": 0,
        "1261": 0,
        "1262": 0,
        "1263": 0.002,
        "1264": 0.002,
        "1265": 0.043,
        "1266": 0.005,
        "1268": 0.003,
        "1269": 0.034,
        "1270": 0.046,
        "1271": 0,
        "1272": 0,
        "1275": 0,
        "1276": 0,
        "1277": 0,
        "1278": 0,
        "1279": 0,
        "1280": 0,
        "1283": 14,
        "1292": 0.003,
        "1293": 0.081,
        "2000": 1.06
      }
    },
    {
      "id": "169987",
      "name": "zeller - gumó",
      "category": "zöldség",
      "state": "cooked",
      "rawPortionGrams": 25,
      "portionGrams": 25,
      "edible": true,
      "plantBased": true,
      "edibleAlone": true,
      "purchaseRawGrams": 100,
      "purchasePrice": 200,
      "dailyMinGrams": 0,
      "dailyMaxGrams": 500,
      "purchaseUrl": "claude",
      "highFodmap": true,
      "nutrients": {
        "1003": 0.96,
        "1004": 0.19,
        "1005": 5.9,
        "1008": 27,
        "1051": 92.3,
        "1079": 1.2,
        "1087": 26,
        "1089": 0.43,
        "1090": 12,
        "1091": 66,
        "1092": 173,
        "1093": 61,
        "1095": 0.2,
        "1098": 0.043,
        "1101": 0.096,
        "1103": 0.4,
        "1105": 0,
        "1106": 0,
        "1110": 0,
        "1114": 0,
        "1162": 3.6,
        "1165": 0.027,
        "1166": 0.037,
        "1167": 0.427,
        "1170": 0.203,
        "1175": 0.101,
        "1177": 3,
        "1178": 0,
        "1187": 3,
        "1190": 3,
        "1253": 0,
        "1257": 0
      },
      "scientificName": "Apium graveolens"
    }
  ],
  "nutrients": [
    {
      "id": 1003,
      "name": "Protein",
      "unit": "g",
      "category": "basics",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1004,
      "name": "Total lipid (fat)",
      "unit": "g",
      "category": "basics",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1005,
      "name": "Carbohydrate, by difference",
      "unit": "g",
      "category": "basics",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1008,
      "name": "Energy",
      "unit": "kcal",
      "category": "basics",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1051,
      "name": "Water",
      "unit": "g",
      "category": "basics",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1079,
      "name": "Fiber, total dietary",
      "unit": "g",
      "category": "basics",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 2000,
      "name": "Sugars, total including NLEA",
      "unit": "g",
      "category": "sugars",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1110,
      "name": "Vitamin D (D2 + D3), International Units",
      "unit": "IU",
      "category": "vitamins",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1162,
      "name": "Vitamin C, total ascorbic acid",
      "unit": "mg",
      "category": "vitamins",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1177,
      "name": "Folate, total",
      "unit": "µg",
      "category": "vitamins",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1178,
      "name": "Vitamin B-12",
      "unit": "µg",
      "category": "vitamins",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1180,
      "name": "Choline, total",
      "unit": "mg",
      "category": "vitamins",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1087,
      "name": "Calcium, Ca",
      "unit": "mg",
      "category": "minerals",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1089,
      "name": "Iron, Fe",
      "unit": "mg",
      "category": "minerals",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1090,
      "name": "Magnesium, Mg",
      "unit": "mg",
      "category": "minerals",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1092,
      "name": "Potassium, K",
      "unit": "mg",
      "category": "minerals",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1093,
      "name": "Sodium, Na",
      "unit": "mg",
      "category": "minerals",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1257,
      "name": "Fatty acids, total trans",
      "unit": "g",
      "category": "fattyacids",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1258,
      "name": "Fatty acids, total saturated",
      "unit": "g",
      "category": "fattyacids",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1272,
      "name": "PUFA 22:6 n-3 (DHA)",
      "unit": "g",
      "category": "fattyacids",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1278,
      "name": "PUFA 20:5 n-3 (EPA)",
      "unit": "g",
      "category": "fattyacids",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1404,
      "name": "PUFA 18:3 n-3 c,c,c (ALA)",
      "unit": "g",
      "category": "fattyacids",
      "priority": "critical",
      "algorithm": "ignore"
    },
    {
      "id": 1106,
      "name": "Vitamin A, RAE",
      "unit": "µg",
      "category": "vitamins",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1109,
      "name": "Vitamin E (alpha-tocopherol)",
      "unit": "mg",
      "category": "vitamins",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1175,
      "name": "Vitamin B-6",
      "unit": "mg",
      "category": "vitamins",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1185,
      "name": "Vitamin K (phylloquinone)",
      "unit": "µg",
      "category": "vitamins",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1190,
      "name": "Folate, DFE",
      "unit": "µg",
      "category": "vitamins",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1091,
      "name": "Phosphorus, P",
      "unit": "mg",
      "category": "minerals",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1095,
      "name": "Zinc, Zn",
      "unit": "mg",
      "category": "minerals",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1098,
      "name": "Copper, Cu",
      "unit": "mg",
      "category": "minerals",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1099,
      "name": "Fluoride, F",
      "unit": "µg",
      "category": "minerals",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1101,
      "name": "Manganese, Mn",
      "unit": "mg",
      "category": "minerals",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1103,
      "name": "Selenium, Se",
      "unit": "µg",
      "category": "minerals",
      "priority": "high",
      "algorithm": "ignore"
    },
    {
      "id": 1104,
      "name": "Vitamin A, IU",
      "unit": "IU",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1105,
      "name": "Retinol",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1107,
      "name": "Carotene, beta",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1108,
      "name": "Carotene, alpha",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1111,
      "name": "Vitamin D2 (ergocalciferol)",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1112,
      "name": "Vitamin D3 (cholecalciferol)",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1114,
      "name": "Vitamin D (D2 + D3)",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1125,
      "name": "Tocopherol, beta",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1126,
      "name": "Tocopherol, gamma",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1127,
      "name": "Tocopherol, delta",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1128,
      "name": "Tocotrienol, alpha",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1129,
      "name": "Tocotrienol, beta",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1130,
      "name": "Tocotrienol, gamma",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1131,
      "name": "Tocotrienol, delta",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1165,
      "name": "Thiamin",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1166,
      "name": "Riboflavin",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1167,
      "name": "Niacin",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1170,
      "name": "Pantothenic acid",
      "unit": "mg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1183,
      "name": "Vitamin K (Menaquinone-4)",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1184,
      "name": "Vitamin K (Dihydrophylloquinone)",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1187,
      "name": "Folate, food",
      "unit": "µg",
      "category": "vitamins",
      "priority": "medium",
      "algorithm": "ignore"
    },
    {
      "id": 1009,
      "name": "Starch",
      "unit": "g",
      "category": "sugars",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1010,
      "name": "Sucrose",
      "unit": "g",
      "category": "sugars",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1011,
      "name": "Glucose",
      "unit": "g",
      "category": "sugars",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1012,
      "name": "Fructose",
      "unit": "g",
      "category": "sugars",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1013,
      "name": "Lactose",
      "unit": "g",
      "category": "sugars",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1014,
      "name": "Maltose",
      "unit": "g",
      "category": "sugars",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1075,
      "name": "Galactose",
      "unit": "g",
      "category": "sugars",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1210,
      "name": "Tryptophan",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1211,
      "name": "Threonine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1212,
      "name": "Isoleucine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1213,
      "name": "Leucine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1214,
      "name": "Lysine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1215,
      "name": "Methionine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1216,
      "name": "Cystine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1217,
      "name": "Phenylalanine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1218,
      "name": "Tyrosine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1219,
      "name": "Valine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1220,
      "name": "Arginine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1221,
      "name": "Histidine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1222,
      "name": "Alanine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1223,
      "name": "Aspartic acid",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1224,
      "name": "Glutamic acid",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1225,
      "name": "Glycine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1226,
      "name": "Proline",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1227,
      "name": "Serine",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1228,
      "name": "Hydroxyproline",
      "unit": "g",
      "category": "aminoacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1259,
      "name": "SFA 4:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1260,
      "name": "SFA 6:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1261,
      "name": "SFA 8:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1262,
      "name": "SFA 10:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1263,
      "name": "SFA 12:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1264,
      "name": "SFA 14:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1265,
      "name": "SFA 16:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1266,
      "name": "SFA 18:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1267,
      "name": "SFA 20:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1268,
      "name": "MUFA 18:1",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1269,
      "name": "PUFA 18:2",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1270,
      "name": "PUFA 18:3",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1271,
      "name": "PUFA 20:4",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1273,
      "name": "SFA 22:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1274,
      "name": "MUFA 14:1",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1275,
      "name": "MUFA 16:1",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1276,
      "name": "PUFA 18:4",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1277,
      "name": "MUFA 20:1",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1279,
      "name": "MUFA 22:1",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1280,
      "name": "PUFA 22:5 n-3 (DPA)",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1292,
      "name": "Fatty acids, total monounsaturated",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1293,
      "name": "Fatty acids, total polyunsaturated",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1299,
      "name": "SFA 15:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1300,
      "name": "SFA 17:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1301,
      "name": "SFA 24:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1303,
      "name": "TFA 16:1 t",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1304,
      "name": "TFA 18:1 t",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1305,
      "name": "TFA 22:1 t",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1306,
      "name": "TFA 18:2 t not further defined",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1307,
      "name": "PUFA 18:2 i",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1310,
      "name": "TFA 18:2 t,t",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1311,
      "name": "PUFA 18:2 CLAs",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1312,
      "name": "MUFA 24:1 c",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1313,
      "name": "PUFA 20:2 n-6 c,c",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1314,
      "name": "MUFA 16:1 c",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1315,
      "name": "MUFA 18:1 c",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1316,
      "name": "PUFA 18:2 n-6 c,c",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1317,
      "name": "MUFA 22:1 c",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1321,
      "name": "PUFA 18:3 n-6 c,c,c",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1323,
      "name": "MUFA 17:1",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1325,
      "name": "PUFA 20:3",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1329,
      "name": "Fatty acids, total trans-monoenoic",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1331,
      "name": "Fatty acids, total trans-polyenoic",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1332,
      "name": "SFA 13:0",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1333,
      "name": "MUFA 15:1",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1405,
      "name": "PUFA 20:3 n-3",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1406,
      "name": "PUFA 20:4 n-6",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1409,
      "name": "PUFA 18:3i",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1411,
      "name": "PUFA 22:4",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1412,
      "name": "MUFA 18:1-11 t (18:1t n-7)",
      "unit": "g",
      "category": "fattyacids",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1253,
      "name": "Cholesterol",
      "unit": "mg",
      "category": "sterols",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1283,
      "name": "Phytosterols",
      "unit": "mg",
      "category": "sterols",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1285,
      "name": "Stigmasterol",
      "unit": "mg",
      "category": "sterols",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1286,
      "name": "Campesterol",
      "unit": "mg",
      "category": "sterols",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1288,
      "name": "Beta-sitosterol",
      "unit": "mg",
      "category": "sterols",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1058,
      "name": "Theobromine",
      "unit": "mg",
      "category": "magic",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1120,
      "name": "Cryptoxanthin, beta",
      "unit": "µg",
      "category": "magic",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1122,
      "name": "Lycopene",
      "unit": "µg",
      "category": "magic",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1123,
      "name": "Lutein + zeaxanthin",
      "unit": "µg",
      "category": "magic",
      "priority": "low",
      "algorithm": "ignore"
    },
    {
      "id": 1198,
      "name": "Betaine",
      "unit": "mg",
      "category": "magic",
      "priority": "low",
      "algorithm": "ignore"
    }
  ],
  "buildInfo": {
    "timestamp": "2026-04-30T12:59:25.086Z",
    "foodCount": 261,
    "nutrientCount": 140,
    "version": "1.0.0",
    "source": {
      "foodsFile": "foods.csv",
      "nutrientsFile": "nutrients.csv",
      "usdaFileCount": 376
    }
  }
} as const
